import { Injectable } from '@angular/core';
import { ParamMap } from '@angular/router';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { isNil, cloneDeep } from 'lodash-es';
import { ToastrService } from 'ngx-toastr';

import { WavelengthShellService } from 'wavelength-ui';
import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';


import { CleanupLoggerService } from './cleanup.logging.service';
import { FootprintManager_asn_order_creation_formComponent } from './FootprintManager.asn_order_creation_form.component';
import { FootprintManager_asn_order_transfer_outstanding_options_formComponent } from './FootprintManager.asn_order_transfer_outstanding_options_form.component';
import { FootprintManager_auto_load_options_formComponent } from './FootprintManager.auto_load_options_form.component';
import { FootprintManager_auto_pick_options_formComponent } from './FootprintManager.auto_pick_options_form.component';
import { FootprintManager_auto_receive_and_putaway_formComponent } from './FootprintManager.auto_receive_and_putaway_form.component';
import { FootprintManager_billing_cancellation_options_formComponent } from './FootprintManager.billing_cancellation_options_form.component';
import { FootprintManager_billing_contract_creation_formComponent } from './FootprintManager.billing_contract_creation_form.component';
import { FootprintManager_billing_contract_line_creation_formComponent } from './FootprintManager.billing_contract_line_creation_form.component';
import { FootprintManager_blind_return_project_selector_formComponent } from './FootprintManager.blind_return_project_selector_form.component';
import { FootprintManager_bulk_licenseplate_directed_move_formComponent } from './FootprintManager.bulk_licenseplate_directed_move_form.component';
import { FootprintManager_bulk_receiving_row_input_formComponent } from './FootprintManager.bulk_receiving_row_input_form.component';
import { FootprintManager_carrier_creation_formComponent } from './FootprintManager.carrier_creation_form.component';
import { FootprintManager_carrierservicetype_creation_formComponent } from './FootprintManager.carrierservicetype_creation_form.component';
import { FootprintManager_dock_appointment_assign_door_options_formComponent } from './FootprintManager.dock_appointment_assign_door_options_form.component';
import { FootprintManager_dock_appointment_cancel_options_formComponent } from './FootprintManager.dock_appointment_cancel_options_form.component';
import { FootprintManager_dock_appointment_check_in_options_formComponent } from './FootprintManager.dock_appointment_check_in_options_form.component';
import { FootprintManager_dock_appointment_creation_formComponent } from './FootprintManager.dock_appointment_creation_form.component';
import { FootprintManager_dock_door_creation_formComponent } from './FootprintManager.dock_door_creation_form.component';
import { FootprintManager_finalize_audit_formComponent } from './FootprintManager.finalize_audit_form.component';
import { FootprintManager_footprint_manager_homeComponent } from './FootprintManager.footprint_manager_home.component';
import { FootprintManager_generic_formComponent } from './FootprintManager.generic_form.component';
import { FootprintManager_get_average_serial_weights_formComponent } from './FootprintManager.get_average_serial_weights_form.component';
import { FootprintManager_get_licenseplate_formComponent } from './FootprintManager.get_licenseplate_form.component';
import { FootprintManager_inbound_orders_update_formComponent } from './FootprintManager.inbound_orders_update_form.component';
import { FootprintManager_inspection_select_task_status_formComponent } from './FootprintManager.inspection_select_task_status_form.component';
import { FootprintManager_inspection_task_creation_formComponent } from './FootprintManager.inspection_task_creation_form.component';
import { FootprintManager_integration_info_by_order_idComponent } from './FootprintManager.integration_info_by_order_id.component';
import { FootprintManager_inventory_adjustment_formComponent } from './FootprintManager.inventory_adjustment_form.component';
import { FootprintManager_inventory_and_licenseplate_move_formComponent } from './FootprintManager.inventory_and_licenseplate_move_form.component';
import { FootprintManager_inventory_creation_formComponent } from './FootprintManager.inventory_creation_form.component';
import { FootprintManager_inventory_transfer_creation_formComponent } from './FootprintManager.inventory_transfer_creation_form.component';
import { FootprintManager_inventory_transfer_formComponent } from './FootprintManager.inventory_transfer_form.component';
import { FootprintManager_inventory_transformation_additional_options_formComponent } from './FootprintManager.inventory_transformation_additional_options_form.component';
import { FootprintManager_inventory_transformation_creation_formComponent } from './FootprintManager.inventory_transformation_creation_form.component';
import { FootprintManager_inventory_transformations_target_material_formComponent } from './FootprintManager.inventory_transformations_target_material_form.component';
import { FootprintManager_inventory_type_selection_formComponent } from './FootprintManager.inventory_type_selection_form.component';
import { FootprintManager_invoice_creation_formComponent } from './FootprintManager.invoice_creation_form.component';
import { FootprintManager_invoice_creation_options_formComponent } from './FootprintManager.invoice_creation_options_form.component';
import { FootprintManager_invoice_status_change_options_formComponent } from './FootprintManager.invoice_status_change_options_form.component';
import { FootprintManager_load_container_create_formComponent } from './FootprintManager.load_container_create_form.component';
import { FootprintManager_location_creation_formComponent } from './FootprintManager.location_creation_form.component';
import { FootprintManager_location_replenishment_creation_formComponent } from './FootprintManager.location_replenishment_creation_form.component';
import { FootprintManager_lot_bulk_update_formComponent } from './FootprintManager.lot_bulk_update_form.component';
import { FootprintManager_lot_bulk_update_status_formComponent } from './FootprintManager.lot_bulk_update_status_form.component';
import { FootprintManager_lot_creation_formComponent } from './FootprintManager.lot_creation_form.component';
import { FootprintManager_lot_creation_form_with_materialComponent } from './FootprintManager.lot_creation_form_with_material.component';
import { FootprintManager_manufacturing_order_copy_formComponent } from './FootprintManager.manufacturing_order_copy_form.component';
import { FootprintManager_manufacturing_order_formComponent } from './FootprintManager.manufacturing_order_form.component';
import { FootprintManager_manufacturing_order_line_multiple_substitutions_swap_formComponent } from './FootprintManager.manufacturing_order_line_multiple_substitutions_swap_form.component';
import { FootprintManager_manufacturing_order_line_production_confirmation_setup_formComponent } from './FootprintManager.manufacturing_order_line_production_confirmation_setup_form.component';
import { FootprintManager_manufacturing_order_line_substitution_swap_formComponent } from './FootprintManager.manufacturing_order_line_substitution_swap_form.component';
import { FootprintManager_material_catalog_source_material_copy_formComponent } from './FootprintManager.material_catalog_source_material_copy_form.component';
import { FootprintManager_material_catalog_source_material_creation_formComponent } from './FootprintManager.material_catalog_source_material_creation_form.component';
import { FootprintManager_material_copy_formComponent } from './FootprintManager.material_copy_form.component';
import { FootprintManager_material_creation_formComponent } from './FootprintManager.material_creation_form.component';
import { FootprintManager_material_update_formComponent } from './FootprintManager.material_update_form.component';
import { FootprintManager_order_completion_options_formComponent } from './FootprintManager.order_completion_options_form.component';
import { FootprintManager_outbound_orders_update_formComponent } from './FootprintManager.outbound_orders_update_form.component';
import { FootprintManager_owner_creation_formComponent } from './FootprintManager.owner_creation_form.component';
import { FootprintManager_owner_update_formComponent } from './FootprintManager.owner_update_form.component';
import { FootprintManager_pack_verification_failure_formComponent } from './FootprintManager.pack_verification_failure_form.component';
import { FootprintManager_pallet_class_creation_formComponent } from './FootprintManager.pallet_class_creation_form.component';
import { FootprintManager_pallet_transaction_creation_formComponent } from './FootprintManager.pallet_transaction_creation_form.component';
import { FootprintManager_plan_formComponent } from './FootprintManager.plan_form.component';
import { FootprintManager_print_license_plate_labels_formComponent } from './FootprintManager.print_license_plate_labels_form.component';
import { FootprintManager_print_order_labels_formComponent } from './FootprintManager.print_order_labels_form.component';
import { FootprintManager_project_creation_formComponent } from './FootprintManager.project_creation_form.component';
import { FootprintManager_project_update_formComponent } from './FootprintManager.project_update_form.component';
import { FootprintManager_purchase_order_copy_formComponent } from './FootprintManager.purchase_order_copy_form.component';
import { FootprintManager_purchase_order_creation_formComponent } from './FootprintManager.purchase_order_creation_form.component';
import { FootprintManager_reason_code_creation_formComponent } from './FootprintManager.reason_code_creation_form.component';
import { FootprintManager_return_order_creation_formComponent } from './FootprintManager.return_order_creation_form.component';
import { FootprintManager_sales_order_cancellation_options_formComponent } from './FootprintManager.sales_order_cancellation_options_form.component';
import { FootprintManager_sales_order_copy_formComponent } from './FootprintManager.sales_order_copy_form.component';
import { FootprintManager_sales_order_creation_formComponent } from './FootprintManager.sales_order_creation_form.component';
import { FootprintManager_sales_order_pick_task_cancellation_options_formComponent } from './FootprintManager.sales_order_pick_task_cancellation_options_form.component';
import { FootprintManager_sales_orders_processing_options_formComponent } from './FootprintManager.sales_orders_processing_options_form.component';
import { FootprintManager_select_pack_verification_location_formComponent } from './FootprintManager.select_pack_verification_location_form.component';
import { FootprintManager_select_user_formComponent } from './FootprintManager.select_user_form.component';
import { FootprintManager_temperature_capture_formComponent } from './FootprintManager.temperature_capture_form.component';
import { FootprintManager_transfer_licenseplate_formComponent } from './FootprintManager.transfer_licenseplate_form.component';
import { FootprintManager_transfer_transload_licenseplate_formComponent } from './FootprintManager.transfer_transload_licenseplate_form.component';
import { FootprintManager_transload_order_creation_formComponent } from './FootprintManager.transload_order_creation_form.component';
import { FootprintManager_unloading_formComponent } from './FootprintManager.unloading_form.component';
import { FootprintManager_unpicking_formComponent } from './FootprintManager.unpicking_form.component';
import { FootprintManager_unreceiving_all_options_formComponent } from './FootprintManager.unreceiving_all_options_form.component';
import { FootprintManager_unreceiving_single_taskId_formComponent } from './FootprintManager.unreceiving_single_taskId_form.component';
import { FootprintManager_vendorlot_creation_formComponent } from './FootprintManager.vendorlot_creation_form.component';
import { FootprintManager_warehouse_creation_formComponent } from './FootprintManager.warehouse_creation_form.component';
import { FootprintManager_warehouse_transfer_creation_formComponent } from './FootprintManager.warehouse_transfer_creation_form.component';
import { FootprintManager_wave_update_formComponent } from './FootprintManager.wave_update_form.component';
import { FootprintManager_work_class_creation_formComponent } from './FootprintManager.work_class_creation_form.component';
import { FootprintManager_work_order_creation_formComponent } from './FootprintManager.work_order_creation_form.component';
import { FootprintManager_workshift_formComponent } from './FootprintManager.workshift_form.component';
import { FootprintManager_asn_order_editorComponent } from './FootprintManager.asn_order_editor.component';
import { FootprintManager_billing_contract_editorComponent } from './FootprintManager.billing_contract_editor.component';
import { FootprintManager_billing_contract_line_editorComponent } from './FootprintManager.billing_contract_line_editor.component';
import { FootprintManager_billing_record_editorComponent } from './FootprintManager.billing_record_editor.component';
import { FootprintManager_carrier_editorComponent } from './FootprintManager.carrier_editor.component';
import { FootprintManager_carrierservicetype_editorComponent } from './FootprintManager.carrierservicetype_editor.component';
import { FootprintManager_count_task_editorComponent } from './FootprintManager.count_task_editor.component';
import { FootprintManager_dock_appointment_editorComponent } from './FootprintManager.dock_appointment_editor.component';
import { FootprintManager_dock_door_editorComponent } from './FootprintManager.dock_door_editor.component';
import { FootprintManager_inspection_task_editorComponent } from './FootprintManager.inspection_task_editor.component';
import { FootprintManager_inventory_count_editorComponent } from './FootprintManager.inventory_count_editor.component';
import { FootprintManager_inventory_transfer_editorComponent } from './FootprintManager.inventory_transfer_editor.component';
import { FootprintManager_inventory_transformation_editorComponent } from './FootprintManager.inventory_transformation_editor.component';
import { FootprintManager_inventory_transformation_source_line_editorComponent } from './FootprintManager.inventory_transformation_source_line_editor.component';
import { FootprintManager_inventory_transformation_target_line_editorComponent } from './FootprintManager.inventory_transformation_target_line_editor.component';
import { FootprintManager_invoice_editorComponent } from './FootprintManager.invoice_editor.component';
import { FootprintManager_licenseplate_editorComponent } from './FootprintManager.licenseplate_editor.component';
import { FootprintManager_load_container_add_ordersComponent } from './FootprintManager.load_container_add_orders.component';
import { FootprintManager_load_container_editorComponent } from './FootprintManager.load_container_editor.component';
import { FootprintManager_location_editorComponent } from './FootprintManager.location_editor.component';
import { FootprintManager_location_replenishment_editorComponent } from './FootprintManager.location_replenishment_editor.component';
import { FootprintManager_lot_editorComponent } from './FootprintManager.lot_editor.component';
import { FootprintManager_manufacturing_order_components_serial_numbers_pick_editorComponent } from './FootprintManager.manufacturing_order_components_serial_numbers_pick_editor.component';
import { FootprintManager_manufacturing_order_editorComponent } from './FootprintManager.manufacturing_order_editor.component';
import { FootprintManager_manufacturing_order_return_to_stock_editorComponent } from './FootprintManager.manufacturing_order_return_to_stock_editor.component';
import { FootprintManager_manufacturing_orders_create_serial_numbers_editorComponent } from './FootprintManager.manufacturing_orders_create_serial_numbers_editor.component';
import { FootprintManager_material_editorComponent } from './FootprintManager.material_editor.component';
import { FootprintManager_material_kit_editorComponent } from './FootprintManager.material_kit_editor.component';
import { FootprintManager_material_substitutions_editorComponent } from './FootprintManager.material_substitutions_editor.component';
import { FootprintManager_owner_editorComponent } from './FootprintManager.owner_editor.component';
import { FootprintManager_pack_verification_completion_editorComponent } from './FootprintManager.pack_verification_completion_editor.component';
import { FootprintManager_pack_verification_shipping_container_properties_editorComponent } from './FootprintManager.pack_verification_shipping_container_properties_editor.component';
import { FootprintManager_pack_verification_verify_container_editorComponent } from './FootprintManager.pack_verification_verify_container_editor.component';
import { FootprintManager_plan_editorComponent } from './FootprintManager.plan_editor.component';
import { FootprintManager_process_orderComponent } from './FootprintManager.process_order.component';
import { FootprintManager_project_editorComponent } from './FootprintManager.project_editor.component';
import { FootprintManager_purchase_order_editorComponent } from './FootprintManager.purchase_order_editor.component';
import { FootprintManager_reason_code_editorComponent } from './FootprintManager.reason_code_editor.component';
import { FootprintManager_return_order_editorComponent } from './FootprintManager.return_order_editor.component';
import { FootprintManager_sales_order_editorComponent } from './FootprintManager.sales_order_editor.component';
import { FootprintManager_sales_order_line_kit_editorComponent } from './FootprintManager.sales_order_line_kit_editor.component';
import { FootprintManager_serialnumber_editorComponent } from './FootprintManager.serialnumber_editor.component';
import { FootprintManager_shipping_container_editorComponent } from './FootprintManager.shipping_container_editor.component';
import { FootprintManager_task_assignment_editorComponent } from './FootprintManager.task_assignment_editor.component';
import { FootprintManager_task_details_editorComponent } from './FootprintManager.task_details_editor.component';
import { FootprintManager_transload_order_editorComponent } from './FootprintManager.transload_order_editor.component';
import { FootprintManager_warehouse_editorComponent } from './FootprintManager.warehouse_editor.component';
import { FootprintManager_warehouse_transfer_editorComponent } from './FootprintManager.warehouse_transfer_editor.component';
import { FootprintManager_warehouse_transfer_inbound_order_editorComponent } from './FootprintManager.warehouse_transfer_inbound_order_editor.component';
import { FootprintManager_warehouse_transfer_outbound_order_editorComponent } from './FootprintManager.warehouse_transfer_outbound_order_editor.component';
import { FootprintManager_wave_editorComponent } from './FootprintManager.wave_editor.component';
import { FootprintManager_work_class_editorComponent } from './FootprintManager.work_class_editor.component';
import { FootprintManager_work_order_editorComponent } from './FootprintManager.work_order_editor.component';
import { FootprintManager_workshift_editorComponent } from './FootprintManager.workshift_editor.component';
import { FootprintManager_accessorial_tasks_gridComponent } from './FootprintManager.accessorial_tasks_grid.component';
import { FootprintManager_accounts_gridComponent } from './FootprintManager.accounts_grid.component';
import { FootprintManager_activity_gridComponent } from './FootprintManager.activity_grid.component';
import { FootprintManager_allocation_configurations_gridComponent } from './FootprintManager.allocation_configurations_grid.component';
import { FootprintManager_asn_order_children_tasks_gridComponent } from './FootprintManager.asn_order_children_tasks_grid.component';
import { FootprintManager_asn_order_licenseplates_gridComponent } from './FootprintManager.asn_order_licenseplates_grid.component';
import { FootprintManager_asn_order_licenseplates_receiving_tasks_gridComponent } from './FootprintManager.asn_order_licenseplates_receiving_tasks_grid.component';
import { FootprintManager_asn_order_receiving_tasks_gridComponent } from './FootprintManager.asn_order_receiving_tasks_grid.component';
import { FootprintManager_asn_order_tasks_gridComponent } from './FootprintManager.asn_order_tasks_grid.component';
import { FootprintManager_asn_orderlines_gridComponent } from './FootprintManager.asn_orderlines_grid.component';
import { FootprintManager_assigned_orders_on_wave_gridComponent } from './FootprintManager.assigned_orders_on_wave_grid.component';
import { FootprintManager_audit_serial_numbers_gridComponent } from './FootprintManager.audit_serial_numbers_grid.component';
import { FootprintManager_available_inventory_gridComponent } from './FootprintManager.available_inventory_grid.component';
import { FootprintManager_billing_contract_lines_gridComponent } from './FootprintManager.billing_contract_lines_grid.component';
import { FootprintManager_billing_contracts_gridComponent } from './FootprintManager.billing_contracts_grid.component';
import { FootprintManager_billing_projects_gridComponent } from './FootprintManager.billing_projects_grid.component';
import { FootprintManager_billing_rates_gridComponent } from './FootprintManager.billing_rates_grid.component';
import { FootprintManager_billing_records_by_invoiceline_gridComponent } from './FootprintManager.billing_records_by_invoiceline_grid.component';
import { FootprintManager_billing_records_gridComponent } from './FootprintManager.billing_records_grid.component';
import { FootprintManager_billing_supplemental_fees_gridComponent } from './FootprintManager.billing_supplemental_fees_grid.component';
import { FootprintManager_blind_shipping_container_return_tasks_gridComponent } from './FootprintManager.blind_shipping_container_return_tasks_grid.component';
import { FootprintManager_carriers_gridComponent } from './FootprintManager.carriers_grid.component';
import { FootprintManager_carrierservices_gridComponent } from './FootprintManager.carrierservices_grid.component';
import { FootprintManager_carrierservicetypes_gridComponent } from './FootprintManager.carrierservicetypes_grid.component';
import { FootprintManager_child_serialnumbers_gridComponent } from './FootprintManager.child_serialnumbers_grid.component';
import { FootprintManager_contact_addresses_gridComponent } from './FootprintManager.contact_addresses_grid.component';
import { FootprintManager_container_type_assignment_gridComponent } from './FootprintManager.container_type_assignment_grid.component';
import { FootprintManager_container_types_gridComponent } from './FootprintManager.container_types_grid.component';
import { FootprintManager_count_tasks_gridComponent } from './FootprintManager.count_tasks_grid.component';
import { FootprintManager_count_tasks_no_filter_gridComponent } from './FootprintManager.count_tasks_no_filter_grid.component';
import { FootprintManager_customer_return_shipping_containers_gridComponent } from './FootprintManager.customer_return_shipping_containers_grid.component';
import { FootprintManager_dock_appointment_types_gridComponent } from './FootprintManager.dock_appointment_types_grid.component';
import { FootprintManager_dock_appointments_dashboard_gridComponent } from './FootprintManager.dock_appointments_dashboard_grid.component';
import { FootprintManager_dock_appointments_gridComponent } from './FootprintManager.dock_appointments_grid.component';
import { FootprintManager_dock_appointments_selection_gridComponent } from './FootprintManager.dock_appointments_selection_grid.component';
import { FootprintManager_entity_attachments_gridComponent } from './FootprintManager.entity_attachments_grid.component';
import { FootprintManager_entity_import_requests_gridComponent } from './FootprintManager.entity_import_requests_grid.component';
import { FootprintManager_entity_user_defined_field_values_gridComponent } from './FootprintManager.entity_user_defined_field_values_grid.component';
import { FootprintManager_field_selector_gridComponent } from './FootprintManager.field_selector_grid.component';
import { FootprintManager_footprint_events_gridComponent } from './FootprintManager.footprint_events_grid.component';
import { FootprintManager_inbound_orders_gridComponent } from './FootprintManager.inbound_orders_grid.component';
import { FootprintManager_inspection_operation_codes_gridComponent } from './FootprintManager.inspection_operation_codes_grid.component';
import { FootprintManager_inspection_tasks_gridComponent } from './FootprintManager.inspection_tasks_grid.component';
import { FootprintManager_instructions_gridComponent } from './FootprintManager.instructions_grid.component';
import { FootprintManager_inventory_by_licenseplate_selection_gridComponent } from './FootprintManager.inventory_by_licenseplate_selection_grid.component';
import { FootprintManager_inventory_by_licenseplate_single_selection_gridComponent } from './FootprintManager.inventory_by_licenseplate_single_selection_grid.component';
import { FootprintManager_inventory_by_location_selection_gridComponent } from './FootprintManager.inventory_by_location_selection_grid.component';
import { FootprintManager_inventory_by_lot_selection_gridComponent } from './FootprintManager.inventory_by_lot_selection_grid.component';
import { FootprintManager_inventory_by_lot_single_selection_gridComponent } from './FootprintManager.inventory_by_lot_single_selection_grid.component';
import { FootprintManager_inventory_by_serialnumber_selection_gridComponent } from './FootprintManager.inventory_by_serialnumber_selection_grid.component';
import { FootprintManager_inventory_by_serialnumber_single_selection_gridComponent } from './FootprintManager.inventory_by_serialnumber_single_selection_grid.component';
import { FootprintManager_inventory_counts_gridComponent } from './FootprintManager.inventory_counts_grid.component';
import { FootprintManager_inventory_licenseplate_gridComponent } from './FootprintManager.inventory_licenseplate_grid.component';
import { FootprintManager_inventory_licenseplate_snapshot_gridComponent } from './FootprintManager.inventory_licenseplate_snapshot_grid.component';
import { FootprintManager_inventory_location_gridComponent } from './FootprintManager.inventory_location_grid.component';
import { FootprintManager_inventory_lot_gridComponent } from './FootprintManager.inventory_lot_grid.component';
import { FootprintManager_inventory_lot_snapshot_gridComponent } from './FootprintManager.inventory_lot_snapshot_grid.component';
import { FootprintManager_inventory_material_gridComponent } from './FootprintManager.inventory_material_grid.component';
import { FootprintManager_inventory_material_snapshot_gridComponent } from './FootprintManager.inventory_material_snapshot_grid.component';
import { FootprintManager_inventory_measurement_units_gridComponent } from './FootprintManager.inventory_measurement_units_grid.component';
import { FootprintManager_inventory_parent_licenseplate_gridComponent } from './FootprintManager.inventory_parent_licenseplate_grid.component';
import { FootprintManager_inventory_statuses_gridComponent } from './FootprintManager.inventory_statuses_grid.component';
import { FootprintManager_inventory_tasks_gridComponent } from './FootprintManager.inventory_tasks_grid.component';
import { FootprintManager_inventory_transfer_intermediaries_gridComponent } from './FootprintManager.inventory_transfer_intermediaries_grid.component';
import { FootprintManager_inventory_transfer_lines_gridComponent } from './FootprintManager.inventory_transfer_lines_grid.component';
import { FootprintManager_inventory_transfers_gridComponent } from './FootprintManager.inventory_transfers_grid.component';
import { FootprintManager_inventory_transformation_source_lines_gridComponent } from './FootprintManager.inventory_transformation_source_lines_grid.component';
import { FootprintManager_inventory_transformation_source_lines_selector_by_licenseplate_gridComponent } from './FootprintManager.inventory_transformation_source_lines_selector_by_licenseplate_grid.component';
import { FootprintManager_inventory_transformation_source_lines_selector_by_location_gridComponent } from './FootprintManager.inventory_transformation_source_lines_selector_by_location_grid.component';
import { FootprintManager_inventory_transformation_source_lines_selector_by_lot_gridComponent } from './FootprintManager.inventory_transformation_source_lines_selector_by_lot_grid.component';
import { FootprintManager_inventory_transformation_source_lines_selector_by_material_gridComponent } from './FootprintManager.inventory_transformation_source_lines_selector_by_material_grid.component';
import { FootprintManager_inventory_transformation_source_lines_selector_by_serialnumbers_gridComponent } from './FootprintManager.inventory_transformation_source_lines_selector_by_serialnumbers_grid.component';
import { FootprintManager_inventory_transformation_target_lines_gridComponent } from './FootprintManager.inventory_transformation_target_lines_grid.component';
import { FootprintManager_inventory_transformations_gridComponent } from './FootprintManager.inventory_transformations_grid.component';
import { FootprintManager_invoice_lines_gridComponent } from './FootprintManager.invoice_lines_grid.component';
import { FootprintManager_invoices_gridComponent } from './FootprintManager.invoices_grid.component';
import { FootprintManager_licenseplate_gridComponent } from './FootprintManager.licenseplate_grid.component';
import { FootprintManager_load_container_orders_gridComponent } from './FootprintManager.load_container_orders_grid.component';
import { FootprintManager_load_container_unassigned_orders_gridComponent } from './FootprintManager.load_container_unassigned_orders_grid.component';
import { FootprintManager_load_containers_gridComponent } from './FootprintManager.load_containers_grid.component';
import { FootprintManager_location_projects_gridComponent } from './FootprintManager.location_projects_grid.component';
import { FootprintManager_locations_gridComponent } from './FootprintManager.locations_grid.component';
import { FootprintManager_locations_navigational_gridComponent } from './FootprintManager.locations_navigational_grid.component';
import { FootprintManager_locations_replenishments_gridComponent } from './FootprintManager.locations_replenishments_grid.component';
import { FootprintManager_locations_selector_gridComponent } from './FootprintManager.locations_selector_grid.component';
import { FootprintManager_lots_gridComponent } from './FootprintManager.lots_grid.component';
import { FootprintManager_lots_grid_flatComponent } from './FootprintManager.lots_grid_flat.component';
import { FootprintManager_lots_udf_gridComponent } from './FootprintManager.lots_udf_grid.component';
import { FootprintManager_manual_allocations_gridComponent } from './FootprintManager.manual_allocations_grid.component';
import { FootprintManager_manufacturing_equipment_gridComponent } from './FootprintManager.manufacturing_equipment_grid.component';
import { FootprintManager_manufacturing_locations_gridComponent } from './FootprintManager.manufacturing_locations_grid.component';
import { FootprintManager_manufacturing_order_component_serial_number_selection_gridComponent } from './FootprintManager.manufacturing_order_component_serial_number_selection_grid.component';
import { FootprintManager_manufacturing_order_line_components_production_confirmation_gridComponent } from './FootprintManager.manufacturing_order_line_components_production_confirmation_grid.component';
import { FootprintManager_manufacturing_order_line_production_confirmation_gridComponent } from './FootprintManager.manufacturing_order_line_production_confirmation_grid.component';
import { FootprintManager_manufacturing_order_lines_components_for_process_gridComponent } from './FootprintManager.manufacturing_order_lines_components_for_process_grid.component';
import { FootprintManager_manufacturing_order_lines_components_gridComponent } from './FootprintManager.manufacturing_order_lines_components_grid.component';
import { FootprintManager_manufacturing_order_lines_gridComponent } from './FootprintManager.manufacturing_order_lines_grid.component';
import { FootprintManager_manufacturing_order_lines_production_sub_components_gridComponent } from './FootprintManager.manufacturing_order_lines_production_sub_components_grid.component';
import { FootprintManager_manufacturing_order_return_to_stock_gridComponent } from './FootprintManager.manufacturing_order_return_to_stock_grid.component';
import { FootprintManager_manufacturing_order_undo_manufacturing_production_components_gridComponent } from './FootprintManager.manufacturing_order_undo_manufacturing_production_components_grid.component';
import { FootprintManager_manufacturing_order_undo_manufacturing_production_finished_product_gridComponent } from './FootprintManager.manufacturing_order_undo_manufacturing_production_finished_product_grid.component';
import { FootprintManager_manufacturing_orders_gridComponent } from './FootprintManager.manufacturing_orders_grid.component';
import { FootprintManager_manufacturing_orders_manufacturing_production_components_gridComponent } from './FootprintManager.manufacturing_orders_manufacturing_production_components_grid.component';
import { FootprintManager_manufacturing_orders_manufacturing_production_gridComponent } from './FootprintManager.manufacturing_orders_manufacturing_production_grid.component';
import { FootprintManager_manufacturing_workshifts_gridComponent } from './FootprintManager.manufacturing_workshifts_grid.component';
import { FootprintManager_material_aliases_gridComponent } from './FootprintManager.material_aliases_grid.component';
import { FootprintManager_material_catalog_source_material_project_subscribers_gridComponent } from './FootprintManager.material_catalog_source_material_project_subscribers_grid.component';
import { FootprintManager_material_catalog_source_materials_gridComponent } from './FootprintManager.material_catalog_source_materials_grid.component';
import { FootprintManager_material_catalogs_by_project_gridComponent } from './FootprintManager.material_catalogs_by_project_grid.component';
import { FootprintManager_material_catalogs_gridComponent } from './FootprintManager.material_catalogs_grid.component';
import { FootprintManager_material_catalogs_project_subscribers_gridComponent } from './FootprintManager.material_catalogs_project_subscribers_grid.component';
import { FootprintManager_material_components_gridComponent } from './FootprintManager.material_components_grid.component';
import { FootprintManager_material_kits_gridComponent } from './FootprintManager.material_kits_grid.component';
import { FootprintManager_material_packagings_by_project_gridComponent } from './FootprintManager.material_packagings_by_project_grid.component';
import { FootprintManager_material_packagings_gridComponent } from './FootprintManager.material_packagings_grid.component';
import { FootprintManager_material_substitutions_gridComponent } from './FootprintManager.material_substitutions_grid.component';
import { FootprintManager_materials_by_base_packaging_gridComponent } from './FootprintManager.materials_by_base_packaging_grid.component';
import { FootprintManager_materials_navigational_gridComponent } from './FootprintManager.materials_navigational_grid.component';
import { FootprintManager_materials_selector_gridComponent } from './FootprintManager.materials_selector_grid.component';
import { FootprintManager_materials_udf_gridComponent } from './FootprintManager.materials_udf_grid.component';
import { FootprintManager_orderaddresses_gridComponent } from './FootprintManager.orderaddresses_grid.component';
import { FootprintManager_outbound_orders_eligible_for_return_gridComponent } from './FootprintManager.outbound_orders_eligible_for_return_grid.component';
import { FootprintManager_outbound_orders_gridComponent } from './FootprintManager.outbound_orders_grid.component';
import { FootprintManager_owners_navigation_gridComponent } from './FootprintManager.owners_navigation_grid.component';
import { FootprintManager_ownersaccounts_gridComponent } from './FootprintManager.ownersaccounts_grid.component';
import { FootprintManager_ownerscarrierslookup_gridComponent } from './FootprintManager.ownerscarrierslookup_grid.component';
import { FootprintManager_pack_verification_instructions_gridComponent } from './FootprintManager.pack_verification_instructions_grid.component';
import { FootprintManager_pack_verification_shipping_container_contents_gridComponent } from './FootprintManager.pack_verification_shipping_container_contents_grid.component';
import { FootprintManager_pallet_classes_gridComponent } from './FootprintManager.pallet_classes_grid.component';
import { FootprintManager_pallet_inventory_by_class_gridComponent } from './FootprintManager.pallet_inventory_by_class_grid.component';
import { FootprintManager_pallet_inventory_by_project_gridComponent } from './FootprintManager.pallet_inventory_by_project_grid.component';
import { FootprintManager_pallet_transactions_gridComponent } from './FootprintManager.pallet_transactions_grid.component';
import { FootprintManager_pallet_transactions_shipment_gridComponent } from './FootprintManager.pallet_transactions_shipment_grid.component';
import { FootprintManager_pick_slips_gridComponent } from './FootprintManager.pick_slips_grid.component';
import { FootprintManager_pick_waves_expanded_gridComponent } from './FootprintManager.pick_waves_expanded_grid.component';
import { FootprintManager_pick_waves_gridComponent } from './FootprintManager.pick_waves_grid.component';
import { FootprintManager_plans_gridComponent } from './FootprintManager.plans_grid.component';
import { FootprintManager_primary_picks_gridComponent } from './FootprintManager.primary_picks_grid.component';
import { FootprintManager_projects_gridComponent } from './FootprintManager.projects_grid.component';
import { FootprintManager_purchase_order_bulk_receiving_by_taskId_gridComponent } from './FootprintManager.purchase_order_bulk_receiving_by_taskId_grid.component';
import { FootprintManager_purchase_order_children_tasks_gridComponent } from './FootprintManager.purchase_order_children_tasks_grid.component';
import { FootprintManager_purchase_order_lines_gridComponent } from './FootprintManager.purchase_order_lines_grid.component';
import { FootprintManager_purchase_order_received_inventory_gridComponent } from './FootprintManager.purchase_order_received_inventory_grid.component';
import { FootprintManager_purchase_order_receiving_gridComponent } from './FootprintManager.purchase_order_receiving_grid.component';
import { FootprintManager_purchase_order_tasks_gridComponent } from './FootprintManager.purchase_order_tasks_grid.component';
import { FootprintManager_reason_codes_gridComponent } from './FootprintManager.reason_codes_grid.component';
import { FootprintManager_replenishment_inventory_licenseplate_gridComponent } from './FootprintManager.replenishment_inventory_licenseplate_grid.component';
import { FootprintManager_replenishment_tasks_gridComponent } from './FootprintManager.replenishment_tasks_grid.component';
import { FootprintManager_return_order_lines_gridComponent } from './FootprintManager.return_order_lines_grid.component';
import { FootprintManager_return_orders_gridComponent } from './FootprintManager.return_orders_grid.component';
import { FootprintManager_return_shipping_containers_gridComponent } from './FootprintManager.return_shipping_containers_grid.component';
import { FootprintManager_sales_order_children_tasks_gridComponent } from './FootprintManager.sales_order_children_tasks_grid.component';
import { FootprintManager_sales_order_line_components_gridComponent } from './FootprintManager.sales_order_line_components_grid.component';
import { FootprintManager_sales_order_line_kit_gridComponent } from './FootprintManager.sales_order_line_kit_grid.component';
import { FootprintManager_sales_order_line_substitutions_gridComponent } from './FootprintManager.sales_order_line_substitutions_grid.component';
import { FootprintManager_sales_order_lines_gridComponent } from './FootprintManager.sales_order_lines_grid.component';
import { FootprintManager_sales_order_picking_gridComponent } from './FootprintManager.sales_order_picking_grid.component';
import { FootprintManager_sales_order_tasks_gridComponent } from './FootprintManager.sales_order_tasks_grid.component';
import { FootprintManager_scanned_values_gridComponent } from './FootprintManager.scanned_values_grid.component';
import { FootprintManager_serialnumbers_creation_gridComponent } from './FootprintManager.serialnumbers_creation_grid.component';
import { FootprintManager_serialnumbers_gridComponent } from './FootprintManager.serialnumbers_grid.component';
import { FootprintManager_serialnumbers_modification_gridComponent } from './FootprintManager.serialnumbers_modification_grid.component';
import { FootprintManager_serialnumbers_selection_gridComponent } from './FootprintManager.serialnumbers_selection_grid.component';
import { FootprintManager_shipping_container_tasks_child_gridComponent } from './FootprintManager.shipping_container_tasks_child_grid.component';
import { FootprintManager_shipping_container_tasks_gridComponent } from './FootprintManager.shipping_container_tasks_grid.component';
import { FootprintManager_shipping_containers_gridComponent } from './FootprintManager.shipping_containers_grid.component';
import { FootprintManager_shipping_containers_to_verify_gridComponent } from './FootprintManager.shipping_containers_to_verify_grid.component';
import { FootprintManager_shippingcontents_gridComponent } from './FootprintManager.shippingcontents_grid.component';
import { FootprintManager_storage_categories_gridComponent } from './FootprintManager.storage_categories_grid.component';
import { FootprintManager_storage_category_rules_gridComponent } from './FootprintManager.storage_category_rules_grid.component';
import { FootprintManager_submitted_survey_inputs_gridComponent } from './FootprintManager.submitted_survey_inputs_grid.component';
import { FootprintManager_submitted_surveys_gridComponent } from './FootprintManager.submitted_surveys_grid.component';
import { FootprintManager_support_tests_gridComponent } from './FootprintManager.support_tests_grid.component';
import { FootprintManager_survey_grid_input_values_gridComponent } from './FootprintManager.survey_grid_input_values_grid.component';
import { FootprintManager_task_assignment_gridComponent } from './FootprintManager.task_assignment_grid.component';
import { FootprintManager_temperature_capture_reading_points_gridComponent } from './FootprintManager.temperature_capture_reading_points_grid.component';
import { FootprintManager_temperature_capture_reading_types_gridComponent } from './FootprintManager.temperature_capture_reading_types_grid.component';
import { FootprintManager_temperature_readings_gridComponent } from './FootprintManager.temperature_readings_grid.component';
import { FootprintManager_transload_order_lines_gridComponent } from './FootprintManager.transload_order_lines_grid.component';
import { FootprintManager_transload_order_received_inventory_gridComponent } from './FootprintManager.transload_order_received_inventory_grid.component';
import { FootprintManager_transload_order_receiving_gridComponent } from './FootprintManager.transload_order_receiving_grid.component';
import { FootprintManager_transload_orders_gridComponent } from './FootprintManager.transload_orders_grid.component';
import { FootprintManager_transload_outbound_shipments_gridComponent } from './FootprintManager.transload_outbound_shipments_grid.component';
import { FootprintManager_vendorlots_selector_gridComponent } from './FootprintManager.vendorlots_selector_grid.component';
import { FootprintManager_warehouse_transfer_inbound_licenseplates_gridComponent } from './FootprintManager.warehouse_transfer_inbound_licenseplates_grid.component';
import { FootprintManager_warehouse_transfer_inbound_order_licenseplates_receiving_tasks_gridComponent } from './FootprintManager.warehouse_transfer_inbound_order_licenseplates_receiving_tasks_grid.component';
import { FootprintManager_warehouse_transfer_inbound_order_receiving_tasks_gridComponent } from './FootprintManager.warehouse_transfer_inbound_order_receiving_tasks_grid.component';
import { FootprintManager_warehouse_transfer_inbound_orderlines_gridComponent } from './FootprintManager.warehouse_transfer_inbound_orderlines_grid.component';
import { FootprintManager_warehouse_transfer_outbound_order_lines_gridComponent } from './FootprintManager.warehouse_transfer_outbound_order_lines_grid.component';
import { FootprintManager_warehouse_transfer_outbound_order_manual_allocations_gridComponent } from './FootprintManager.warehouse_transfer_outbound_order_manual_allocations_grid.component';
import { FootprintManager_warehouse_transfer_outbound_order_shippingcontents_gridComponent } from './FootprintManager.warehouse_transfer_outbound_order_shippingcontents_grid.component';
import { FootprintManager_warehouse_transfer_picking_gridComponent } from './FootprintManager.warehouse_transfer_picking_grid.component';
import { FootprintManager_warehouse_transfers_gridComponent } from './FootprintManager.warehouse_transfers_grid.component';
import { FootprintManager_warehouses_navigation_gridComponent } from './FootprintManager.warehouses_navigation_grid.component';
import { FootprintManager_wave_creation_gridComponent } from './FootprintManager.wave_creation_grid.component';
import { FootprintManager_work_class_operation_codes_gridComponent } from './FootprintManager.work_class_operation_codes_grid.component';
import { FootprintManager_work_class_users_gridComponent } from './FootprintManager.work_class_users_grid.component';
import { FootprintManager_work_classes_gridComponent } from './FootprintManager.work_classes_grid.component';
import { FootprintManager_work_orders_gridComponent } from './FootprintManager.work_orders_grid.component';
import { FootprintManager_activity_hubComponent } from './FootprintManager.activity_hub.component';
import { FootprintManager_allocation_configurations_hubComponent } from './FootprintManager.allocation_configurations_hub.component';
import { FootprintManager_audit_serial_numbers_hubComponent } from './FootprintManager.audit_serial_numbers_hub.component';
import { FootprintManager_billing_contracts_hubComponent } from './FootprintManager.billing_contracts_hub.component';
import { FootprintManager_billing_records_hubComponent } from './FootprintManager.billing_records_hub.component';
import { FootprintManager_blind_return_shipping_container_hubComponent } from './FootprintManager.blind_return_shipping_container_hub.component';
import { FootprintManager_carrier_management_hubComponent } from './FootprintManager.carrier_management_hub.component';
import { FootprintManager_configurations_inventory_hubComponent } from './FootprintManager.configurations_inventory_hub.component';
import { FootprintManager_configurations_storage_categories_hubComponent } from './FootprintManager.configurations_storage_categories_hub.component';
import { FootprintManager_dock_appointments_hubComponent } from './FootprintManager.dock_appointments_hub.component';
import { FootprintManager_dock_doors_hubComponent } from './FootprintManager.dock_doors_hub.component';
import { FootprintManager_driver_check_out_hubComponent } from './FootprintManager.driver_check_out_hub.component';
import { FootprintManager_entity_import_hubComponent } from './FootprintManager.entity_import_hub.component';
import { FootprintManager_footprint_events_hubComponent } from './FootprintManager.footprint_events_hub.component';
import { FootprintManager_inbound_orders_hubComponent } from './FootprintManager.inbound_orders_hub.component';
import { FootprintManager_inspections_hubComponent } from './FootprintManager.inspections_hub.component';
import { FootprintManager_inventory_counts_hubComponent } from './FootprintManager.inventory_counts_hub.component';
import { FootprintManager_inventory_hubComponent } from './FootprintManager.inventory_hub.component';
import { FootprintManager_inventory_transfers_hubComponent } from './FootprintManager.inventory_transfers_hub.component';
import { FootprintManager_inventory_transformations_hubComponent } from './FootprintManager.inventory_transformations_hub.component';
import { FootprintManager_invoices_hubComponent } from './FootprintManager.invoices_hub.component';
import { FootprintManager_labor_management_hubComponent } from './FootprintManager.labor_management_hub.component';
import { FootprintManager_load_containers_hubComponent } from './FootprintManager.load_containers_hub.component';
import { FootprintManager_lots_hubComponent } from './FootprintManager.lots_hub.component';
import { FootprintManager_manufacturing_configuration_hubComponent } from './FootprintManager.manufacturing_configuration_hub.component';
import { FootprintManager_manufacturing_locations_hubComponent } from './FootprintManager.manufacturing_locations_hub.component';
import { FootprintManager_manufacturing_orders_hubComponent } from './FootprintManager.manufacturing_orders_hub.component';
import { FootprintManager_material_attachments_hubComponent } from './FootprintManager.material_attachments_hub.component';
import { FootprintManager_material_catalogs_hubComponent } from './FootprintManager.material_catalogs_hub.component';
import { FootprintManager_materials_hubComponent } from './FootprintManager.materials_hub.component';
import { FootprintManager_orders_attachments_hubComponent } from './FootprintManager.orders_attachments_hub.component';
import { FootprintManager_orders_hubComponent } from './FootprintManager.orders_hub.component';
import { FootprintManager_outbound_orders_hubComponent } from './FootprintManager.outbound_orders_hub.component';
import { FootprintManager_owners_and_projects_hubComponent } from './FootprintManager.owners_and_projects_hub.component';
import { FootprintManager_owners_hubComponent } from './FootprintManager.owners_hub.component';
import { FootprintManager_pack_verification_hubComponent } from './FootprintManager.pack_verification_hub.component';
import { FootprintManager_projects_hubComponent } from './FootprintManager.projects_hub.component';
import { FootprintManager_replenishment_hubComponent } from './FootprintManager.replenishment_hub.component';
import { FootprintManager_returns_hubComponent } from './FootprintManager.returns_hub.component';
import { FootprintManager_serialnumbers_hubComponent } from './FootprintManager.serialnumbers_hub.component';
import { FootprintManager_shipping_containers_hubComponent } from './FootprintManager.shipping_containers_hub.component';
import { FootprintManager_single_licenseplate_hubComponent } from './FootprintManager.single_licenseplate_hub.component';
import { FootprintManager_single_location_hubComponent } from './FootprintManager.single_location_hub.component';
import { FootprintManager_single_lot_hubComponent } from './FootprintManager.single_lot_hub.component';
import { FootprintManager_single_material_catalog_source_material_hubComponent } from './FootprintManager.single_material_catalog_source_material_hub.component';
import { FootprintManager_single_material_hubComponent } from './FootprintManager.single_material_hub.component';
import { FootprintManager_single_owner_hubComponent } from './FootprintManager.single_owner_hub.component';
import { FootprintManager_single_parent_licenseplate_hubComponent } from './FootprintManager.single_parent_licenseplate_hub.component';
import { FootprintManager_single_project_hubComponent } from './FootprintManager.single_project_hub.component';
import { FootprintManager_single_serialnumber_hubComponent } from './FootprintManager.single_serialnumber_hub.component';
import { FootprintManager_single_survey_hubComponent } from './FootprintManager.single_survey_hub.component';
import { FootprintManager_single_warehouse_hubComponent } from './FootprintManager.single_warehouse_hub.component';
import { FootprintManager_single_wave_hubComponent } from './FootprintManager.single_wave_hub.component';
import { FootprintManager_support_tests_hubComponent } from './FootprintManager.support_tests_hub.component';
import { FootprintManager_surveys_hubComponent } from './FootprintManager.surveys_hub.component';
import { FootprintManager_transload_orders_hubComponent } from './FootprintManager.transload_orders_hub.component';
import { FootprintManager_warehouse_transfers_hubComponent } from './FootprintManager.warehouse_transfers_hub.component';
import { FootprintManager_warehouses_hubComponent } from './FootprintManager.warehouses_hub.component';
import { FootprintManager_waves_hubComponent } from './FootprintManager.waves_hub.component';
import { FootprintManager_work_classes_hubComponent } from './FootprintManager.work_classes_hub.component';
import { FootprintManager_work_orders_hubComponent } from './FootprintManager.work_orders_hub.component';
import { FootprintManager_dock_appointments_calendarComponent } from './FootprintManager.dock_appointments_calendar.component';
import { FootprintManager_manufacturing_orders_calendarComponent } from './FootprintManager.manufacturing_orders_calendar.component';
import { FootprintManager_dock_appointment_selection_wizardComponent } from './FootprintManager.dock_appointment_selection_wizard.component';
import { FootprintManager_inventory_by_location_selection_wizardComponent } from './FootprintManager.inventory_by_location_selection_wizard.component';
import { FootprintManager_inventory_by_lot_selection_wizardComponent } from './FootprintManager.inventory_by_lot_selection_wizard.component';
import { FootprintManager_inventory_by_lot_single_selection_wizardComponent } from './FootprintManager.inventory_by_lot_single_selection_wizard.component';
import { FootprintManager_inventory_by_lp_selection_wizardComponent } from './FootprintManager.inventory_by_lp_selection_wizard.component';
import { FootprintManager_inventory_by_lp_single_selection_wizardComponent } from './FootprintManager.inventory_by_lp_single_selection_wizard.component';
import { FootprintManager_inventory_by_serialnumber_selection_wizardComponent } from './FootprintManager.inventory_by_serialnumber_selection_wizard.component';
import { FootprintManager_inventory_by_serialnumber_single_selection_wizardComponent } from './FootprintManager.inventory_by_serialnumber_single_selection_wizard.component';
import { FootprintManager_inventory_transformation_advanced_wizardComponent } from './FootprintManager.inventory_transformation_advanced_wizard.component';
import { FootprintManager_inventory_transformation_quick_wizardComponent } from './FootprintManager.inventory_transformation_quick_wizard.component';
import { FootprintManager_manufacturing_order_production_confirmation_undo_wizardComponent } from './FootprintManager.manufacturing_order_production_confirmation_undo_wizard.component';
import { FootprintManager_manufacturing_order_production_confirmation_wizardComponent } from './FootprintManager.manufacturing_order_production_confirmation_wizard.component';
import { FootprintManager_pack_verification_wizardComponent } from './FootprintManager.pack_verification_wizard.component';
import { FootprintManager_purchase_order_bulk_receiving_by_taskId_wizardComponent } from './FootprintManager.purchase_order_bulk_receiving_by_taskId_wizard.component';
import { FootprintManager_billing_record_activity_listComponent } from './FootprintManager.billing_record_activity_list.component';
import { FootprintManager_count_tasks_listComponent } from './FootprintManager.count_tasks_list.component';
import { FootprintManager_dock_appointment_activity_listComponent } from './FootprintManager.dock_appointment_activity_list.component';
import { FootprintManager_dock_doors_listComponent } from './FootprintManager.dock_doors_list.component';
import { FootprintManager_licenseplate_listComponent } from './FootprintManager.licenseplate_list.component';
import { FootprintManager_licenseplatecontent_listComponent } from './FootprintManager.licenseplatecontent_list.component';
import { FootprintManager_licenseplates_by_shipping_container_listComponent } from './FootprintManager.licenseplates_by_shipping_container_list.component';
import { FootprintManager_shipping_containers_listComponent } from './FootprintManager.shipping_containers_list.component';
import { FootprintManager_view_xml_payloadComponent } from './FootprintManager.view_xml_payload.component';
import { FootprintManager_dock_door_visualizationComponent } from './FootprintManager.dock_door_visualization.component';
import { FootprintManager_commercial_invoice_contentComponent } from './FootprintManager.commercial_invoice_content.component';
import { FootprintManager_shipping_label_contentComponent } from './FootprintManager.shipping_label_content.component';
import { FootprintManager_archived_options_dd_singleComponent } from './FootprintManager.archived_options_dd_single.component';
import { FootprintManager_daysOfWeek_zt_singleComponent } from './FootprintManager.daysOfWeek_zt_single.component';
import { FootprintManager_enabled_disabled_toggle_dd_singleComponent } from './FootprintManager.enabled_disabled_toggle_dd_single.component';
import { FootprintManager_footprint_events_statuses_dd_singleComponent } from './FootprintManager.footprint_events_statuses_dd_single.component';
import { FootprintManager_footprint_events_type_dd_singleComponent } from './FootprintManager.footprint_events_type_dd_single.component';
import { FootprintManager_hourly_options_dd_singleComponent } from './FootprintManager.hourly_options_dd_single.component';
import { FootprintManager_inventory_count_statuses_dd_alt_singleComponent } from './FootprintManager.inventory_count_statuses_dd_alt_single.component';
import { FootprintManager_kit_view_sales_order_lines_singleComponent } from './FootprintManager.kit_view_sales_order_lines_single.component';
import { FootprintManager_lots_dd_singleComponent } from './FootprintManager.lots_dd_single.component';
import { FootprintManager_manufacturing_output_locations_dd_singleComponent } from './FootprintManager.manufacturing_output_locations_dd_single.component';
import { FootprintManager_manufacturing_output_locations_simple_dd_singleComponent } from './FootprintManager.manufacturing_output_locations_simple_dd_single.component';
import { FootprintManager_manufacturing_staging_locations_dd_singleComponent } from './FootprintManager.manufacturing_staging_locations_dd_single.component';
import { FootprintManager_material_type_dd_singleComponent } from './FootprintManager.material_type_dd_single.component';
import { FootprintManager_monthsOfYear_zt_singleComponent } from './FootprintManager.monthsOfYear_zt_single.component';
import { FootprintManager_orderclasses_inbound_dd_singleComponent } from './FootprintManager.orderclasses_inbound_dd_single.component';
import { FootprintManager_orders_by_project_dd_singleComponent } from './FootprintManager.orders_by_project_dd_single.component';
import { FootprintManager_pallet_classes_dd_singleComponent } from './FootprintManager.pallet_classes_dd_single.component';
import { FootprintManager_print_order_labels_options_dd_singleComponent } from './FootprintManager.print_order_labels_options_dd_single.component';
import { FootprintManager_reason_code_parent_entities_dd_singleComponent } from './FootprintManager.reason_code_parent_entities_dd_single.component';
import { FootprintManager_reason_code_parent_entity_ids_dd_singleComponent } from './FootprintManager.reason_code_parent_entity_ids_dd_single.component';
import { FootprintManager_reason_codes_dd_singleComponent } from './FootprintManager.reason_codes_dd_single.component';
import { FootprintManager_support_tests_dd_singleComponent } from './FootprintManager.support_tests_dd_single.component';
import { FootprintManager_vendorlots_dd_singleComponent } from './FootprintManager.vendorlots_dd_single.component';
import { FootprintManager_weight_field_dd_singleComponent } from './FootprintManager.weight_field_dd_single.component';
import { FootprintManager_archived_options_dd_multiComponent } from './FootprintManager.archived_options_dd_multi.component';
import { FootprintManager_daysOfWeek_zt_multiComponent } from './FootprintManager.daysOfWeek_zt_multi.component';
import { FootprintManager_enabled_disabled_toggle_dd_multiComponent } from './FootprintManager.enabled_disabled_toggle_dd_multi.component';
import { FootprintManager_footprint_events_statuses_dd_multiComponent } from './FootprintManager.footprint_events_statuses_dd_multi.component';
import { FootprintManager_footprint_events_type_dd_multiComponent } from './FootprintManager.footprint_events_type_dd_multi.component';
import { FootprintManager_hourly_options_dd_multiComponent } from './FootprintManager.hourly_options_dd_multi.component';
import { FootprintManager_inventory_count_statuses_dd_alt_multiComponent } from './FootprintManager.inventory_count_statuses_dd_alt_multi.component';
import { FootprintManager_kit_view_sales_order_lines_multiComponent } from './FootprintManager.kit_view_sales_order_lines_multi.component';
import { FootprintManager_lots_dd_multiComponent } from './FootprintManager.lots_dd_multi.component';
import { FootprintManager_manufacturing_output_locations_dd_multiComponent } from './FootprintManager.manufacturing_output_locations_dd_multi.component';
import { FootprintManager_manufacturing_output_locations_simple_dd_multiComponent } from './FootprintManager.manufacturing_output_locations_simple_dd_multi.component';
import { FootprintManager_manufacturing_staging_locations_dd_multiComponent } from './FootprintManager.manufacturing_staging_locations_dd_multi.component';
import { FootprintManager_material_type_dd_multiComponent } from './FootprintManager.material_type_dd_multi.component';
import { FootprintManager_monthsOfYear_zt_multiComponent } from './FootprintManager.monthsOfYear_zt_multi.component';
import { FootprintManager_orderclasses_inbound_dd_multiComponent } from './FootprintManager.orderclasses_inbound_dd_multi.component';
import { FootprintManager_orders_by_project_dd_multiComponent } from './FootprintManager.orders_by_project_dd_multi.component';
import { FootprintManager_pallet_classes_dd_multiComponent } from './FootprintManager.pallet_classes_dd_multi.component';
import { FootprintManager_print_order_labels_options_dd_multiComponent } from './FootprintManager.print_order_labels_options_dd_multi.component';
import { FootprintManager_reason_code_parent_entities_dd_multiComponent } from './FootprintManager.reason_code_parent_entities_dd_multi.component';
import { FootprintManager_reason_code_parent_entity_ids_dd_multiComponent } from './FootprintManager.reason_code_parent_entity_ids_dd_multi.component';
import { FootprintManager_reason_codes_dd_multiComponent } from './FootprintManager.reason_codes_dd_multi.component';
import { FootprintManager_support_tests_dd_multiComponent } from './FootprintManager.support_tests_dd_multi.component';
import { FootprintManager_vendorlots_dd_multiComponent } from './FootprintManager.vendorlots_dd_multi.component';
import { FootprintManager_weight_field_dd_multiComponent } from './FootprintManager.weight_field_dd_multi.component';
import { FootprintManager_manufacturing_order_serial_number_selector_current_component_widgetComponent } from './FootprintManager.manufacturing_order_serial_number_selector_current_component_widget.component';
import { FootprintManager_manufacturing_order_serial_number_selector_total_components_widgetComponent } from './FootprintManager.manufacturing_order_serial_number_selector_total_components_widget.component';
import { FootprintManager_scheduled_for_today_widgetComponent } from './FootprintManager.scheduled_for_today_widget.component';
import { FootprintManager_billing_record_activity_cardComponent } from './FootprintManager.billing_record_activity_card.component';
import { FootprintManager_count_task_cardComponent } from './FootprintManager.count_task_card.component';
import { FootprintManager_dock_appoinment_activity_cardComponent } from './FootprintManager.dock_appoinment_activity_card.component';
import { FootprintManager_dock_appointment_cardComponent } from './FootprintManager.dock_appointment_card.component';
import { FootprintManager_dock_door_cardComponent } from './FootprintManager.dock_door_card.component';
import { FootprintManager_licenseplate_cardComponent } from './FootprintManager.licenseplate_card.component';
import { FootprintManager_licenseplate_content_cardComponent } from './FootprintManager.licenseplate_content_card.component';
import { FootprintManager_licenseplate_with_content_cardComponent } from './FootprintManager.licenseplate_with_content_card.component';
import { FootprintManager_manufacturing_orders_for_calendar_cardComponent } from './FootprintManager.manufacturing_orders_for_calendar_card.component';
import { FootprintManager_shipping_container_cardComponent } from './FootprintManager.shipping_container_card.component';

import { Document360_ShellService } from './Document360.shell.service';
import { Usersnap_ShellService } from './Usersnap.shell.service';
import { Utilities_ShellService } from './Utilities.shell.service';
import { Addresses_ShellService } from './Addresses.shell.service';
import { BarcodeParsing_ShellService } from './BarcodeParsing.shell.service';
import { BarTender_ShellService } from './BarTender.shell.service';
import { Catalogs_ShellService } from './Catalogs.shell.service';
import { Discussions_ShellService } from './Discussions.shell.service';
import { DockAppointments_ShellService } from './DockAppointments.shell.service';
import { EntityImport_ShellService } from './EntityImport.shell.service';
import { Equipment_ShellService } from './Equipment.shell.service';
import { ExcelInventoryImport_ShellService } from './ExcelInventoryImport.shell.service';
import { ExcelLocationImport_ShellService } from './ExcelLocationImport.shell.service';
import { ExcelMaterialImport_ShellService } from './ExcelMaterialImport.shell.service';
import { ExcelProjectImport_ShellService } from './ExcelProjectImport.shell.service';
import { Inspections_ShellService } from './Inspections.shell.service';
import { InventoryTransfers_ShellService } from './InventoryTransfers.shell.service';
import { LaborManagement_ShellService } from './LaborManagement.shell.service';
import { LoadContainers_ShellService } from './LoadContainers.shell.service';
import { Owners_ShellService } from './Owners.shell.service';
import { PalletTransactions_ShellService } from './PalletTransactions.shell.service';
import { PrimaryPicks_ShellService } from './PrimaryPicks.shell.service';
import { Replenishments_ShellService } from './Replenishments.shell.service';
import { Returns_ShellService } from './Returns.shell.service';
import { Surveys_ShellService } from './Surveys.shell.service';
import { TemperatureReadings_ShellService } from './TemperatureReadings.shell.service';
import { TransloadOrders_ShellService } from './TransloadOrders.shell.service';
import { WarehouseTransfers_ShellService } from './WarehouseTransfers.shell.service';
import { Waves_ShellService } from './Waves.shell.service';
import { Instructions_ShellService } from './Instructions.shell.service';
import { WorkOrders_ShellService } from './WorkOrders.shell.service';
import { InventoryCounts_ShellService } from './InventoryCounts.shell.service';
import { ShippingContainers_ShellService } from './ShippingContainers.shell.service';
import { Materials_ShellService } from './Materials.shell.service';
import { Carriers_ShellService } from './Carriers.shell.service';
import { Locations_ShellService } from './Locations.shell.service';
import { PurchaseOrders_ShellService } from './PurchaseOrders.shell.service';
import { Allocations_ShellService } from './Allocations.shell.service';
import { PrintNode_ShellService } from './PrintNode.shell.service';
import { SerialNumbers_ShellService } from './SerialNumbers.shell.service';
import { Lots_ShellService } from './Lots.shell.service';
import { Inventory_ShellService } from './Inventory.shell.service';
import { AsnOrders_ShellService } from './AsnOrders.shell.service';
import { ExcelOrderImport_ShellService } from './ExcelOrderImport.shell.service';
import { Attachments_ShellService } from './Attachments.shell.service';
import { Cartonization_ShellService } from './Cartonization.shell.service';
import { Invoices_ShellService } from './Invoices.shell.service';
import { Notifications_ShellService } from './Notifications.shell.service';
import { InventoryTransformations_ShellService } from './InventoryTransformations.shell.service';
import { Manifesting_ShellService } from './Manifesting.shell.service';
import { PackVerification_ShellService } from './PackVerification.shell.service';
import { SalesOrders_ShellService } from './SalesOrders.shell.service';
import { Manufacturing_ShellService } from './Manufacturing.shell.service';

@Injectable({ providedIn: 'root' })
export class FootprintManager_ShellService extends WavelengthShellService  {
  constructor(
    dialog : MatDialog,
    toastr: ToastrService,
    private $logger: CleanupLoggerService,
    public Document360: Document360_ShellService,
    public Usersnap: Usersnap_ShellService,
    public Utilities: Utilities_ShellService,
    public Addresses: Addresses_ShellService,
    public BarcodeParsing: BarcodeParsing_ShellService,
    public BarTender: BarTender_ShellService,
    public Catalogs: Catalogs_ShellService,
    public Discussions: Discussions_ShellService,
    public DockAppointments: DockAppointments_ShellService,
    public EntityImport: EntityImport_ShellService,
    public Equipment: Equipment_ShellService,
    public ExcelInventoryImport: ExcelInventoryImport_ShellService,
    public ExcelLocationImport: ExcelLocationImport_ShellService,
    public ExcelMaterialImport: ExcelMaterialImport_ShellService,
    public ExcelProjectImport: ExcelProjectImport_ShellService,
    public Inspections: Inspections_ShellService,
    public InventoryTransfers: InventoryTransfers_ShellService,
    public LaborManagement: LaborManagement_ShellService,
    public LoadContainers: LoadContainers_ShellService,
    public Owners: Owners_ShellService,
    public PalletTransactions: PalletTransactions_ShellService,
    public PrimaryPicks: PrimaryPicks_ShellService,
    public Replenishments: Replenishments_ShellService,
    public Returns: Returns_ShellService,
    public Surveys: Surveys_ShellService,
    public TemperatureReadings: TemperatureReadings_ShellService,
    public TransloadOrders: TransloadOrders_ShellService,
    public WarehouseTransfers: WarehouseTransfers_ShellService,
    public Waves: Waves_ShellService,
    public Instructions: Instructions_ShellService,
    public WorkOrders: WorkOrders_ShellService,
    public InventoryCounts: InventoryCounts_ShellService,
    public ShippingContainers: ShippingContainers_ShellService,
    public Materials: Materials_ShellService,
    public Carriers: Carriers_ShellService,
    public Locations: Locations_ShellService,
    public PurchaseOrders: PurchaseOrders_ShellService,
    public Allocations: Allocations_ShellService,
    public PrintNode: PrintNode_ShellService,
    public SerialNumbers: SerialNumbers_ShellService,
    public Lots: Lots_ShellService,
    public Inventory: Inventory_ShellService,
    public AsnOrders: AsnOrders_ShellService,
    public ExcelOrderImport: ExcelOrderImport_ShellService,
    public Attachments: Attachments_ShellService,
    public Cartonization: Cartonization_ShellService,
    public Invoices: Invoices_ShellService,
    public Notifications: Notifications_ShellService,
    public InventoryTransformations: InventoryTransformations_ShellService,
    public Manifesting: Manifesting_ShellService,
    public PackVerification: PackVerification_ShellService,
    public SalesOrders: SalesOrders_ShellService,
    public Manufacturing: Manufacturing_ShellService,
  ) {
    super(dialog, toastr);
  }

  public FootprintManager: FootprintManager_ShellService = this;

  public openasn_order_creation_form(inParams:{ projectId?: number, ownerId?: number, warehouseId?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'New ASN order',
        referenceName: 'FootprintManager_asn_order_creation_form',
        component: FootprintManager_asn_order_creation_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openasn_order_creation_formDialog(
    inParams:{ projectId?: number, ownerId?: number, warehouseId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_asn_order_creation_formComponent,
      'New ASN order',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openasn_order_transfer_outstanding_options_form(replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'ASN Order Transfer Outstanding Options',
        referenceName: 'FootprintManager_asn_order_transfer_outstanding_options_form',
        component: FootprintManager_asn_order_transfer_outstanding_options_formComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openasn_order_transfer_outstanding_options_formDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean, createNewOrder?: boolean, notes?: string, copyUdfs?: boolean, ignore?: boolean, cancelCompletion?: boolean }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_asn_order_transfer_outstanding_options_formComponent,
      'ASN Order Transfer Outstanding Options',
      mode,
      dialogSize
    )
  }
  public openauto_load_options_form(inParams:{ warehouseId: number, loadLocationId?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Auto Load Options',
        referenceName: 'FootprintManager_auto_load_options_form',
        component: FootprintManager_auto_load_options_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openauto_load_options_formDialog(
    inParams:{ warehouseId: number, loadLocationId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean, loadLocation?: number }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_auto_load_options_formComponent,
      'Auto Load Options',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openauto_pick_options_form(inParams:{ warehouse_id: number, load_location_id?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Auto Pick Options',
        referenceName: 'FootprintManager_auto_pick_options_form',
        component: FootprintManager_auto_pick_options_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openauto_pick_options_formDialog(
    inParams:{ warehouse_id: number, load_location_id?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean, auto_load?: boolean, load_location?: number, license_plate_lookup?: string }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_auto_pick_options_formComponent,
      'Auto Pick Options',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openauto_receive_and_putaway_form(inParams:{ orderId: number, taskIds?: number[], licenseplateIds?: number[] }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Auto-receive and putaway',
        referenceName: 'FootprintManager_auto_receive_and_putaway_form',
        component: FootprintManager_auto_receive_and_putaway_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openauto_receive_and_putaway_formDialog(
    inParams:{ orderId: number, taskIds?: number[], licenseplateIds?: number[] }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ isReceived?: boolean, reason?: string, isPutaway?: boolean, isConfirm?: boolean }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_auto_receive_and_putaway_formComponent,
      'Auto-receive and putaway',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openbilling_cancellation_options_form(inParams:{ title?: string, parentId: number, parentEntity: string }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Generic billing cancellation ',
        referenceName: 'FootprintManager_billing_cancellation_options_form',
        component: FootprintManager_billing_cancellation_options_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openbilling_cancellation_options_formDialog(
    inParams:{ title?: string, parentId: number, parentEntity: string }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean, reasonCodeId?: number, notes?: string }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_billing_cancellation_options_formComponent,
      'Generic billing cancellation ',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openbilling_contract_creation_form(inParams:{ ownerId?: number, projectId?: number, copy?: boolean }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'New billing contract',
        referenceName: 'FootprintManager_billing_contract_creation_form',
        component: FootprintManager_billing_contract_creation_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openbilling_contract_creation_formDialog(
    inParams:{ ownerId?: number, projectId?: number, copy?: boolean }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ projectId?: number }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_billing_contract_creation_formComponent,
      'New billing contract',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openbilling_contract_line_creation_form(inParams:{ billingContractId?: number, strategyName?: string, statusId?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'New billing contract line',
        referenceName: 'FootprintManager_billing_contract_line_creation_form',
        component: FootprintManager_billing_contract_line_creation_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openbilling_contract_line_creation_formDialog(
    inParams:{ billingContractId?: number, strategyName?: string, statusId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_billing_contract_line_creation_formComponent,
      'New billing contract line',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openblind_return_project_selector_form(inParams:{ gtin: string }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Select project',
        referenceName: 'FootprintManager_blind_return_project_selector_form',
        component: FootprintManager_blind_return_project_selector_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openblind_return_project_selector_formDialog(
    inParams:{ gtin: string }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ projectId?: number }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_blind_return_project_selector_formComponent,
      'Select project',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openbulk_licenseplate_directed_move_form(inParams:{ licenseplates: { id?: number, warehouseId?: number, typeId?: number, locationId?: number }[] }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Move License Plates',
        referenceName: 'FootprintManager_bulk_licenseplate_directed_move_form',
        component: FootprintManager_bulk_licenseplate_directed_move_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openbulk_licenseplate_directed_move_formDialog(
    inParams:{ licenseplates: { id?: number, warehouseId?: number, typeId?: number, locationId?: number }[] }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_bulk_licenseplate_directed_move_formComponent,
      'Move License Plates',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openbulk_receiving_row_input_form(inParams:{ materialId: number, packagingId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Bulk Receiving',
        referenceName: 'FootprintManager_bulk_receiving_row_input_form',
        component: FootprintManager_bulk_receiving_row_input_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openbulk_receiving_row_input_formDialog(
    inParams:{ materialId: number, packagingId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ palletCount?: number, fullPalletQuantity?: number }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_bulk_receiving_row_input_formComponent,
      'Bulk Receiving',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opencarrier_creation_form(replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'New carrier',
        referenceName: 'FootprintManager_carrier_creation_form',
        component: FootprintManager_carrier_creation_formComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public opencarrier_creation_formDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_carrier_creation_formComponent,
      'New carrier',
      mode,
      dialogSize
    )
  }
  public opencarrierservicetype_creation_form(replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'carrierservicetype_creation_form');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Create a new carrier service type',
        referenceName: 'FootprintManager_carrierservicetype_creation_form',
        component: FootprintManager_carrierservicetype_creation_formComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public opencarrierservicetype_creation_formDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean }> {
    this.$logger.log('FootprintManager', 'carrierservicetype_creation_form');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_carrierservicetype_creation_formComponent,
      'Create a new carrier service type',
      mode,
      dialogSize
    )
  }
  public opendock_appointment_assign_door_options_form(inParams:{ title?: string, dockAppointmentId: number, warehouseId: number, scheduledDockDoorId?: number, appointmentType?: string }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: ' Dock appointment door assignment',
        referenceName: 'FootprintManager_dock_appointment_assign_door_options_form',
        component: FootprintManager_dock_appointment_assign_door_options_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opendock_appointment_assign_door_options_formDialog(
    inParams:{ title?: string, dockAppointmentId: number, warehouseId: number, scheduledDockDoorId?: number, appointmentType?: string }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean, assignedDoorId?: number }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_dock_appointment_assign_door_options_formComponent,
      ' Dock appointment door assignment',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opendock_appointment_cancel_options_form(inParams:{ title?: string }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Dock appointment cancellation',
        referenceName: 'FootprintManager_dock_appointment_cancel_options_form',
        component: FootprintManager_dock_appointment_cancel_options_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opendock_appointment_cancel_options_formDialog(
    inParams:{ title?: string }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean, reasonCodeId?: number }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_dock_appointment_cancel_options_formComponent,
      'Dock appointment cancellation',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opendock_appointment_check_in_options_form(inParams:{ title?: string, dockAppointmentId: number, warehouseId: number, scheduledDockDoorId?: number, appointmentType?: string }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Dock appointment check in',
        referenceName: 'FootprintManager_dock_appointment_check_in_options_form',
        component: FootprintManager_dock_appointment_check_in_options_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opendock_appointment_check_in_options_formDialog(
    inParams:{ title?: string, dockAppointmentId: number, warehouseId: number, scheduledDockDoorId?: number, appointmentType?: string }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean, scheduledDoorId?: number, assignedDoorId?: number, driverName?: string, driverLicense?: string, vehicleLicense?: string }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_dock_appointment_check_in_options_formComponent,
      'Dock appointment check in',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opendock_appointment_creation_form(inParams:{ warehouseId?: number[], lookupcode?: string, scheduledArrival?: string, scheduledDeparture?: string, dockDoor?: number, typeId?: number, ownerId?: number, projectId?: number, carrierId?: number, orderId?: number, loadContainerId?: number, shipmentId?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Schedule appointment',
        referenceName: 'FootprintManager_dock_appointment_creation_form',
        component: FootprintManager_dock_appointment_creation_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opendock_appointment_creation_formDialog(
    inParams:{ warehouseId?: number[], lookupcode?: string, scheduledArrival?: string, scheduledDeparture?: string, dockDoor?: number, typeId?: number, ownerId?: number, projectId?: number, carrierId?: number, orderId?: number, loadContainerId?: number, shipmentId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_dock_appointment_creation_formComponent,
      'Schedule appointment',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opendock_door_creation_form(inParams:{ warehouseId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Create dock door',
        referenceName: 'FootprintManager_dock_door_creation_form',
        component: FootprintManager_dock_door_creation_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opendock_door_creation_formDialog(
    inParams:{ warehouseId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_dock_door_creation_formComponent,
      'Create dock door',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openfinalize_audit_form(inParams:{ licensePlateId?: number, missingSerialNumberIds: number[], warehouseId: number, locationId?: number, shippingContainerId?: number, foundSerialNumberIds: number[] }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Finalize audit',
        referenceName: 'FootprintManager_finalize_audit_form',
        component: FootprintManager_finalize_audit_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openfinalize_audit_formDialog(
    inParams:{ licensePlateId?: number, missingSerialNumberIds: number[], warehouseId: number, locationId?: number, shippingContainerId?: number, foundSerialNumberIds: number[] }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ isConfirm: boolean, reasonCodeId?: number }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_finalize_audit_formComponent,
      'Finalize audit',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openfootprint_manager_home(replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'footprint_manager_home');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Home',
        referenceName: 'FootprintManager_footprint_manager_home',
        component: FootprintManager_footprint_manager_homeComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openfootprint_manager_homeDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    this.$logger.log('FootprintManager', 'footprint_manager_home');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_footprint_manager_homeComponent,
      'Home',
      mode,
      dialogSize
    )
  }
  public opengeneric_form(inParams:{ stringField1?: string, stringField2?: string, stringField3?: string, stringField4?: string, stringField5?: string, dateField1?: string, dateField2?: string, dateField3?: string, dateField4?: string, dateField5?: string, numberField1?: string, numberField2?: string, numberField3?: string, numberField4?: string, numberField5?: string, title?: string }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'generic_form',
        referenceName: 'FootprintManager_generic_form',
        component: FootprintManager_generic_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opengeneric_formDialog(
    inParams:{ stringField1?: string, stringField2?: string, stringField3?: string, stringField4?: string, stringField5?: string, dateField1?: string, dateField2?: string, dateField3?: string, dateField4?: string, dateField5?: string, numberField1?: string, numberField2?: string, numberField3?: string, numberField4?: string, numberField5?: string, title?: string }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ stringField1?: string, stringField2?: string, stringField3?: string, stringField4?: string, stringField5?: string, dateField1?: string, dateField2?: string, dateField3?: string, dateField4?: string, dateField5?: string, numberField1?: number, numberField2?: number, numberField3?: number, numberField4?: number, numberField5?: number }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_generic_formComponent,
      'generic_form',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openget_average_serial_weights_form(inParams:{ serial_numbers: { id?: number, lookup: string, net_weight: number, gross_weight: number }[], weight_uom_id: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Distribute total weight across all items',
        referenceName: 'FootprintManager_get_average_serial_weights_form',
        component: FootprintManager_get_average_serial_weights_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openget_average_serial_weights_formDialog(
    inParams:{ serial_numbers: { id?: number, lookup: string, net_weight: number, gross_weight: number }[], weight_uom_id: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ serial_numbers?: { id?: number, lookup: string, net_weight: number, gross_weight: number }[], total_net?: number, total_gross?: number, weight_uom_id?: number }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_get_average_serial_weights_formComponent,
      'Distribute total weight across all items',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openget_licenseplate_form(inParams:{ warehouseId: number }, replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'get_licenseplate_form');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Get license plate',
        referenceName: 'FootprintManager_get_licenseplate_form',
        component: FootprintManager_get_licenseplate_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openget_licenseplate_formDialog(
    inParams:{ warehouseId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ locationId?: number, licenseplateId?: number }> {
    this.$logger.log('FootprintManager', 'get_licenseplate_form');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_get_licenseplate_formComponent,
      'Get license plate',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openinbound_orders_update_form(replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Update Orders',
        referenceName: 'FootprintManager_inbound_orders_update_form',
        component: FootprintManager_inbound_orders_update_formComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openinbound_orders_update_formDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean, carrierId?: number, expectedDate?: string, reference?: string }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_inbound_orders_update_formComponent,
      'Update Orders',
      mode,
      dialogSize
    )
  }
  public openinspection_select_task_status_form(replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Select task status',
        referenceName: 'FootprintManager_inspection_select_task_status_form',
        component: FootprintManager_inspection_select_task_status_formComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openinspection_select_task_status_formDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ taskStatusId?: number }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_inspection_select_task_status_formComponent,
      'Select task status',
      mode,
      dialogSize
    )
  }
  public openinspection_task_creation_form(inParams:{ warehouseId?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Create inspection task',
        referenceName: 'FootprintManager_inspection_task_creation_form',
        component: FootprintManager_inspection_task_creation_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openinspection_task_creation_formDialog(
    inParams:{ warehouseId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ taskId?: number }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_inspection_task_creation_formComponent,
      'Create inspection task',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openintegration_info_by_order_id(inParams:{ order_id?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'integration_info_by_order_id',
        referenceName: 'FootprintManager_integration_info_by_order_id',
        component: FootprintManager_integration_info_by_order_idComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openintegration_info_by_order_idDialog(
    inParams:{ order_id?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_integration_info_by_order_idComponent,
      'integration_info_by_order_id',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openinventory_adjustment_form(inParams:{ licenseplateId: number, lotId: number, packagingId: number, packagedAmount: number, availablePackagedAmount: number, serialnumberId?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Inventory quantity adjustment',
        referenceName: 'FootprintManager_inventory_adjustment_form',
        component: FootprintManager_inventory_adjustment_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openinventory_adjustment_formDialog(
    inParams:{ licenseplateId: number, lotId: number, packagingId: number, packagedAmount: number, availablePackagedAmount: number, serialnumberId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_inventory_adjustment_formComponent,
      'Inventory quantity adjustment',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openinventory_and_licenseplate_move_form(inParams:{ warehouseId?: number, locationId?: number, materialId?: number, vendorlotId?: number, licenseplates?: { id?: number, content?: { lotId?: number, packagingId?: number, packagedAmount?: number, availablePackagedAmount?: number }[] }[], serialNumberIds?: number[] }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Inventory move',
        referenceName: 'FootprintManager_inventory_and_licenseplate_move_form',
        component: FootprintManager_inventory_and_licenseplate_move_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openinventory_and_licenseplate_move_formDialog(
    inParams:{ warehouseId?: number, locationId?: number, materialId?: number, vendorlotId?: number, licenseplates?: { id?: number, content?: { lotId?: number, packagingId?: number, packagedAmount?: number, availablePackagedAmount?: number }[] }[], serialNumberIds?: number[] }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_inventory_and_licenseplate_move_formComponent,
      'Inventory move',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openinventory_creation_form(inParams:{ projectId?: number, warehouseId?: number, materialId?: number, packagingId?: number, lotId?: number, licenseplateId?: number, ownerId?: number, locationId?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'New inventory',
        referenceName: 'FootprintManager_inventory_creation_form',
        component: FootprintManager_inventory_creation_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openinventory_creation_formDialog(
    inParams:{ projectId?: number, warehouseId?: number, materialId?: number, packagingId?: number, lotId?: number, licenseplateId?: number, ownerId?: number, locationId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_inventory_creation_formComponent,
      'New inventory',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openinventory_transfer_creation_form(replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'New inventory transfer',
        referenceName: 'FootprintManager_inventory_transfer_creation_form',
        component: FootprintManager_inventory_transfer_creation_formComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openinventory_transfer_creation_formDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_inventory_transfer_creation_formComponent,
      'New inventory transfer',
      mode,
      dialogSize
    )
  }
  public openinventory_transfer_form(inParams:{ lotId: number, packagingId: number, licenseplateId: number, packagedAmount: number, materialId: number, availablePackagedAmount: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Inventory transfer',
        referenceName: 'FootprintManager_inventory_transfer_form',
        component: FootprintManager_inventory_transfer_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openinventory_transfer_formDialog(
    inParams:{ lotId: number, packagingId: number, licenseplateId: number, packagedAmount: number, materialId: number, availablePackagedAmount: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_inventory_transfer_formComponent,
      'Inventory transfer',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openinventory_transformation_additional_options_form(inParams:{ inventory_transformation_id?: number, source_line_id?: number }, replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'inventory_transformation_additional_options_form');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Inventory transformation additonal options',
        referenceName: 'FootprintManager_inventory_transformation_additional_options_form',
        component: FootprintManager_inventory_transformation_additional_options_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openinventory_transformation_additional_options_formDialog(
    inParams:{ inventory_transformation_id?: number, source_line_id?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ additional_options?: { general: { keep_source_creation_date: boolean, convert_packaging_to_base: boolean }, serial_number_options: { copy_weights: boolean, copy_volume: boolean, copy_dimensions: boolean }, lot_number_options: { copy_udfs: boolean, copy_lot_number: boolean, copy_vendor_lot_number: boolean } } }> {
    this.$logger.log('FootprintManager', 'inventory_transformation_additional_options_form');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_inventory_transformation_additional_options_formComponent,
      'Inventory transformation additonal options',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openinventory_transformation_creation_form(inParams:{ projectId?: number, ownerId?: number, warehouseId?: number, quick_transform?: boolean }, replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'inventory_transformation_creation_form');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'New inventory transformation',
        referenceName: 'FootprintManager_inventory_transformation_creation_form',
        component: FootprintManager_inventory_transformation_creation_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openinventory_transformation_creation_formDialog(
    inParams:{ projectId?: number, ownerId?: number, warehouseId?: number, quick_transform?: boolean }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ inventory_transformation?: { id: number, warehouse_id: number, project_id: number } }> {
    this.$logger.log('FootprintManager', 'inventory_transformation_creation_form');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_inventory_transformation_creation_formComponent,
      'New inventory transformation',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openinventory_transformations_target_material_form(inParams:{ project_id: number, warehouse_id: number, inventory_transformation_id: number, source_line_id?: number, type?: number, additional_options?: { general: { keep_source_creation_date: boolean, convert_packaging_to_base: boolean }, serial_number_options: { copy_udfs: boolean, copy_attachments: boolean, copy_weights: boolean, copy_volume: boolean, copy_dimensions: boolean, copy_status: boolean }, lot_number_options: { copy_udfs: boolean, copy_lot_number: boolean, copy_vendor_lot_number: boolean } } }, replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'inventory_transformations_target_material_form');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Add inventory to transform',
        referenceName: 'FootprintManager_inventory_transformations_target_material_form',
        component: FootprintManager_inventory_transformations_target_material_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openinventory_transformations_target_material_formDialog(
    inParams:{ project_id: number, warehouse_id: number, inventory_transformation_id: number, source_line_id?: number, type?: number, additional_options?: { general: { keep_source_creation_date: boolean, convert_packaging_to_base: boolean }, serial_number_options: { copy_udfs: boolean, copy_attachments: boolean, copy_weights: boolean, copy_volume: boolean, copy_dimensions: boolean, copy_status: boolean }, lot_number_options: { copy_udfs: boolean, copy_lot_number: boolean, copy_vendor_lot_number: boolean } } }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ inventory_to_transform?: { target_material_id: number, packaging_id: number, lot_id: number, vendor_lot_id: number, weight: number, weight_uom: number, new_quantity: number } }> {
    this.$logger.log('FootprintManager', 'inventory_transformations_target_material_form');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_inventory_transformations_target_material_formComponent,
      'Add inventory to transform',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openinventory_type_selection_form(replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Select inventory type',
        referenceName: 'FootprintManager_inventory_type_selection_form',
        component: FootprintManager_inventory_type_selection_formComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openinventory_type_selection_formDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean, inventoryTypeId?: number }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_inventory_type_selection_formComponent,
      'Select inventory type',
      mode,
      dialogSize
    )
  }
  public openinvoice_creation_form(inParams:{ projectId?: number, ownerId?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'New invoice',
        referenceName: 'FootprintManager_invoice_creation_form',
        component: FootprintManager_invoice_creation_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openinvoice_creation_formDialog(
    inParams:{ projectId?: number, ownerId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_invoice_creation_formComponent,
      'New invoice',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openinvoice_creation_options_form(inParams:{ title?: string, projectId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Invoice creation options',
        referenceName: 'FootprintManager_invoice_creation_options_form',
        component: FootprintManager_invoice_creation_options_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openinvoice_creation_options_formDialog(
    inParams:{ title?: string, projectId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean, invoiceId?: number, notes?: string }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_invoice_creation_options_formComponent,
      'Invoice creation options',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openinvoice_status_change_options_form(inParams:{ title?: string, excludeStatusId?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Invoice Status Change Options',
        referenceName: 'FootprintManager_invoice_status_change_options_form',
        component: FootprintManager_invoice_status_change_options_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openinvoice_status_change_options_formDialog(
    inParams:{ title?: string, excludeStatusId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean, statusId?: number, notes?: string }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_invoice_status_change_options_formComponent,
      'Invoice Status Change Options',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openload_container_create_form(inParams:{ warehouseId?: number, orderTypeId?: number, projectId?: number, ownerId?: number, loadContainerId?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'New Load Container',
        referenceName: 'FootprintManager_load_container_create_form',
        component: FootprintManager_load_container_create_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openload_container_create_formDialog(
    inParams:{ warehouseId?: number, orderTypeId?: number, projectId?: number, ownerId?: number, loadContainerId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_load_container_create_formComponent,
      'New Load Container',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openlocation_creation_form(inParams:{ warehouseId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'New location',
        referenceName: 'FootprintManager_location_creation_form',
        component: FootprintManager_location_creation_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openlocation_creation_formDialog(
    inParams:{ warehouseId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean, locationId?: number }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_location_creation_formComponent,
      'New location',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openlocation_replenishment_creation_form(inParams:{ projectId?: number, warehouseId?: number, locationId?: number, materialId?: number, ownerId?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Create new rule',
        referenceName: 'FootprintManager_location_replenishment_creation_form',
        component: FootprintManager_location_replenishment_creation_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openlocation_replenishment_creation_formDialog(
    inParams:{ projectId?: number, warehouseId?: number, locationId?: number, materialId?: number, ownerId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_location_replenishment_creation_formComponent,
      'Create new rule',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openlot_bulk_update_form(replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Update lots and vendor lots',
        referenceName: 'FootprintManager_lot_bulk_update_form',
        component: FootprintManager_lot_bulk_update_formComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openlot_bulk_update_formDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean, lotLookupCode?: string, vendorLookupCode?: string, expirationDate?: string, manufacturedDate?: string }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_lot_bulk_update_formComponent,
      'Update lots and vendor lots',
      mode,
      dialogSize
    )
  }
  public openlot_bulk_update_status_form(inParams:{ message: string }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Lot status change',
        referenceName: 'FootprintManager_lot_bulk_update_status_form',
        component: FootprintManager_lot_bulk_update_status_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openlot_bulk_update_status_formDialog(
    inParams:{ message: string }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ statusId?: number, reasonCodeIds?: number[] }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_lot_bulk_update_status_formComponent,
      'Lot status change',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openlot_creation_form(inParams:{ materialId: number, lotLookupCode?: string, vendorLotLookupCode?: string, vendorLotId?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'New lot',
        referenceName: 'FootprintManager_lot_creation_form',
        component: FootprintManager_lot_creation_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openlot_creation_formDialog(
    inParams:{ materialId: number, lotLookupCode?: string, vendorLotLookupCode?: string, vendorLotId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ lotId?: number, confirm?: boolean }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_lot_creation_formComponent,
      'New lot',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openlot_creation_form_with_material(inParams:{ materialId?: number, ownerId?: number, projectId?: number, vendorLotId?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'New lot with material',
        referenceName: 'FootprintManager_lot_creation_form_with_material',
        component: FootprintManager_lot_creation_form_with_materialComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openlot_creation_form_with_materialDialog(
    inParams:{ materialId?: number, ownerId?: number, projectId?: number, vendorLotId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ lotId?: number, confirm?: boolean }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_lot_creation_form_with_materialComponent,
      'New lot with material',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openmanufacturing_order_copy_form(inParams:{ order_id: number, lookup_code: string }, replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'manufacturing_order_copy_form');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Copy manufacturing order',
        referenceName: 'FootprintManager_manufacturing_order_copy_form',
        component: FootprintManager_manufacturing_order_copy_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openmanufacturing_order_copy_formDialog(
    inParams:{ order_id: number, lookup_code: string }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean }> {
    this.$logger.log('FootprintManager', 'manufacturing_order_copy_form');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_manufacturing_order_copy_formComponent,
      'Copy manufacturing order',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openmanufacturing_order_form(replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'manufacturing_order_form');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'New order',
        referenceName: 'FootprintManager_manufacturing_order_form',
        component: FootprintManager_manufacturing_order_formComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openmanufacturing_order_formDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    this.$logger.log('FootprintManager', 'manufacturing_order_form');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_manufacturing_order_formComponent,
      'New order',
      mode,
      dialogSize
    )
  }
  public openmanufacturing_order_line_multiple_substitutions_swap_form(inParams:{ material_name?: string, material_packaging?: string, material_amount?: number, substitution_ids?: number[], material_ids?: number[], warehouse_id?: number }, replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'manufacturing_order_line_multiple_substitutions_swap_form');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Order line multiple substitutions swap',
        referenceName: 'FootprintManager_manufacturing_order_line_multiple_substitutions_swap_form',
        component: FootprintManager_manufacturing_order_line_multiple_substitutions_swap_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openmanufacturing_order_line_multiple_substitutions_swap_formDialog(
    inParams:{ material_name?: string, material_packaging?: string, material_amount?: number, substitution_ids?: number[], material_ids?: number[], warehouse_id?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ material_swapped?: boolean, subtitution_id?: number }> {
    this.$logger.log('FootprintManager', 'manufacturing_order_line_multiple_substitutions_swap_form');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_manufacturing_order_line_multiple_substitutions_swap_formComponent,
      'Order line multiple substitutions swap',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openmanufacturing_order_line_production_confirmation_setup_form(inParams:{ warehouse_id?: number, output_location_id?: number, project_id?: number, planned_quantity?: number, finished_good_id?: number, finished_good?: string }, replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'manufacturing_order_line_production_confirmation_setup_form');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Order line production confirmation setup',
        referenceName: 'FootprintManager_manufacturing_order_line_production_confirmation_setup_form',
        component: FootprintManager_manufacturing_order_line_production_confirmation_setup_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openmanufacturing_order_line_production_confirmation_setup_formDialog(
    inParams:{ warehouse_id?: number, output_location_id?: number, project_id?: number, planned_quantity?: number, finished_good_id?: number, finished_good?: string }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ workshift_id?: number, equipment_id?: number, output_location_id?: number }> {
    this.$logger.log('FootprintManager', 'manufacturing_order_line_production_confirmation_setup_form');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_manufacturing_order_line_production_confirmation_setup_formComponent,
      'Order line production confirmation setup',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openmanufacturing_order_line_substitution_swap_form(inParams:{ material_name?: string, material_packaging?: string, substitution_name?: string, substitution_packaging?: string, material_amount?: number, substitution_amount?: number, ratio?: number }, replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'manufacturing_order_line_substitution_swap_form');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Order line substitutions swap',
        referenceName: 'FootprintManager_manufacturing_order_line_substitution_swap_form',
        component: FootprintManager_manufacturing_order_line_substitution_swap_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openmanufacturing_order_line_substitution_swap_formDialog(
    inParams:{ material_name?: string, material_packaging?: string, substitution_name?: string, substitution_packaging?: string, material_amount?: number, substitution_amount?: number, ratio?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ material_swapped?: boolean }> {
    this.$logger.log('FootprintManager', 'manufacturing_order_line_substitution_swap_form');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_manufacturing_order_line_substitution_swap_formComponent,
      'Order line substitutions swap',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openmaterial_catalog_source_material_copy_form(inParams:{ materialIds: number[], catalog_id: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Copy source material',
        referenceName: 'FootprintManager_material_catalog_source_material_copy_form',
        component: FootprintManager_material_catalog_source_material_copy_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openmaterial_catalog_source_material_copy_formDialog(
    inParams:{ materialIds: number[], catalog_id: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean, materialId?: number }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_material_catalog_source_material_copy_formComponent,
      'Copy source material',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openmaterial_catalog_source_material_creation_form(inParams:{ catalog_id: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Create material catalog source material',
        referenceName: 'FootprintManager_material_catalog_source_material_creation_form',
        component: FootprintManager_material_catalog_source_material_creation_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openmaterial_catalog_source_material_creation_formDialog(
    inParams:{ catalog_id: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ materialId?: number, confirm?: boolean }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_material_catalog_source_material_creation_formComponent,
      'Create material catalog source material',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openmaterial_copy_form(inParams:{ projectId?: number, ownerId?: number, materialIds?: number[] }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Materials copy',
        referenceName: 'FootprintManager_material_copy_form',
        component: FootprintManager_material_copy_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openmaterial_copy_formDialog(
    inParams:{ projectId?: number, ownerId?: number, materialIds?: number[] }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean, materialId?: number }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_material_copy_formComponent,
      'Materials copy',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openmaterial_creation_form(inParams:{ projectId?: number, ownerId?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'New material',
        referenceName: 'FootprintManager_material_creation_form',
        component: FootprintManager_material_creation_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openmaterial_creation_formDialog(
    inParams:{ projectId?: number, ownerId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ materialId?: number, confirm?: boolean }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_material_creation_formComponent,
      'New material',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openmaterial_update_form(replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Edit material',
        referenceName: 'FootprintManager_material_update_form',
        component: FootprintManager_material_update_formComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openmaterial_update_formDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ materialGroupId?: number, shelfLifeSpan?: number, allocationStrategyId?: number, confirm?: boolean, statusId?: number, allocationStrategyWorkflowId?: string }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_material_update_formComponent,
      'Edit material',
      mode,
      dialogSize
    )
  }
  public openorder_completion_options_form(inParams:{ warehouseId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Order completion options',
        referenceName: 'FootprintManager_order_completion_options_form',
        component: FootprintManager_order_completion_options_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openorder_completion_options_formDialog(
    inParams:{ warehouseId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean, autoLoad?: boolean, loadLocation?: number }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_order_completion_options_formComponent,
      'Order completion options',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openoutbound_orders_update_form(inParams:{ orders: { orderId?: number, shipmentId?: number }[] }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Update orders',
        referenceName: 'FootprintManager_outbound_orders_update_form',
        component: FootprintManager_outbound_orders_update_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openoutbound_orders_update_formDialog(
    inParams:{ orders: { orderId?: number, shipmentId?: number }[] }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_outbound_orders_update_formComponent,
      'Update orders',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openowner_creation_form(replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'New owner',
        referenceName: 'FootprintManager_owner_creation_form',
        component: FootprintManager_owner_creation_formComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openowner_creation_formDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean, ownerId?: number, reason?: string }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_owner_creation_formComponent,
      'New owner',
      mode,
      dialogSize
    )
  }
  public openowner_update_form(replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Owner status change',
        referenceName: 'FootprintManager_owner_update_form',
        component: FootprintManager_owner_update_formComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openowner_update_formDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean, ownerStatusId?: number }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_owner_update_formComponent,
      'Owner status change',
      mode,
      dialogSize
    )
  }
  public openpack_verification_failure_form(inParams:{ shippingContainerCode: string }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Fail verification?',
        referenceName: 'FootprintManager_pack_verification_failure_form',
        component: FootprintManager_pack_verification_failure_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openpack_verification_failure_formDialog(
    inParams:{ shippingContainerCode: string }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ reasonCodeId?: number, isConfirmed?: boolean }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_pack_verification_failure_formComponent,
      'Fail verification?',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openpallet_class_creation_form(replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Create pallet class',
        referenceName: 'FootprintManager_pallet_class_creation_form',
        component: FootprintManager_pallet_class_creation_formComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openpallet_class_creation_formDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_pallet_class_creation_formComponent,
      'Create pallet class',
      mode,
      dialogSize
    )
  }
  public openpallet_transaction_creation_form(inParams:{ project_id?: number, shipment_id?: number, pallet_class_id?: number, order_lookup_code?: string, pallets_in?: number, pallets_out?: number, transaction_id?: number, amount?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Create pallet transaction',
        referenceName: 'FootprintManager_pallet_transaction_creation_form',
        component: FootprintManager_pallet_transaction_creation_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openpallet_transaction_creation_formDialog(
    inParams:{ project_id?: number, shipment_id?: number, pallet_class_id?: number, order_lookup_code?: string, pallets_in?: number, pallets_out?: number, transaction_id?: number, amount?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_pallet_transaction_creation_formComponent,
      'Create pallet transaction',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openplan_form(replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'plan_form');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Plan',
        referenceName: 'FootprintManager_plan_form',
        component: FootprintManager_plan_formComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openplan_formDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    this.$logger.log('FootprintManager', 'plan_form');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_plan_formComponent,
      'Plan',
      mode,
      dialogSize
    )
  }
  public openprint_license_plate_labels_form(inParams:{ orderId: number, licensePlateId?: number }, replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'print_license_plate_labels_form');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Print license plate labels',
        referenceName: 'FootprintManager_print_license_plate_labels_form',
        component: FootprintManager_print_license_plate_labels_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openprint_license_plate_labels_formDialog(
    inParams:{ orderId: number, licensePlateId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    this.$logger.log('FootprintManager', 'print_license_plate_labels_form');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_print_license_plate_labels_formComponent,
      'Print license plate labels',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openprint_order_labels_form(inParams:{ orderId: number, context: string, shipmentId?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Print order labels form',
        referenceName: 'FootprintManager_print_order_labels_form',
        component: FootprintManager_print_order_labels_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openprint_order_labels_formDialog(
    inParams:{ orderId: number, context: string, shipmentId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_print_order_labels_formComponent,
      'Print order labels form',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openproject_creation_form(inParams:{ ownerId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'New project',
        referenceName: 'FootprintManager_project_creation_form',
        component: FootprintManager_project_creation_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openproject_creation_formDialog(
    inParams:{ ownerId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean, projectId?: number, reason?: string }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_project_creation_formComponent,
      'New project',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openproject_update_form(replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Update Project',
        referenceName: 'FootprintManager_project_update_form',
        component: FootprintManager_project_update_formComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openproject_update_formDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean, projectStatusId?: number }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_project_update_formComponent,
      'Update Project',
      mode,
      dialogSize
    )
  }
  public openpurchase_order_copy_form(inParams:{ order_id: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Copy purchase order',
        referenceName: 'FootprintManager_purchase_order_copy_form',
        component: FootprintManager_purchase_order_copy_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openpurchase_order_copy_formDialog(
    inParams:{ order_id: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ new_order_id?: number, confirm?: boolean }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_purchase_order_copy_formComponent,
      'Copy purchase order',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openpurchase_order_creation_form(inParams:{ projectId?: number, ownerId?: number, warehouseId?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'New purchase order',
        referenceName: 'FootprintManager_purchase_order_creation_form',
        component: FootprintManager_purchase_order_creation_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openpurchase_order_creation_formDialog(
    inParams:{ projectId?: number, ownerId?: number, warehouseId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_purchase_order_creation_formComponent,
      'New purchase order',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openreason_code_creation_form(replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Create reason code',
        referenceName: 'FootprintManager_reason_code_creation_form',
        component: FootprintManager_reason_code_creation_formComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openreason_code_creation_formDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_reason_code_creation_formComponent,
      'Create reason code',
      mode,
      dialogSize
    )
  }
  public openreturn_order_creation_form(inParams:{ projectId?: number, ownerId?: number, warehouseId?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Create Return Order',
        referenceName: 'FootprintManager_return_order_creation_form',
        component: FootprintManager_return_order_creation_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openreturn_order_creation_formDialog(
    inParams:{ projectId?: number, ownerId?: number, warehouseId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_return_order_creation_formComponent,
      'Create Return Order',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opensales_order_cancellation_options_form(inParams:{ title?: string, parentId: number, parentEntity: string }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Generic Sales Order Cancellation ',
        referenceName: 'FootprintManager_sales_order_cancellation_options_form',
        component: FootprintManager_sales_order_cancellation_options_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opensales_order_cancellation_options_formDialog(
    inParams:{ title?: string, parentId: number, parentEntity: string }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean, reasonCodeId?: number }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_sales_order_cancellation_options_formComponent,
      'Generic Sales Order Cancellation ',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opensales_order_copy_form(inParams:{ order_id: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Copy sales order',
        referenceName: 'FootprintManager_sales_order_copy_form',
        component: FootprintManager_sales_order_copy_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opensales_order_copy_formDialog(
    inParams:{ order_id: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ new_order_id?: number, confirm?: boolean }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_sales_order_copy_formComponent,
      'Copy sales order',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opensales_order_creation_form(inParams:{ projectId?: number, ownerId?: number, warehouseId?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'New sales order',
        referenceName: 'FootprintManager_sales_order_creation_form',
        component: FootprintManager_sales_order_creation_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opensales_order_creation_formDialog(
    inParams:{ projectId?: number, ownerId?: number, warehouseId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_sales_order_creation_formComponent,
      'New sales order',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opensales_order_pick_task_cancellation_options_form(inParams:{ title?: string, parentId: number, parentEntity: string, cancelOrderRequest?: boolean, autoCancelOrderRequest?: boolean }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Generic Sales Order Pick Task Cancellation ',
        referenceName: 'FootprintManager_sales_order_pick_task_cancellation_options_form',
        component: FootprintManager_sales_order_pick_task_cancellation_options_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opensales_order_pick_task_cancellation_options_formDialog(
    inParams:{ title?: string, parentId: number, parentEntity: string, cancelOrderRequest?: boolean, autoCancelOrderRequest?: boolean }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean, reasonCodeId?: number, cancelOrderConfirmed?: boolean, cancelOrderReasonCodeId?: number }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_sales_order_pick_task_cancellation_options_formComponent,
      'Generic Sales Order Pick Task Cancellation ',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opensales_orders_processing_options_form(inParams:{ order_ids: number[], default_waving: boolean, expand_order_line_kits?: boolean, is_wave_created?: boolean }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'processing options',
        referenceName: 'FootprintManager_sales_orders_processing_options_form',
        component: FootprintManager_sales_orders_processing_options_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opensales_orders_processing_options_formDialog(
    inParams:{ order_ids: number[], default_waving: boolean, expand_order_line_kits?: boolean, is_wave_created?: boolean }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean, waveOptions?: { isCreateWave?: boolean, isProcessWave?: boolean, isReleaseWave?: boolean, priority?: number, description?: string, abortIfErrors?: boolean, groupOnWave?: boolean, isCreateManualAllocationTasks?: boolean }, processingStrategyWorkflowId?: string, expand_order_line_kits_request?: boolean }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_sales_orders_processing_options_formComponent,
      'processing options',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openselect_pack_verification_location_form(inParams:{ shipping_container_id: number, warehouse_id: number, is_open_wizard?: boolean }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Select location',
        referenceName: 'FootprintManager_select_pack_verification_location_form',
        component: FootprintManager_select_pack_verification_location_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openselect_pack_verification_location_formDialog(
    inParams:{ shipping_container_id: number, warehouse_id: number, is_open_wizard?: boolean }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ location_id?: number }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_select_pack_verification_location_formComponent,
      'Select location',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openselect_user_form(inParams:{ operationCodeIds?: number[], workClassIds?: number[] }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Assign user to task',
        referenceName: 'FootprintManager_select_user_form',
        component: FootprintManager_select_user_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openselect_user_formDialog(
    inParams:{ operationCodeIds?: number[], workClassIds?: number[] }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ user?: { id?: string, username?: string } }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_select_user_formComponent,
      'Assign user to task',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opentemperature_capture_form(inParams:{ shipmentId?: number, shipmentLineId?: number, licensePlateId?: number, loadContainerId?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'New temperature reading',
        referenceName: 'FootprintManager_temperature_capture_form',
        component: FootprintManager_temperature_capture_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opentemperature_capture_formDialog(
    inParams:{ shipmentId?: number, shipmentLineId?: number, licensePlateId?: number, loadContainerId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_temperature_capture_formComponent,
      'New temperature reading',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opentransfer_licenseplate_form(inParams:{ licenseplateIds?: number[], sourceShipmentId: number, targetShipmentId?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'transfer_licenseplate_form',
        referenceName: 'FootprintManager_transfer_licenseplate_form',
        component: FootprintManager_transfer_licenseplate_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opentransfer_licenseplate_formDialog(
    inParams:{ licenseplateIds?: number[], sourceShipmentId: number, targetShipmentId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean, auto_pick?: boolean }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_transfer_licenseplate_formComponent,
      'transfer_licenseplate_form',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opentransfer_transload_licenseplate_form(inParams:{ licenseplate_ids: number[], transload_id: number, current_outbound_shipment_id?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Transfer transload licenseplate',
        referenceName: 'FootprintManager_transfer_transload_licenseplate_form',
        component: FootprintManager_transfer_transload_licenseplate_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opentransfer_transload_licenseplate_formDialog(
    inParams:{ licenseplate_ids: number[], transload_id: number, current_outbound_shipment_id?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_transfer_transload_licenseplate_formComponent,
      'Transfer transload licenseplate',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opentransload_order_creation_form(inParams:{ projectId?: number, ownerId?: number, warehouseId?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Create transload order',
        referenceName: 'FootprintManager_transload_order_creation_form',
        component: FootprintManager_transload_order_creation_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opentransload_order_creation_formDialog(
    inParams:{ projectId?: number, ownerId?: number, warehouseId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_transload_order_creation_formComponent,
      'Create transload order',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openunloading_form(inParams:{ licenseplateId: number, shipmentId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Unloading Inventory',
        referenceName: 'FootprintManager_unloading_form',
        component: FootprintManager_unloading_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openunloading_formDialog(
    inParams:{ licenseplateId: number, shipmentId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_unloading_formComponent,
      'Unloading Inventory',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openunpicking_form(inParams:{ licenseplateId: number, locationId?: number, inventory?: { lotId: number, packagingId: number, packagedAmount: number, shipmentLineId: number, unpickPackagedAmount?: number, serialNumberIds?: number[] }, suppress_manual_allocation?: boolean }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Unpick Inventory',
        referenceName: 'FootprintManager_unpicking_form',
        component: FootprintManager_unpicking_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openunpicking_formDialog(
    inParams:{ licenseplateId: number, locationId?: number, inventory?: { lotId: number, packagingId: number, packagedAmount: number, shipmentLineId: number, unpickPackagedAmount?: number, serialNumberIds?: number[] }, suppress_manual_allocation?: boolean }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_unpicking_formComponent,
      'Unpick Inventory',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openunreceiving_all_options_form(inParams:{ title?: string }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Unreceive All Inventory',
        referenceName: 'FootprintManager_unreceiving_all_options_form',
        component: FootprintManager_unreceiving_all_options_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openunreceiving_all_options_formDialog(
    inParams:{ title?: string }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean, reasonCodeId?: number }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_unreceiving_all_options_formComponent,
      'Unreceive All Inventory',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openunreceiving_single_taskId_form(inParams:{ licenseplateId: number, lotId: number, packagingId: number, packagedAmount: number, taskId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Unreceive Inventory',
        referenceName: 'FootprintManager_unreceiving_single_taskId_form',
        component: FootprintManager_unreceiving_single_taskId_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openunreceiving_single_taskId_formDialog(
    inParams:{ licenseplateId: number, lotId: number, packagingId: number, packagedAmount: number, taskId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_unreceiving_single_taskId_formComponent,
      'Unreceive Inventory',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openvendorlot_creation_form(inParams:{ materialId: number, vendorLookupcode?: string }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'New vendor lot',
        referenceName: 'FootprintManager_vendorlot_creation_form',
        component: FootprintManager_vendorlot_creation_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openvendorlot_creation_formDialog(
    inParams:{ materialId: number, vendorLookupcode?: string }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ vendorLotId?: number, confirm?: boolean }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_vendorlot_creation_formComponent,
      'New vendor lot',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openwarehouse_creation_form(replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'New warehouse',
        referenceName: 'FootprintManager_warehouse_creation_form',
        component: FootprintManager_warehouse_creation_formComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openwarehouse_creation_formDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean, warehouseId?: number, reason?: string }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_warehouse_creation_formComponent,
      'New warehouse',
      mode,
      dialogSize
    )
  }
  public openwarehouse_transfer_creation_form(replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Create warehouse transfer',
        referenceName: 'FootprintManager_warehouse_transfer_creation_form',
        component: FootprintManager_warehouse_transfer_creation_formComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openwarehouse_transfer_creation_formDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_warehouse_transfer_creation_formComponent,
      'Create warehouse transfer',
      mode,
      dialogSize
    )
  }
  public openwave_update_form(inParams:{ waveId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Wave update form',
        referenceName: 'FootprintManager_wave_update_form',
        component: FootprintManager_wave_update_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openwave_update_formDialog(
    inParams:{ waveId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_wave_update_formComponent,
      'Wave update form',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openwork_class_creation_form(replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Create work class',
        referenceName: 'FootprintManager_work_class_creation_form',
        component: FootprintManager_work_class_creation_formComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openwork_class_creation_formDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ workClassId?: number }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_work_class_creation_formComponent,
      'Create work class',
      mode,
      dialogSize
    )
  }
  public openwork_order_creation_form(inParams:{ projectId?: number, ownerId?: number, warehouseId?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Create Work Order',
        referenceName: 'FootprintManager_work_order_creation_form',
        component: FootprintManager_work_order_creation_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openwork_order_creation_formDialog(
    inParams:{ projectId?: number, ownerId?: number, warehouseId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_work_order_creation_formComponent,
      'Create Work Order',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openworkshift_form(inParams:{ warehouse_id: number }, replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'workshift_form');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'workshift_form',
        referenceName: 'FootprintManager_workshift_form',
        component: FootprintManager_workshift_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openworkshift_formDialog(
    inParams:{ warehouse_id: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    this.$logger.log('FootprintManager', 'workshift_form');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_workshift_formComponent,
      'workshift_form',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openasn_order_editor(inParams:{ order_id: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Edit ASN order',
        referenceName: 'FootprintManager_asn_order_editor',
        component: FootprintManager_asn_order_editorComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openasn_order_editorDialog(
    inParams:{ order_id: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_asn_order_editorComponent,
      'Edit ASN order',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openbilling_contract_editor(inParams:{ contractId: number, edit?: boolean }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Edit Billing Contract',
        referenceName: 'FootprintManager_billing_contract_editor',
        component: FootprintManager_billing_contract_editorComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openbilling_contract_editorDialog(
    inParams:{ contractId: number, edit?: boolean }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_billing_contract_editorComponent,
      'Edit Billing Contract',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openbilling_contract_line_editor(inParams:{ billingContractLineId: number, edit: boolean, operationCodeId?: number, billingAggregationStrategy?: string, statusId?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Billing Contract Line Editor',
        referenceName: 'FootprintManager_billing_contract_line_editor',
        component: FootprintManager_billing_contract_line_editorComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openbilling_contract_line_editorDialog(
    inParams:{ billingContractLineId: number, edit: boolean, operationCodeId?: number, billingAggregationStrategy?: string, statusId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ updated?: boolean }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_billing_contract_line_editorComponent,
      'Billing Contract Line Editor',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openbilling_record_editor(inParams:{ billingTaskId: number }, replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'billing_record_editor');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Edit Billing Record',
        referenceName: 'FootprintManager_billing_record_editor',
        component: FootprintManager_billing_record_editorComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openbilling_record_editorDialog(
    inParams:{ billingTaskId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    this.$logger.log('FootprintManager', 'billing_record_editor');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_billing_record_editorComponent,
      'Edit Billing Record',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opencarrier_editor(inParams:{ carrierId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Edit Carrier',
        referenceName: 'FootprintManager_carrier_editor',
        component: FootprintManager_carrier_editorComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opencarrier_editorDialog(
    inParams:{ carrierId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_carrier_editorComponent,
      'Edit Carrier',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opencarrierservicetype_editor(inParams:{ carrierservicetypeId: number }, replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'carrierservicetype_editor');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Edit Carrier Service Type',
        referenceName: 'FootprintManager_carrierservicetype_editor',
        component: FootprintManager_carrierservicetype_editorComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opencarrierservicetype_editorDialog(
    inParams:{ carrierservicetypeId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean }> {
    this.$logger.log('FootprintManager', 'carrierservicetype_editor');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_carrierservicetype_editorComponent,
      'Edit Carrier Service Type',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opencount_task_editor(inParams:{ taskId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'count_task_editor',
        referenceName: 'FootprintManager_count_task_editor',
        component: FootprintManager_count_task_editorComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opencount_task_editorDialog(
    inParams:{ taskId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_count_task_editorComponent,
      'count_task_editor',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opendock_appointment_editor(inParams:{ dockAppointmentId: number, orderId?: number, loadContainerId?: number, shipmentId?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Edit appointment',
        referenceName: 'FootprintManager_dock_appointment_editor',
        component: FootprintManager_dock_appointment_editorComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opendock_appointment_editorDialog(
    inParams:{ dockAppointmentId: number, orderId?: number, loadContainerId?: number, shipmentId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_dock_appointment_editorComponent,
      'Edit appointment',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opendock_door_editor(inParams:{ locationId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Edit Dock Door',
        referenceName: 'FootprintManager_dock_door_editor',
        component: FootprintManager_dock_door_editorComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opendock_door_editorDialog(
    inParams:{ locationId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_dock_door_editorComponent,
      'Edit Dock Door',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openinspection_task_editor(inParams:{ taskId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Inspection task',
        referenceName: 'FootprintManager_inspection_task_editor',
        component: FootprintManager_inspection_task_editorComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openinspection_task_editorDialog(
    inParams:{ taskId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_inspection_task_editorComponent,
      'Inspection task',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openinventory_count_editor(inParams:{ inventoryCountId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'inventory_count_editor',
        referenceName: 'FootprintManager_inventory_count_editor',
        component: FootprintManager_inventory_count_editorComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openinventory_count_editorDialog(
    inParams:{ inventoryCountId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_inventory_count_editorComponent,
      'inventory_count_editor',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openinventory_transfer_editor(inParams:{ inventoryTransferId: number, warehouseId?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Inventory transfer',
        referenceName: 'FootprintManager_inventory_transfer_editor',
        component: FootprintManager_inventory_transfer_editorComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openinventory_transfer_editorDialog(
    inParams:{ inventoryTransferId: number, warehouseId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_inventory_transfer_editorComponent,
      'Inventory transfer',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openinventory_transformation_editor(inParams:{ inventory_transformation_id: number }, replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'inventory_transformation_editor');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Edit inventory transformation',
        referenceName: 'FootprintManager_inventory_transformation_editor',
        component: FootprintManager_inventory_transformation_editorComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openinventory_transformation_editorDialog(
    inParams:{ inventory_transformation_id: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    this.$logger.log('FootprintManager', 'inventory_transformation_editor');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_inventory_transformation_editorComponent,
      'Edit inventory transformation',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openinventory_transformation_source_line_editor(inParams:{ project_id: number, warehouse_id: number, inventory_transformation_id: number, source_line_id?: number }, replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'inventory_transformation_source_line_editor');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'inventory_transformation_source_line_editor',
        referenceName: 'FootprintManager_inventory_transformation_source_line_editor',
        component: FootprintManager_inventory_transformation_source_line_editorComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openinventory_transformation_source_line_editorDialog(
    inParams:{ project_id: number, warehouse_id: number, inventory_transformation_id: number, source_line_id?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ source_line_id?: number }> {
    this.$logger.log('FootprintManager', 'inventory_transformation_source_line_editor');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_inventory_transformation_source_line_editorComponent,
      'inventory_transformation_source_line_editor',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openinventory_transformation_target_line_editor(inParams:{ inventory_transformation_id: number, source_line_id?: number, projectId?: number, warehouse_id?: number, additional_options?: { general: { keep_source_creation_date: boolean, convert_packaging_to_base: boolean }, serial_number_options: { copy_weights: boolean, copy_volume: boolean, copy_dimensions: boolean }, lot_number_options: { copy_udfs: boolean, copy_lot_number: boolean, copy_vendor_lot_number: boolean } } }, replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'inventory_transformation_target_line_editor');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'inventory_transformation_target_line_editor',
        referenceName: 'FootprintManager_inventory_transformation_target_line_editor',
        component: FootprintManager_inventory_transformation_target_line_editorComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openinventory_transformation_target_line_editorDialog(
    inParams:{ inventory_transformation_id: number, source_line_id?: number, projectId?: number, warehouse_id?: number, additional_options?: { general: { keep_source_creation_date: boolean, convert_packaging_to_base: boolean }, serial_number_options: { copy_weights: boolean, copy_volume: boolean, copy_dimensions: boolean }, lot_number_options: { copy_udfs: boolean, copy_lot_number: boolean, copy_vendor_lot_number: boolean } } }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ target_line_id?: number }> {
    this.$logger.log('FootprintManager', 'inventory_transformation_target_line_editor');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_inventory_transformation_target_line_editorComponent,
      'inventory_transformation_target_line_editor',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openinvoice_editor(inParams:{ invoiceId: number, invoice_lines?: { open_to_line?: number } }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Edit invoice',
        referenceName: 'FootprintManager_invoice_editor',
        component: FootprintManager_invoice_editorComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openinvoice_editorDialog(
    inParams:{ invoiceId: number, invoice_lines?: { open_to_line?: number } }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_invoice_editorComponent,
      'Edit invoice',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openlicenseplate_editor(inParams:{ licenseplateId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Edit LP',
        referenceName: 'FootprintManager_licenseplate_editor',
        component: FootprintManager_licenseplate_editorComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openlicenseplate_editorDialog(
    inParams:{ licenseplateId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_licenseplate_editorComponent,
      'Edit LP',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openload_container_add_orders(inParams:{ loadContainerId?: number, warehouseId?: number, orderTypeId?: number, projectId?: number, ownerId?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Load Container Add Orders',
        referenceName: 'FootprintManager_load_container_add_orders',
        component: FootprintManager_load_container_add_ordersComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openload_container_add_ordersDialog(
    inParams:{ loadContainerId?: number, warehouseId?: number, orderTypeId?: number, projectId?: number, ownerId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_load_container_add_ordersComponent,
      'Load Container Add Orders',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openload_container_editor(inParams:{ loadContainerId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Load Container Editor',
        referenceName: 'FootprintManager_load_container_editor',
        component: FootprintManager_load_container_editorComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openload_container_editorDialog(
    inParams:{ loadContainerId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_load_container_editorComponent,
      'Load Container Editor',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openlocation_editor(inParams:{ locationId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Edit Location',
        referenceName: 'FootprintManager_location_editor',
        component: FootprintManager_location_editorComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openlocation_editorDialog(
    inParams:{ locationId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_location_editorComponent,
      'Edit Location',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openlocation_replenishment_editor(inParams:{ locationReplenishmentId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Edit Rule',
        referenceName: 'FootprintManager_location_replenishment_editor',
        component: FootprintManager_location_replenishment_editorComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openlocation_replenishment_editorDialog(
    inParams:{ locationReplenishmentId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_location_replenishment_editorComponent,
      'Edit Rule',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openlot_editor(inParams:{ lotId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Edit lot',
        referenceName: 'FootprintManager_lot_editor',
        component: FootprintManager_lot_editorComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openlot_editorDialog(
    inParams:{ lotId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_lot_editorComponent,
      'Edit lot',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openmanufacturing_order_components_serial_numbers_pick_editor(inParams:{ serial_controlled_materials?: number, material_ids?: { material_id?: number, serial_count_needed?: number, material_name?: string, packaging_name?: string, license_plate?: number }[], warehouse_id?: number, iteration?: number, serial_numbers?: { serialNumberId?: number, weightUOM?: number, volumeUOM?: number, dimensionsUOM?: number, grossVolume?: number, netVolume?: number, grossWeight?: number, netWeight?: number, materialId?: number, licensePlate?: number }[], location?: number }, replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'manufacturing_order_components_serial_numbers_pick_editor');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Select serial numbers',
        referenceName: 'FootprintManager_manufacturing_order_components_serial_numbers_pick_editor',
        component: FootprintManager_manufacturing_order_components_serial_numbers_pick_editorComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openmanufacturing_order_components_serial_numbers_pick_editorDialog(
    inParams:{ serial_controlled_materials?: number, material_ids?: { material_id?: number, serial_count_needed?: number, material_name?: string, packaging_name?: string, license_plate?: number }[], warehouse_id?: number, iteration?: number, serial_numbers?: { serialNumberId?: number, weightUOM?: number, volumeUOM?: number, dimensionsUOM?: number, grossVolume?: number, netVolume?: number, grossWeight?: number, netWeight?: number, materialId?: number, licensePlate?: number }[], location?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ serial_numbers?: { serialNumberId?: number, weightUOM?: number, volumeUOM?: number, dimensionsUOM?: number, grossVolume?: number, netVolume?: number, grossWeight?: number, netWeight?: number, materialId?: number, licensePlate?: number }[] }> {
    this.$logger.log('FootprintManager', 'manufacturing_order_components_serial_numbers_pick_editor');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_manufacturing_order_components_serial_numbers_pick_editorComponent,
      'Select serial numbers',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openmanufacturing_order_editor(inParams:{ manufacturing_order_id: number }, replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'manufacturing_order_editor');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Order editor',
        referenceName: 'FootprintManager_manufacturing_order_editor',
        component: FootprintManager_manufacturing_order_editorComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openmanufacturing_order_editorDialog(
    inParams:{ manufacturing_order_id: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    this.$logger.log('FootprintManager', 'manufacturing_order_editor');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_manufacturing_order_editorComponent,
      'Order editor',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openmanufacturing_order_return_to_stock_editor(inParams:{ manufacturing_order_id?: number, manufacturing_order_line_id?: number, finished_good?: string, warehouse_id?: number, project_id?: number, task_chain_head?: number, location_id?: number }, replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'manufacturing_order_return_to_stock_editor');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Manufacturing order stock return',
        referenceName: 'FootprintManager_manufacturing_order_return_to_stock_editor',
        component: FootprintManager_manufacturing_order_return_to_stock_editorComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openmanufacturing_order_return_to_stock_editorDialog(
    inParams:{ manufacturing_order_id?: number, manufacturing_order_line_id?: number, finished_good?: string, warehouse_id?: number, project_id?: number, task_chain_head?: number, location_id?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    this.$logger.log('FootprintManager', 'manufacturing_order_return_to_stock_editor');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_manufacturing_order_return_to_stock_editorComponent,
      'Manufacturing order stock return',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openmanufacturing_orders_create_serial_numbers_editor(inParams:{ material_id?: number, produced_quantity?: number, lot_id?: number, packaging_id?: number, license_plate_id?: number }, replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'manufacturing_orders_create_serial_numbers_editor');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Create new serials',
        referenceName: 'FootprintManager_manufacturing_orders_create_serial_numbers_editor',
        component: FootprintManager_manufacturing_orders_create_serial_numbers_editorComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openmanufacturing_orders_create_serial_numbers_editorDialog(
    inParams:{ material_id?: number, produced_quantity?: number, lot_id?: number, packaging_id?: number, license_plate_id?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ serials?: { MaterialId?: number, LicensePlateId?: number, LotId?: number, GrossVolume?: number, GrossWeight?: number, VolumeUomId?: number, WeightUomId?: number, NetWeight?: number, NetVolume?: number, DimensionUomId?: number, Height?: number, Length?: number, PackagingId?: number, Width?: number, LookupCode?: string }[] }> {
    this.$logger.log('FootprintManager', 'manufacturing_orders_create_serial_numbers_editor');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_manufacturing_orders_create_serial_numbers_editorComponent,
      'Create new serials',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openmaterial_editor(inParams:{ materialId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Edit material',
        referenceName: 'FootprintManager_material_editor',
        component: FootprintManager_material_editorComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openmaterial_editorDialog(
    inParams:{ materialId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_material_editorComponent,
      'Edit material',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openmaterial_kit_editor(inParams:{ material_id: number, project_id: number, packaging_id?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'material_kit_editor',
        referenceName: 'FootprintManager_material_kit_editor',
        component: FootprintManager_material_kit_editorComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openmaterial_kit_editorDialog(
    inParams:{ material_id: number, project_id: number, packaging_id?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_material_kit_editorComponent,
      'material_kit_editor',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openmaterial_substitutions_editor(inParams:{ material_id: number, packaging_id?: number, project_id: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Material Substitutions',
        referenceName: 'FootprintManager_material_substitutions_editor',
        component: FootprintManager_material_substitutions_editorComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openmaterial_substitutions_editorDialog(
    inParams:{ material_id: number, packaging_id?: number, project_id: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_material_substitutions_editorComponent,
      'Material Substitutions',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openowner_editor(inParams:{ ownerId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Edit Owner',
        referenceName: 'FootprintManager_owner_editor',
        component: FootprintManager_owner_editorComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openowner_editorDialog(
    inParams:{ ownerId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_owner_editorComponent,
      'Edit Owner',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openpack_verification_completion_editor(inParams:{ shippingContainerId: number, startVerificationTaskId: number, instructions?: { entity?: string, code?: string, instruction?: string, isCompleted?: boolean }[], scannedValues?: { scannedValue: string, lotId: number, packagingId: number }[], properties?: { containerType?: string, dimensions?: string, weight?: string }, targetLocationId: number, can_fail_verification: boolean }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Complete verification',
        referenceName: 'FootprintManager_pack_verification_completion_editor',
        component: FootprintManager_pack_verification_completion_editorComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openpack_verification_completion_editorDialog(
    inParams:{ shippingContainerId: number, startVerificationTaskId: number, instructions?: { entity?: string, code?: string, instruction?: string, isCompleted?: boolean }[], scannedValues?: { scannedValue: string, lotId: number, packagingId: number }[], properties?: { containerType?: string, dimensions?: string, weight?: string }, targetLocationId: number, can_fail_verification: boolean }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_pack_verification_completion_editorComponent,
      'Complete verification',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openpack_verification_shipping_container_properties_editor(inParams:{ shippingContainerId: number, startVerificationTaskId: number, targetLocationId?: number, isReadOnly: boolean, can_fail_verification: boolean }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Shipping container properties',
        referenceName: 'FootprintManager_pack_verification_shipping_container_properties_editor',
        component: FootprintManager_pack_verification_shipping_container_properties_editorComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openpack_verification_shipping_container_properties_editorDialog(
    inParams:{ shippingContainerId: number, startVerificationTaskId: number, targetLocationId?: number, isReadOnly: boolean, can_fail_verification: boolean }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_pack_verification_shipping_container_properties_editorComponent,
      'Shipping container properties',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openpack_verification_verify_container_editor(inParams:{ shippingContainerId: number, startVerificationTaskId: number, isBlind?: boolean, targetLocationId?: number, isReadOnly?: boolean, can_fail_verification: boolean }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Verify Container',
        referenceName: 'FootprintManager_pack_verification_verify_container_editor',
        component: FootprintManager_pack_verification_verify_container_editorComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openpack_verification_verify_container_editorDialog(
    inParams:{ shippingContainerId: number, startVerificationTaskId: number, isBlind?: boolean, targetLocationId?: number, isReadOnly?: boolean, can_fail_verification: boolean }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ scannedValues?: { scannedValue?: string, materialId?: number, serialNumberId?: number, isVerified?: boolean, reasons?: string[], lotId?: number, packagingId?: number }[] }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_pack_verification_verify_container_editorComponent,
      'Verify Container',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openplan_editor(inParams:{ plan_id?: string }, replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'plan_editor');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Plan',
        referenceName: 'FootprintManager_plan_editor',
        component: FootprintManager_plan_editorComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openplan_editorDialog(
    inParams:{ plan_id?: string }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    this.$logger.log('FootprintManager', 'plan_editor');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_plan_editorComponent,
      'Plan',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openprocess_order(inParams:{ order_id: number }, replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'process_order');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Process order',
        referenceName: 'FootprintManager_process_order',
        component: FootprintManager_process_orderComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openprocess_orderDialog(
    inParams:{ order_id: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    this.$logger.log('FootprintManager', 'process_order');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_process_orderComponent,
      'Process order',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openproject_editor(inParams:{ projectId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Edit Project',
        referenceName: 'FootprintManager_project_editor',
        component: FootprintManager_project_editorComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openproject_editorDialog(
    inParams:{ projectId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_project_editorComponent,
      'Edit Project',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openpurchase_order_editor(inParams:{ orderId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Edit purchase order',
        referenceName: 'FootprintManager_purchase_order_editor',
        component: FootprintManager_purchase_order_editorComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openpurchase_order_editorDialog(
    inParams:{ orderId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_purchase_order_editorComponent,
      'Edit purchase order',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openreason_code_editor(inParams:{ reasonCodeId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'reason_code_editor',
        referenceName: 'FootprintManager_reason_code_editor',
        component: FootprintManager_reason_code_editorComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openreason_code_editorDialog(
    inParams:{ reasonCodeId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_reason_code_editorComponent,
      'reason_code_editor',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openreturn_order_editor(inParams:{ orderId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Edit Return Order',
        referenceName: 'FootprintManager_return_order_editor',
        component: FootprintManager_return_order_editorComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openreturn_order_editorDialog(
    inParams:{ orderId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_return_order_editorComponent,
      'Edit Return Order',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opensales_order_editor(inParams:{ orderId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Edit sales order',
        referenceName: 'FootprintManager_sales_order_editor',
        component: FootprintManager_sales_order_editorComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opensales_order_editorDialog(
    inParams:{ orderId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_sales_order_editorComponent,
      'Edit sales order',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opensales_order_line_kit_editor(inParams:{ material_id: number, project_id: number, packaging_id: number, line_number: number, line_status_id: number, packaged_amount: number, order_id: number, shipment_id: number, warehouse_id: number, order_status_id: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Sale order line kit editor',
        referenceName: 'FootprintManager_sales_order_line_kit_editor',
        component: FootprintManager_sales_order_line_kit_editorComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opensales_order_line_kit_editorDialog(
    inParams:{ material_id: number, project_id: number, packaging_id: number, line_number: number, line_status_id: number, packaged_amount: number, order_id: number, shipment_id: number, warehouse_id: number, order_status_id: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_sales_order_line_kit_editorComponent,
      'Sale order line kit editor',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openserialnumber_editor(inParams:{ serialnumberId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Edit serial',
        referenceName: 'FootprintManager_serialnumber_editor',
        component: FootprintManager_serialnumber_editorComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openserialnumber_editorDialog(
    inParams:{ serialnumberId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_serialnumber_editorComponent,
      'Edit serial',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openshipping_container_editor(inParams:{ shippingContainerId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Container',
        referenceName: 'FootprintManager_shipping_container_editor',
        component: FootprintManager_shipping_container_editorComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openshipping_container_editorDialog(
    inParams:{ shippingContainerId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_shipping_container_editorComponent,
      'Container',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opentask_assignment_editor(inParams:{ taskId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Task',
        referenceName: 'FootprintManager_task_assignment_editor',
        component: FootprintManager_task_assignment_editorComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opentask_assignment_editorDialog(
    inParams:{ taskId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ isConfirmed?: boolean }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_task_assignment_editorComponent,
      'Task',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opentask_details_editor(inParams:{ taskId: number, is_non_editable?: boolean }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Task Detail',
        referenceName: 'FootprintManager_task_details_editor',
        component: FootprintManager_task_details_editorComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opentask_details_editorDialog(
    inParams:{ taskId: number, is_non_editable?: boolean }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ isConfirmed?: boolean }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_task_details_editorComponent,
      'Task Detail',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opentransload_order_editor(inParams:{ orderId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Edit Transload Order',
        referenceName: 'FootprintManager_transload_order_editor',
        component: FootprintManager_transload_order_editorComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opentransload_order_editorDialog(
    inParams:{ orderId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_transload_order_editorComponent,
      'Edit Transload Order',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openwarehouse_editor(inParams:{ warehouseId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Edit Warehouse',
        referenceName: 'FootprintManager_warehouse_editor',
        component: FootprintManager_warehouse_editorComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openwarehouse_editorDialog(
    inParams:{ warehouseId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_warehouse_editorComponent,
      'Edit Warehouse',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openwarehouse_transfer_editor(inParams:{ warehouseTransferId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Warehouse transfer editor',
        referenceName: 'FootprintManager_warehouse_transfer_editor',
        component: FootprintManager_warehouse_transfer_editorComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openwarehouse_transfer_editorDialog(
    inParams:{ warehouseTransferId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_warehouse_transfer_editorComponent,
      'Warehouse transfer editor',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openwarehouse_transfer_inbound_order_editor(inParams:{ orderId: number, warehouseTransferId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Edit Inbound Order',
        referenceName: 'FootprintManager_warehouse_transfer_inbound_order_editor',
        component: FootprintManager_warehouse_transfer_inbound_order_editorComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openwarehouse_transfer_inbound_order_editorDialog(
    inParams:{ orderId: number, warehouseTransferId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_warehouse_transfer_inbound_order_editorComponent,
      'Edit Inbound Order',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openwarehouse_transfer_outbound_order_editor(inParams:{ orderId: number, warehouseTransferId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Edit outbound order',
        referenceName: 'FootprintManager_warehouse_transfer_outbound_order_editor',
        component: FootprintManager_warehouse_transfer_outbound_order_editorComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openwarehouse_transfer_outbound_order_editorDialog(
    inParams:{ orderId: number, warehouseTransferId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_warehouse_transfer_outbound_order_editorComponent,
      'Edit outbound order',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openwave_editor(inParams:{ waveId: number, projectId?: number, ownerId?: number, warehouseId?: number, showCreate?: boolean }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Wave editor',
        referenceName: 'FootprintManager_wave_editor',
        component: FootprintManager_wave_editorComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openwave_editorDialog(
    inParams:{ waveId: number, projectId?: number, ownerId?: number, warehouseId?: number, showCreate?: boolean }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_wave_editorComponent,
      'Wave editor',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openwork_class_editor(inParams:{ workClassId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Work class',
        referenceName: 'FootprintManager_work_class_editor',
        component: FootprintManager_work_class_editorComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openwork_class_editorDialog(
    inParams:{ workClassId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ isDeleted?: boolean, isConfirmed?: boolean, promises?: any[] }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_work_class_editorComponent,
      'Work class',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openwork_order_editor(inParams:{ workOrderId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Edit Work Order',
        referenceName: 'FootprintManager_work_order_editor',
        component: FootprintManager_work_order_editorComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openwork_order_editorDialog(
    inParams:{ workOrderId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_work_order_editorComponent,
      'Edit Work Order',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openworkshift_editor(inParams:{ workshift_id: number, is_new: boolean }, replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'workshift_editor');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Workshift Edit',
        referenceName: 'FootprintManager_workshift_editor',
        component: FootprintManager_workshift_editorComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openworkshift_editorDialog(
    inParams:{ workshift_id: number, is_new: boolean }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    this.$logger.log('FootprintManager', 'workshift_editor');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_workshift_editorComponent,
      'Workshift Edit',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openaccessorial_tasks_grid(inParams:{ workOrderId?: number, projectId?: number, entityStatusId: number, orderId?: number, warehouseId: number, shippingContainerId?: number, showAllOpCodes?: boolean, shipmentId?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Accessorials',
        referenceName: 'FootprintManager_accessorial_tasks_grid',
        component: FootprintManager_accessorial_tasks_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openaccessorial_tasks_gridDialog(
    inParams:{ workOrderId?: number, projectId?: number, entityStatusId: number, orderId?: number, warehouseId: number, shippingContainerId?: number, showAllOpCodes?: boolean, shipmentId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_accessorial_tasks_gridComponent,
      'Accessorials',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openaccounts_grid(inParams:{ ownerId: number, accountTypeId: number, typeIds: number[], allowSelection: boolean, title?: string, excludeAccountIds?: number[] }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Addresses',
        referenceName: 'FootprintManager_accounts_grid',
        component: FootprintManager_accounts_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openaccounts_gridDialog(
    inParams:{ ownerId: number, accountTypeId: number, typeIds: number[], allowSelection: boolean, title?: string, excludeAccountIds?: number[] }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ accountId?: number, contactId?: number, addressId?: number, confirm?: boolean, ownerId?: number }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_accounts_gridComponent,
      'Addresses',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openactivity_grid(inParams:{ project_ids?: number[], owner_ids?: number[], warehouse_ids?: number[], operation_code_ids?: number[], status_ids?: number[], location_id?: number, seven_days_before_flag?: boolean }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Activity Grid',
        referenceName: 'FootprintManager_activity_grid',
        component: FootprintManager_activity_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openactivity_gridDialog(
    inParams:{ project_ids?: number[], owner_ids?: number[], warehouse_ids?: number[], operation_code_ids?: number[], status_ids?: number[], location_id?: number, seven_days_before_flag?: boolean }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_activity_gridComponent,
      'Activity Grid',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openallocation_configurations_grid(inParams:{ applicable_config_ids?: number[] }, replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'allocation_configurations_grid');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Allocation configurations',
        referenceName: 'FootprintManager_allocation_configurations_grid',
        component: FootprintManager_allocation_configurations_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openallocation_configurations_gridDialog(
    inParams:{ applicable_config_ids?: number[] }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    this.$logger.log('FootprintManager', 'allocation_configurations_grid');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_allocation_configurations_gridComponent,
      'Allocation configurations',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openasn_order_children_tasks_grid(inParams:{ taskId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'ASN order children tasks',
        referenceName: 'FootprintManager_asn_order_children_tasks_grid',
        component: FootprintManager_asn_order_children_tasks_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openasn_order_children_tasks_gridDialog(
    inParams:{ taskId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_asn_order_children_tasks_gridComponent,
      'ASN order children tasks',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openasn_order_licenseplates_grid(inParams:{ order_id: number, order_status_id: number, project_id: number, can_unreceive?: boolean }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'License plates',
        referenceName: 'FootprintManager_asn_order_licenseplates_grid',
        component: FootprintManager_asn_order_licenseplates_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openasn_order_licenseplates_gridDialog(
    inParams:{ order_id: number, order_status_id: number, project_id: number, can_unreceive?: boolean }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_asn_order_licenseplates_gridComponent,
      'License plates',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openasn_order_licenseplates_receiving_tasks_grid(inParams:{ licenseplateId: number, orderId: number, projectId: number, orderStatusId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Receiving tasks',
        referenceName: 'FootprintManager_asn_order_licenseplates_receiving_tasks_grid',
        component: FootprintManager_asn_order_licenseplates_receiving_tasks_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openasn_order_licenseplates_receiving_tasks_gridDialog(
    inParams:{ licenseplateId: number, orderId: number, projectId: number, orderStatusId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_asn_order_licenseplates_receiving_tasks_gridComponent,
      'Receiving tasks',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openasn_order_receiving_tasks_grid(inParams:{ orderId: number, orderStatusId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Receiving tasks',
        referenceName: 'FootprintManager_asn_order_receiving_tasks_grid',
        component: FootprintManager_asn_order_receiving_tasks_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openasn_order_receiving_tasks_gridDialog(
    inParams:{ orderId: number, orderStatusId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_asn_order_receiving_tasks_gridComponent,
      'Receiving tasks',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openasn_order_tasks_grid(inParams:{ orderId: number, shipmentId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'ASN order tasks',
        referenceName: 'FootprintManager_asn_order_tasks_grid',
        component: FootprintManager_asn_order_tasks_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openasn_order_tasks_gridDialog(
    inParams:{ orderId: number, shipmentId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_asn_order_tasks_gridComponent,
      'ASN order tasks',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openasn_orderlines_grid(inParams:{ orderId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Order lines',
        referenceName: 'FootprintManager_asn_orderlines_grid',
        component: FootprintManager_asn_orderlines_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openasn_orderlines_gridDialog(
    inParams:{ orderId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_asn_orderlines_gridComponent,
      'Order lines',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openassigned_orders_on_wave_grid(inParams:{ waveId: number, waveStatusId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Assigned orders',
        referenceName: 'FootprintManager_assigned_orders_on_wave_grid',
        component: FootprintManager_assigned_orders_on_wave_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openassigned_orders_on_wave_gridDialog(
    inParams:{ waveId: number, waveStatusId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ refresh?: boolean }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_assigned_orders_on_wave_gridComponent,
      'Assigned orders',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openaudit_serial_numbers_grid(inParams:{ scannedBarcodes: { barcode: string, serialNumber: string, isValid: boolean, serialNumberId: number }[], watchList: { barcode: string, serialNumber: string }[], context?: string }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Audit serial numbers',
        referenceName: 'FootprintManager_audit_serial_numbers_grid',
        component: FootprintManager_audit_serial_numbers_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openaudit_serial_numbers_gridDialog(
    inParams:{ scannedBarcodes: { barcode: string, serialNumber: string, isValid: boolean, serialNumberId: number }[], watchList: { barcode: string, serialNumber: string }[], context?: string }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_audit_serial_numbers_gridComponent,
      'Audit serial numbers',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openavailable_inventory_grid(inParams:{ materialId: number, warehouseId: number, recommendedAmount?: number, taskId?: number, lotId?: number, vendorLotId?: number, allowInactive?: boolean }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Available inventory',
        referenceName: 'FootprintManager_available_inventory_grid',
        component: FootprintManager_available_inventory_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openavailable_inventory_gridDialog(
    inParams:{ materialId: number, warehouseId: number, recommendedAmount?: number, taskId?: number, lotId?: number, vendorLotId?: number, allowInactive?: boolean }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_available_inventory_gridComponent,
      'Available inventory',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openbilling_contract_lines_grid(inParams:{ contractId: number, strategyName?: string, edit?: boolean, hide?: string[], statusId?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Billing contract lines',
        referenceName: 'FootprintManager_billing_contract_lines_grid',
        component: FootprintManager_billing_contract_lines_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openbilling_contract_lines_gridDialog(
    inParams:{ contractId: number, strategyName?: string, edit?: boolean, hide?: string[], statusId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ updated?: boolean }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_billing_contract_lines_gridComponent,
      'Billing contract lines',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openbilling_contracts_grid(inParams:{ ownerId?: number, projectId?: number, statusIds?: number[], endDate?: string }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Billing contracts',
        referenceName: 'FootprintManager_billing_contracts_grid',
        component: FootprintManager_billing_contracts_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openbilling_contracts_gridDialog(
    inParams:{ ownerId?: number, projectId?: number, statusIds?: number[], endDate?: string }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_billing_contracts_gridComponent,
      'Billing contracts',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openbilling_projects_grid(inParams:{ billingContractLineId: number, edit: boolean }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Billing projects grid',
        referenceName: 'FootprintManager_billing_projects_grid',
        component: FootprintManager_billing_projects_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openbilling_projects_gridDialog(
    inParams:{ billingContractLineId: number, edit: boolean }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_billing_projects_gridComponent,
      'Billing projects grid',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openbilling_rates_grid(inParams:{ billingContractLineId?: number, edit: boolean, typeId: number, accessorialTemplateLineId?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Billing rates',
        referenceName: 'FootprintManager_billing_rates_grid',
        component: FootprintManager_billing_rates_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openbilling_rates_gridDialog(
    inParams:{ billingContractLineId?: number, edit: boolean, typeId: number, accessorialTemplateLineId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_billing_rates_gridComponent,
      'Billing rates',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openbilling_records_by_invoiceline_grid(inParams:{ invoiceLineId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Billing records by invoice line',
        referenceName: 'FootprintManager_billing_records_by_invoiceline_grid',
        component: FootprintManager_billing_records_by_invoiceline_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openbilling_records_by_invoiceline_gridDialog(
    inParams:{ invoiceLineId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_billing_records_by_invoiceline_gridComponent,
      'Billing records by invoice line',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openbilling_records_grid(inParams:{ ownerId?: number, projectId?: number, materialIds?: number[], warehouseIds?: number[], orderIds?: number[], includeCancelled?: boolean, includeInvoiced?: boolean, shipmentIds?: number[], workOrderId?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Billing records',
        referenceName: 'FootprintManager_billing_records_grid',
        component: FootprintManager_billing_records_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openbilling_records_gridDialog(
    inParams:{ ownerId?: number, projectId?: number, materialIds?: number[], warehouseIds?: number[], orderIds?: number[], includeCancelled?: boolean, includeInvoiced?: boolean, shipmentIds?: number[], workOrderId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_billing_records_gridComponent,
      'Billing records',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openbilling_supplemental_fees_grid(inParams:{ billingContractLineId: number, edit: boolean }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Billing supplemental fees grid',
        referenceName: 'FootprintManager_billing_supplemental_fees_grid',
        component: FootprintManager_billing_supplemental_fees_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openbilling_supplemental_fees_gridDialog(
    inParams:{ billingContractLineId: number, edit: boolean }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_billing_supplemental_fees_gridComponent,
      'Billing supplemental fees grid',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openblind_shipping_container_return_tasks_grid(inParams:{ warehouseId?: number, locationId?: number, sourceShippingContainerId: number, sourceLicensePlateId?: number, inputScan?: string }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Return tasks',
        referenceName: 'FootprintManager_blind_shipping_container_return_tasks_grid',
        component: FootprintManager_blind_shipping_container_return_tasks_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openblind_shipping_container_return_tasks_gridDialog(
    inParams:{ warehouseId?: number, locationId?: number, sourceShippingContainerId: number, sourceLicensePlateId?: number, inputScan?: string }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_blind_shipping_container_return_tasks_gridComponent,
      'Return tasks',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opencarriers_grid(replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Carriers',
        referenceName: 'FootprintManager_carriers_grid',
        component: FootprintManager_carriers_gridComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public opencarriers_gridDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_carriers_gridComponent,
      'Carriers',
      mode,
      dialogSize
    )
  }
  public opencarrierservices_grid(inParams:{ carrierId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Carrier services',
        referenceName: 'FootprintManager_carrierservices_grid',
        component: FootprintManager_carrierservices_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opencarrierservices_gridDialog(
    inParams:{ carrierId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_carrierservices_gridComponent,
      'Carrier services',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opencarrierservicetypes_grid(replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Service types',
        referenceName: 'FootprintManager_carrierservicetypes_grid',
        component: FootprintManager_carrierservicetypes_gridComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public opencarrierservicetypes_gridDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_carrierservicetypes_gridComponent,
      'Service types',
      mode,
      dialogSize
    )
  }
  public openchild_serialnumbers_grid(inParams:{ chainHead: number, archived: boolean, fullTextSearch?: string }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Child serials',
        referenceName: 'FootprintManager_child_serialnumbers_grid',
        component: FootprintManager_child_serialnumbers_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openchild_serialnumbers_gridDialog(
    inParams:{ chainHead: number, archived: boolean, fullTextSearch?: string }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_child_serialnumbers_gridComponent,
      'Child serials',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opencontact_addresses_grid(inParams:{ entity: string, entityId: number, typeIds?: number[] }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Addresses',
        referenceName: 'FootprintManager_contact_addresses_grid',
        component: FootprintManager_contact_addresses_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opencontact_addresses_gridDialog(
    inParams:{ entity: string, entityId: number, typeIds?: number[] }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_contact_addresses_gridComponent,
      'Addresses',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opencontainer_type_assignment_grid(inParams:{ ownerId?: number, projectId?: number, materialId?: number, enabled?: boolean, assignmentLevel?: string }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Container assignment grid',
        referenceName: 'FootprintManager_container_type_assignment_grid',
        component: FootprintManager_container_type_assignment_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opencontainer_type_assignment_gridDialog(
    inParams:{ ownerId?: number, projectId?: number, materialId?: number, enabled?: boolean, assignmentLevel?: string }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_container_type_assignment_gridComponent,
      'Container assignment grid',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opencontainer_types_grid(inParams:{ ownerId?: number, projectId?: number, materialId?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Container types',
        referenceName: 'FootprintManager_container_types_grid',
        component: FootprintManager_container_types_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opencontainer_types_gridDialog(
    inParams:{ ownerId?: number, projectId?: number, materialId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_container_types_gridComponent,
      'Container types',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opencount_tasks_grid(inParams:{ inventoryCountId?: number, allowEdit?: boolean, statusIds?: number[], warehouseIds?: number[] }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Count tasks',
        referenceName: 'FootprintManager_count_tasks_grid',
        component: FootprintManager_count_tasks_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opencount_tasks_gridDialog(
    inParams:{ inventoryCountId?: number, allowEdit?: boolean, statusIds?: number[], warehouseIds?: number[] }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_count_tasks_gridComponent,
      'Count tasks',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opencount_tasks_no_filter_grid(inParams:{ allowEdit?: boolean, statusIds?: number[], warehouseIds?: number[] }, replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'count_tasks_no_filter_grid');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Count tasks',
        referenceName: 'FootprintManager_count_tasks_no_filter_grid',
        component: FootprintManager_count_tasks_no_filter_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opencount_tasks_no_filter_gridDialog(
    inParams:{ allowEdit?: boolean, statusIds?: number[], warehouseIds?: number[] }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    this.$logger.log('FootprintManager', 'count_tasks_no_filter_grid');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_count_tasks_no_filter_gridComponent,
      'Count tasks',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opencustomer_return_shipping_containers_grid(inParams:{ orderId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Shipping containers',
        referenceName: 'FootprintManager_customer_return_shipping_containers_grid',
        component: FootprintManager_customer_return_shipping_containers_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opencustomer_return_shipping_containers_gridDialog(
    inParams:{ orderId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_customer_return_shipping_containers_gridComponent,
      'Shipping containers',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opendock_appointment_types_grid(replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Dock appointment types',
        referenceName: 'FootprintManager_dock_appointment_types_grid',
        component: FootprintManager_dock_appointment_types_gridComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public opendock_appointment_types_gridDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_dock_appointment_types_gridComponent,
      'Dock appointment types',
      mode,
      dialogSize
    )
  }
  public opendock_appointments_dashboard_grid(inParams:{ ownerId?: number, projectId?: number, warehouseIds: number[], typeIds?: number[], statusIds?: number[], fromDate?: string, toDate?: string }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Appointments dashboard',
        referenceName: 'FootprintManager_dock_appointments_dashboard_grid',
        component: FootprintManager_dock_appointments_dashboard_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opendock_appointments_dashboard_gridDialog(
    inParams:{ ownerId?: number, projectId?: number, warehouseIds: number[], typeIds?: number[], statusIds?: number[], fromDate?: string, toDate?: string }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_dock_appointments_dashboard_gridComponent,
      'Appointments dashboard',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opendock_appointments_grid(inParams:{ typeIds?: number[], ownerId?: number, projectId?: number, carrierId?: number, statusIds?: number[], warehouseIds: number[], fromDate?: string, toDate?: string, dockDoorIds?: number[] }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Appointments',
        referenceName: 'FootprintManager_dock_appointments_grid',
        component: FootprintManager_dock_appointments_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opendock_appointments_gridDialog(
    inParams:{ typeIds?: number[], ownerId?: number, projectId?: number, carrierId?: number, statusIds?: number[], warehouseIds: number[], fromDate?: string, toDate?: string, dockDoorIds?: number[] }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_dock_appointments_gridComponent,
      'Appointments',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opendock_appointments_selection_grid(inParams:{ typeIds?: number[], carrierId?: number, statusIds?: number[], warehouseId?: number, scheduledProjectId?: number, excludedDockAppointmentIds?: number[] }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Dock appointments',
        referenceName: 'FootprintManager_dock_appointments_selection_grid',
        component: FootprintManager_dock_appointments_selection_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opendock_appointments_selection_gridDialog(
    inParams:{ typeIds?: number[], carrierId?: number, statusIds?: number[], warehouseId?: number, scheduledProjectId?: number, excludedDockAppointmentIds?: number[] }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ dockAppointmentId?: number }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_dock_appointments_selection_gridComponent,
      'Dock appointments',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openentity_attachments_grid(inParams:{ entityType: string, entityKeys: { name?: string, value?: any }[] }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Attachments',
        referenceName: 'FootprintManager_entity_attachments_grid',
        component: FootprintManager_entity_attachments_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openentity_attachments_gridDialog(
    inParams:{ entityType: string, entityKeys: { name?: string, value?: any }[] }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_entity_attachments_gridComponent,
      'Attachments',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openentity_import_requests_grid(inParams:{ statusCodes?: string[], projects?: string[], warehouses?: string[], singleWarehouse?: string, singleProjectName?: string, singleProjectLookupCode?: string, requestId?: string, projectsExact?: string[], warehousesExact?: string[], dateFrom?: string, dateTo?: string, dateType?: string }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Entity imports',
        referenceName: 'FootprintManager_entity_import_requests_grid',
        component: FootprintManager_entity_import_requests_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openentity_import_requests_gridDialog(
    inParams:{ statusCodes?: string[], projects?: string[], warehouses?: string[], singleWarehouse?: string, singleProjectName?: string, singleProjectLookupCode?: string, requestId?: string, projectsExact?: string[], warehousesExact?: string[], dateFrom?: string, dateTo?: string, dateType?: string }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_entity_import_requests_gridComponent,
      'Entity imports',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openentity_user_defined_field_values_grid(inParams:{ entityType: string, entityKeys: { name?: string, value?: any }[] }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Custom fields',
        referenceName: 'FootprintManager_entity_user_defined_field_values_grid',
        component: FootprintManager_entity_user_defined_field_values_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openentity_user_defined_field_values_gridDialog(
    inParams:{ entityType: string, entityKeys: { name?: string, value?: any }[] }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_entity_user_defined_field_values_gridComponent,
      'Custom fields',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openfield_selector_grid(inParams:{ Columns: { Key?: string, Name?: string, IsSelected?: boolean }[] }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Select fields',
        referenceName: 'FootprintManager_field_selector_grid',
        component: FootprintManager_field_selector_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openfield_selector_gridDialog(
    inParams:{ Columns: { Key?: string, Name?: string, IsSelected?: boolean }[] }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ Columns?: { Key?: string, Name?: string, IsSelected?: boolean }[] }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_field_selector_gridComponent,
      'Select fields',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openfootprint_events_grid(inParams:{ statusIds?: number[], typeIds?: number[] }, replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'footprint_events_grid');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Footprint Events',
        referenceName: 'FootprintManager_footprint_events_grid',
        component: FootprintManager_footprint_events_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openfootprint_events_gridDialog(
    inParams:{ statusIds?: number[], typeIds?: number[] }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    this.$logger.log('FootprintManager', 'footprint_events_grid');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_footprint_events_gridComponent,
      'Footprint Events',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openinbound_orders_grid(inParams:{ ownerId?: number, projectId?: number, warehouseId?: number[], statusIds?: number[], orderClassIds?: number[], reference?: string, materialIds?: number[] }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Inbound orders',
        referenceName: 'FootprintManager_inbound_orders_grid',
        component: FootprintManager_inbound_orders_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openinbound_orders_gridDialog(
    inParams:{ ownerId?: number, projectId?: number, warehouseId?: number[], statusIds?: number[], orderClassIds?: number[], reference?: string, materialIds?: number[] }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_inbound_orders_gridComponent,
      'Inbound orders',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openinspection_operation_codes_grid(replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Operation codes',
        referenceName: 'FootprintManager_inspection_operation_codes_grid',
        component: FootprintManager_inspection_operation_codes_gridComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openinspection_operation_codes_gridDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_inspection_operation_codes_gridComponent,
      'Operation codes',
      mode,
      dialogSize
    )
  }
  public openinspection_tasks_grid(inParams:{ warehouseId: number, operationCodeIds?: number[] }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Inspection tasks',
        referenceName: 'FootprintManager_inspection_tasks_grid',
        component: FootprintManager_inspection_tasks_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openinspection_tasks_gridDialog(
    inParams:{ warehouseId: number, operationCodeIds?: number[] }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_inspection_tasks_gridComponent,
      'Inspection tasks',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openinstructions_grid(inParams:{ entityName: string, enabled: boolean, typeIds?: number[], entityKey1: number, entityKey2?: number, entityKey3?: number, entityKey4?: number, lookup_code?: string }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Instructions',
        referenceName: 'FootprintManager_instructions_grid',
        component: FootprintManager_instructions_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openinstructions_gridDialog(
    inParams:{ entityName: string, enabled: boolean, typeIds?: number[], entityKey1: number, entityKey2?: number, entityKey3?: number, entityKey4?: number, lookup_code?: string }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_instructions_gridComponent,
      'Instructions',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openinventory_by_licenseplate_selection_grid(inParams:{ warehouseId: number, materialId?: number, packagingId?: number, lotId?: number, projectId: number, packagedAmountRequest?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Inventory by LP',
        referenceName: 'FootprintManager_inventory_by_licenseplate_selection_grid',
        component: FootprintManager_inventory_by_licenseplate_selection_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openinventory_by_licenseplate_selection_gridDialog(
    inParams:{ warehouseId: number, materialId?: number, packagingId?: number, lotId?: number, projectId: number, packagedAmountRequest?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ inventory?: { lotId?: number, licenseplateId?: number, packagingId?: number, packagedAmount?: number, vendorLotId?: number }[] }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_inventory_by_licenseplate_selection_gridComponent,
      'Inventory by LP',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openinventory_by_licenseplate_single_selection_grid(inParams:{ warehouseId: number, materialId: number, packagingId: number, lotId?: number, projectId: number, packagedAmountRequest: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Inventory by LP single',
        referenceName: 'FootprintManager_inventory_by_licenseplate_single_selection_grid',
        component: FootprintManager_inventory_by_licenseplate_single_selection_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openinventory_by_licenseplate_single_selection_gridDialog(
    inParams:{ warehouseId: number, materialId: number, packagingId: number, lotId?: number, projectId: number, packagedAmountRequest: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ inventory?: { lotId?: number, licenseplateId?: number, packagingId?: number, packagedAmount?: number, vendorLotId?: number }[] }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_inventory_by_licenseplate_single_selection_gridComponent,
      'Inventory by LP single',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openinventory_by_location_selection_grid(inParams:{ warehouseId: number, materialId?: number, packagingId?: number, lotId?: number, projectId: number, packagedAmountRequest?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Inventory by location',
        referenceName: 'FootprintManager_inventory_by_location_selection_grid',
        component: FootprintManager_inventory_by_location_selection_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openinventory_by_location_selection_gridDialog(
    inParams:{ warehouseId: number, materialId?: number, packagingId?: number, lotId?: number, projectId: number, packagedAmountRequest?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ inventory?: { lotId?: number, locationId?: number, packagingId?: number, packagedAmount?: number, vendorLotId?: number }[] }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_inventory_by_location_selection_gridComponent,
      'Inventory by location',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openinventory_by_lot_selection_grid(inParams:{ warehouseId: number, materialId?: number, packagingId?: number, lotId?: number, projectId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Inventory by lot',
        referenceName: 'FootprintManager_inventory_by_lot_selection_grid',
        component: FootprintManager_inventory_by_lot_selection_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openinventory_by_lot_selection_gridDialog(
    inParams:{ warehouseId: number, materialId?: number, packagingId?: number, lotId?: number, projectId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ inventory?: { lotId?: number, packagingId?: number, packagedAmount?: number }[] }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_inventory_by_lot_selection_gridComponent,
      'Inventory by lot',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openinventory_by_lot_single_selection_grid(inParams:{ warehouseId: number, materialId: number, packagingId: number, projectId: number, packagedAmountRequest: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Inventory by lot single',
        referenceName: 'FootprintManager_inventory_by_lot_single_selection_grid',
        component: FootprintManager_inventory_by_lot_single_selection_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openinventory_by_lot_single_selection_gridDialog(
    inParams:{ warehouseId: number, materialId: number, packagingId: number, projectId: number, packagedAmountRequest: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ inventory?: { lotId?: number, packagingId?: number, packagedAmount?: number, vendorLotId?: number }[] }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_inventory_by_lot_single_selection_gridComponent,
      'Inventory by lot single',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openinventory_by_serialnumber_selection_grid(inParams:{ warehouseId: number, materialId?: number, packagingId?: number, lotId?: number, projectId: number, exclude_serials?: number[] }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Inventory by serialnumber',
        referenceName: 'FootprintManager_inventory_by_serialnumber_selection_grid',
        component: FootprintManager_inventory_by_serialnumber_selection_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openinventory_by_serialnumber_selection_gridDialog(
    inParams:{ warehouseId: number, materialId?: number, packagingId?: number, lotId?: number, projectId: number, exclude_serials?: number[] }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ inventory?: { serial_number_id?: number, lookup_code?: string, chain_head?: number }[] }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_inventory_by_serialnumber_selection_gridComponent,
      'Inventory by serialnumber',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openinventory_by_serialnumber_single_selection_grid(inParams:{ warehouseId: number, materialId: number, packagingId: number, lotId?: number, projectId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Inventory by SN single',
        referenceName: 'FootprintManager_inventory_by_serialnumber_single_selection_grid',
        component: FootprintManager_inventory_by_serialnumber_single_selection_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openinventory_by_serialnumber_single_selection_gridDialog(
    inParams:{ warehouseId: number, materialId: number, packagingId: number, lotId?: number, projectId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ inventory?: { serialnumberId?: number, lotId?: number, vendorLotId?: number }[] }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_inventory_by_serialnumber_single_selection_gridComponent,
      'Inventory by SN single',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openinventory_counts_grid(inParams:{ warehouseIds?: number[], statusIds?: number[] }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Inventory counts',
        referenceName: 'FootprintManager_inventory_counts_grid',
        component: FootprintManager_inventory_counts_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openinventory_counts_gridDialog(
    inParams:{ warehouseIds?: number[], statusIds?: number[] }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_inventory_counts_gridComponent,
      'Inventory counts',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openinventory_licenseplate_grid(inParams:{ licenseplateId?: number, ownerId?: number, projectId?: number, warehouseId?: number, materialIds?: number[] }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Inventory by LP',
        referenceName: 'FootprintManager_inventory_licenseplate_grid',
        component: FootprintManager_inventory_licenseplate_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openinventory_licenseplate_gridDialog(
    inParams:{ licenseplateId?: number, ownerId?: number, projectId?: number, warehouseId?: number, materialIds?: number[] }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_inventory_licenseplate_gridComponent,
      'Inventory by LP',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openinventory_licenseplate_snapshot_grid(inParams:{ captureDate: string, projectId: number, warehouseId: number, materialIds?: number[] }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Inventory licenseplate snapshot',
        referenceName: 'FootprintManager_inventory_licenseplate_snapshot_grid',
        component: FootprintManager_inventory_licenseplate_snapshot_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openinventory_licenseplate_snapshot_gridDialog(
    inParams:{ captureDate: string, projectId: number, warehouseId: number, materialIds?: number[] }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_inventory_licenseplate_snapshot_gridComponent,
      'Inventory licenseplate snapshot',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openinventory_location_grid(inParams:{ ownerId?: number, projectId?: number, warehouseId?: number, locationId?: number, materialIds?: number[], lotId?: number, zonePath?: string }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Inventory',
        referenceName: 'FootprintManager_inventory_location_grid',
        component: FootprintManager_inventory_location_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openinventory_location_gridDialog(
    inParams:{ ownerId?: number, projectId?: number, warehouseId?: number, locationId?: number, materialIds?: number[], lotId?: number, zonePath?: string }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_inventory_location_gridComponent,
      'Inventory',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openinventory_lot_grid(inParams:{ ownerId?: number, projectId?: number, warehouseId?: number, materialIds?: number[] }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Inventory by lot',
        referenceName: 'FootprintManager_inventory_lot_grid',
        component: FootprintManager_inventory_lot_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openinventory_lot_gridDialog(
    inParams:{ ownerId?: number, projectId?: number, warehouseId?: number, materialIds?: number[] }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_inventory_lot_gridComponent,
      'Inventory by lot',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openinventory_lot_snapshot_grid(inParams:{ captureDate: string, projectId: number, warehouseId: number, materialIds?: number[] }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Inventory lot snapshot',
        referenceName: 'FootprintManager_inventory_lot_snapshot_grid',
        component: FootprintManager_inventory_lot_snapshot_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openinventory_lot_snapshot_gridDialog(
    inParams:{ captureDate: string, projectId: number, warehouseId: number, materialIds?: number[] }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_inventory_lot_snapshot_gridComponent,
      'Inventory lot snapshot',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openinventory_material_grid(inParams:{ ownerId?: number, projectId?: number, warehouseId?: number, materialIds?: number[] }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Inventory by material',
        referenceName: 'FootprintManager_inventory_material_grid',
        component: FootprintManager_inventory_material_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openinventory_material_gridDialog(
    inParams:{ ownerId?: number, projectId?: number, warehouseId?: number, materialIds?: number[] }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_inventory_material_gridComponent,
      'Inventory by material',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openinventory_material_snapshot_grid(inParams:{ captureDate: string, projectId: number, warehouseId: number, materialIds?: number[] }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Inventory material snapshot',
        referenceName: 'FootprintManager_inventory_material_snapshot_grid',
        component: FootprintManager_inventory_material_snapshot_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openinventory_material_snapshot_gridDialog(
    inParams:{ captureDate: string, projectId: number, warehouseId: number, materialIds?: number[] }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_inventory_material_snapshot_gridComponent,
      'Inventory material snapshot',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openinventory_measurement_units_grid(replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Packages',
        referenceName: 'FootprintManager_inventory_measurement_units_grid',
        component: FootprintManager_inventory_measurement_units_gridComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openinventory_measurement_units_gridDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_inventory_measurement_units_gridComponent,
      'Packages',
      mode,
      dialogSize
    )
  }
  public openinventory_parent_licenseplate_grid(inParams:{ licenseplateId?: number, ownerId?: number, projectId?: number, warehouseId?: number[], materialIds?: number[] }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Inventory by parent LP',
        referenceName: 'FootprintManager_inventory_parent_licenseplate_grid',
        component: FootprintManager_inventory_parent_licenseplate_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openinventory_parent_licenseplate_gridDialog(
    inParams:{ licenseplateId?: number, ownerId?: number, projectId?: number, warehouseId?: number[], materialIds?: number[] }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_inventory_parent_licenseplate_gridComponent,
      'Inventory by parent LP',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openinventory_statuses_grid(replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Inventory statuses',
        referenceName: 'FootprintManager_inventory_statuses_grid',
        component: FootprintManager_inventory_statuses_gridComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openinventory_statuses_gridDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_inventory_statuses_gridComponent,
      'Inventory statuses',
      mode,
      dialogSize
    )
  }
  public openinventory_tasks_grid(inParams:{ lotId?: number, materialIds?: number[], projectId?: number, licenseplateId?: number, locationId?: number, ownerId?: number, warehouseIds?: number[], materialId?: number, serialnumberId?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Inventory tasks',
        referenceName: 'FootprintManager_inventory_tasks_grid',
        component: FootprintManager_inventory_tasks_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openinventory_tasks_gridDialog(
    inParams:{ lotId?: number, materialIds?: number[], projectId?: number, licenseplateId?: number, locationId?: number, ownerId?: number, warehouseIds?: number[], materialId?: number, serialnumberId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_inventory_tasks_gridComponent,
      'Inventory tasks',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openinventory_transfer_intermediaries_grid(inParams:{ inventoryTransferId: number, code: string, warehouseId: number, sourceProjectId: number, targetProjectId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'inventory transfer intermediaries',
        referenceName: 'FootprintManager_inventory_transfer_intermediaries_grid',
        component: FootprintManager_inventory_transfer_intermediaries_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openinventory_transfer_intermediaries_gridDialog(
    inParams:{ inventoryTransferId: number, code: string, warehouseId: number, sourceProjectId: number, targetProjectId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_inventory_transfer_intermediaries_gridComponent,
      'inventory transfer intermediaries',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openinventory_transfer_lines_grid(inParams:{ inventoryTransferId: number, sourceProjectId?: number, targetProjectId?: number, warehouseId?: number, can_update?: boolean, can_delete?: boolean }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Inventory transfer lines',
        referenceName: 'FootprintManager_inventory_transfer_lines_grid',
        component: FootprintManager_inventory_transfer_lines_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openinventory_transfer_lines_gridDialog(
    inParams:{ inventoryTransferId: number, sourceProjectId?: number, targetProjectId?: number, warehouseId?: number, can_update?: boolean, can_delete?: boolean }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_inventory_transfer_lines_gridComponent,
      'Inventory transfer lines',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openinventory_transfers_grid(inParams:{ warehouses?: number[], sourceProjectId?: number, targetProjectId?: number, statusIds?: number[] }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Inventory transfers',
        referenceName: 'FootprintManager_inventory_transfers_grid',
        component: FootprintManager_inventory_transfers_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openinventory_transfers_gridDialog(
    inParams:{ warehouses?: number[], sourceProjectId?: number, targetProjectId?: number, statusIds?: number[] }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_inventory_transfers_gridComponent,
      'Inventory transfers',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openinventory_transformation_source_lines_grid(inParams:{ inventory_transformation_id: number, line_number?: number, project_id: number, warehouse_id: number, inventory_transformation_status_id?: number, source_read_only?: boolean, target_read_only?: boolean }, replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'inventory_transformation_source_lines_grid');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Inventory transformation source lines',
        referenceName: 'FootprintManager_inventory_transformation_source_lines_grid',
        component: FootprintManager_inventory_transformation_source_lines_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openinventory_transformation_source_lines_gridDialog(
    inParams:{ inventory_transformation_id: number, line_number?: number, project_id: number, warehouse_id: number, inventory_transformation_status_id?: number, source_read_only?: boolean, target_read_only?: boolean }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    this.$logger.log('FootprintManager', 'inventory_transformation_source_lines_grid');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_inventory_transformation_source_lines_gridComponent,
      'Inventory transformation source lines',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openinventory_transformation_source_lines_selector_by_licenseplate_grid(inParams:{ material_id: number, lot_id?: number, vendor_lot_id?: number, warehouse_id?: number, project_id?: number, package_id?: number, inventory_transformation_id: number, type: number, source_line_id?: number, gross_weight?: number, weight_uom?: number }, replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'inventory_transformation_source_lines_selector_by_licenseplate_grid');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'inventory_transformation_source_lines_selector_by_licenseplate_grid',
        referenceName: 'FootprintManager_inventory_transformation_source_lines_selector_by_licenseplate_grid',
        component: FootprintManager_inventory_transformation_source_lines_selector_by_licenseplate_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openinventory_transformation_source_lines_selector_by_licenseplate_gridDialog(
    inParams:{ material_id: number, lot_id?: number, vendor_lot_id?: number, warehouse_id?: number, project_id?: number, package_id?: number, inventory_transformation_id: number, type: number, source_line_id?: number, gross_weight?: number, weight_uom?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ source_line_ids?: number[] }> {
    this.$logger.log('FootprintManager', 'inventory_transformation_source_lines_selector_by_licenseplate_grid');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_inventory_transformation_source_lines_selector_by_licenseplate_gridComponent,
      'inventory_transformation_source_lines_selector_by_licenseplate_grid',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openinventory_transformation_source_lines_selector_by_location_grid(inParams:{ material_id: number, lot_id?: number, vendor_lot_id?: number, warehouse_id?: number, project_id?: number, package_id?: number, inventory_transformation_id: number, type: number }, replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'inventory_transformation_source_lines_selector_by_location_grid');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'inventory_transformation_source_lines_selector_by_location_grid',
        referenceName: 'FootprintManager_inventory_transformation_source_lines_selector_by_location_grid',
        component: FootprintManager_inventory_transformation_source_lines_selector_by_location_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openinventory_transformation_source_lines_selector_by_location_gridDialog(
    inParams:{ material_id: number, lot_id?: number, vendor_lot_id?: number, warehouse_id?: number, project_id?: number, package_id?: number, inventory_transformation_id: number, type: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ source_line_id?: number }> {
    this.$logger.log('FootprintManager', 'inventory_transformation_source_lines_selector_by_location_grid');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_inventory_transformation_source_lines_selector_by_location_gridComponent,
      'inventory_transformation_source_lines_selector_by_location_grid',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openinventory_transformation_source_lines_selector_by_lot_grid(inParams:{ material_id: number, lot_id?: number, vendor_lot_id?: number, warehouse_id?: number, project_id?: number, package_id?: number, inventory_transformation_id: number, type: number, source_line_id?: number, gross_weight?: number, weight_uom?: number }, replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'inventory_transformation_source_lines_selector_by_lot_grid');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'inventory_transformation_source_lines_selector_by_lot_grid',
        referenceName: 'FootprintManager_inventory_transformation_source_lines_selector_by_lot_grid',
        component: FootprintManager_inventory_transformation_source_lines_selector_by_lot_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openinventory_transformation_source_lines_selector_by_lot_gridDialog(
    inParams:{ material_id: number, lot_id?: number, vendor_lot_id?: number, warehouse_id?: number, project_id?: number, package_id?: number, inventory_transformation_id: number, type: number, source_line_id?: number, gross_weight?: number, weight_uom?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ source_line_ids?: number[] }> {
    this.$logger.log('FootprintManager', 'inventory_transformation_source_lines_selector_by_lot_grid');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_inventory_transformation_source_lines_selector_by_lot_gridComponent,
      'inventory_transformation_source_lines_selector_by_lot_grid',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openinventory_transformation_source_lines_selector_by_material_grid(inParams:{ material_id: number, lot_id?: number, vendor_lot_id?: number, warehouse_id?: number, project_id?: number, package_id?: number, inventory_transformation_id: number, type: number, source_line_id?: number, weight?: number, weight_uom?: number }, replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'inventory_transformation_source_lines_selector_by_material_grid');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'inventory_transformation_source_lines_selector_by_material_grid',
        referenceName: 'FootprintManager_inventory_transformation_source_lines_selector_by_material_grid',
        component: FootprintManager_inventory_transformation_source_lines_selector_by_material_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openinventory_transformation_source_lines_selector_by_material_gridDialog(
    inParams:{ material_id: number, lot_id?: number, vendor_lot_id?: number, warehouse_id?: number, project_id?: number, package_id?: number, inventory_transformation_id: number, type: number, source_line_id?: number, weight?: number, weight_uom?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ source_line_ids?: number[] }> {
    this.$logger.log('FootprintManager', 'inventory_transformation_source_lines_selector_by_material_grid');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_inventory_transformation_source_lines_selector_by_material_gridComponent,
      'inventory_transformation_source_lines_selector_by_material_grid',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openinventory_transformation_source_lines_selector_by_serialnumbers_grid(inParams:{ material_id: number, lot_id?: number, vendor_lot_id?: number, warehouse_id?: number, project_id?: number, package_id?: number, inventory_transformation_id: number, type: number, source_line_id?: number, gross_weight?: number, weight_uom?: number }, replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'inventory_transformation_source_lines_selector_by_serialnumbers_grid');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'inventory_transformation_source_lines_selector_by_serialnumbers_grid',
        referenceName: 'FootprintManager_inventory_transformation_source_lines_selector_by_serialnumbers_grid',
        component: FootprintManager_inventory_transformation_source_lines_selector_by_serialnumbers_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openinventory_transformation_source_lines_selector_by_serialnumbers_gridDialog(
    inParams:{ material_id: number, lot_id?: number, vendor_lot_id?: number, warehouse_id?: number, project_id?: number, package_id?: number, inventory_transformation_id: number, type: number, source_line_id?: number, gross_weight?: number, weight_uom?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ source_line_ids?: number[] }> {
    this.$logger.log('FootprintManager', 'inventory_transformation_source_lines_selector_by_serialnumbers_grid');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_inventory_transformation_source_lines_selector_by_serialnumbers_gridComponent,
      'inventory_transformation_source_lines_selector_by_serialnumbers_grid',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openinventory_transformation_target_lines_grid(inParams:{ inventory_transformation_id: number, line_numbers?: number[], source_line_id?: number, inventory_to_transform?: { target_material_id?: number, packaging_id?: number, lot_id?: number, vendor_lot_id?: number, weight?: number, weight_uom?: number, new_quantity?: number, length?: number, width?: number, height?: number, dimensions_uom?: number }, warehouse_id: number, additional_options?: { general: { keep_source_creation_date: boolean, convert_packaging_to_base: boolean }, serial_number_options: { copy_weights: boolean, copy_volume: boolean, copy_dimensions: boolean }, lot_number_options: { copy_udfs: boolean, copy_lot_number: boolean, copy_vendor_lot_number: boolean } }, is_read_only?: boolean, inventory_transformation_status_id?: number }, replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'inventory_transformation_target_lines_grid');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Inventory transformation target lines',
        referenceName: 'FootprintManager_inventory_transformation_target_lines_grid',
        component: FootprintManager_inventory_transformation_target_lines_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openinventory_transformation_target_lines_gridDialog(
    inParams:{ inventory_transformation_id: number, line_numbers?: number[], source_line_id?: number, inventory_to_transform?: { target_material_id?: number, packaging_id?: number, lot_id?: number, vendor_lot_id?: number, weight?: number, weight_uom?: number, new_quantity?: number, length?: number, width?: number, height?: number, dimensions_uom?: number }, warehouse_id: number, additional_options?: { general: { keep_source_creation_date: boolean, convert_packaging_to_base: boolean }, serial_number_options: { copy_weights: boolean, copy_volume: boolean, copy_dimensions: boolean }, lot_number_options: { copy_udfs: boolean, copy_lot_number: boolean, copy_vendor_lot_number: boolean } }, is_read_only?: boolean, inventory_transformation_status_id?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ target_line_id?: number }> {
    this.$logger.log('FootprintManager', 'inventory_transformation_target_lines_grid');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_inventory_transformation_target_lines_gridComponent,
      'Inventory transformation target lines',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openinventory_transformations_grid(inParams:{ owner_id?: number, project_id?: number, warehouse_ids?: number[], status_ids?: number[] }, replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'inventory_transformations_grid');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'inventory_transformations_grid',
        referenceName: 'FootprintManager_inventory_transformations_grid',
        component: FootprintManager_inventory_transformations_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openinventory_transformations_gridDialog(
    inParams:{ owner_id?: number, project_id?: number, warehouse_ids?: number[], status_ids?: number[] }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    this.$logger.log('FootprintManager', 'inventory_transformations_grid');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_inventory_transformations_gridComponent,
      'inventory_transformations_grid',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openinvoice_lines_grid(inParams:{ invoiceId: number, invoiceTypeId?: number, open_to_line?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Invoice lines',
        referenceName: 'FootprintManager_invoice_lines_grid',
        component: FootprintManager_invoice_lines_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openinvoice_lines_gridDialog(
    inParams:{ invoiceId: number, invoiceTypeId?: number, open_to_line?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_invoice_lines_gridComponent,
      'Invoice lines',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openinvoices_grid(inParams:{ ownerId?: number, projectId?: number, statusIds?: number[] }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Invoices',
        referenceName: 'FootprintManager_invoices_grid',
        component: FootprintManager_invoices_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openinvoices_gridDialog(
    inParams:{ ownerId?: number, projectId?: number, statusIds?: number[] }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_invoices_gridComponent,
      'Invoices',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openlicenseplate_grid(inParams:{ locationId: number, lotId: number, packagedId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Select a licenseplate',
        referenceName: 'FootprintManager_licenseplate_grid',
        component: FootprintManager_licenseplate_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openlicenseplate_gridDialog(
    inParams:{ locationId: number, lotId: number, packagedId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean, licenseplateId?: number, packagedAmount?: number, packagingId?: number }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_licenseplate_gridComponent,
      'Select a licenseplate',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openload_container_orders_grid(inParams:{ loadContainerId: number, edit?: boolean, warehouseId?: number, orderTypeId?: number, status_id?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Orders by load container',
        referenceName: 'FootprintManager_load_container_orders_grid',
        component: FootprintManager_load_container_orders_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openload_container_orders_gridDialog(
    inParams:{ loadContainerId: number, edit?: boolean, warehouseId?: number, orderTypeId?: number, status_id?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ warehouseId?: number, orderTypeId?: number, ownerId?: number, projectId?: number, carrierId?: number, createdCount?: number }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_load_container_orders_gridComponent,
      'Orders by load container',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openload_container_unassigned_orders_grid(inParams:{ ownerId?: number, projectId?: number, statusIds?: number[], orderTypeId?: number, warehouseId?: number, loadContainerId?: number, lookupCode?: string }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Unassigned orders for load containers',
        referenceName: 'FootprintManager_load_container_unassigned_orders_grid',
        component: FootprintManager_load_container_unassigned_orders_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openload_container_unassigned_orders_gridDialog(
    inParams:{ ownerId?: number, projectId?: number, statusIds?: number[], orderTypeId?: number, warehouseId?: number, loadContainerId?: number, lookupCode?: string }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_load_container_unassigned_orders_gridComponent,
      'Unassigned orders for load containers',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openload_containers_grid(inParams:{ statusIds?: number[], ownerId?: number, orderTypeIds?: number[] }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Load containers',
        referenceName: 'FootprintManager_load_containers_grid',
        component: FootprintManager_load_containers_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openload_containers_gridDialog(
    inParams:{ statusIds?: number[], ownerId?: number, orderTypeIds?: number[] }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_load_containers_gridComponent,
      'Load containers',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openlocation_projects_grid(inParams:{ locationId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Location project assignments',
        referenceName: 'FootprintManager_location_projects_grid',
        component: FootprintManager_location_projects_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openlocation_projects_gridDialog(
    inParams:{ locationId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_location_projects_gridComponent,
      'Location project assignments',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openlocations_grid(inParams:{ warehouseId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Locations',
        referenceName: 'FootprintManager_locations_grid',
        component: FootprintManager_locations_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openlocations_gridDialog(
    inParams:{ warehouseId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_locations_gridComponent,
      'Locations',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openlocations_navigational_grid(inParams:{ warehouseId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Locations',
        referenceName: 'FootprintManager_locations_navigational_grid',
        component: FootprintManager_locations_navigational_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openlocations_navigational_gridDialog(
    inParams:{ warehouseId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_locations_navigational_gridComponent,
      'Locations',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openlocations_replenishments_grid(inParams:{ materialId?: number[], warehouseIds?: number[], locationId?: number[], projectId?: number, ownerId?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Replenishments',
        referenceName: 'FootprintManager_locations_replenishments_grid',
        component: FootprintManager_locations_replenishments_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openlocations_replenishments_gridDialog(
    inParams:{ materialId?: number[], warehouseIds?: number[], locationId?: number[], projectId?: number, ownerId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_locations_replenishments_gridComponent,
      'Replenishments',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openlocations_selector_grid(inParams:{ warehouseId: number, selectedLocationIds?: number[], isExclude?: boolean, allowEdit: boolean }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Location selector',
        referenceName: 'FootprintManager_locations_selector_grid',
        component: FootprintManager_locations_selector_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openlocations_selector_gridDialog(
    inParams:{ warehouseId: number, selectedLocationIds?: number[], isExclude?: boolean, allowEdit: boolean }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ selectedLocationIds?: number[] }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_locations_selector_gridComponent,
      'Location selector',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openlots_grid(inParams:{ ownerIds?: number[], projectIds?: number[], materialIds?: number[], statusIds?: number[] }, replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'lots_grid');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Lots grid',
        referenceName: 'FootprintManager_lots_grid',
        component: FootprintManager_lots_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openlots_gridDialog(
    inParams:{ ownerIds?: number[], projectIds?: number[], materialIds?: number[], statusIds?: number[] }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    this.$logger.log('FootprintManager', 'lots_grid');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_lots_gridComponent,
      'Lots grid',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openlots_grid_flat(inParams:{ ownerIds?: number[], projectIds?: number[], materialIds?: number[], statusIds?: number[] }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Lots grid from flat data source',
        referenceName: 'FootprintManager_lots_grid_flat',
        component: FootprintManager_lots_grid_flatComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openlots_grid_flatDialog(
    inParams:{ ownerIds?: number[], projectIds?: number[], materialIds?: number[], statusIds?: number[] }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_lots_grid_flatComponent,
      'Lots grid from flat data source',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openlots_udf_grid(inParams:{ projectId?: number, ownerId?: number, materialIds?: number[], lotId?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Lots UDF',
        referenceName: 'FootprintManager_lots_udf_grid',
        component: FootprintManager_lots_udf_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openlots_udf_gridDialog(
    inParams:{ projectId?: number, ownerId?: number, materialIds?: number[], lotId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_lots_udf_gridComponent,
      'Lots UDF',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openmanual_allocations_grid(inParams:{ waveId?: number, orderId?: number, allowInactive?: boolean }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Manual allocations',
        referenceName: 'FootprintManager_manual_allocations_grid',
        component: FootprintManager_manual_allocations_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openmanual_allocations_gridDialog(
    inParams:{ waveId?: number, orderId?: number, allowInactive?: boolean }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_manual_allocations_gridComponent,
      'Manual allocations',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openmanufacturing_equipment_grid(inParams:{ warehouse: number }, replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'manufacturing_equipment_grid');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Equipment',
        referenceName: 'FootprintManager_manufacturing_equipment_grid',
        component: FootprintManager_manufacturing_equipment_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openmanufacturing_equipment_gridDialog(
    inParams:{ warehouse: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    this.$logger.log('FootprintManager', 'manufacturing_equipment_grid');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_manufacturing_equipment_gridComponent,
      'Equipment',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openmanufacturing_locations_grid(inParams:{ warehouse_id: number }, replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'manufacturing_locations_grid');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Locations',
        referenceName: 'FootprintManager_manufacturing_locations_grid',
        component: FootprintManager_manufacturing_locations_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openmanufacturing_locations_gridDialog(
    inParams:{ warehouse_id: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    this.$logger.log('FootprintManager', 'manufacturing_locations_grid');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_manufacturing_locations_gridComponent,
      'Locations',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openmanufacturing_order_component_serial_number_selection_grid(inParams:{ material_id?: number, warehouse_id?: number, serials_needed_count?: number, iteration?: number, license_plate?: number }, replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'manufacturing_order_component_serial_number_selection_grid');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'manufacturing_order_component_serial_number_selection_grid',
        referenceName: 'FootprintManager_manufacturing_order_component_serial_number_selection_grid',
        component: FootprintManager_manufacturing_order_component_serial_number_selection_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openmanufacturing_order_component_serial_number_selection_gridDialog(
    inParams:{ material_id?: number, warehouse_id?: number, serials_needed_count?: number, iteration?: number, license_plate?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ valid_data?: boolean, iteration?: number }> {
    this.$logger.log('FootprintManager', 'manufacturing_order_component_serial_number_selection_grid');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_manufacturing_order_component_serial_number_selection_gridComponent,
      'manufacturing_order_component_serial_number_selection_grid',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openmanufacturing_order_line_components_production_confirmation_grid(inParams:{ finished_good_id?: number, warehouse_id?: number, quantity_to_produce?: number, license_plate_ids?: number[], location_id?: number, project_id?: number }, replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'manufacturing_order_line_components_production_confirmation_grid');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Order line components production confirmation grid',
        referenceName: 'FootprintManager_manufacturing_order_line_components_production_confirmation_grid',
        component: FootprintManager_manufacturing_order_line_components_production_confirmation_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openmanufacturing_order_line_components_production_confirmation_gridDialog(
    inParams:{ finished_good_id?: number, warehouse_id?: number, quantity_to_produce?: number, license_plate_ids?: number[], location_id?: number, project_id?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ data?: { lineNumber?: number, consumedQuantity?: number, scrappedQuantity?: number, sourceLicensePlate?: number, lot?: number, lotExpiration?: string, mainComponentIdentifier?: number, packageId?: number, componentMaterialId?: number }[] }> {
    this.$logger.log('FootprintManager', 'manufacturing_order_line_components_production_confirmation_grid');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_manufacturing_order_line_components_production_confirmation_gridComponent,
      'Order line components production confirmation grid',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openmanufacturing_order_line_production_confirmation_grid(inParams:{ finished_good?: string, planned_quantity?: number, material_id?: number, output_location_id?: number }, replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'manufacturing_order_line_production_confirmation_grid');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Order line production confirmation',
        referenceName: 'FootprintManager_manufacturing_order_line_production_confirmation_grid',
        component: FootprintManager_manufacturing_order_line_production_confirmation_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openmanufacturing_order_line_production_confirmation_gridDialog(
    inParams:{ finished_good?: string, planned_quantity?: number, material_id?: number, output_location_id?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ license_plate_ids?: { amountToIncrease?: number, licensePlate?: number, lotId?: number, materialId?: number, packaging?: number }[], actual_produced_quantity?: number }> {
    this.$logger.log('FootprintManager', 'manufacturing_order_line_production_confirmation_grid');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_manufacturing_order_line_production_confirmation_gridComponent,
      'Order line production confirmation',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openmanufacturing_order_lines_components_for_process_grid(inParams:{ order_id: number, warehouse_id: number }, replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'manufacturing_order_lines_components_for_process_grid');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Components to be processed',
        referenceName: 'FootprintManager_manufacturing_order_lines_components_for_process_grid',
        component: FootprintManager_manufacturing_order_lines_components_for_process_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openmanufacturing_order_lines_components_for_process_gridDialog(
    inParams:{ order_id: number, warehouse_id: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    this.$logger.log('FootprintManager', 'manufacturing_order_lines_components_for_process_grid');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_manufacturing_order_lines_components_for_process_gridComponent,
      'Components to be processed',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openmanufacturing_order_lines_components_grid(inParams:{ finished_good_id: number, warehouse_id: number, finished_good_quantity?: number, is_kit?: boolean, project_id: number, order_id: number, line_number: number, order_status_id: number }, replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'manufacturing_order_lines_components_grid');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Manufacturing Order Lines Components',
        referenceName: 'FootprintManager_manufacturing_order_lines_components_grid',
        component: FootprintManager_manufacturing_order_lines_components_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openmanufacturing_order_lines_components_gridDialog(
    inParams:{ finished_good_id: number, warehouse_id: number, finished_good_quantity?: number, is_kit?: boolean, project_id: number, order_id: number, line_number: number, order_status_id: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    this.$logger.log('FootprintManager', 'manufacturing_order_lines_components_grid');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_manufacturing_order_lines_components_gridComponent,
      'Manufacturing Order Lines Components',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openmanufacturing_order_lines_grid(inParams:{ order_id: number, project_id: number, order_status_id: number, warehouse_id: number, output_location_id?: number, source_location_id?: number }, replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'manufacturing_order_lines_grid');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Manufacturing order lines',
        referenceName: 'FootprintManager_manufacturing_order_lines_grid',
        component: FootprintManager_manufacturing_order_lines_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openmanufacturing_order_lines_gridDialog(
    inParams:{ order_id: number, project_id: number, order_status_id: number, warehouse_id: number, output_location_id?: number, source_location_id?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    this.$logger.log('FootprintManager', 'manufacturing_order_lines_grid');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_manufacturing_order_lines_gridComponent,
      'Manufacturing order lines',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openmanufacturing_order_lines_production_sub_components_grid(inParams:{ material_id?: number, location_id?: number, component?: string, main_component_identifier?: number, rows?: { lineNumber: number, consumedQuantity: number, scrappedQuantity: number, sourceLicensePlate: number, lot: number, lotExpiration: string, mainComponentIdentifier: number, packageId: number, componentMaterialId: number }[], package_id?: number, project_id?: number, warehouse_id?: number }, replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'manufacturing_order_lines_production_sub_components_grid');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Selecting component for manufacturing production',
        referenceName: 'FootprintManager_manufacturing_order_lines_production_sub_components_grid',
        component: FootprintManager_manufacturing_order_lines_production_sub_components_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openmanufacturing_order_lines_production_sub_components_gridDialog(
    inParams:{ material_id?: number, location_id?: number, component?: string, main_component_identifier?: number, rows?: { lineNumber: number, consumedQuantity: number, scrappedQuantity: number, sourceLicensePlate: number, lot: number, lotExpiration: string, mainComponentIdentifier: number, packageId: number, componentMaterialId: number }[], package_id?: number, project_id?: number, warehouse_id?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ rows?: { lineNumber?: number, component?: string, consumedQuantity?: number, scrappedQuantity?: number, unusedQuantity?: number, sourceLicensePlate?: number, lot?: number, lotExpiration?: string, mainComponentIdentifier?: number, packageId?: number, componentMaterialId?: number }[] }> {
    this.$logger.log('FootprintManager', 'manufacturing_order_lines_production_sub_components_grid');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_manufacturing_order_lines_production_sub_components_gridComponent,
      'Selecting component for manufacturing production',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openmanufacturing_order_return_to_stock_grid(inParams:{ manufacturing_order_line_id?: number, warehouse_id?: number, location: number, manufacturing_order_id?: number, task_chain_head?: number }, replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'manufacturing_order_return_to_stock_grid');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Components',
        referenceName: 'FootprintManager_manufacturing_order_return_to_stock_grid',
        component: FootprintManager_manufacturing_order_return_to_stock_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openmanufacturing_order_return_to_stock_gridDialog(
    inParams:{ manufacturing_order_line_id?: number, warehouse_id?: number, location: number, manufacturing_order_id?: number, task_chain_head?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ rows?: { materialId?: number, lot?: number, amountToReturn?: number, licensePlate?: number, packageId?: number, sourceLicensePlate?: number, targetLot?: number }[] }> {
    this.$logger.log('FootprintManager', 'manufacturing_order_return_to_stock_grid');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_manufacturing_order_return_to_stock_gridComponent,
      'Components',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openmanufacturing_order_undo_manufacturing_production_components_grid(inParams:{ manufacturing_order_id?: number, manufacturing_order_line_id?: number, chain_head_id?: number }, replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'manufacturing_order_undo_manufacturing_production_components_grid');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Undo production confirmation',
        referenceName: 'FootprintManager_manufacturing_order_undo_manufacturing_production_components_grid',
        component: FootprintManager_manufacturing_order_undo_manufacturing_production_components_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openmanufacturing_order_undo_manufacturing_production_components_gridDialog(
    inParams:{ manufacturing_order_id?: number, manufacturing_order_line_id?: number, chain_head_id?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ rows?: { material_id?: number, increase_quantity?: number, license_plate?: number, location?: number, lot?: number, packaging_id?: number }[] }> {
    this.$logger.log('FootprintManager', 'manufacturing_order_undo_manufacturing_production_components_grid');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_manufacturing_order_undo_manufacturing_production_components_gridComponent,
      'Undo production confirmation',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openmanufacturing_order_undo_manufacturing_production_finished_product_grid(inParams:{ manufacturing_order_id?: number, manufacturing_order_line_id?: number, task_chain_head?: number }, replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'manufacturing_order_undo_manufacturing_production_finished_product_grid');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Undoing manufacturing production for the finished products',
        referenceName: 'FootprintManager_manufacturing_order_undo_manufacturing_production_finished_product_grid',
        component: FootprintManager_manufacturing_order_undo_manufacturing_production_finished_product_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openmanufacturing_order_undo_manufacturing_production_finished_product_gridDialog(
    inParams:{ manufacturing_order_id?: number, manufacturing_order_line_id?: number, task_chain_head?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ rows?: { material_id?: number, decrease_quantity?: number, license_plate?: number, location?: number, packaging_id?: number, lot?: number }[] }> {
    this.$logger.log('FootprintManager', 'manufacturing_order_undo_manufacturing_production_finished_product_grid');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_manufacturing_order_undo_manufacturing_production_finished_product_gridComponent,
      'Undoing manufacturing production for the finished products',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openmanufacturing_orders_grid(inParams:{ warehouse_ids?: number[], owner_id?: number, project_id?: number, status_ids?: number[] }, replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'manufacturing_orders_grid');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Orders',
        referenceName: 'FootprintManager_manufacturing_orders_grid',
        component: FootprintManager_manufacturing_orders_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openmanufacturing_orders_gridDialog(
    inParams:{ warehouse_ids?: number[], owner_id?: number, project_id?: number, status_ids?: number[] }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    this.$logger.log('FootprintManager', 'manufacturing_orders_grid');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_manufacturing_orders_gridComponent,
      'Orders',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openmanufacturing_orders_manufacturing_production_components_grid(inParams:{ manufacturing_order_id?: number, manufacturing_order_line_id?: number, warehouse_id?: number, task_chain_head?: number }, replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'manufacturing_orders_manufacturing_production_components_grid');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Manufacturing order production components',
        referenceName: 'FootprintManager_manufacturing_orders_manufacturing_production_components_grid',
        component: FootprintManager_manufacturing_orders_manufacturing_production_components_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openmanufacturing_orders_manufacturing_production_components_gridDialog(
    inParams:{ manufacturing_order_id?: number, manufacturing_order_line_id?: number, warehouse_id?: number, task_chain_head?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    this.$logger.log('FootprintManager', 'manufacturing_orders_manufacturing_production_components_grid');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_manufacturing_orders_manufacturing_production_components_gridComponent,
      'Manufacturing order production components',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openmanufacturing_orders_manufacturing_production_grid(inParams:{ manufacturing_order_id?: number }, replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'manufacturing_orders_manufacturing_production_grid');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Manufacturing production',
        referenceName: 'FootprintManager_manufacturing_orders_manufacturing_production_grid',
        component: FootprintManager_manufacturing_orders_manufacturing_production_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openmanufacturing_orders_manufacturing_production_gridDialog(
    inParams:{ manufacturing_order_id?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    this.$logger.log('FootprintManager', 'manufacturing_orders_manufacturing_production_grid');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_manufacturing_orders_manufacturing_production_gridComponent,
      'Manufacturing production',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openmanufacturing_workshifts_grid(inParams:{ warehouse: number }, replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'manufacturing_workshifts_grid');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Workshifts',
        referenceName: 'FootprintManager_manufacturing_workshifts_grid',
        component: FootprintManager_manufacturing_workshifts_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openmanufacturing_workshifts_gridDialog(
    inParams:{ warehouse: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    this.$logger.log('FootprintManager', 'manufacturing_workshifts_grid');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_manufacturing_workshifts_gridComponent,
      'Workshifts',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openmaterial_aliases_grid(inParams:{ material_id: number, project_id: number, materialCode?: string }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Material aliases',
        referenceName: 'FootprintManager_material_aliases_grid',
        component: FootprintManager_material_aliases_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openmaterial_aliases_gridDialog(
    inParams:{ material_id: number, project_id: number, materialCode?: string }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_material_aliases_gridComponent,
      'Material aliases',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openmaterial_catalog_source_material_project_subscribers_grid(inParams:{ source_material_id: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Material catalog source material project subscribers',
        referenceName: 'FootprintManager_material_catalog_source_material_project_subscribers_grid',
        component: FootprintManager_material_catalog_source_material_project_subscribers_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openmaterial_catalog_source_material_project_subscribers_gridDialog(
    inParams:{ source_material_id: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_material_catalog_source_material_project_subscribers_gridComponent,
      'Material catalog source material project subscribers',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openmaterial_catalog_source_materials_grid(inParams:{ catalog_id: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Material catalog source materials',
        referenceName: 'FootprintManager_material_catalog_source_materials_grid',
        component: FootprintManager_material_catalog_source_materials_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openmaterial_catalog_source_materials_gridDialog(
    inParams:{ catalog_id: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_material_catalog_source_materials_gridComponent,
      'Material catalog source materials',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openmaterial_catalogs_by_project_grid(inParams:{ project_id: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Material catalogs by project',
        referenceName: 'FootprintManager_material_catalogs_by_project_grid',
        component: FootprintManager_material_catalogs_by_project_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openmaterial_catalogs_by_project_gridDialog(
    inParams:{ project_id: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_material_catalogs_by_project_gridComponent,
      'Material catalogs by project',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openmaterial_catalogs_grid(replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Material catalogs',
        referenceName: 'FootprintManager_material_catalogs_grid',
        component: FootprintManager_material_catalogs_gridComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openmaterial_catalogs_gridDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_material_catalogs_gridComponent,
      'Material catalogs',
      mode,
      dialogSize
    )
  }
  public openmaterial_catalogs_project_subscribers_grid(inParams:{ catalog_id: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Material catalog project subscribers',
        referenceName: 'FootprintManager_material_catalogs_project_subscribers_grid',
        component: FootprintManager_material_catalogs_project_subscribers_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openmaterial_catalogs_project_subscribers_gridDialog(
    inParams:{ catalog_id: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_material_catalogs_project_subscribers_gridComponent,
      'Material catalog project subscribers',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openmaterial_components_grid(inParams:{ material_id: number, packaging_id: number, project_id: number, suppress_new_row: boolean }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Material components',
        referenceName: 'FootprintManager_material_components_grid',
        component: FootprintManager_material_components_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openmaterial_components_gridDialog(
    inParams:{ material_id: number, packaging_id: number, project_id: number, suppress_new_row: boolean }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_material_components_gridComponent,
      'Material components',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openmaterial_kits_grid(inParams:{ material_id: number, project_id: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Material kits',
        referenceName: 'FootprintManager_material_kits_grid',
        component: FootprintManager_material_kits_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openmaterial_kits_gridDialog(
    inParams:{ material_id: number, project_id: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_material_kits_gridComponent,
      'Material kits',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openmaterial_packagings_by_project_grid(inParams:{ materialIds?: number[], ownerId?: number, projectId?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Packagings by project',
        referenceName: 'FootprintManager_material_packagings_by_project_grid',
        component: FootprintManager_material_packagings_by_project_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openmaterial_packagings_by_project_gridDialog(
    inParams:{ materialIds?: number[], ownerId?: number, projectId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_material_packagings_by_project_gridComponent,
      'Packagings by project',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openmaterial_packagings_grid(inParams:{ materialId?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Packagings',
        referenceName: 'FootprintManager_material_packagings_grid',
        component: FootprintManager_material_packagings_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openmaterial_packagings_gridDialog(
    inParams:{ materialId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_material_packagings_gridComponent,
      'Packagings',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openmaterial_substitutions_grid(inParams:{ material_id: number, packaging_id: number, project_id: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Material substitutions',
        referenceName: 'FootprintManager_material_substitutions_grid',
        component: FootprintManager_material_substitutions_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openmaterial_substitutions_gridDialog(
    inParams:{ material_id: number, packaging_id: number, project_id: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_material_substitutions_gridComponent,
      'Material substitutions',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openmaterials_by_base_packaging_grid(inParams:{ projectId?: number, ownerId?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Materials',
        referenceName: 'FootprintManager_materials_by_base_packaging_grid',
        component: FootprintManager_materials_by_base_packaging_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openmaterials_by_base_packaging_gridDialog(
    inParams:{ projectId?: number, ownerId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_materials_by_base_packaging_gridComponent,
      'Materials',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openmaterials_navigational_grid(inParams:{ ownerId?: number, projectId?: number, materialIds?: number[] }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Materials',
        referenceName: 'FootprintManager_materials_navigational_grid',
        component: FootprintManager_materials_navigational_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openmaterials_navigational_gridDialog(
    inParams:{ ownerId?: number, projectId?: number, materialIds?: number[] }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_materials_navigational_gridComponent,
      'Materials',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openmaterials_selector_grid(inParams:{ selectedMaterialIds?: number[], isExclude?: boolean, allowEdit: boolean }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Material selector',
        referenceName: 'FootprintManager_materials_selector_grid',
        component: FootprintManager_materials_selector_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openmaterials_selector_gridDialog(
    inParams:{ selectedMaterialIds?: number[], isExclude?: boolean, allowEdit: boolean }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ selectedMaterialIds?: number[] }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_materials_selector_gridComponent,
      'Material selector',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openmaterials_udf_grid(inParams:{ projectId?: number, ownerId?: number, materialIds?: number[] }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Materials advanced',
        referenceName: 'FootprintManager_materials_udf_grid',
        component: FootprintManager_materials_udf_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openmaterials_udf_gridDialog(
    inParams:{ projectId?: number, ownerId?: number, materialIds?: number[] }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_materials_udf_gridComponent,
      'Materials advanced',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openorderaddresses_grid(inParams:{ orderId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Order addresses',
        referenceName: 'FootprintManager_orderaddresses_grid',
        component: FootprintManager_orderaddresses_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openorderaddresses_gridDialog(
    inParams:{ orderId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_orderaddresses_gridComponent,
      'Order addresses',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openoutbound_orders_eligible_for_return_grid(inParams:{ warehouseIds?: number[], ownerId?: number, projectId?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Completed outbound orders',
        referenceName: 'FootprintManager_outbound_orders_eligible_for_return_grid',
        component: FootprintManager_outbound_orders_eligible_for_return_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openoutbound_orders_eligible_for_return_gridDialog(
    inParams:{ warehouseIds?: number[], ownerId?: number, projectId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ orderIds?: number[] }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_outbound_orders_eligible_for_return_gridComponent,
      'Completed outbound orders',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openoutbound_orders_grid(inParams:{ ownerId?: number, projectId?: number, warehouseId?: number[], statusIds?: number[], countries?: string[], carrierId?: number, carrierServiceId?: number, reference?: string, materialIds?: number[], waveId?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Outbound orders',
        referenceName: 'FootprintManager_outbound_orders_grid',
        component: FootprintManager_outbound_orders_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openoutbound_orders_gridDialog(
    inParams:{ ownerId?: number, projectId?: number, warehouseId?: number[], statusIds?: number[], countries?: string[], carrierId?: number, carrierServiceId?: number, reference?: string, materialIds?: number[], waveId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_outbound_orders_gridComponent,
      'Outbound orders',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openowners_navigation_grid(inParams:{ ownerStatusId?: number, ownerId?: number, projectIds?: number[] }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Owners',
        referenceName: 'FootprintManager_owners_navigation_grid',
        component: FootprintManager_owners_navigation_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openowners_navigation_gridDialog(
    inParams:{ ownerStatusId?: number, ownerId?: number, projectIds?: number[] }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_owners_navigation_gridComponent,
      'Owners',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openownersaccounts_grid(inParams:{ ownerId: number, accountTypeId: number, typeIds: number[], allowSelection: boolean }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Addresses',
        referenceName: 'FootprintManager_ownersaccounts_grid',
        component: FootprintManager_ownersaccounts_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openownersaccounts_gridDialog(
    inParams:{ ownerId: number, accountTypeId: number, typeIds: number[], allowSelection: boolean }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ accountId?: number, contactId?: number, addressId?: number, confirm?: boolean }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_ownersaccounts_gridComponent,
      'Addresses',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openownerscarrierslookup_grid(inParams:{ ownerId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Owner carriers lookup',
        referenceName: 'FootprintManager_ownerscarrierslookup_grid',
        component: FootprintManager_ownerscarrierslookup_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openownerscarrierslookup_gridDialog(
    inParams:{ ownerId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_ownerscarrierslookup_gridComponent,
      'Owner carriers lookup',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openpack_verification_instructions_grid(inParams:{ shippingContainerId: number, startVerificationTaskId: number, isReadOnly: boolean }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Instructions',
        referenceName: 'FootprintManager_pack_verification_instructions_grid',
        component: FootprintManager_pack_verification_instructions_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openpack_verification_instructions_gridDialog(
    inParams:{ shippingContainerId: number, startVerificationTaskId: number, isReadOnly: boolean }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_pack_verification_instructions_gridComponent,
      'Instructions',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openpack_verification_shipping_container_contents_grid(inParams:{ shippingContainerId: number, canAddManually?: boolean, startVerificationTaskId: number, isReadOnly?: boolean, scannedValues: { scannedValue?: string, lotId?: number, packagingId?: number }[], isBlind?: boolean, expectedSerialNumbers?: { lookupCode: string, lotId: number, packagingId: number, id: number, licensePlateId: number }[], locationId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Container contents',
        referenceName: 'FootprintManager_pack_verification_shipping_container_contents_grid',
        component: FootprintManager_pack_verification_shipping_container_contents_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openpack_verification_shipping_container_contents_gridDialog(
    inParams:{ shippingContainerId: number, canAddManually?: boolean, startVerificationTaskId: number, isReadOnly?: boolean, scannedValues: { scannedValue?: string, lotId?: number, packagingId?: number }[], isBlind?: boolean, expectedSerialNumbers?: { lookupCode: string, lotId: number, packagingId: number, id: number, licensePlateId: number }[], locationId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_pack_verification_shipping_container_contents_gridComponent,
      'Container contents',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openpallet_classes_grid(inParams:{ pallet_class_id?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Pallet classes grid',
        referenceName: 'FootprintManager_pallet_classes_grid',
        component: FootprintManager_pallet_classes_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openpallet_classes_gridDialog(
    inParams:{ pallet_class_id?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_pallet_classes_gridComponent,
      'Pallet classes grid',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openpallet_inventory_by_class_grid(replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Pallet inventory by class grid',
        referenceName: 'FootprintManager_pallet_inventory_by_class_grid',
        component: FootprintManager_pallet_inventory_by_class_gridComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openpallet_inventory_by_class_gridDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_pallet_inventory_by_class_gridComponent,
      'Pallet inventory by class grid',
      mode,
      dialogSize
    )
  }
  public openpallet_inventory_by_project_grid(replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'pallet_inventory_by_project_grid',
        referenceName: 'FootprintManager_pallet_inventory_by_project_grid',
        component: FootprintManager_pallet_inventory_by_project_gridComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openpallet_inventory_by_project_gridDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_pallet_inventory_by_project_gridComponent,
      'pallet_inventory_by_project_grid',
      mode,
      dialogSize
    )
  }
  public openpallet_transactions_grid(inParams:{ project_id?: number, pallet_class_id?: number, project_lookup_code?: string, pallet_class_name?: string }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Pallet transactions grid',
        referenceName: 'FootprintManager_pallet_transactions_grid',
        component: FootprintManager_pallet_transactions_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openpallet_transactions_gridDialog(
    inParams:{ project_id?: number, pallet_class_id?: number, project_lookup_code?: string, pallet_class_name?: string }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_pallet_transactions_gridComponent,
      'Pallet transactions grid',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openpallet_transactions_shipment_grid(inParams:{ project_id?: number, shipment_id?: number, order_lookup_code?: string }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Pallet transactions shipment grid',
        referenceName: 'FootprintManager_pallet_transactions_shipment_grid',
        component: FootprintManager_pallet_transactions_shipment_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openpallet_transactions_shipment_gridDialog(
    inParams:{ project_id?: number, shipment_id?: number, order_lookup_code?: string }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_pallet_transactions_shipment_gridComponent,
      'Pallet transactions shipment grid',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openpick_slips_grid(inParams:{ waveId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Pick slips',
        referenceName: 'FootprintManager_pick_slips_grid',
        component: FootprintManager_pick_slips_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openpick_slips_gridDialog(
    inParams:{ waveId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_pick_slips_gridComponent,
      'Pick slips',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openpick_waves_expanded_grid(inParams:{ WaveId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Pick waves expanded',
        referenceName: 'FootprintManager_pick_waves_expanded_grid',
        component: FootprintManager_pick_waves_expanded_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openpick_waves_expanded_gridDialog(
    inParams:{ WaveId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_pick_waves_expanded_gridComponent,
      'Pick waves expanded',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openpick_waves_grid(inParams:{ ownerId?: number[], projectId?: number[], warehouseId?: number[], statusIds?: number[] }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Pick waves',
        referenceName: 'FootprintManager_pick_waves_grid',
        component: FootprintManager_pick_waves_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openpick_waves_gridDialog(
    inParams:{ ownerId?: number[], projectId?: number[], warehouseId?: number[], statusIds?: number[] }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_pick_waves_gridComponent,
      'Pick waves',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openplans_grid(replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'plans_grid');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Plans',
        referenceName: 'FootprintManager_plans_grid',
        component: FootprintManager_plans_gridComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openplans_gridDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    this.$logger.log('FootprintManager', 'plans_grid');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_plans_gridComponent,
      'Plans',
      mode,
      dialogSize
    )
  }
  public openprimary_picks_grid(inParams:{ warehouse_id?: number, location_id?: number, material_id?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Primary picks',
        referenceName: 'FootprintManager_primary_picks_grid',
        component: FootprintManager_primary_picks_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openprimary_picks_gridDialog(
    inParams:{ warehouse_id?: number, location_id?: number, material_id?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_primary_picks_gridComponent,
      'Primary picks',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openprojects_grid(inParams:{ projectStatusId?: number, ownerId?: number, projectIds?: number[] }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Projects',
        referenceName: 'FootprintManager_projects_grid',
        component: FootprintManager_projects_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openprojects_gridDialog(
    inParams:{ projectStatusId?: number, ownerId?: number, projectIds?: number[] }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_projects_gridComponent,
      'Projects',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openpurchase_order_bulk_receiving_by_taskId_grid(inParams:{ taskId: number, palletCount: number, fullPalletQuantity?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Bulk receiving task',
        referenceName: 'FootprintManager_purchase_order_bulk_receiving_by_taskId_grid',
        component: FootprintManager_purchase_order_bulk_receiving_by_taskId_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openpurchase_order_bulk_receiving_by_taskId_gridDialog(
    inParams:{ taskId: number, palletCount: number, fullPalletQuantity?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_purchase_order_bulk_receiving_by_taskId_gridComponent,
      'Bulk receiving task',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openpurchase_order_children_tasks_grid(inParams:{ taskId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Purchase order children tasks',
        referenceName: 'FootprintManager_purchase_order_children_tasks_grid',
        component: FootprintManager_purchase_order_children_tasks_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openpurchase_order_children_tasks_gridDialog(
    inParams:{ taskId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_purchase_order_children_tasks_gridComponent,
      'Purchase order children tasks',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openpurchase_order_lines_grid(inParams:{ orderId: number, shipmentId: number, projectId: number, orderStatusId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Order lines',
        referenceName: 'FootprintManager_purchase_order_lines_grid',
        component: FootprintManager_purchase_order_lines_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openpurchase_order_lines_gridDialog(
    inParams:{ orderId: number, shipmentId: number, projectId: number, orderStatusId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_purchase_order_lines_gridComponent,
      'Order lines',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openpurchase_order_received_inventory_grid(inParams:{ orderId: number, shipmentId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Received inventory',
        referenceName: 'FootprintManager_purchase_order_received_inventory_grid',
        component: FootprintManager_purchase_order_received_inventory_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openpurchase_order_received_inventory_gridDialog(
    inParams:{ orderId: number, shipmentId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_purchase_order_received_inventory_gridComponent,
      'Received inventory',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openpurchase_order_receiving_grid(inParams:{ orderId: number, shipmentId: number, orderStatusId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Receiving tasks',
        referenceName: 'FootprintManager_purchase_order_receiving_grid',
        component: FootprintManager_purchase_order_receiving_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openpurchase_order_receiving_gridDialog(
    inParams:{ orderId: number, shipmentId: number, orderStatusId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_purchase_order_receiving_gridComponent,
      'Receiving tasks',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openpurchase_order_tasks_grid(inParams:{ orderId: number, shipmentId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Purchase order tasks',
        referenceName: 'FootprintManager_purchase_order_tasks_grid',
        component: FootprintManager_purchase_order_tasks_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openpurchase_order_tasks_gridDialog(
    inParams:{ orderId: number, shipmentId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_purchase_order_tasks_gridComponent,
      'Purchase order tasks',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openreason_codes_grid(inParams:{ parentEntity?: string }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Reason codes',
        referenceName: 'FootprintManager_reason_codes_grid',
        component: FootprintManager_reason_codes_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openreason_codes_gridDialog(
    inParams:{ parentEntity?: string }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_reason_codes_gridComponent,
      'Reason codes',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openreplenishment_inventory_licenseplate_grid(inParams:{ ownerId?: number, projectId?: number, warehouseIds?: number[], materialIds?: number[], locationIds?: number[] }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Inventory by LP',
        referenceName: 'FootprintManager_replenishment_inventory_licenseplate_grid',
        component: FootprintManager_replenishment_inventory_licenseplate_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openreplenishment_inventory_licenseplate_gridDialog(
    inParams:{ ownerId?: number, projectId?: number, warehouseIds?: number[], materialIds?: number[], locationIds?: number[] }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_replenishment_inventory_licenseplate_gridComponent,
      'Inventory by LP',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openreplenishment_tasks_grid(inParams:{ materialIds?: number[], projectId?: number, locationIds?: number[], ownerId?: number, warehouseIds?: number[] }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Replenishment tasks',
        referenceName: 'FootprintManager_replenishment_tasks_grid',
        component: FootprintManager_replenishment_tasks_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openreplenishment_tasks_gridDialog(
    inParams:{ materialIds?: number[], projectId?: number, locationIds?: number[], ownerId?: number, warehouseIds?: number[] }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_replenishment_tasks_gridComponent,
      'Replenishment tasks',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openreturn_order_lines_grid(inParams:{ orderId: number, shipmentId: number, projectId: number, orderStatusId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Order lines',
        referenceName: 'FootprintManager_return_order_lines_grid',
        component: FootprintManager_return_order_lines_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openreturn_order_lines_gridDialog(
    inParams:{ orderId: number, shipmentId: number, projectId: number, orderStatusId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_return_order_lines_gridComponent,
      'Order lines',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openreturn_orders_grid(inParams:{ ownerId?: number, projectId?: number, warehouseIds?: number[], statusIds?: number[], orderClassIds?: number[], reference?: string, blindShippingContainerId?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Return orders',
        referenceName: 'FootprintManager_return_orders_grid',
        component: FootprintManager_return_orders_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openreturn_orders_gridDialog(
    inParams:{ ownerId?: number, projectId?: number, warehouseIds?: number[], statusIds?: number[], orderClassIds?: number[], reference?: string, blindShippingContainerId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_return_orders_gridComponent,
      'Return orders',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openreturn_shipping_containers_grid(inParams:{ ownerId?: number, projectId?: number, warehouseIds?: number[], orderStatusIds?: number[], orderClassIds?: number[], reference?: string }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Return shipping containers',
        referenceName: 'FootprintManager_return_shipping_containers_grid',
        component: FootprintManager_return_shipping_containers_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openreturn_shipping_containers_gridDialog(
    inParams:{ ownerId?: number, projectId?: number, warehouseIds?: number[], orderStatusIds?: number[], orderClassIds?: number[], reference?: string }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_return_shipping_containers_gridComponent,
      'Return shipping containers',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opensales_order_children_tasks_grid(inParams:{ taskId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Sales order children tasks',
        referenceName: 'FootprintManager_sales_order_children_tasks_grid',
        component: FootprintManager_sales_order_children_tasks_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opensales_order_children_tasks_gridDialog(
    inParams:{ taskId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_sales_order_children_tasks_gridComponent,
      'Sales order children tasks',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opensales_order_line_components_grid(inParams:{ order_id: number, shipment_id: number, project_id: number, order_status_id: number, warehouse_id: number, line_number: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Sales order line kit components',
        referenceName: 'FootprintManager_sales_order_line_components_grid',
        component: FootprintManager_sales_order_line_components_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opensales_order_line_components_gridDialog(
    inParams:{ order_id: number, shipment_id: number, project_id: number, order_status_id: number, warehouse_id: number, line_number: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_sales_order_line_components_gridComponent,
      'Sales order line kit components',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opensales_order_line_kit_grid(inParams:{ material_id: number, packaging_id: number, project_id: number, order_id: number, line_number: number, line_status_id: number, packaged_amount: number, warehouse_id: number, shipment_id: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Sales order line kit management',
        referenceName: 'FootprintManager_sales_order_line_kit_grid',
        component: FootprintManager_sales_order_line_kit_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opensales_order_line_kit_gridDialog(
    inParams:{ material_id: number, packaging_id: number, project_id: number, order_id: number, line_number: number, line_status_id: number, packaged_amount: number, warehouse_id: number, shipment_id: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_sales_order_line_kit_gridComponent,
      'Sales order line kit management',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opensales_order_line_substitutions_grid(inParams:{ material_id: number, packaging_id: number, warehouse_id: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Sales order line substitutions management',
        referenceName: 'FootprintManager_sales_order_line_substitutions_grid',
        component: FootprintManager_sales_order_line_substitutions_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opensales_order_line_substitutions_gridDialog(
    inParams:{ material_id: number, packaging_id: number, warehouse_id: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ material_id?: number, packaging_id?: number }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_sales_order_line_substitutions_gridComponent,
      'Sales order line substitutions management',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opensales_order_lines_grid(inParams:{ orderId: number, shipmentId: number, projectId: number, orderStatusId: number, warehouseId: number, orderState?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Order lines',
        referenceName: 'FootprintManager_sales_order_lines_grid',
        component: FootprintManager_sales_order_lines_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opensales_order_lines_gridDialog(
    inParams:{ orderId: number, shipmentId: number, projectId: number, orderStatusId: number, warehouseId: number, orderState?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_sales_order_lines_gridComponent,
      'Order lines',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opensales_order_picking_grid(inParams:{ orderId?: number, shipmentId?: number, waveId?: number, orderStatusId?: number, waveStatusId?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Picking tasks',
        referenceName: 'FootprintManager_sales_order_picking_grid',
        component: FootprintManager_sales_order_picking_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opensales_order_picking_gridDialog(
    inParams:{ orderId?: number, shipmentId?: number, waveId?: number, orderStatusId?: number, waveStatusId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_sales_order_picking_gridComponent,
      'Picking tasks',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opensales_order_tasks_grid(inParams:{ orderId?: number, shipmentId?: number, waveId?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Sales Order Tasks',
        referenceName: 'FootprintManager_sales_order_tasks_grid',
        component: FootprintManager_sales_order_tasks_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opensales_order_tasks_gridDialog(
    inParams:{ orderId?: number, shipmentId?: number, waveId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_sales_order_tasks_gridComponent,
      'Sales Order Tasks',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openscanned_values_grid(inParams:{ scannedValues: { Value?: string, Note?: string }[], expectedValues?: string[] }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Scanned values',
        referenceName: 'FootprintManager_scanned_values_grid',
        component: FootprintManager_scanned_values_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openscanned_values_gridDialog(
    inParams:{ scannedValues: { Value?: string, Note?: string }[], expectedValues?: string[] }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_scanned_values_gridComponent,
      'Scanned values',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openserialnumbers_creation_grid(inParams:{ materialId: number, packagingId: number, packagedAmount: number, averageGross?: number, averageNet?: number, weightUomId?: number, averageLength?: number, averageWidth?: number, averageHeight?: number, dimensionUomId?: number, lotId?: number, licensePlateId?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Create serial numbers',
        referenceName: 'FootprintManager_serialnumbers_creation_grid',
        component: FootprintManager_serialnumbers_creation_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openserialnumbers_creation_gridDialog(
    inParams:{ materialId: number, packagingId: number, packagedAmount: number, averageGross?: number, averageNet?: number, weightUomId?: number, averageLength?: number, averageWidth?: number, averageHeight?: number, dimensionUomId?: number, lotId?: number, licensePlateId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ serialNumbers?: { LookupCode?: string, NetWeightValue?: number, GrossWeightValue?: number, WeightUOM?: number, Width?: number, Height?: number, Length?: number, DimensionUOM?: number, NetVolumeValue?: number, GrossVolumeValue?: number, VolumeUOM?: number }[], confirm?: boolean }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_serialnumbers_creation_gridComponent,
      'Create serial numbers',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openserialnumbers_grid(inParams:{ licenseplateIds?: number[], locationId?: number, warehouseIds?: number[], lotId?: number, materialIds?: number[], projectId?: number, ownerId?: number, archived?: boolean, search?: string, packagingId?: number, orderId?: number, orderLineNumber?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Serial numbers',
        referenceName: 'FootprintManager_serialnumbers_grid',
        component: FootprintManager_serialnumbers_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openserialnumbers_gridDialog(
    inParams:{ licenseplateIds?: number[], locationId?: number, warehouseIds?: number[], lotId?: number, materialIds?: number[], projectId?: number, ownerId?: number, archived?: boolean, search?: string, packagingId?: number, orderId?: number, orderLineNumber?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_serialnumbers_gridComponent,
      'Serial numbers',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openserialnumbers_modification_grid(inParams:{ serial_number_request?: { GrossVolumeValue?: number, GrossWeightValue?: number, Height?: number, Length?: number, LookupCode?: string, NetVolumeValue?: number, NetWeightValue?: number, DimensionsUOM?: number, WeightUOM?: number, Width?: number }[], packagedAmountRequest?: number }, replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'serialnumbers_modification_grid');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Select serial numbers',
        referenceName: 'FootprintManager_serialnumbers_modification_grid',
        component: FootprintManager_serialnumbers_modification_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openserialnumbers_modification_gridDialog(
    inParams:{ serial_number_request?: { GrossVolumeValue?: number, GrossWeightValue?: number, Height?: number, Length?: number, LookupCode?: string, NetVolumeValue?: number, NetWeightValue?: number, DimensionsUOM?: number, WeightUOM?: number, Width?: number }[], packagedAmountRequest?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ serial_number_request?: { GrossVolumeValue?: number, GrossWeightValue?: number, Height?: number, Length?: number, LookupCode?: string, NetVolumeValue?: number, NetWeightValue?: number, VolumeUOM?: number, WeightUOM?: number, Width?: number, DimensionUOM?: number }[], confirm?: boolean }> {
    this.$logger.log('FootprintManager', 'serialnumbers_modification_grid');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_serialnumbers_modification_gridComponent,
      'Select serial numbers',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openserialnumbers_selection_grid(inParams:{ lotId: number, licenseplateId: number, packagingId: number, packagedAmountRequest: number, serialNumberIds?: number[], filterSerialNumberIds?: number[] }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Select serial numbers',
        referenceName: 'FootprintManager_serialnumbers_selection_grid',
        component: FootprintManager_serialnumbers_selection_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openserialnumbers_selection_gridDialog(
    inParams:{ lotId: number, licenseplateId: number, packagingId: number, packagedAmountRequest: number, serialNumberIds?: number[], filterSerialNumberIds?: number[] }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ SerialNumberLookupCodes?: string[], confirm?: boolean, SerialNumberIds?: number[] }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_serialnumbers_selection_gridComponent,
      'Select serial numbers',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openshipping_container_tasks_child_grid(inParams:{ shippingContainerId: number, chainHead?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Shipping container child tasks',
        referenceName: 'FootprintManager_shipping_container_tasks_child_grid',
        component: FootprintManager_shipping_container_tasks_child_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openshipping_container_tasks_child_gridDialog(
    inParams:{ shippingContainerId: number, chainHead?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_shipping_container_tasks_child_gridComponent,
      'Shipping container child tasks',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openshipping_container_tasks_grid(inParams:{ shippingContainerId: number, chainHead?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Shipping container tasks',
        referenceName: 'FootprintManager_shipping_container_tasks_grid',
        component: FootprintManager_shipping_container_tasks_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openshipping_container_tasks_gridDialog(
    inParams:{ shippingContainerId: number, chainHead?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_shipping_container_tasks_gridComponent,
      'Shipping container tasks',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openshipping_containers_grid(inParams:{ ownerIds?: number[], projectIds?: number[], warehouseIds?: number[], orderTypeIds?: number[], shipmentStatuses?: number[] }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Shipping containers grid',
        referenceName: 'FootprintManager_shipping_containers_grid',
        component: FootprintManager_shipping_containers_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openshipping_containers_gridDialog(
    inParams:{ ownerIds?: number[], projectIds?: number[], warehouseIds?: number[], orderTypeIds?: number[], shipmentStatuses?: number[] }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_shipping_containers_gridComponent,
      'Shipping containers grid',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openshipping_containers_to_verify_grid(inParams:{ warehouseId: number, locationId?: number, shippingContainerCode?: string, isFailed: boolean }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Containers to verify',
        referenceName: 'FootprintManager_shipping_containers_to_verify_grid',
        component: FootprintManager_shipping_containers_to_verify_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openshipping_containers_to_verify_gridDialog(
    inParams:{ warehouseId: number, locationId?: number, shippingContainerCode?: string, isFailed: boolean }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_shipping_containers_to_verify_gridComponent,
      'Containers to verify',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openshippingcontents_grid(inParams:{ orderId: number, shipmentId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Shipping contents',
        referenceName: 'FootprintManager_shippingcontents_grid',
        component: FootprintManager_shippingcontents_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openshippingcontents_gridDialog(
    inParams:{ orderId: number, shipmentId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_shippingcontents_gridComponent,
      'Shipping contents',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openstorage_categories_grid(replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Storage categories',
        referenceName: 'FootprintManager_storage_categories_grid',
        component: FootprintManager_storage_categories_gridComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openstorage_categories_gridDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_storage_categories_gridComponent,
      'Storage categories',
      mode,
      dialogSize
    )
  }
  public openstorage_category_rules_grid(replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Storage category rules',
        referenceName: 'FootprintManager_storage_category_rules_grid',
        component: FootprintManager_storage_category_rules_gridComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openstorage_category_rules_gridDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_storage_category_rules_gridComponent,
      'Storage category rules',
      mode,
      dialogSize
    )
  }
  public opensubmitted_survey_inputs_grid(inParams:{ surveyId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Survey inputs',
        referenceName: 'FootprintManager_submitted_survey_inputs_grid',
        component: FootprintManager_submitted_survey_inputs_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opensubmitted_survey_inputs_gridDialog(
    inParams:{ surveyId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_submitted_survey_inputs_gridComponent,
      'Survey inputs',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opensubmitted_surveys_grid(inParams:{ entities?: { type?: string, ids?: number[] }[], operationContextTypes?: string[], warehouseIds?: number[] }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Submitted surveys',
        referenceName: 'FootprintManager_submitted_surveys_grid',
        component: FootprintManager_submitted_surveys_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opensubmitted_surveys_gridDialog(
    inParams:{ entities?: { type?: string, ids?: number[] }[], operationContextTypes?: string[], warehouseIds?: number[] }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_submitted_surveys_gridComponent,
      'Submitted surveys',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opensupport_tests_grid(inParams:{ test_ids?: number[], test_runs?: number, rows_override?: number }, replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'support_tests_grid');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Support tests grid',
        referenceName: 'FootprintManager_support_tests_grid',
        component: FootprintManager_support_tests_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opensupport_tests_gridDialog(
    inParams:{ test_ids?: number[], test_runs?: number, rows_override?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    this.$logger.log('FootprintManager', 'support_tests_grid');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_support_tests_gridComponent,
      'Support tests grid',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opensurvey_grid_input_values_grid(inParams:{ values: { header1?: string, header2?: string, header3?: string, header4?: string, header5?: string }[], headers?: { header1?: string, header2?: string, header3?: string, header4?: string, header5?: string } }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Grid inputs',
        referenceName: 'FootprintManager_survey_grid_input_values_grid',
        component: FootprintManager_survey_grid_input_values_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opensurvey_grid_input_values_gridDialog(
    inParams:{ values: { header1?: string, header2?: string, header3?: string, header4?: string, header5?: string }[], headers?: { header1?: string, header2?: string, header3?: string, header4?: string, header5?: string } }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_survey_grid_input_values_gridComponent,
      'Grid inputs',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opentask_assignment_grid(inParams:{ warehouseIds?: number[], workClassIds?: number[], fromDate?: string, toDate?: string, projectId?: number, ownerId?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Task assignment',
        referenceName: 'FootprintManager_task_assignment_grid',
        component: FootprintManager_task_assignment_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opentask_assignment_gridDialog(
    inParams:{ warehouseIds?: number[], workClassIds?: number[], fromDate?: string, toDate?: string, projectId?: number, ownerId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_task_assignment_gridComponent,
      'Task assignment',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opentemperature_capture_reading_points_grid(replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Temperature reading points',
        referenceName: 'FootprintManager_temperature_capture_reading_points_grid',
        component: FootprintManager_temperature_capture_reading_points_gridComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public opentemperature_capture_reading_points_gridDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_temperature_capture_reading_points_gridComponent,
      'Temperature reading points',
      mode,
      dialogSize
    )
  }
  public opentemperature_capture_reading_types_grid(replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Temperature reading types',
        referenceName: 'FootprintManager_temperature_capture_reading_types_grid',
        component: FootprintManager_temperature_capture_reading_types_gridComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public opentemperature_capture_reading_types_gridDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_temperature_capture_reading_types_gridComponent,
      'Temperature reading types',
      mode,
      dialogSize
    )
  }
  public opentemperature_readings_grid(inParams:{ loadContainerId?: number, shipmentId?: number, licensePlateId?: number, orderId?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Temperature readings',
        referenceName: 'FootprintManager_temperature_readings_grid',
        component: FootprintManager_temperature_readings_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opentemperature_readings_gridDialog(
    inParams:{ loadContainerId?: number, shipmentId?: number, licensePlateId?: number, orderId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_temperature_readings_gridComponent,
      'Temperature readings',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opentransload_order_lines_grid(inParams:{ orderId: number, shipmentId: number, projectId: number, orderStatusId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Order lines',
        referenceName: 'FootprintManager_transload_order_lines_grid',
        component: FootprintManager_transload_order_lines_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opentransload_order_lines_gridDialog(
    inParams:{ orderId: number, shipmentId: number, projectId: number, orderStatusId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_transload_order_lines_gridComponent,
      'Order lines',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opentransload_order_received_inventory_grid(inParams:{ orderId: number, shipmentId: number, transload_id: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Received inventory',
        referenceName: 'FootprintManager_transload_order_received_inventory_grid',
        component: FootprintManager_transload_order_received_inventory_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opentransload_order_received_inventory_gridDialog(
    inParams:{ orderId: number, shipmentId: number, transload_id: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_transload_order_received_inventory_gridComponent,
      'Received inventory',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opentransload_order_receiving_grid(inParams:{ orderId: number, shipmentId: number, orderStatusId: number, transload_id: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Receiving tasks',
        referenceName: 'FootprintManager_transload_order_receiving_grid',
        component: FootprintManager_transload_order_receiving_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opentransload_order_receiving_gridDialog(
    inParams:{ orderId: number, shipmentId: number, orderStatusId: number, transload_id: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_transload_order_receiving_gridComponent,
      'Receiving tasks',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opentransload_orders_grid(inParams:{ ownerId?: number, projectId?: number, warehouseId?: number[], statusIds?: number[], materialIds?: number[] }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Transload orders',
        referenceName: 'FootprintManager_transload_orders_grid',
        component: FootprintManager_transload_orders_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opentransload_orders_gridDialog(
    inParams:{ ownerId?: number, projectId?: number, warehouseId?: number[], statusIds?: number[], materialIds?: number[] }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_transload_orders_gridComponent,
      'Transload orders',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opentransload_outbound_shipments_grid(inParams:{ orderId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Transload outbound shipments',
        referenceName: 'FootprintManager_transload_outbound_shipments_grid',
        component: FootprintManager_transload_outbound_shipments_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opentransload_outbound_shipments_gridDialog(
    inParams:{ orderId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_transload_outbound_shipments_gridComponent,
      'Transload outbound shipments',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openvendorlots_selector_grid(inParams:{ selectedVendorlotIds?: number[], isExclude?: boolean, allowEdit: boolean }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Vendor lot selector',
        referenceName: 'FootprintManager_vendorlots_selector_grid',
        component: FootprintManager_vendorlots_selector_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openvendorlots_selector_gridDialog(
    inParams:{ selectedVendorlotIds?: number[], isExclude?: boolean, allowEdit: boolean }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ selectedVendorlotIds?: number[] }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_vendorlots_selector_gridComponent,
      'Vendor lot selector',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openwarehouse_transfer_inbound_licenseplates_grid(inParams:{ orderId: number, orderStatusId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'License plates',
        referenceName: 'FootprintManager_warehouse_transfer_inbound_licenseplates_grid',
        component: FootprintManager_warehouse_transfer_inbound_licenseplates_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openwarehouse_transfer_inbound_licenseplates_gridDialog(
    inParams:{ orderId: number, orderStatusId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_warehouse_transfer_inbound_licenseplates_gridComponent,
      'License plates',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openwarehouse_transfer_inbound_order_licenseplates_receiving_tasks_grid(inParams:{ licenseplateId: number, orderId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Receiving tasks',
        referenceName: 'FootprintManager_warehouse_transfer_inbound_order_licenseplates_receiving_tasks_grid',
        component: FootprintManager_warehouse_transfer_inbound_order_licenseplates_receiving_tasks_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openwarehouse_transfer_inbound_order_licenseplates_receiving_tasks_gridDialog(
    inParams:{ licenseplateId: number, orderId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_warehouse_transfer_inbound_order_licenseplates_receiving_tasks_gridComponent,
      'Receiving tasks',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openwarehouse_transfer_inbound_order_receiving_tasks_grid(inParams:{ orderId: number, readOnly?: boolean }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Receiving tasks',
        referenceName: 'FootprintManager_warehouse_transfer_inbound_order_receiving_tasks_grid',
        component: FootprintManager_warehouse_transfer_inbound_order_receiving_tasks_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openwarehouse_transfer_inbound_order_receiving_tasks_gridDialog(
    inParams:{ orderId: number, readOnly?: boolean }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_warehouse_transfer_inbound_order_receiving_tasks_gridComponent,
      'Receiving tasks',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openwarehouse_transfer_inbound_orderlines_grid(inParams:{ orderId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Order lines',
        referenceName: 'FootprintManager_warehouse_transfer_inbound_orderlines_grid',
        component: FootprintManager_warehouse_transfer_inbound_orderlines_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openwarehouse_transfer_inbound_orderlines_gridDialog(
    inParams:{ orderId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_warehouse_transfer_inbound_orderlines_gridComponent,
      'Order lines',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openwarehouse_transfer_outbound_order_lines_grid(inParams:{ orderId: number, shipmentId: number, projectId: number, orderStatusId: number, warehouseId: number, warehouseTransferId: number, readOnly?: boolean }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Order lines',
        referenceName: 'FootprintManager_warehouse_transfer_outbound_order_lines_grid',
        component: FootprintManager_warehouse_transfer_outbound_order_lines_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openwarehouse_transfer_outbound_order_lines_gridDialog(
    inParams:{ orderId: number, shipmentId: number, projectId: number, orderStatusId: number, warehouseId: number, warehouseTransferId: number, readOnly?: boolean }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_warehouse_transfer_outbound_order_lines_gridComponent,
      'Order lines',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openwarehouse_transfer_outbound_order_manual_allocations_grid(inParams:{ orderId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Manual allocations',
        referenceName: 'FootprintManager_warehouse_transfer_outbound_order_manual_allocations_grid',
        component: FootprintManager_warehouse_transfer_outbound_order_manual_allocations_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openwarehouse_transfer_outbound_order_manual_allocations_gridDialog(
    inParams:{ orderId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_warehouse_transfer_outbound_order_manual_allocations_gridComponent,
      'Manual allocations',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openwarehouse_transfer_outbound_order_shippingcontents_grid(inParams:{ orderId: number, shipmentId: number, orderStatusId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Shipping contents',
        referenceName: 'FootprintManager_warehouse_transfer_outbound_order_shippingcontents_grid',
        component: FootprintManager_warehouse_transfer_outbound_order_shippingcontents_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openwarehouse_transfer_outbound_order_shippingcontents_gridDialog(
    inParams:{ orderId: number, shipmentId: number, orderStatusId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_warehouse_transfer_outbound_order_shippingcontents_gridComponent,
      'Shipping contents',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openwarehouse_transfer_picking_grid(inParams:{ orderId?: number, shipmentId?: number, waveId?: number, orderStatusId?: number, waveStatusId?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Picking tasks',
        referenceName: 'FootprintManager_warehouse_transfer_picking_grid',
        component: FootprintManager_warehouse_transfer_picking_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openwarehouse_transfer_picking_gridDialog(
    inParams:{ orderId?: number, shipmentId?: number, waveId?: number, orderStatusId?: number, waveStatusId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_warehouse_transfer_picking_gridComponent,
      'Picking tasks',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openwarehouse_transfers_grid(inParams:{ warehouseIds?: number[], statusIds?: number[] }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Warehouse transfers',
        referenceName: 'FootprintManager_warehouse_transfers_grid',
        component: FootprintManager_warehouse_transfers_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openwarehouse_transfers_gridDialog(
    inParams:{ warehouseIds?: number[], statusIds?: number[] }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_warehouse_transfers_gridComponent,
      'Warehouse transfers',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openwarehouses_navigation_grid(inParams:{ warehouseId?: number, timezone?: string[] }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Warehouses',
        referenceName: 'FootprintManager_warehouses_navigation_grid',
        component: FootprintManager_warehouses_navigation_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openwarehouses_navigation_gridDialog(
    inParams:{ warehouseId?: number, timezone?: string[] }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_warehouses_navigation_gridComponent,
      'Warehouses',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openwave_creation_grid(inParams:{ ownerId?: number, projectId?: number, warehouseIds?: number[], waveId?: number, showCreate?: boolean, carrierId?: number, carrierServiceId?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Create wave',
        referenceName: 'FootprintManager_wave_creation_grid',
        component: FootprintManager_wave_creation_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openwave_creation_gridDialog(
    inParams:{ ownerId?: number, projectId?: number, warehouseIds?: number[], waveId?: number, showCreate?: boolean, carrierId?: number, carrierServiceId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_wave_creation_gridComponent,
      'Create wave',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openwork_class_operation_codes_grid(inParams:{ workClassId: number, operationCodes?: any }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Operation codes',
        referenceName: 'FootprintManager_work_class_operation_codes_grid',
        component: FootprintManager_work_class_operation_codes_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openwork_class_operation_codes_gridDialog(
    inParams:{ workClassId: number, operationCodes?: any }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ operationCodes?: { id?: number, priority?: number, name?: string }[] }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_work_class_operation_codes_gridComponent,
      'Operation codes',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openwork_class_users_grid(inParams:{ users?: any[] }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Work class users',
        referenceName: 'FootprintManager_work_class_users_grid',
        component: FootprintManager_work_class_users_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openwork_class_users_gridDialog(
    inParams:{ users?: any[] }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ users?: { id?: string, displayName?: string }[] }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_work_class_users_gridComponent,
      'Work class users',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openwork_classes_grid(replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Work classes',
        referenceName: 'FootprintManager_work_classes_grid',
        component: FootprintManager_work_classes_gridComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openwork_classes_gridDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_work_classes_gridComponent,
      'Work classes',
      mode,
      dialogSize
    )
  }
  public openwork_orders_grid(inParams:{ ownerId?: number, projectId?: number, warehouseId?: number, statusIds?: number[] }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Work orders',
        referenceName: 'FootprintManager_work_orders_grid',
        component: FootprintManager_work_orders_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openwork_orders_gridDialog(
    inParams:{ ownerId?: number, projectId?: number, warehouseId?: number, statusIds?: number[] }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_work_orders_gridComponent,
      'Work orders',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openactivity_hub(replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Activity Hub',
        referenceName: 'FootprintManager_activity_hub',
        component: FootprintManager_activity_hubComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openactivity_hubDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_activity_hubComponent,
      'Activity Hub',
      mode,
      dialogSize
    )
  }
  public openallocation_configurations_hub(replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'allocation_configurations_hub');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Allocation configurations',
        referenceName: 'FootprintManager_allocation_configurations_hub',
        component: FootprintManager_allocation_configurations_hubComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openallocation_configurations_hubDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    this.$logger.log('FootprintManager', 'allocation_configurations_hub');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_allocation_configurations_hubComponent,
      'Allocation configurations',
      mode,
      dialogSize
    )
  }
  public openaudit_serial_numbers_hub(inParams:{ licensePlateId?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Audit serial numbers',
        referenceName: 'FootprintManager_audit_serial_numbers_hub',
        component: FootprintManager_audit_serial_numbers_hubComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openaudit_serial_numbers_hubDialog(
    inParams:{ licensePlateId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_audit_serial_numbers_hubComponent,
      'Audit serial numbers',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openbilling_contracts_hub(replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Billing Contracts Hub',
        referenceName: 'FootprintManager_billing_contracts_hub',
        component: FootprintManager_billing_contracts_hubComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openbilling_contracts_hubDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_billing_contracts_hubComponent,
      'Billing Contracts Hub',
      mode,
      dialogSize
    )
  }
  public openbilling_records_hub(replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Billing records hub',
        referenceName: 'FootprintManager_billing_records_hub',
        component: FootprintManager_billing_records_hubComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openbilling_records_hubDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_billing_records_hubComponent,
      'Billing records hub',
      mode,
      dialogSize
    )
  }
  public openblind_return_shipping_container_hub(inParams:{ shippingContainerId?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Blind return',
        referenceName: 'FootprintManager_blind_return_shipping_container_hub',
        component: FootprintManager_blind_return_shipping_container_hubComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openblind_return_shipping_container_hubDialog(
    inParams:{ shippingContainerId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_blind_return_shipping_container_hubComponent,
      'Blind return',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opencarrier_management_hub(replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Carrier management hub',
        referenceName: 'FootprintManager_carrier_management_hub',
        component: FootprintManager_carrier_management_hubComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public opencarrier_management_hubDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_carrier_management_hubComponent,
      'Carrier management hub',
      mode,
      dialogSize
    )
  }
  public openconfigurations_inventory_hub(replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Inventory configurations',
        referenceName: 'FootprintManager_configurations_inventory_hub',
        component: FootprintManager_configurations_inventory_hubComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openconfigurations_inventory_hubDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_configurations_inventory_hubComponent,
      'Inventory configurations',
      mode,
      dialogSize
    )
  }
  public openconfigurations_storage_categories_hub(replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Storage Configurations',
        referenceName: 'FootprintManager_configurations_storage_categories_hub',
        component: FootprintManager_configurations_storage_categories_hubComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openconfigurations_storage_categories_hubDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_configurations_storage_categories_hubComponent,
      'Storage Configurations',
      mode,
      dialogSize
    )
  }
  public opendock_appointments_hub(replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Dock appointments hub',
        referenceName: 'FootprintManager_dock_appointments_hub',
        component: FootprintManager_dock_appointments_hubComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public opendock_appointments_hubDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_dock_appointments_hubComponent,
      'Dock appointments hub',
      mode,
      dialogSize
    )
  }
  public opendock_doors_hub(inParams:{ warehouseIds?: number[] }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Dock doors hub',
        referenceName: 'FootprintManager_dock_doors_hub',
        component: FootprintManager_dock_doors_hubComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opendock_doors_hubDialog(
    inParams:{ warehouseIds?: number[] }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_dock_doors_hubComponent,
      'Dock doors hub',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opendriver_check_out_hub(inParams:{ orderId?: number, load_container_id?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Driver check out hub',
        referenceName: 'FootprintManager_driver_check_out_hub',
        component: FootprintManager_driver_check_out_hubComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opendriver_check_out_hubDialog(
    inParams:{ orderId?: number, load_container_id?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_driver_check_out_hubComponent,
      'Driver check out hub',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openentity_import_hub(replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Entity import hub',
        referenceName: 'FootprintManager_entity_import_hub',
        component: FootprintManager_entity_import_hubComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openentity_import_hubDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_entity_import_hubComponent,
      'Entity import hub',
      mode,
      dialogSize
    )
  }
  public openfootprint_events_hub(replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'footprint_events_hub');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Footprint events',
        referenceName: 'FootprintManager_footprint_events_hub',
        component: FootprintManager_footprint_events_hubComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openfootprint_events_hubDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    this.$logger.log('FootprintManager', 'footprint_events_hub');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_footprint_events_hubComponent,
      'Footprint events',
      mode,
      dialogSize
    )
  }
  public openinbound_orders_hub(replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Inbound hub',
        referenceName: 'FootprintManager_inbound_orders_hub',
        component: FootprintManager_inbound_orders_hubComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openinbound_orders_hubDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_inbound_orders_hubComponent,
      'Inbound hub',
      mode,
      dialogSize
    )
  }
  public openinspections_hub(replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Inspections hub',
        referenceName: 'FootprintManager_inspections_hub',
        component: FootprintManager_inspections_hubComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openinspections_hubDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_inspections_hubComponent,
      'Inspections hub',
      mode,
      dialogSize
    )
  }
  public openinventory_counts_hub(replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Inventory Counts',
        referenceName: 'FootprintManager_inventory_counts_hub',
        component: FootprintManager_inventory_counts_hubComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openinventory_counts_hubDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_inventory_counts_hubComponent,
      'Inventory Counts',
      mode,
      dialogSize
    )
  }
  public openinventory_hub(inParams:{ ownerId?: number, projectId?: number, warehouseId?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Inventory Hub',
        referenceName: 'FootprintManager_inventory_hub',
        component: FootprintManager_inventory_hubComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openinventory_hubDialog(
    inParams:{ ownerId?: number, projectId?: number, warehouseId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_inventory_hubComponent,
      'Inventory Hub',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openinventory_transfers_hub(replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Inventory transfers hub',
        referenceName: 'FootprintManager_inventory_transfers_hub',
        component: FootprintManager_inventory_transfers_hubComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openinventory_transfers_hubDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_inventory_transfers_hubComponent,
      'Inventory transfers hub',
      mode,
      dialogSize
    )
  }
  public openinventory_transformations_hub(replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'inventory_transformations_hub');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Inventory transformations hub',
        referenceName: 'FootprintManager_inventory_transformations_hub',
        component: FootprintManager_inventory_transformations_hubComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openinventory_transformations_hubDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    this.$logger.log('FootprintManager', 'inventory_transformations_hub');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_inventory_transformations_hubComponent,
      'Inventory transformations hub',
      mode,
      dialogSize
    )
  }
  public openinvoices_hub(inParams:{ ownerId?: number, projectId?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Invoices Hub',
        referenceName: 'FootprintManager_invoices_hub',
        component: FootprintManager_invoices_hubComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openinvoices_hubDialog(
    inParams:{ ownerId?: number, projectId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_invoices_hubComponent,
      'Invoices Hub',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openlabor_management_hub(replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Labor management',
        referenceName: 'FootprintManager_labor_management_hub',
        component: FootprintManager_labor_management_hubComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openlabor_management_hubDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_labor_management_hubComponent,
      'Labor management',
      mode,
      dialogSize
    )
  }
  public openload_containers_hub(replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Load Containers Hub',
        referenceName: 'FootprintManager_load_containers_hub',
        component: FootprintManager_load_containers_hubComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openload_containers_hubDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_load_containers_hubComponent,
      'Load Containers Hub',
      mode,
      dialogSize
    )
  }
  public openlots_hub(replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Lots hub',
        referenceName: 'FootprintManager_lots_hub',
        component: FootprintManager_lots_hubComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openlots_hubDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_lots_hubComponent,
      'Lots hub',
      mode,
      dialogSize
    )
  }
  public openmanufacturing_configuration_hub(replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'manufacturing_configuration_hub');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Manufacturing configuration',
        referenceName: 'FootprintManager_manufacturing_configuration_hub',
        component: FootprintManager_manufacturing_configuration_hubComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openmanufacturing_configuration_hubDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    this.$logger.log('FootprintManager', 'manufacturing_configuration_hub');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_manufacturing_configuration_hubComponent,
      'Manufacturing configuration',
      mode,
      dialogSize
    )
  }
  public openmanufacturing_locations_hub(inParams:{ warehouse_id: number }, replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'manufacturing_locations_hub');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'locations_for_manufacturing_hub',
        referenceName: 'FootprintManager_manufacturing_locations_hub',
        component: FootprintManager_manufacturing_locations_hubComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openmanufacturing_locations_hubDialog(
    inParams:{ warehouse_id: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    this.$logger.log('FootprintManager', 'manufacturing_locations_hub');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_manufacturing_locations_hubComponent,
      'locations_for_manufacturing_hub',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openmanufacturing_orders_hub(replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'manufacturing_orders_hub');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Manufacturing orders hub',
        referenceName: 'FootprintManager_manufacturing_orders_hub',
        component: FootprintManager_manufacturing_orders_hubComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openmanufacturing_orders_hubDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    this.$logger.log('FootprintManager', 'manufacturing_orders_hub');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_manufacturing_orders_hubComponent,
      'Manufacturing orders hub',
      mode,
      dialogSize
    )
  }
  public openmaterial_attachments_hub(inParams:{ materialId: number, packagingId?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Material attachments',
        referenceName: 'FootprintManager_material_attachments_hub',
        component: FootprintManager_material_attachments_hubComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openmaterial_attachments_hubDialog(
    inParams:{ materialId: number, packagingId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_material_attachments_hubComponent,
      'Material attachments',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openmaterial_catalogs_hub(inParams:{ project_id?: number, material_catalog_id?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Material catalogs Hub',
        referenceName: 'FootprintManager_material_catalogs_hub',
        component: FootprintManager_material_catalogs_hubComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openmaterial_catalogs_hubDialog(
    inParams:{ project_id?: number, material_catalog_id?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_material_catalogs_hubComponent,
      'Material catalogs Hub',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openmaterials_hub(inParams:{ ownerId?: number, projectId?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Materials hub',
        referenceName: 'FootprintManager_materials_hub',
        component: FootprintManager_materials_hubComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openmaterials_hubDialog(
    inParams:{ ownerId?: number, projectId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_materials_hubComponent,
      'Materials hub',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openorders_attachments_hub(inParams:{ orderId?: number, shipmentId?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'orders_attachments_hub',
        referenceName: 'FootprintManager_orders_attachments_hub',
        component: FootprintManager_orders_attachments_hubComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openorders_attachments_hubDialog(
    inParams:{ orderId?: number, shipmentId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_orders_attachments_hubComponent,
      'orders_attachments_hub',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openorders_hub(replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Orders Hub',
        referenceName: 'FootprintManager_orders_hub',
        component: FootprintManager_orders_hubComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openorders_hubDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_orders_hubComponent,
      'Orders Hub',
      mode,
      dialogSize
    )
  }
  public openoutbound_orders_hub(replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Outbound orders hub',
        referenceName: 'FootprintManager_outbound_orders_hub',
        component: FootprintManager_outbound_orders_hubComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openoutbound_orders_hubDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_outbound_orders_hubComponent,
      'Outbound orders hub',
      mode,
      dialogSize
    )
  }
  public openowners_and_projects_hub(replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'owners_and_projects_hub');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Owners and projects hub',
        referenceName: 'FootprintManager_owners_and_projects_hub',
        component: FootprintManager_owners_and_projects_hubComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openowners_and_projects_hubDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    this.$logger.log('FootprintManager', 'owners_and_projects_hub');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_owners_and_projects_hubComponent,
      'Owners and projects hub',
      mode,
      dialogSize
    )
  }
  public openowners_hub(replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Owners Hub',
        referenceName: 'FootprintManager_owners_hub',
        component: FootprintManager_owners_hubComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openowners_hubDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_owners_hubComponent,
      'Owners Hub',
      mode,
      dialogSize
    )
  }
  public openpack_verification_hub(replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Pack verification hub',
        referenceName: 'FootprintManager_pack_verification_hub',
        component: FootprintManager_pack_verification_hubComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openpack_verification_hubDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_pack_verification_hubComponent,
      'Pack verification hub',
      mode,
      dialogSize
    )
  }
  public openprojects_hub(replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Projects Hub',
        referenceName: 'FootprintManager_projects_hub',
        component: FootprintManager_projects_hubComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openprojects_hubDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_projects_hubComponent,
      'Projects Hub',
      mode,
      dialogSize
    )
  }
  public openreplenishment_hub(replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Replenishment Hub',
        referenceName: 'FootprintManager_replenishment_hub',
        component: FootprintManager_replenishment_hubComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openreplenishment_hubDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_replenishment_hubComponent,
      'Replenishment Hub',
      mode,
      dialogSize
    )
  }
  public openreturns_hub(replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Returns hub',
        referenceName: 'FootprintManager_returns_hub',
        component: FootprintManager_returns_hubComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openreturns_hubDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_returns_hubComponent,
      'Returns hub',
      mode,
      dialogSize
    )
  }
  public openserialnumbers_hub(replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Serialnumbers Hub',
        referenceName: 'FootprintManager_serialnumbers_hub',
        component: FootprintManager_serialnumbers_hubComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openserialnumbers_hubDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_serialnumbers_hubComponent,
      'Serialnumbers Hub',
      mode,
      dialogSize
    )
  }
  public openshipping_containers_hub(replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Shipping containers hub',
        referenceName: 'FootprintManager_shipping_containers_hub',
        component: FootprintManager_shipping_containers_hubComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openshipping_containers_hubDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_shipping_containers_hubComponent,
      'Shipping containers hub',
      mode,
      dialogSize
    )
  }
  public opensingle_licenseplate_hub(inParams:{ licenseplateId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Single license plate hub',
        referenceName: 'FootprintManager_single_licenseplate_hub',
        component: FootprintManager_single_licenseplate_hubComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opensingle_licenseplate_hubDialog(
    inParams:{ licenseplateId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_single_licenseplate_hubComponent,
      'Single license plate hub',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opensingle_location_hub(inParams:{ locationId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Single Location Hub',
        referenceName: 'FootprintManager_single_location_hub',
        component: FootprintManager_single_location_hubComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opensingle_location_hubDialog(
    inParams:{ locationId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_single_location_hubComponent,
      'Single Location Hub',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opensingle_lot_hub(inParams:{ lotId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Single Lot Hub',
        referenceName: 'FootprintManager_single_lot_hub',
        component: FootprintManager_single_lot_hubComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opensingle_lot_hubDialog(
    inParams:{ lotId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_single_lot_hubComponent,
      'Single Lot Hub',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opensingle_material_catalog_source_material_hub(inParams:{ materialId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Single material catalog source material Hub',
        referenceName: 'FootprintManager_single_material_catalog_source_material_hub',
        component: FootprintManager_single_material_catalog_source_material_hubComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opensingle_material_catalog_source_material_hubDialog(
    inParams:{ materialId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_single_material_catalog_source_material_hubComponent,
      'Single material catalog source material Hub',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opensingle_material_hub(inParams:{ materialId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Single Material Hub',
        referenceName: 'FootprintManager_single_material_hub',
        component: FootprintManager_single_material_hubComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opensingle_material_hubDialog(
    inParams:{ materialId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_single_material_hubComponent,
      'Single Material Hub',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opensingle_owner_hub(inParams:{ ownerId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Single Owner Hub',
        referenceName: 'FootprintManager_single_owner_hub',
        component: FootprintManager_single_owner_hubComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opensingle_owner_hubDialog(
    inParams:{ ownerId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_single_owner_hubComponent,
      'Single Owner Hub',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opensingle_parent_licenseplate_hub(inParams:{ licenseplateId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Single Parent Licenseplate Hub',
        referenceName: 'FootprintManager_single_parent_licenseplate_hub',
        component: FootprintManager_single_parent_licenseplate_hubComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opensingle_parent_licenseplate_hubDialog(
    inParams:{ licenseplateId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_single_parent_licenseplate_hubComponent,
      'Single Parent Licenseplate Hub',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opensingle_project_hub(inParams:{ projectId: number, ownerId?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Single Project Hub',
        referenceName: 'FootprintManager_single_project_hub',
        component: FootprintManager_single_project_hubComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opensingle_project_hubDialog(
    inParams:{ projectId: number, ownerId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_single_project_hubComponent,
      'Single Project Hub',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opensingle_serialnumber_hub(inParams:{ serialnumberId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Single serial number hub',
        referenceName: 'FootprintManager_single_serialnumber_hub',
        component: FootprintManager_single_serialnumber_hubComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opensingle_serialnumber_hubDialog(
    inParams:{ serialnumberId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_single_serialnumber_hubComponent,
      'Single serial number hub',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opensingle_survey_hub(inParams:{ surveyId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Submitted survey',
        referenceName: 'FootprintManager_single_survey_hub',
        component: FootprintManager_single_survey_hubComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opensingle_survey_hubDialog(
    inParams:{ surveyId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_single_survey_hubComponent,
      'Submitted survey',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opensingle_warehouse_hub(inParams:{ warehouseId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Single Warehouse Hub',
        referenceName: 'FootprintManager_single_warehouse_hub',
        component: FootprintManager_single_warehouse_hubComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opensingle_warehouse_hubDialog(
    inParams:{ warehouseId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_single_warehouse_hubComponent,
      'Single Warehouse Hub',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opensingle_wave_hub(inParams:{ waveId: number, waveDescription?: string, waveStatus?: string, ownerId?: number, projectId?: number, warehouseIds?: number[], allowInactive?: boolean }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Single wave',
        referenceName: 'FootprintManager_single_wave_hub',
        component: FootprintManager_single_wave_hubComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opensingle_wave_hubDialog(
    inParams:{ waveId: number, waveDescription?: string, waveStatus?: string, ownerId?: number, projectId?: number, warehouseIds?: number[], allowInactive?: boolean }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_single_wave_hubComponent,
      'Single wave',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opensupport_tests_hub(replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'support_tests_hub');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Support Tests Hub',
        referenceName: 'FootprintManager_support_tests_hub',
        component: FootprintManager_support_tests_hubComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public opensupport_tests_hubDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    this.$logger.log('FootprintManager', 'support_tests_hub');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_support_tests_hubComponent,
      'Support Tests Hub',
      mode,
      dialogSize
    )
  }
  public opensurveys_hub(replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Surveys hub',
        referenceName: 'FootprintManager_surveys_hub',
        component: FootprintManager_surveys_hubComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public opensurveys_hubDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_surveys_hubComponent,
      'Surveys hub',
      mode,
      dialogSize
    )
  }
  public opentransload_orders_hub(replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Transload Orders Hub',
        referenceName: 'FootprintManager_transload_orders_hub',
        component: FootprintManager_transload_orders_hubComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public opentransload_orders_hubDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_transload_orders_hubComponent,
      'Transload Orders Hub',
      mode,
      dialogSize
    )
  }
  public openwarehouse_transfers_hub(replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Warehouse transfers',
        referenceName: 'FootprintManager_warehouse_transfers_hub',
        component: FootprintManager_warehouse_transfers_hubComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openwarehouse_transfers_hubDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_warehouse_transfers_hubComponent,
      'Warehouse transfers',
      mode,
      dialogSize
    )
  }
  public openwarehouses_hub(replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Warehouses hub',
        referenceName: 'FootprintManager_warehouses_hub',
        component: FootprintManager_warehouses_hubComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openwarehouses_hubDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_warehouses_hubComponent,
      'Warehouses hub',
      mode,
      dialogSize
    )
  }
  public openwaves_hub(replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Waves hub',
        referenceName: 'FootprintManager_waves_hub',
        component: FootprintManager_waves_hubComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openwaves_hubDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_waves_hubComponent,
      'Waves hub',
      mode,
      dialogSize
    )
  }
  public openwork_classes_hub(replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Manage work classes',
        referenceName: 'FootprintManager_work_classes_hub',
        component: FootprintManager_work_classes_hubComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openwork_classes_hubDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_work_classes_hubComponent,
      'Manage work classes',
      mode,
      dialogSize
    )
  }
  public openwork_orders_hub(replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Work orders hub',
        referenceName: 'FootprintManager_work_orders_hub',
        component: FootprintManager_work_orders_hubComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openwork_orders_hubDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_work_orders_hubComponent,
      'Work orders hub',
      mode,
      dialogSize
    )
  }
  public opendock_appointments_calendar(inParams:{ warehouseIds: number[], typeIds?: number[], ownerId?: number, projectId?: number, carrierId?: number, statusIds?: number[], dockDoorIds?: number[], viewDate?: string }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Calendar',
        referenceName: 'FootprintManager_dock_appointments_calendar',
        component: FootprintManager_dock_appointments_calendarComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opendock_appointments_calendarDialog(
    inParams:{ warehouseIds: number[], typeIds?: number[], ownerId?: number, projectId?: number, carrierId?: number, statusIds?: number[], dockDoorIds?: number[], viewDate?: string }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ filters?: { viewDate?: string, dockDoorIds?: number[] } }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_dock_appointments_calendarComponent,
      'Calendar',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openmanufacturing_orders_calendar(inParams:{ warehouse_ids?: number[], project_id?: number }, replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'manufacturing_orders_calendar');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'manufacturing_orders_calendar',
        referenceName: 'FootprintManager_manufacturing_orders_calendar',
        component: FootprintManager_manufacturing_orders_calendarComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openmanufacturing_orders_calendarDialog(
    inParams:{ warehouse_ids?: number[], project_id?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    this.$logger.log('FootprintManager', 'manufacturing_orders_calendar');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_manufacturing_orders_calendarComponent,
      'manufacturing_orders_calendar',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }

  public opendock_appointment_selection_wizardDialog(
    inParams:{ warehouseId?: number, dockDoor?: number, carrierId?: number, orderId?: number, scheduledProjectId?: number, excludedDockAppointmentIds?: number[], typeIds?: number[] }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean, dockAppointmentId?: number }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Xlarge;
    }

    return this.openDialog(
      FootprintManager_dock_appointment_selection_wizardComponent,
      'Dock appointment selection',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }

  public openinventory_by_location_selection_wizardDialog(
    inParams:{ warehouseId: number, projectId: number, materialId?: number, packagingId?: number, lotId?: number, packagedAmountRequest?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ inventory?: { lotId?: number, locationId?: number, packagingId?: number, packagedAmount?: number, vendorLotId?: number }[] }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Xlarge;
    }

    return this.openDialog(
      FootprintManager_inventory_by_location_selection_wizardComponent,
      'Inventory by Location Selection Wizard',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }

  public openinventory_by_lot_selection_wizardDialog(
    inParams:{ warehouseId: number, projectId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ inventory?: { lotId?: number, licenseplateId?: number, packagingId?: number, packagedAmount?: number }[] }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Xlarge;
    }

    return this.openDialog(
      FootprintManager_inventory_by_lot_selection_wizardComponent,
      'Inventory By Lot Selection Wizard',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }

  public openinventory_by_lot_single_selection_wizardDialog(
    inParams:{ warehouseId: number, projectId: number, materialId: number, packagingId: number, packagedAmountRequest: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ inventory?: { lotId?: number, licenseplateId?: number, packagingId?: number, packagedAmount?: number, vendorLotId?: number }[] }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Xlarge;
    }

    return this.openDialog(
      FootprintManager_inventory_by_lot_single_selection_wizardComponent,
      'Inventory By Lot Single Selection Wizard',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }

  public openinventory_by_lp_selection_wizardDialog(
    inParams:{ warehouseId: number, projectId: number, materialId?: number, packagingId?: number, lotId?: number, packagedAmountRequest?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ inventory?: { lotId?: number, licensePlateId?: number, packagingId?: number, packagedAmount?: number, vendorLotId?: number }[] }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Xlarge;
    }

    return this.openDialog(
      FootprintManager_inventory_by_lp_selection_wizardComponent,
      'Inventory by LP Selection Wizard',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }

  public openinventory_by_lp_single_selection_wizardDialog(
    inParams:{ warehouseId: number, projectId: number, materialId: number, packagingId: number, lotId?: number, packagedAmountRequest: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ inventory?: { lotId?: number, licensePlateId?: number, packagingId?: number, packagedAmount?: number, vendorLotId?: number }[] }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Xlarge;
    }

    return this.openDialog(
      FootprintManager_inventory_by_lp_single_selection_wizardComponent,
      'Inventory by LP Single Selection Wizard',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }

  public openinventory_by_serialnumber_selection_wizardDialog(
    inParams:{ warehouseId: number, projectId: number, excludeSerials?: number[] }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ inventory?: { serialnumberId?: number }[] }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Xlarge;
    }

    return this.openDialog(
      FootprintManager_inventory_by_serialnumber_selection_wizardComponent,
      'Inventory By Serialnumber Selection Wizard',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }

  public openinventory_by_serialnumber_single_selection_wizardDialog(
    inParams:{ warehouseId: number, projectId: number, materialId: number, packagingId: number, lotId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ inventory?: { serialnumberId?: number, lotId?: number, vendorLotId?: number }[] }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Xlarge;
    }

    return this.openDialog(
      FootprintManager_inventory_by_serialnumber_single_selection_wizardComponent,
      'Inventory By SN Single Selection Wizard',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }

  public openinventory_transformation_advanced_wizardDialog(
    inParams:{ project_id: number, warehouse_id: number, inventory_transformation_id: number, source_line_id?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    this.$logger.log('FootprintManager', 'inventory_transformation_advanced_wizard');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Xlarge;
    }

    return this.openDialog(
      FootprintManager_inventory_transformation_advanced_wizardComponent,
      'Add inventory to transform',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }

  public openinventory_transformation_quick_wizardDialog(
    inParams:{ is_quick_transformation: boolean, project_id?: number, warehouse_id?: number, owner_id?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ inventory_transformation_id?: number }> {
    this.$logger.log('FootprintManager', 'inventory_transformation_quick_wizard');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Xlarge;
    }

    return this.openDialog(
      FootprintManager_inventory_transformation_quick_wizardComponent,
      'Quick transformation a material',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }

  public openmanufacturing_order_production_confirmation_undo_wizardDialog(
    inParams:{ manufacturing_order_id?: number, manufacturing_order_line_id?: number, task_chain_head?: number, warehouse_id?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    this.$logger.log('FootprintManager', 'manufacturing_order_production_confirmation_undo_wizard');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Xlarge;
    }

    return this.openDialog(
      FootprintManager_manufacturing_order_production_confirmation_undo_wizardComponent,
      'Undo production confirmation',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }

  public openmanufacturing_order_production_confirmation_wizardDialog(
    inParams:{ scheduled_run_code?: number, warehouse_id?: number, output_location_id?: number, project_id?: number, planned_quantity?: number, material_id?: number, finished_good?: string, finished_good_id?: number, expected_source_location?: number, manufacturing_order_id?: number, finished_product_is_serialized?: boolean }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    this.$logger.log('FootprintManager', 'manufacturing_order_production_confirmation_wizard');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Xlarge;
    }

    return this.openDialog(
      FootprintManager_manufacturing_order_production_confirmation_wizardComponent,
      'Confirm manufacturing production',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }

  public openpack_verification_wizardDialog(
    inParams:{ shippingContainerId: number, startVerificationTaskId?: number, targetLocationId?: number, isBlind?: boolean }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Xlarge;
    }

    return this.openDialog(
      FootprintManager_pack_verification_wizardComponent,
      'Pack verification',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }

  public openpurchase_order_bulk_receiving_by_taskId_wizardDialog(
    inParams:{ taskId: number, materialId: number, packagingId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Xlarge;
    }

    return this.openDialog(
      FootprintManager_purchase_order_bulk_receiving_by_taskId_wizardComponent,
      'Bulk Receiving',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openbilling_record_activity_list(inParams:{ billingTaskId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Billing record activity',
        referenceName: 'FootprintManager_billing_record_activity_list',
        component: FootprintManager_billing_record_activity_listComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openbilling_record_activity_listDialog(
    inParams:{ billingTaskId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_billing_record_activity_listComponent,
      'Billing record activity',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opencount_tasks_list(inParams:{ countTaskId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Count tasks',
        referenceName: 'FootprintManager_count_tasks_list',
        component: FootprintManager_count_tasks_listComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opencount_tasks_listDialog(
    inParams:{ countTaskId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_count_tasks_listComponent,
      'Count tasks',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opendock_appointment_activity_list(inParams:{ dockAppointmentId: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Appointment history',
        referenceName: 'FootprintManager_dock_appointment_activity_list',
        component: FootprintManager_dock_appointment_activity_listComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opendock_appointment_activity_listDialog(
    inParams:{ dockAppointmentId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_dock_appointment_activity_listComponent,
      'Appointment history',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opendock_doors_list(inParams:{ warehouseIds?: number[], appointmentType?: string, active?: boolean }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Dock doors',
        referenceName: 'FootprintManager_dock_doors_list',
        component: FootprintManager_dock_doors_listComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opendock_doors_listDialog(
    inParams:{ warehouseIds?: number[], appointmentType?: string, active?: boolean }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_dock_doors_listComponent,
      'Dock doors',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openlicenseplate_list(inParams:{ locationId?: number, materialId?: number, projectId?: number, lotId?: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'License plates',
        referenceName: 'FootprintManager_licenseplate_list',
        component: FootprintManager_licenseplate_listComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openlicenseplate_listDialog(
    inParams:{ locationId?: number, materialId?: number, projectId?: number, lotId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_licenseplate_listComponent,
      'License plates',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openlicenseplatecontent_list(inParams:{ licenseplateId: number }, replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'licenseplatecontent_list');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'License plate content',
        referenceName: 'FootprintManager_licenseplatecontent_list',
        component: FootprintManager_licenseplatecontent_listComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openlicenseplatecontent_listDialog(
    inParams:{ licenseplateId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    this.$logger.log('FootprintManager', 'licenseplatecontent_list');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_licenseplatecontent_listComponent,
      'License plate content',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openlicenseplates_by_shipping_container_list(inParams:{ shippingContainerId: number }, replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'licenseplates_by_shipping_container_list');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'License plates by shipping container',
        referenceName: 'FootprintManager_licenseplates_by_shipping_container_list',
        component: FootprintManager_licenseplates_by_shipping_container_listComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openlicenseplates_by_shipping_container_listDialog(
    inParams:{ shippingContainerId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    this.$logger.log('FootprintManager', 'licenseplates_by_shipping_container_list');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_licenseplates_by_shipping_container_listComponent,
      'License plates by shipping container',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openshipping_containers_list(inParams:{ shipmentId: number }, replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'shipping_containers_list');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Shipping containers',
        referenceName: 'FootprintManager_shipping_containers_list',
        component: FootprintManager_shipping_containers_listComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openshipping_containers_listDialog(
    inParams:{ shipmentId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    this.$logger.log('FootprintManager', 'shipping_containers_list');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_shipping_containers_listComponent,
      'Shipping containers',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openview_xml_payload(inParams:{ payload?: any, title?: string }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'view_xml_payload',
        referenceName: 'FootprintManager_view_xml_payload',
        component: FootprintManager_view_xml_payloadComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openview_xml_payloadDialog(
    inParams:{ payload?: any, title?: string }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_view_xml_payloadComponent,
      'view_xml_payload',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opendock_door_visualization(inParams:{ warehouse_id: number }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Dock door view',
        referenceName: 'FootprintManager_dock_door_visualization',
        component: FootprintManager_dock_door_visualizationComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opendock_door_visualizationDialog(
    inParams:{ warehouse_id: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_dock_door_visualizationComponent,
      'Dock door view',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opencommercial_invoice_content(inParams:{ url: string }, replaceCurrentView?: boolean) {
    this.$logger.log('FootprintManager', 'commercial_invoice_content');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Commercial invoice',
        referenceName: 'FootprintManager_commercial_invoice_content',
        component: FootprintManager_commercial_invoice_contentComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opencommercial_invoice_contentDialog(
    inParams:{ url: string }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    this.$logger.log('FootprintManager', 'commercial_invoice_content');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_commercial_invoice_contentComponent,
      'Commercial invoice',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openshipping_label_content(inParams:{ url: string }, replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Shipping label',
        referenceName: 'FootprintManager_shipping_label_content',
        component: FootprintManager_shipping_label_contentComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openshipping_label_contentDialog(
    inParams:{ url: string }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootprintManager_shipping_label_contentComponent,
      'Shipping label',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }

  public override getComponentInformation(referenceName: string, params: ParamMap): { title: string, component: any, inParams: any } {
    if (referenceName === 'FootprintManager_asn_order_creation_form') {
      const title = 'New ASN order';
      const component = FootprintManager_asn_order_creation_formComponent;
      const inParams:{ projectId?: number, ownerId?: number, warehouseId?: number } = { projectId: null, ownerId: null, warehouseId: null };
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_asn_order_transfer_outstanding_options_form') {
      const title = 'ASN Order Transfer Outstanding Options';
      const component = FootprintManager_asn_order_transfer_outstanding_options_formComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_auto_load_options_form') {
      const title = 'Auto Load Options';
      const component = FootprintManager_auto_load_options_formComponent;
      const inParams:{ warehouseId: number, loadLocationId?: number } = { warehouseId: null, loadLocationId: null };
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('loadLocationId'))) {
        const paramValueString = params.get('loadLocationId');
        inParams.loadLocationId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_auto_pick_options_form') {
      const title = 'Auto Pick Options';
      const component = FootprintManager_auto_pick_options_formComponent;
      const inParams:{ warehouse_id: number, load_location_id?: number } = { warehouse_id: null, load_location_id: null };
      if (!isNil(params.get('warehouse_id'))) {
        const paramValueString = params.get('warehouse_id');
        inParams.warehouse_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('load_location_id'))) {
        const paramValueString = params.get('load_location_id');
        inParams.load_location_id = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_auto_receive_and_putaway_form') {
      const title = 'Auto-receive and putaway';
      const component = FootprintManager_auto_receive_and_putaway_formComponent;
      const inParams:{ orderId: number, taskIds?: number[], licenseplateIds?: number[] } = { orderId: null, taskIds: [], licenseplateIds: [] };
      if (!isNil(params.get('orderId'))) {
        const paramValueString = params.get('orderId');
        inParams.orderId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('taskIds'))) {
        const paramValueString = params.get('taskIds');
        inParams.taskIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('licenseplateIds'))) {
        const paramValueString = params.get('licenseplateIds');
        inParams.licenseplateIds = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_billing_cancellation_options_form') {
      const title = 'Generic billing cancellation ';
      const component = FootprintManager_billing_cancellation_options_formComponent;
      const inParams:{ title?: string, parentId: number, parentEntity: string } = { title: null, parentId: null, parentEntity: null };
      if (!isNil(params.get('title'))) {
        const paramValueString = params.get('title');
        // TODO: date
        inParams.title = paramValueString;
              }
      if (!isNil(params.get('parentId'))) {
        const paramValueString = params.get('parentId');
        inParams.parentId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('parentEntity'))) {
        const paramValueString = params.get('parentEntity');
        // TODO: date
        inParams.parentEntity = paramValueString;
              }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_billing_contract_creation_form') {
      const title = 'New billing contract';
      const component = FootprintManager_billing_contract_creation_formComponent;
      const inParams:{ ownerId?: number, projectId?: number, copy?: boolean } = { ownerId: null, projectId: null, copy: null };
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('copy'))) {
        const paramValueString = params.get('copy');
        inParams.copy = this.convertToBoolean(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_billing_contract_line_creation_form') {
      const title = 'New billing contract line';
      const component = FootprintManager_billing_contract_line_creation_formComponent;
      const inParams:{ billingContractId?: number, strategyName?: string, statusId?: number } = { billingContractId: null, strategyName: null, statusId: null };
      if (!isNil(params.get('billingContractId'))) {
        const paramValueString = params.get('billingContractId');
        inParams.billingContractId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('strategyName'))) {
        const paramValueString = params.get('strategyName');
        // TODO: date
        inParams.strategyName = paramValueString;
              }
      if (!isNil(params.get('statusId'))) {
        const paramValueString = params.get('statusId');
        inParams.statusId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_blind_return_project_selector_form') {
      const title = 'Select project';
      const component = FootprintManager_blind_return_project_selector_formComponent;
      const inParams:{ gtin: string } = { gtin: null };
      if (!isNil(params.get('gtin'))) {
        const paramValueString = params.get('gtin');
        // TODO: date
        inParams.gtin = paramValueString;
              }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_bulk_licenseplate_directed_move_form') {
      const title = 'Move License Plates';
      const component = FootprintManager_bulk_licenseplate_directed_move_formComponent;
      const inParams:{ licenseplates: { id?: number, warehouseId?: number, typeId?: number, locationId?: number }[] } = { licenseplates: [] };
      if (!isNil(params.get('licenseplates'))) {
        const paramValueString = params.get('licenseplates');
        inParams.licenseplates = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_bulk_receiving_row_input_form') {
      const title = 'Bulk Receiving';
      const component = FootprintManager_bulk_receiving_row_input_formComponent;
      const inParams:{ materialId: number, packagingId: number } = { materialId: null, packagingId: null };
      if (!isNil(params.get('materialId'))) {
        const paramValueString = params.get('materialId');
        inParams.materialId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('packagingId'))) {
        const paramValueString = params.get('packagingId');
        inParams.packagingId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_carrier_creation_form') {
      const title = 'New carrier';
      const component = FootprintManager_carrier_creation_formComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_carrierservicetype_creation_form') {
      this.$logger.log('FootprintManager', 'carrierservicetype_creation_form');
      const title = 'Create a new carrier service type';
      const component = FootprintManager_carrierservicetype_creation_formComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_dock_appointment_assign_door_options_form') {
      const title = ' Dock appointment door assignment';
      const component = FootprintManager_dock_appointment_assign_door_options_formComponent;
      const inParams:{ title?: string, dockAppointmentId: number, warehouseId: number, scheduledDockDoorId?: number, appointmentType?: string } = { title: null, dockAppointmentId: null, warehouseId: null, scheduledDockDoorId: null, appointmentType: null };
      if (!isNil(params.get('title'))) {
        const paramValueString = params.get('title');
        // TODO: date
        inParams.title = paramValueString;
              }
      if (!isNil(params.get('dockAppointmentId'))) {
        const paramValueString = params.get('dockAppointmentId');
        inParams.dockAppointmentId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('scheduledDockDoorId'))) {
        const paramValueString = params.get('scheduledDockDoorId');
        inParams.scheduledDockDoorId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('appointmentType'))) {
        const paramValueString = params.get('appointmentType');
        // TODO: date
        inParams.appointmentType = paramValueString;
              }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_dock_appointment_cancel_options_form') {
      const title = 'Dock appointment cancellation';
      const component = FootprintManager_dock_appointment_cancel_options_formComponent;
      const inParams:{ title?: string } = { title: null };
      if (!isNil(params.get('title'))) {
        const paramValueString = params.get('title');
        // TODO: date
        inParams.title = paramValueString;
              }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_dock_appointment_check_in_options_form') {
      const title = 'Dock appointment check in';
      const component = FootprintManager_dock_appointment_check_in_options_formComponent;
      const inParams:{ title?: string, dockAppointmentId: number, warehouseId: number, scheduledDockDoorId?: number, appointmentType?: string } = { title: null, dockAppointmentId: null, warehouseId: null, scheduledDockDoorId: null, appointmentType: null };
      if (!isNil(params.get('title'))) {
        const paramValueString = params.get('title');
        // TODO: date
        inParams.title = paramValueString;
              }
      if (!isNil(params.get('dockAppointmentId'))) {
        const paramValueString = params.get('dockAppointmentId');
        inParams.dockAppointmentId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('scheduledDockDoorId'))) {
        const paramValueString = params.get('scheduledDockDoorId');
        inParams.scheduledDockDoorId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('appointmentType'))) {
        const paramValueString = params.get('appointmentType');
        // TODO: date
        inParams.appointmentType = paramValueString;
              }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_dock_appointment_creation_form') {
      const title = 'Schedule appointment';
      const component = FootprintManager_dock_appointment_creation_formComponent;
      const inParams:{ warehouseId?: number[], lookupcode?: string, scheduledArrival?: string, scheduledDeparture?: string, dockDoor?: number, typeId?: number, ownerId?: number, projectId?: number, carrierId?: number, orderId?: number, loadContainerId?: number, shipmentId?: number } = { warehouseId: [], lookupcode: null, scheduledArrival: null, scheduledDeparture: null, dockDoor: null, typeId: null, ownerId: null, projectId: null, carrierId: null, orderId: null, loadContainerId: null, shipmentId: null };
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('lookupcode'))) {
        const paramValueString = params.get('lookupcode');
        // TODO: date
        inParams.lookupcode = paramValueString;
              }
      if (!isNil(params.get('scheduledArrival'))) {
        const paramValueString = params.get('scheduledArrival');
        // TODO: date
        inParams.scheduledArrival = paramValueString;
              }
      if (!isNil(params.get('scheduledDeparture'))) {
        const paramValueString = params.get('scheduledDeparture');
        // TODO: date
        inParams.scheduledDeparture = paramValueString;
              }
      if (!isNil(params.get('dockDoor'))) {
        const paramValueString = params.get('dockDoor');
        inParams.dockDoor = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('typeId'))) {
        const paramValueString = params.get('typeId');
        inParams.typeId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('carrierId'))) {
        const paramValueString = params.get('carrierId');
        inParams.carrierId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('orderId'))) {
        const paramValueString = params.get('orderId');
        inParams.orderId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('loadContainerId'))) {
        const paramValueString = params.get('loadContainerId');
        inParams.loadContainerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('shipmentId'))) {
        const paramValueString = params.get('shipmentId');
        inParams.shipmentId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_dock_door_creation_form') {
      const title = 'Create dock door';
      const component = FootprintManager_dock_door_creation_formComponent;
      const inParams:{ warehouseId: number } = { warehouseId: null };
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_finalize_audit_form') {
      const title = 'Finalize audit';
      const component = FootprintManager_finalize_audit_formComponent;
      const inParams:{ licensePlateId?: number, missingSerialNumberIds: number[], warehouseId: number, locationId?: number, shippingContainerId?: number, foundSerialNumberIds: number[] } = { licensePlateId: null, missingSerialNumberIds: [], warehouseId: null, locationId: null, shippingContainerId: null, foundSerialNumberIds: [] };
      if (!isNil(params.get('licensePlateId'))) {
        const paramValueString = params.get('licensePlateId');
        inParams.licensePlateId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('missingSerialNumberIds'))) {
        const paramValueString = params.get('missingSerialNumberIds');
        inParams.missingSerialNumberIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('locationId'))) {
        const paramValueString = params.get('locationId');
        inParams.locationId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('shippingContainerId'))) {
        const paramValueString = params.get('shippingContainerId');
        inParams.shippingContainerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('foundSerialNumberIds'))) {
        const paramValueString = params.get('foundSerialNumberIds');
        inParams.foundSerialNumberIds = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_footprint_manager_home') {
      this.$logger.log('FootprintManager', 'footprint_manager_home');
      const title = 'Home';
      const component = FootprintManager_footprint_manager_homeComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_generic_form') {
      const title = 'generic_form';
      const component = FootprintManager_generic_formComponent;
      const inParams:{ stringField1?: string, stringField2?: string, stringField3?: string, stringField4?: string, stringField5?: string, dateField1?: string, dateField2?: string, dateField3?: string, dateField4?: string, dateField5?: string, numberField1?: string, numberField2?: string, numberField3?: string, numberField4?: string, numberField5?: string, title?: string } = { stringField1: null, stringField2: null, stringField3: null, stringField4: null, stringField5: null, dateField1: null, dateField2: null, dateField3: null, dateField4: null, dateField5: null, numberField1: null, numberField2: null, numberField3: null, numberField4: null, numberField5: null, title: null };
      if (!isNil(params.get('stringField1'))) {
        const paramValueString = params.get('stringField1');
        // TODO: date
        inParams.stringField1 = paramValueString;
              }
      if (!isNil(params.get('stringField2'))) {
        const paramValueString = params.get('stringField2');
        // TODO: date
        inParams.stringField2 = paramValueString;
              }
      if (!isNil(params.get('stringField3'))) {
        const paramValueString = params.get('stringField3');
        // TODO: date
        inParams.stringField3 = paramValueString;
              }
      if (!isNil(params.get('stringField4'))) {
        const paramValueString = params.get('stringField4');
        // TODO: date
        inParams.stringField4 = paramValueString;
              }
      if (!isNil(params.get('stringField5'))) {
        const paramValueString = params.get('stringField5');
        // TODO: date
        inParams.stringField5 = paramValueString;
              }
      if (!isNil(params.get('dateField1'))) {
        const paramValueString = params.get('dateField1');
        // TODO: date
        inParams.dateField1 = paramValueString;
              }
      if (!isNil(params.get('dateField2'))) {
        const paramValueString = params.get('dateField2');
        // TODO: date
        inParams.dateField2 = paramValueString;
              }
      if (!isNil(params.get('dateField3'))) {
        const paramValueString = params.get('dateField3');
        // TODO: date
        inParams.dateField3 = paramValueString;
              }
      if (!isNil(params.get('dateField4'))) {
        const paramValueString = params.get('dateField4');
        // TODO: date
        inParams.dateField4 = paramValueString;
              }
      if (!isNil(params.get('dateField5'))) {
        const paramValueString = params.get('dateField5');
        // TODO: date
        inParams.dateField5 = paramValueString;
              }
      if (!isNil(params.get('numberField1'))) {
        const paramValueString = params.get('numberField1');
        // TODO: date
        inParams.numberField1 = paramValueString;
              }
      if (!isNil(params.get('numberField2'))) {
        const paramValueString = params.get('numberField2');
        // TODO: date
        inParams.numberField2 = paramValueString;
              }
      if (!isNil(params.get('numberField3'))) {
        const paramValueString = params.get('numberField3');
        // TODO: date
        inParams.numberField3 = paramValueString;
              }
      if (!isNil(params.get('numberField4'))) {
        const paramValueString = params.get('numberField4');
        // TODO: date
        inParams.numberField4 = paramValueString;
              }
      if (!isNil(params.get('numberField5'))) {
        const paramValueString = params.get('numberField5');
        // TODO: date
        inParams.numberField5 = paramValueString;
              }
      if (!isNil(params.get('title'))) {
        const paramValueString = params.get('title');
        // TODO: date
        inParams.title = paramValueString;
              }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_get_average_serial_weights_form') {
      const title = 'Distribute total weight across all items';
      const component = FootprintManager_get_average_serial_weights_formComponent;
      const inParams:{ serial_numbers: { id?: number, lookup: string, net_weight: number, gross_weight: number }[], weight_uom_id: number } = { serial_numbers: [], weight_uom_id: null };
      if (!isNil(params.get('serial_numbers'))) {
        const paramValueString = params.get('serial_numbers');
        inParams.serial_numbers = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('weight_uom_id'))) {
        const paramValueString = params.get('weight_uom_id');
        inParams.weight_uom_id = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_get_licenseplate_form') {
      this.$logger.log('FootprintManager', 'get_licenseplate_form');
      const title = 'Get license plate';
      const component = FootprintManager_get_licenseplate_formComponent;
      const inParams:{ warehouseId: number } = { warehouseId: null };
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_inbound_orders_update_form') {
      const title = 'Update Orders';
      const component = FootprintManager_inbound_orders_update_formComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_inspection_select_task_status_form') {
      const title = 'Select task status';
      const component = FootprintManager_inspection_select_task_status_formComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_inspection_task_creation_form') {
      const title = 'Create inspection task';
      const component = FootprintManager_inspection_task_creation_formComponent;
      const inParams:{ warehouseId?: number } = { warehouseId: null };
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_integration_info_by_order_id') {
      const title = 'integration_info_by_order_id';
      const component = FootprintManager_integration_info_by_order_idComponent;
      const inParams:{ order_id?: number } = { order_id: null };
      if (!isNil(params.get('order_id'))) {
        const paramValueString = params.get('order_id');
        inParams.order_id = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_inventory_adjustment_form') {
      const title = 'Inventory quantity adjustment';
      const component = FootprintManager_inventory_adjustment_formComponent;
      const inParams:{ licenseplateId: number, lotId: number, packagingId: number, packagedAmount: number, availablePackagedAmount: number, serialnumberId?: number } = { licenseplateId: null, lotId: null, packagingId: null, packagedAmount: null, availablePackagedAmount: null, serialnumberId: null };
      if (!isNil(params.get('licenseplateId'))) {
        const paramValueString = params.get('licenseplateId');
        inParams.licenseplateId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('lotId'))) {
        const paramValueString = params.get('lotId');
        inParams.lotId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('packagingId'))) {
        const paramValueString = params.get('packagingId');
        inParams.packagingId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('packagedAmount'))) {
        const paramValueString = params.get('packagedAmount');
        inParams.packagedAmount = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('availablePackagedAmount'))) {
        const paramValueString = params.get('availablePackagedAmount');
        inParams.availablePackagedAmount = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('serialnumberId'))) {
        const paramValueString = params.get('serialnumberId');
        inParams.serialnumberId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_inventory_and_licenseplate_move_form') {
      const title = 'Inventory move';
      const component = FootprintManager_inventory_and_licenseplate_move_formComponent;
      const inParams:{ warehouseId?: number, locationId?: number, materialId?: number, vendorlotId?: number, licenseplates?: { id?: number, content?: { lotId?: number, packagingId?: number, packagedAmount?: number, availablePackagedAmount?: number }[] }[], serialNumberIds?: number[] } = { warehouseId: null, locationId: null, materialId: null, vendorlotId: null, licenseplates: [], serialNumberIds: [] };
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('locationId'))) {
        const paramValueString = params.get('locationId');
        inParams.locationId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('materialId'))) {
        const paramValueString = params.get('materialId');
        inParams.materialId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('vendorlotId'))) {
        const paramValueString = params.get('vendorlotId');
        inParams.vendorlotId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('licenseplates'))) {
        const paramValueString = params.get('licenseplates');
        inParams.licenseplates = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('serialNumberIds'))) {
        const paramValueString = params.get('serialNumberIds');
        inParams.serialNumberIds = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_inventory_creation_form') {
      const title = 'New inventory';
      const component = FootprintManager_inventory_creation_formComponent;
      const inParams:{ projectId?: number, warehouseId?: number, materialId?: number, packagingId?: number, lotId?: number, licenseplateId?: number, ownerId?: number, locationId?: number } = { projectId: null, warehouseId: null, materialId: null, packagingId: null, lotId: null, licenseplateId: null, ownerId: null, locationId: null };
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('materialId'))) {
        const paramValueString = params.get('materialId');
        inParams.materialId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('packagingId'))) {
        const paramValueString = params.get('packagingId');
        inParams.packagingId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('lotId'))) {
        const paramValueString = params.get('lotId');
        inParams.lotId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('licenseplateId'))) {
        const paramValueString = params.get('licenseplateId');
        inParams.licenseplateId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('locationId'))) {
        const paramValueString = params.get('locationId');
        inParams.locationId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_inventory_transfer_creation_form') {
      const title = 'New inventory transfer';
      const component = FootprintManager_inventory_transfer_creation_formComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_inventory_transfer_form') {
      const title = 'Inventory transfer';
      const component = FootprintManager_inventory_transfer_formComponent;
      const inParams:{ lotId: number, packagingId: number, licenseplateId: number, packagedAmount: number, materialId: number, availablePackagedAmount: number } = { lotId: null, packagingId: null, licenseplateId: null, packagedAmount: null, materialId: null, availablePackagedAmount: null };
      if (!isNil(params.get('lotId'))) {
        const paramValueString = params.get('lotId');
        inParams.lotId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('packagingId'))) {
        const paramValueString = params.get('packagingId');
        inParams.packagingId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('licenseplateId'))) {
        const paramValueString = params.get('licenseplateId');
        inParams.licenseplateId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('packagedAmount'))) {
        const paramValueString = params.get('packagedAmount');
        inParams.packagedAmount = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('materialId'))) {
        const paramValueString = params.get('materialId');
        inParams.materialId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('availablePackagedAmount'))) {
        const paramValueString = params.get('availablePackagedAmount');
        inParams.availablePackagedAmount = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_inventory_transformation_additional_options_form') {
      this.$logger.log('FootprintManager', 'inventory_transformation_additional_options_form');
      const title = 'Inventory transformation additonal options';
      const component = FootprintManager_inventory_transformation_additional_options_formComponent;
      const inParams:{ inventory_transformation_id?: number, source_line_id?: number } = { inventory_transformation_id: null, source_line_id: null };
      if (!isNil(params.get('inventory_transformation_id'))) {
        const paramValueString = params.get('inventory_transformation_id');
        inParams.inventory_transformation_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('source_line_id'))) {
        const paramValueString = params.get('source_line_id');
        inParams.source_line_id = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_inventory_transformation_creation_form') {
      this.$logger.log('FootprintManager', 'inventory_transformation_creation_form');
      const title = 'New inventory transformation';
      const component = FootprintManager_inventory_transformation_creation_formComponent;
      const inParams:{ projectId?: number, ownerId?: number, warehouseId?: number, quick_transform?: boolean } = { projectId: null, ownerId: null, warehouseId: null, quick_transform: null };
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('quick_transform'))) {
        const paramValueString = params.get('quick_transform');
        inParams.quick_transform = this.convertToBoolean(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_inventory_transformations_target_material_form') {
      this.$logger.log('FootprintManager', 'inventory_transformations_target_material_form');
      const title = 'Add inventory to transform';
      const component = FootprintManager_inventory_transformations_target_material_formComponent;
      const inParams:{ project_id: number, warehouse_id: number, inventory_transformation_id: number, source_line_id?: number, type?: number, additional_options?: { general: { keep_source_creation_date: boolean, convert_packaging_to_base: boolean }, serial_number_options: { copy_udfs: boolean, copy_attachments: boolean, copy_weights: boolean, copy_volume: boolean, copy_dimensions: boolean, copy_status: boolean }, lot_number_options: { copy_udfs: boolean, copy_lot_number: boolean, copy_vendor_lot_number: boolean } } } = { project_id: null, warehouse_id: null, inventory_transformation_id: null, source_line_id: null, type: null, additional_options: { general: { keep_source_creation_date: null, convert_packaging_to_base: null }, serial_number_options: { copy_udfs: null, copy_attachments: null, copy_weights: null, copy_volume: null, copy_dimensions: null, copy_status: null }, lot_number_options: { copy_udfs: null, copy_lot_number: null, copy_vendor_lot_number: null } } };
      if (!isNil(params.get('project_id'))) {
        const paramValueString = params.get('project_id');
        inParams.project_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouse_id'))) {
        const paramValueString = params.get('warehouse_id');
        inParams.warehouse_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('inventory_transformation_id'))) {
        const paramValueString = params.get('inventory_transformation_id');
        inParams.inventory_transformation_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('source_line_id'))) {
        const paramValueString = params.get('source_line_id');
        inParams.source_line_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('type'))) {
        const paramValueString = params.get('type');
        inParams.type = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('additional_options'))) {
        const paramValueString = params.get('additional_options');
        inParams.additional_options = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_inventory_type_selection_form') {
      const title = 'Select inventory type';
      const component = FootprintManager_inventory_type_selection_formComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_invoice_creation_form') {
      const title = 'New invoice';
      const component = FootprintManager_invoice_creation_formComponent;
      const inParams:{ projectId?: number, ownerId?: number } = { projectId: null, ownerId: null };
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_invoice_creation_options_form') {
      const title = 'Invoice creation options';
      const component = FootprintManager_invoice_creation_options_formComponent;
      const inParams:{ title?: string, projectId: number } = { title: null, projectId: null };
      if (!isNil(params.get('title'))) {
        const paramValueString = params.get('title');
        // TODO: date
        inParams.title = paramValueString;
              }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_invoice_status_change_options_form') {
      const title = 'Invoice Status Change Options';
      const component = FootprintManager_invoice_status_change_options_formComponent;
      const inParams:{ title?: string, excludeStatusId?: number } = { title: null, excludeStatusId: null };
      if (!isNil(params.get('title'))) {
        const paramValueString = params.get('title');
        // TODO: date
        inParams.title = paramValueString;
              }
      if (!isNil(params.get('excludeStatusId'))) {
        const paramValueString = params.get('excludeStatusId');
        inParams.excludeStatusId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_load_container_create_form') {
      const title = 'New Load Container';
      const component = FootprintManager_load_container_create_formComponent;
      const inParams:{ warehouseId?: number, orderTypeId?: number, projectId?: number, ownerId?: number, loadContainerId?: number } = { warehouseId: null, orderTypeId: null, projectId: null, ownerId: null, loadContainerId: null };
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('orderTypeId'))) {
        const paramValueString = params.get('orderTypeId');
        inParams.orderTypeId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('loadContainerId'))) {
        const paramValueString = params.get('loadContainerId');
        inParams.loadContainerId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_location_creation_form') {
      const title = 'New location';
      const component = FootprintManager_location_creation_formComponent;
      const inParams:{ warehouseId: number } = { warehouseId: null };
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_location_replenishment_creation_form') {
      const title = 'Create new rule';
      const component = FootprintManager_location_replenishment_creation_formComponent;
      const inParams:{ projectId?: number, warehouseId?: number, locationId?: number, materialId?: number, ownerId?: number } = { projectId: null, warehouseId: null, locationId: null, materialId: null, ownerId: null };
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('locationId'))) {
        const paramValueString = params.get('locationId');
        inParams.locationId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('materialId'))) {
        const paramValueString = params.get('materialId');
        inParams.materialId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_lot_bulk_update_form') {
      const title = 'Update lots and vendor lots';
      const component = FootprintManager_lot_bulk_update_formComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_lot_bulk_update_status_form') {
      const title = 'Lot status change';
      const component = FootprintManager_lot_bulk_update_status_formComponent;
      const inParams:{ message: string } = { message: null };
      if (!isNil(params.get('message'))) {
        const paramValueString = params.get('message');
        // TODO: date
        inParams.message = paramValueString;
              }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_lot_creation_form') {
      const title = 'New lot';
      const component = FootprintManager_lot_creation_formComponent;
      const inParams:{ materialId: number, lotLookupCode?: string, vendorLotLookupCode?: string, vendorLotId?: number } = { materialId: null, lotLookupCode: null, vendorLotLookupCode: null, vendorLotId: null };
      if (!isNil(params.get('materialId'))) {
        const paramValueString = params.get('materialId');
        inParams.materialId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('lotLookupCode'))) {
        const paramValueString = params.get('lotLookupCode');
        // TODO: date
        inParams.lotLookupCode = paramValueString;
              }
      if (!isNil(params.get('vendorLotLookupCode'))) {
        const paramValueString = params.get('vendorLotLookupCode');
        // TODO: date
        inParams.vendorLotLookupCode = paramValueString;
              }
      if (!isNil(params.get('vendorLotId'))) {
        const paramValueString = params.get('vendorLotId');
        inParams.vendorLotId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_lot_creation_form_with_material') {
      const title = 'New lot with material';
      const component = FootprintManager_lot_creation_form_with_materialComponent;
      const inParams:{ materialId?: number, ownerId?: number, projectId?: number, vendorLotId?: number } = { materialId: null, ownerId: null, projectId: null, vendorLotId: null };
      if (!isNil(params.get('materialId'))) {
        const paramValueString = params.get('materialId');
        inParams.materialId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('vendorLotId'))) {
        const paramValueString = params.get('vendorLotId');
        inParams.vendorLotId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_manufacturing_order_copy_form') {
      this.$logger.log('FootprintManager', 'manufacturing_order_copy_form');
      const title = 'Copy manufacturing order';
      const component = FootprintManager_manufacturing_order_copy_formComponent;
      const inParams:{ order_id: number, lookup_code: string } = { order_id: null, lookup_code: null };
      if (!isNil(params.get('order_id'))) {
        const paramValueString = params.get('order_id');
        inParams.order_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('lookup_code'))) {
        const paramValueString = params.get('lookup_code');
        // TODO: date
        inParams.lookup_code = paramValueString;
              }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_manufacturing_order_form') {
      this.$logger.log('FootprintManager', 'manufacturing_order_form');
      const title = 'New order';
      const component = FootprintManager_manufacturing_order_formComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_manufacturing_order_line_multiple_substitutions_swap_form') {
      this.$logger.log('FootprintManager', 'manufacturing_order_line_multiple_substitutions_swap_form');
      const title = 'Order line multiple substitutions swap';
      const component = FootprintManager_manufacturing_order_line_multiple_substitutions_swap_formComponent;
      const inParams:{ material_name?: string, material_packaging?: string, material_amount?: number, substitution_ids?: number[], material_ids?: number[], warehouse_id?: number } = { material_name: null, material_packaging: null, material_amount: null, substitution_ids: [], material_ids: [], warehouse_id: null };
      if (!isNil(params.get('material_name'))) {
        const paramValueString = params.get('material_name');
        // TODO: date
        inParams.material_name = paramValueString;
              }
      if (!isNil(params.get('material_packaging'))) {
        const paramValueString = params.get('material_packaging');
        // TODO: date
        inParams.material_packaging = paramValueString;
              }
      if (!isNil(params.get('material_amount'))) {
        const paramValueString = params.get('material_amount');
        inParams.material_amount = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('substitution_ids'))) {
        const paramValueString = params.get('substitution_ids');
        inParams.substitution_ids = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('material_ids'))) {
        const paramValueString = params.get('material_ids');
        inParams.material_ids = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('warehouse_id'))) {
        const paramValueString = params.get('warehouse_id');
        inParams.warehouse_id = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_manufacturing_order_line_production_confirmation_setup_form') {
      this.$logger.log('FootprintManager', 'manufacturing_order_line_production_confirmation_setup_form');
      const title = 'Order line production confirmation setup';
      const component = FootprintManager_manufacturing_order_line_production_confirmation_setup_formComponent;
      const inParams:{ warehouse_id?: number, output_location_id?: number, project_id?: number, planned_quantity?: number, finished_good_id?: number, finished_good?: string } = { warehouse_id: null, output_location_id: null, project_id: null, planned_quantity: null, finished_good_id: null, finished_good: null };
      if (!isNil(params.get('warehouse_id'))) {
        const paramValueString = params.get('warehouse_id');
        inParams.warehouse_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('output_location_id'))) {
        const paramValueString = params.get('output_location_id');
        inParams.output_location_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('project_id'))) {
        const paramValueString = params.get('project_id');
        inParams.project_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('planned_quantity'))) {
        const paramValueString = params.get('planned_quantity');
        inParams.planned_quantity = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('finished_good_id'))) {
        const paramValueString = params.get('finished_good_id');
        inParams.finished_good_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('finished_good'))) {
        const paramValueString = params.get('finished_good');
        // TODO: date
        inParams.finished_good = paramValueString;
              }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_manufacturing_order_line_substitution_swap_form') {
      this.$logger.log('FootprintManager', 'manufacturing_order_line_substitution_swap_form');
      const title = 'Order line substitutions swap';
      const component = FootprintManager_manufacturing_order_line_substitution_swap_formComponent;
      const inParams:{ material_name?: string, material_packaging?: string, substitution_name?: string, substitution_packaging?: string, material_amount?: number, substitution_amount?: number, ratio?: number } = { material_name: null, material_packaging: null, substitution_name: null, substitution_packaging: null, material_amount: null, substitution_amount: null, ratio: null };
      if (!isNil(params.get('material_name'))) {
        const paramValueString = params.get('material_name');
        // TODO: date
        inParams.material_name = paramValueString;
              }
      if (!isNil(params.get('material_packaging'))) {
        const paramValueString = params.get('material_packaging');
        // TODO: date
        inParams.material_packaging = paramValueString;
              }
      if (!isNil(params.get('substitution_name'))) {
        const paramValueString = params.get('substitution_name');
        // TODO: date
        inParams.substitution_name = paramValueString;
              }
      if (!isNil(params.get('substitution_packaging'))) {
        const paramValueString = params.get('substitution_packaging');
        // TODO: date
        inParams.substitution_packaging = paramValueString;
              }
      if (!isNil(params.get('material_amount'))) {
        const paramValueString = params.get('material_amount');
        inParams.material_amount = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('substitution_amount'))) {
        const paramValueString = params.get('substitution_amount');
        inParams.substitution_amount = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('ratio'))) {
        const paramValueString = params.get('ratio');
        inParams.ratio = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_material_catalog_source_material_copy_form') {
      const title = 'Copy source material';
      const component = FootprintManager_material_catalog_source_material_copy_formComponent;
      const inParams:{ materialIds: number[], catalog_id: number } = { materialIds: [], catalog_id: null };
      if (!isNil(params.get('materialIds'))) {
        const paramValueString = params.get('materialIds');
        inParams.materialIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('catalog_id'))) {
        const paramValueString = params.get('catalog_id');
        inParams.catalog_id = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_material_catalog_source_material_creation_form') {
      const title = 'Create material catalog source material';
      const component = FootprintManager_material_catalog_source_material_creation_formComponent;
      const inParams:{ catalog_id: number } = { catalog_id: null };
      if (!isNil(params.get('catalog_id'))) {
        const paramValueString = params.get('catalog_id');
        inParams.catalog_id = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_material_copy_form') {
      const title = 'Materials copy';
      const component = FootprintManager_material_copy_formComponent;
      const inParams:{ projectId?: number, ownerId?: number, materialIds?: number[] } = { projectId: null, ownerId: null, materialIds: [] };
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('materialIds'))) {
        const paramValueString = params.get('materialIds');
        inParams.materialIds = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_material_creation_form') {
      const title = 'New material';
      const component = FootprintManager_material_creation_formComponent;
      const inParams:{ projectId?: number, ownerId?: number } = { projectId: null, ownerId: null };
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_material_update_form') {
      const title = 'Edit material';
      const component = FootprintManager_material_update_formComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_order_completion_options_form') {
      const title = 'Order completion options';
      const component = FootprintManager_order_completion_options_formComponent;
      const inParams:{ warehouseId: number } = { warehouseId: null };
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_outbound_orders_update_form') {
      const title = 'Update orders';
      const component = FootprintManager_outbound_orders_update_formComponent;
      const inParams:{ orders: { orderId?: number, shipmentId?: number }[] } = { orders: [] };
      if (!isNil(params.get('orders'))) {
        const paramValueString = params.get('orders');
        inParams.orders = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_owner_creation_form') {
      const title = 'New owner';
      const component = FootprintManager_owner_creation_formComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_owner_update_form') {
      const title = 'Owner status change';
      const component = FootprintManager_owner_update_formComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_pack_verification_failure_form') {
      const title = 'Fail verification?';
      const component = FootprintManager_pack_verification_failure_formComponent;
      const inParams:{ shippingContainerCode: string } = { shippingContainerCode: null };
      if (!isNil(params.get('shippingContainerCode'))) {
        const paramValueString = params.get('shippingContainerCode');
        // TODO: date
        inParams.shippingContainerCode = paramValueString;
              }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_pallet_class_creation_form') {
      const title = 'Create pallet class';
      const component = FootprintManager_pallet_class_creation_formComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_pallet_transaction_creation_form') {
      const title = 'Create pallet transaction';
      const component = FootprintManager_pallet_transaction_creation_formComponent;
      const inParams:{ project_id?: number, shipment_id?: number, pallet_class_id?: number, order_lookup_code?: string, pallets_in?: number, pallets_out?: number, transaction_id?: number, amount?: number } = { project_id: null, shipment_id: null, pallet_class_id: null, order_lookup_code: null, pallets_in: null, pallets_out: null, transaction_id: null, amount: null };
      if (!isNil(params.get('project_id'))) {
        const paramValueString = params.get('project_id');
        inParams.project_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('shipment_id'))) {
        const paramValueString = params.get('shipment_id');
        inParams.shipment_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('pallet_class_id'))) {
        const paramValueString = params.get('pallet_class_id');
        inParams.pallet_class_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('order_lookup_code'))) {
        const paramValueString = params.get('order_lookup_code');
        // TODO: date
        inParams.order_lookup_code = paramValueString;
              }
      if (!isNil(params.get('pallets_in'))) {
        const paramValueString = params.get('pallets_in');
        inParams.pallets_in = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('pallets_out'))) {
        const paramValueString = params.get('pallets_out');
        inParams.pallets_out = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('transaction_id'))) {
        const paramValueString = params.get('transaction_id');
        inParams.transaction_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('amount'))) {
        const paramValueString = params.get('amount');
        inParams.amount = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_plan_form') {
      this.$logger.log('FootprintManager', 'plan_form');
      const title = 'Plan';
      const component = FootprintManager_plan_formComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_print_license_plate_labels_form') {
      this.$logger.log('FootprintManager', 'print_license_plate_labels_form');
      const title = 'Print license plate labels';
      const component = FootprintManager_print_license_plate_labels_formComponent;
      const inParams:{ orderId: number, licensePlateId?: number } = { orderId: null, licensePlateId: null };
      if (!isNil(params.get('orderId'))) {
        const paramValueString = params.get('orderId');
        inParams.orderId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('licensePlateId'))) {
        const paramValueString = params.get('licensePlateId');
        inParams.licensePlateId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_print_order_labels_form') {
      const title = 'Print order labels form';
      const component = FootprintManager_print_order_labels_formComponent;
      const inParams:{ orderId: number, context: string, shipmentId?: number } = { orderId: null, context: null, shipmentId: null };
      if (!isNil(params.get('orderId'))) {
        const paramValueString = params.get('orderId');
        inParams.orderId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('context'))) {
        const paramValueString = params.get('context');
        // TODO: date
        inParams.context = paramValueString;
              }
      if (!isNil(params.get('shipmentId'))) {
        const paramValueString = params.get('shipmentId');
        inParams.shipmentId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_project_creation_form') {
      const title = 'New project';
      const component = FootprintManager_project_creation_formComponent;
      const inParams:{ ownerId: number } = { ownerId: null };
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_project_update_form') {
      const title = 'Update Project';
      const component = FootprintManager_project_update_formComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_purchase_order_copy_form') {
      const title = 'Copy purchase order';
      const component = FootprintManager_purchase_order_copy_formComponent;
      const inParams:{ order_id: number } = { order_id: null };
      if (!isNil(params.get('order_id'))) {
        const paramValueString = params.get('order_id');
        inParams.order_id = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_purchase_order_creation_form') {
      const title = 'New purchase order';
      const component = FootprintManager_purchase_order_creation_formComponent;
      const inParams:{ projectId?: number, ownerId?: number, warehouseId?: number } = { projectId: null, ownerId: null, warehouseId: null };
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_reason_code_creation_form') {
      const title = 'Create reason code';
      const component = FootprintManager_reason_code_creation_formComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_return_order_creation_form') {
      const title = 'Create Return Order';
      const component = FootprintManager_return_order_creation_formComponent;
      const inParams:{ projectId?: number, ownerId?: number, warehouseId?: number } = { projectId: null, ownerId: null, warehouseId: null };
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_sales_order_cancellation_options_form') {
      const title = 'Generic Sales Order Cancellation ';
      const component = FootprintManager_sales_order_cancellation_options_formComponent;
      const inParams:{ title?: string, parentId: number, parentEntity: string } = { title: null, parentId: null, parentEntity: null };
      if (!isNil(params.get('title'))) {
        const paramValueString = params.get('title');
        // TODO: date
        inParams.title = paramValueString;
              }
      if (!isNil(params.get('parentId'))) {
        const paramValueString = params.get('parentId');
        inParams.parentId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('parentEntity'))) {
        const paramValueString = params.get('parentEntity');
        // TODO: date
        inParams.parentEntity = paramValueString;
              }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_sales_order_copy_form') {
      const title = 'Copy sales order';
      const component = FootprintManager_sales_order_copy_formComponent;
      const inParams:{ order_id: number } = { order_id: null };
      if (!isNil(params.get('order_id'))) {
        const paramValueString = params.get('order_id');
        inParams.order_id = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_sales_order_creation_form') {
      const title = 'New sales order';
      const component = FootprintManager_sales_order_creation_formComponent;
      const inParams:{ projectId?: number, ownerId?: number, warehouseId?: number } = { projectId: null, ownerId: null, warehouseId: null };
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_sales_order_pick_task_cancellation_options_form') {
      const title = 'Generic Sales Order Pick Task Cancellation ';
      const component = FootprintManager_sales_order_pick_task_cancellation_options_formComponent;
      const inParams:{ title?: string, parentId: number, parentEntity: string, cancelOrderRequest?: boolean, autoCancelOrderRequest?: boolean } = { title: null, parentId: null, parentEntity: null, cancelOrderRequest: null, autoCancelOrderRequest: null };
      if (!isNil(params.get('title'))) {
        const paramValueString = params.get('title');
        // TODO: date
        inParams.title = paramValueString;
              }
      if (!isNil(params.get('parentId'))) {
        const paramValueString = params.get('parentId');
        inParams.parentId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('parentEntity'))) {
        const paramValueString = params.get('parentEntity');
        // TODO: date
        inParams.parentEntity = paramValueString;
              }
      if (!isNil(params.get('cancelOrderRequest'))) {
        const paramValueString = params.get('cancelOrderRequest');
        inParams.cancelOrderRequest = this.convertToBoolean(paramValueString);
      }
      if (!isNil(params.get('autoCancelOrderRequest'))) {
        const paramValueString = params.get('autoCancelOrderRequest');
        inParams.autoCancelOrderRequest = this.convertToBoolean(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_sales_orders_processing_options_form') {
      const title = 'processing options';
      const component = FootprintManager_sales_orders_processing_options_formComponent;
      const inParams:{ order_ids: number[], default_waving: boolean, expand_order_line_kits?: boolean, is_wave_created?: boolean } = { order_ids: [], default_waving: null, expand_order_line_kits: null, is_wave_created: null };
      if (!isNil(params.get('order_ids'))) {
        const paramValueString = params.get('order_ids');
        inParams.order_ids = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('default_waving'))) {
        const paramValueString = params.get('default_waving');
        inParams.default_waving = this.convertToBoolean(paramValueString);
      }
      if (!isNil(params.get('expand_order_line_kits'))) {
        const paramValueString = params.get('expand_order_line_kits');
        inParams.expand_order_line_kits = this.convertToBoolean(paramValueString);
      }
      if (!isNil(params.get('is_wave_created'))) {
        const paramValueString = params.get('is_wave_created');
        inParams.is_wave_created = this.convertToBoolean(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_select_pack_verification_location_form') {
      const title = 'Select location';
      const component = FootprintManager_select_pack_verification_location_formComponent;
      const inParams:{ shipping_container_id: number, warehouse_id: number, is_open_wizard?: boolean } = { shipping_container_id: null, warehouse_id: null, is_open_wizard: null };
      if (!isNil(params.get('shipping_container_id'))) {
        const paramValueString = params.get('shipping_container_id');
        inParams.shipping_container_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouse_id'))) {
        const paramValueString = params.get('warehouse_id');
        inParams.warehouse_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('is_open_wizard'))) {
        const paramValueString = params.get('is_open_wizard');
        inParams.is_open_wizard = this.convertToBoolean(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_select_user_form') {
      const title = 'Assign user to task';
      const component = FootprintManager_select_user_formComponent;
      const inParams:{ operationCodeIds?: number[], workClassIds?: number[] } = { operationCodeIds: [], workClassIds: [] };
      if (!isNil(params.get('operationCodeIds'))) {
        const paramValueString = params.get('operationCodeIds');
        inParams.operationCodeIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('workClassIds'))) {
        const paramValueString = params.get('workClassIds');
        inParams.workClassIds = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_temperature_capture_form') {
      const title = 'New temperature reading';
      const component = FootprintManager_temperature_capture_formComponent;
      const inParams:{ shipmentId?: number, shipmentLineId?: number, licensePlateId?: number, loadContainerId?: number } = { shipmentId: null, shipmentLineId: null, licensePlateId: null, loadContainerId: null };
      if (!isNil(params.get('shipmentId'))) {
        const paramValueString = params.get('shipmentId');
        inParams.shipmentId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('shipmentLineId'))) {
        const paramValueString = params.get('shipmentLineId');
        inParams.shipmentLineId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('licensePlateId'))) {
        const paramValueString = params.get('licensePlateId');
        inParams.licensePlateId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('loadContainerId'))) {
        const paramValueString = params.get('loadContainerId');
        inParams.loadContainerId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_transfer_licenseplate_form') {
      const title = 'transfer_licenseplate_form';
      const component = FootprintManager_transfer_licenseplate_formComponent;
      const inParams:{ licenseplateIds?: number[], sourceShipmentId: number, targetShipmentId?: number } = { licenseplateIds: [], sourceShipmentId: null, targetShipmentId: null };
      if (!isNil(params.get('licenseplateIds'))) {
        const paramValueString = params.get('licenseplateIds');
        inParams.licenseplateIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('sourceShipmentId'))) {
        const paramValueString = params.get('sourceShipmentId');
        inParams.sourceShipmentId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('targetShipmentId'))) {
        const paramValueString = params.get('targetShipmentId');
        inParams.targetShipmentId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_transfer_transload_licenseplate_form') {
      const title = 'Transfer transload licenseplate';
      const component = FootprintManager_transfer_transload_licenseplate_formComponent;
      const inParams:{ licenseplate_ids: number[], transload_id: number, current_outbound_shipment_id?: number } = { licenseplate_ids: [], transload_id: null, current_outbound_shipment_id: null };
      if (!isNil(params.get('licenseplate_ids'))) {
        const paramValueString = params.get('licenseplate_ids');
        inParams.licenseplate_ids = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('transload_id'))) {
        const paramValueString = params.get('transload_id');
        inParams.transload_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('current_outbound_shipment_id'))) {
        const paramValueString = params.get('current_outbound_shipment_id');
        inParams.current_outbound_shipment_id = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_transload_order_creation_form') {
      const title = 'Create transload order';
      const component = FootprintManager_transload_order_creation_formComponent;
      const inParams:{ projectId?: number, ownerId?: number, warehouseId?: number } = { projectId: null, ownerId: null, warehouseId: null };
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_unloading_form') {
      const title = 'Unloading Inventory';
      const component = FootprintManager_unloading_formComponent;
      const inParams:{ licenseplateId: number, shipmentId: number } = { licenseplateId: null, shipmentId: null };
      if (!isNil(params.get('licenseplateId'))) {
        const paramValueString = params.get('licenseplateId');
        inParams.licenseplateId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('shipmentId'))) {
        const paramValueString = params.get('shipmentId');
        inParams.shipmentId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_unpicking_form') {
      const title = 'Unpick Inventory';
      const component = FootprintManager_unpicking_formComponent;
      const inParams:{ licenseplateId: number, locationId?: number, inventory?: { lotId: number, packagingId: number, packagedAmount: number, shipmentLineId: number, unpickPackagedAmount?: number, serialNumberIds?: number[] }, suppress_manual_allocation?: boolean } = { licenseplateId: null, locationId: null, inventory: { lotId: null, packagingId: null, packagedAmount: null, shipmentLineId: null, unpickPackagedAmount: null, serialNumberIds: [] }, suppress_manual_allocation: null };
      if (!isNil(params.get('licenseplateId'))) {
        const paramValueString = params.get('licenseplateId');
        inParams.licenseplateId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('locationId'))) {
        const paramValueString = params.get('locationId');
        inParams.locationId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('inventory'))) {
        const paramValueString = params.get('inventory');
        inParams.inventory = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('suppress_manual_allocation'))) {
        const paramValueString = params.get('suppress_manual_allocation');
        inParams.suppress_manual_allocation = this.convertToBoolean(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_unreceiving_all_options_form') {
      const title = 'Unreceive All Inventory';
      const component = FootprintManager_unreceiving_all_options_formComponent;
      const inParams:{ title?: string } = { title: null };
      if (!isNil(params.get('title'))) {
        const paramValueString = params.get('title');
        // TODO: date
        inParams.title = paramValueString;
              }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_unreceiving_single_taskId_form') {
      const title = 'Unreceive Inventory';
      const component = FootprintManager_unreceiving_single_taskId_formComponent;
      const inParams:{ licenseplateId: number, lotId: number, packagingId: number, packagedAmount: number, taskId: number } = { licenseplateId: null, lotId: null, packagingId: null, packagedAmount: null, taskId: null };
      if (!isNil(params.get('licenseplateId'))) {
        const paramValueString = params.get('licenseplateId');
        inParams.licenseplateId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('lotId'))) {
        const paramValueString = params.get('lotId');
        inParams.lotId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('packagingId'))) {
        const paramValueString = params.get('packagingId');
        inParams.packagingId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('packagedAmount'))) {
        const paramValueString = params.get('packagedAmount');
        inParams.packagedAmount = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('taskId'))) {
        const paramValueString = params.get('taskId');
        inParams.taskId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_vendorlot_creation_form') {
      const title = 'New vendor lot';
      const component = FootprintManager_vendorlot_creation_formComponent;
      const inParams:{ materialId: number, vendorLookupcode?: string } = { materialId: null, vendorLookupcode: null };
      if (!isNil(params.get('materialId'))) {
        const paramValueString = params.get('materialId');
        inParams.materialId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('vendorLookupcode'))) {
        const paramValueString = params.get('vendorLookupcode');
        // TODO: date
        inParams.vendorLookupcode = paramValueString;
              }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_warehouse_creation_form') {
      const title = 'New warehouse';
      const component = FootprintManager_warehouse_creation_formComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_warehouse_transfer_creation_form') {
      const title = 'Create warehouse transfer';
      const component = FootprintManager_warehouse_transfer_creation_formComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_wave_update_form') {
      const title = 'Wave update form';
      const component = FootprintManager_wave_update_formComponent;
      const inParams:{ waveId: number } = { waveId: null };
      if (!isNil(params.get('waveId'))) {
        const paramValueString = params.get('waveId');
        inParams.waveId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_work_class_creation_form') {
      const title = 'Create work class';
      const component = FootprintManager_work_class_creation_formComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_work_order_creation_form') {
      const title = 'Create Work Order';
      const component = FootprintManager_work_order_creation_formComponent;
      const inParams:{ projectId?: number, ownerId?: number, warehouseId?: number } = { projectId: null, ownerId: null, warehouseId: null };
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_workshift_form') {
      this.$logger.log('FootprintManager', 'workshift_form');
      const title = 'workshift_form';
      const component = FootprintManager_workshift_formComponent;
      const inParams:{ warehouse_id: number } = { warehouse_id: null };
      if (!isNil(params.get('warehouse_id'))) {
        const paramValueString = params.get('warehouse_id');
        inParams.warehouse_id = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_asn_order_editor') {
      const title = 'Edit ASN order';
      const component = FootprintManager_asn_order_editorComponent;
      const inParams:{ order_id: number } = { order_id: null };
      if (!isNil(params.get('order_id'))) {
        const paramValueString = params.get('order_id');
        inParams.order_id = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_billing_contract_editor') {
      const title = 'Edit Billing Contract';
      const component = FootprintManager_billing_contract_editorComponent;
      const inParams:{ contractId: number, edit?: boolean } = { contractId: null, edit: null };
      if (!isNil(params.get('contractId'))) {
        const paramValueString = params.get('contractId');
        inParams.contractId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('edit'))) {
        const paramValueString = params.get('edit');
        inParams.edit = this.convertToBoolean(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_billing_contract_line_editor') {
      const title = 'Billing Contract Line Editor';
      const component = FootprintManager_billing_contract_line_editorComponent;
      const inParams:{ billingContractLineId: number, edit: boolean, operationCodeId?: number, billingAggregationStrategy?: string, statusId?: number } = { billingContractLineId: null, edit: null, operationCodeId: null, billingAggregationStrategy: null, statusId: null };
      if (!isNil(params.get('billingContractLineId'))) {
        const paramValueString = params.get('billingContractLineId');
        inParams.billingContractLineId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('edit'))) {
        const paramValueString = params.get('edit');
        inParams.edit = this.convertToBoolean(paramValueString);
      }
      if (!isNil(params.get('operationCodeId'))) {
        const paramValueString = params.get('operationCodeId');
        inParams.operationCodeId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('billingAggregationStrategy'))) {
        const paramValueString = params.get('billingAggregationStrategy');
        // TODO: date
        inParams.billingAggregationStrategy = paramValueString;
              }
      if (!isNil(params.get('statusId'))) {
        const paramValueString = params.get('statusId');
        inParams.statusId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_billing_record_editor') {
      this.$logger.log('FootprintManager', 'billing_record_editor');
      const title = 'Edit Billing Record';
      const component = FootprintManager_billing_record_editorComponent;
      const inParams:{ billingTaskId: number } = { billingTaskId: null };
      if (!isNil(params.get('billingTaskId'))) {
        const paramValueString = params.get('billingTaskId');
        inParams.billingTaskId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_carrier_editor') {
      const title = 'Edit Carrier';
      const component = FootprintManager_carrier_editorComponent;
      const inParams:{ carrierId: number } = { carrierId: null };
      if (!isNil(params.get('carrierId'))) {
        const paramValueString = params.get('carrierId');
        inParams.carrierId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_carrierservicetype_editor') {
      this.$logger.log('FootprintManager', 'carrierservicetype_editor');
      const title = 'Edit Carrier Service Type';
      const component = FootprintManager_carrierservicetype_editorComponent;
      const inParams:{ carrierservicetypeId: number } = { carrierservicetypeId: null };
      if (!isNil(params.get('carrierservicetypeId'))) {
        const paramValueString = params.get('carrierservicetypeId');
        inParams.carrierservicetypeId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_count_task_editor') {
      const title = 'count_task_editor';
      const component = FootprintManager_count_task_editorComponent;
      const inParams:{ taskId: number } = { taskId: null };
      if (!isNil(params.get('taskId'))) {
        const paramValueString = params.get('taskId');
        inParams.taskId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_dock_appointment_editor') {
      const title = 'Edit appointment';
      const component = FootprintManager_dock_appointment_editorComponent;
      const inParams:{ dockAppointmentId: number, orderId?: number, loadContainerId?: number, shipmentId?: number } = { dockAppointmentId: null, orderId: null, loadContainerId: null, shipmentId: null };
      if (!isNil(params.get('dockAppointmentId'))) {
        const paramValueString = params.get('dockAppointmentId');
        inParams.dockAppointmentId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('orderId'))) {
        const paramValueString = params.get('orderId');
        inParams.orderId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('loadContainerId'))) {
        const paramValueString = params.get('loadContainerId');
        inParams.loadContainerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('shipmentId'))) {
        const paramValueString = params.get('shipmentId');
        inParams.shipmentId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_dock_door_editor') {
      const title = 'Edit Dock Door';
      const component = FootprintManager_dock_door_editorComponent;
      const inParams:{ locationId: number } = { locationId: null };
      if (!isNil(params.get('locationId'))) {
        const paramValueString = params.get('locationId');
        inParams.locationId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_inspection_task_editor') {
      const title = 'Inspection task';
      const component = FootprintManager_inspection_task_editorComponent;
      const inParams:{ taskId: number } = { taskId: null };
      if (!isNil(params.get('taskId'))) {
        const paramValueString = params.get('taskId');
        inParams.taskId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_inventory_count_editor') {
      const title = 'inventory_count_editor';
      const component = FootprintManager_inventory_count_editorComponent;
      const inParams:{ inventoryCountId: number } = { inventoryCountId: null };
      if (!isNil(params.get('inventoryCountId'))) {
        const paramValueString = params.get('inventoryCountId');
        inParams.inventoryCountId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_inventory_transfer_editor') {
      const title = 'Inventory transfer';
      const component = FootprintManager_inventory_transfer_editorComponent;
      const inParams:{ inventoryTransferId: number, warehouseId?: number } = { inventoryTransferId: null, warehouseId: null };
      if (!isNil(params.get('inventoryTransferId'))) {
        const paramValueString = params.get('inventoryTransferId');
        inParams.inventoryTransferId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_inventory_transformation_editor') {
      this.$logger.log('FootprintManager', 'inventory_transformation_editor');
      const title = 'Edit inventory transformation';
      const component = FootprintManager_inventory_transformation_editorComponent;
      const inParams:{ inventory_transformation_id: number } = { inventory_transformation_id: null };
      if (!isNil(params.get('inventory_transformation_id'))) {
        const paramValueString = params.get('inventory_transformation_id');
        inParams.inventory_transformation_id = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_inventory_transformation_source_line_editor') {
      this.$logger.log('FootprintManager', 'inventory_transformation_source_line_editor');
      const title = 'inventory_transformation_source_line_editor';
      const component = FootprintManager_inventory_transformation_source_line_editorComponent;
      const inParams:{ project_id: number, warehouse_id: number, inventory_transformation_id: number, source_line_id?: number } = { project_id: null, warehouse_id: null, inventory_transformation_id: null, source_line_id: null };
      if (!isNil(params.get('project_id'))) {
        const paramValueString = params.get('project_id');
        inParams.project_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouse_id'))) {
        const paramValueString = params.get('warehouse_id');
        inParams.warehouse_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('inventory_transformation_id'))) {
        const paramValueString = params.get('inventory_transformation_id');
        inParams.inventory_transformation_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('source_line_id'))) {
        const paramValueString = params.get('source_line_id');
        inParams.source_line_id = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_inventory_transformation_target_line_editor') {
      this.$logger.log('FootprintManager', 'inventory_transformation_target_line_editor');
      const title = 'inventory_transformation_target_line_editor';
      const component = FootprintManager_inventory_transformation_target_line_editorComponent;
      const inParams:{ inventory_transformation_id: number, source_line_id?: number, projectId?: number, warehouse_id?: number, additional_options?: { general: { keep_source_creation_date: boolean, convert_packaging_to_base: boolean }, serial_number_options: { copy_weights: boolean, copy_volume: boolean, copy_dimensions: boolean }, lot_number_options: { copy_udfs: boolean, copy_lot_number: boolean, copy_vendor_lot_number: boolean } } } = { inventory_transformation_id: null, source_line_id: null, projectId: null, warehouse_id: null, additional_options: { general: { keep_source_creation_date: null, convert_packaging_to_base: null }, serial_number_options: { copy_weights: null, copy_volume: null, copy_dimensions: null }, lot_number_options: { copy_udfs: null, copy_lot_number: null, copy_vendor_lot_number: null } } };
      if (!isNil(params.get('inventory_transformation_id'))) {
        const paramValueString = params.get('inventory_transformation_id');
        inParams.inventory_transformation_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('source_line_id'))) {
        const paramValueString = params.get('source_line_id');
        inParams.source_line_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouse_id'))) {
        const paramValueString = params.get('warehouse_id');
        inParams.warehouse_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('additional_options'))) {
        const paramValueString = params.get('additional_options');
        inParams.additional_options = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_invoice_editor') {
      const title = 'Edit invoice';
      const component = FootprintManager_invoice_editorComponent;
      const inParams:{ invoiceId: number, invoice_lines?: { open_to_line?: number } } = { invoiceId: null, invoice_lines: { open_to_line: null } };
      if (!isNil(params.get('invoiceId'))) {
        const paramValueString = params.get('invoiceId');
        inParams.invoiceId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('invoice_lines'))) {
        const paramValueString = params.get('invoice_lines');
        inParams.invoice_lines = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_licenseplate_editor') {
      const title = 'Edit LP';
      const component = FootprintManager_licenseplate_editorComponent;
      const inParams:{ licenseplateId: number } = { licenseplateId: null };
      if (!isNil(params.get('licenseplateId'))) {
        const paramValueString = params.get('licenseplateId');
        inParams.licenseplateId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_load_container_add_orders') {
      const title = 'Load Container Add Orders';
      const component = FootprintManager_load_container_add_ordersComponent;
      const inParams:{ loadContainerId?: number, warehouseId?: number, orderTypeId?: number, projectId?: number, ownerId?: number } = { loadContainerId: null, warehouseId: null, orderTypeId: null, projectId: null, ownerId: null };
      if (!isNil(params.get('loadContainerId'))) {
        const paramValueString = params.get('loadContainerId');
        inParams.loadContainerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('orderTypeId'))) {
        const paramValueString = params.get('orderTypeId');
        inParams.orderTypeId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_load_container_editor') {
      const title = 'Load Container Editor';
      const component = FootprintManager_load_container_editorComponent;
      const inParams:{ loadContainerId: number } = { loadContainerId: null };
      if (!isNil(params.get('loadContainerId'))) {
        const paramValueString = params.get('loadContainerId');
        inParams.loadContainerId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_location_editor') {
      const title = 'Edit Location';
      const component = FootprintManager_location_editorComponent;
      const inParams:{ locationId: number } = { locationId: null };
      if (!isNil(params.get('locationId'))) {
        const paramValueString = params.get('locationId');
        inParams.locationId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_location_replenishment_editor') {
      const title = 'Edit Rule';
      const component = FootprintManager_location_replenishment_editorComponent;
      const inParams:{ locationReplenishmentId: number } = { locationReplenishmentId: null };
      if (!isNil(params.get('locationReplenishmentId'))) {
        const paramValueString = params.get('locationReplenishmentId');
        inParams.locationReplenishmentId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_lot_editor') {
      const title = 'Edit lot';
      const component = FootprintManager_lot_editorComponent;
      const inParams:{ lotId: number } = { lotId: null };
      if (!isNil(params.get('lotId'))) {
        const paramValueString = params.get('lotId');
        inParams.lotId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_manufacturing_order_components_serial_numbers_pick_editor') {
      this.$logger.log('FootprintManager', 'manufacturing_order_components_serial_numbers_pick_editor');
      const title = 'Select serial numbers';
      const component = FootprintManager_manufacturing_order_components_serial_numbers_pick_editorComponent;
      const inParams:{ serial_controlled_materials?: number, material_ids?: { material_id?: number, serial_count_needed?: number, material_name?: string, packaging_name?: string, license_plate?: number }[], warehouse_id?: number, iteration?: number, serial_numbers?: { serialNumberId?: number, weightUOM?: number, volumeUOM?: number, dimensionsUOM?: number, grossVolume?: number, netVolume?: number, grossWeight?: number, netWeight?: number, materialId?: number, licensePlate?: number }[], location?: number } = { serial_controlled_materials: null, material_ids: [], warehouse_id: null, iteration: null, serial_numbers: [], location: null };
      if (!isNil(params.get('serial_controlled_materials'))) {
        const paramValueString = params.get('serial_controlled_materials');
        inParams.serial_controlled_materials = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('material_ids'))) {
        const paramValueString = params.get('material_ids');
        inParams.material_ids = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('warehouse_id'))) {
        const paramValueString = params.get('warehouse_id');
        inParams.warehouse_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('iteration'))) {
        const paramValueString = params.get('iteration');
        inParams.iteration = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('serial_numbers'))) {
        const paramValueString = params.get('serial_numbers');
        inParams.serial_numbers = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('location'))) {
        const paramValueString = params.get('location');
        inParams.location = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_manufacturing_order_editor') {
      this.$logger.log('FootprintManager', 'manufacturing_order_editor');
      const title = 'Order editor';
      const component = FootprintManager_manufacturing_order_editorComponent;
      const inParams:{ manufacturing_order_id: number } = { manufacturing_order_id: null };
      if (!isNil(params.get('manufacturing_order_id'))) {
        const paramValueString = params.get('manufacturing_order_id');
        inParams.manufacturing_order_id = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_manufacturing_order_return_to_stock_editor') {
      this.$logger.log('FootprintManager', 'manufacturing_order_return_to_stock_editor');
      const title = 'Manufacturing order stock return';
      const component = FootprintManager_manufacturing_order_return_to_stock_editorComponent;
      const inParams:{ manufacturing_order_id?: number, manufacturing_order_line_id?: number, finished_good?: string, warehouse_id?: number, project_id?: number, task_chain_head?: number, location_id?: number } = { manufacturing_order_id: null, manufacturing_order_line_id: null, finished_good: null, warehouse_id: null, project_id: null, task_chain_head: null, location_id: null };
      if (!isNil(params.get('manufacturing_order_id'))) {
        const paramValueString = params.get('manufacturing_order_id');
        inParams.manufacturing_order_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('manufacturing_order_line_id'))) {
        const paramValueString = params.get('manufacturing_order_line_id');
        inParams.manufacturing_order_line_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('finished_good'))) {
        const paramValueString = params.get('finished_good');
        // TODO: date
        inParams.finished_good = paramValueString;
              }
      if (!isNil(params.get('warehouse_id'))) {
        const paramValueString = params.get('warehouse_id');
        inParams.warehouse_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('project_id'))) {
        const paramValueString = params.get('project_id');
        inParams.project_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('task_chain_head'))) {
        const paramValueString = params.get('task_chain_head');
        inParams.task_chain_head = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('location_id'))) {
        const paramValueString = params.get('location_id');
        inParams.location_id = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_manufacturing_orders_create_serial_numbers_editor') {
      this.$logger.log('FootprintManager', 'manufacturing_orders_create_serial_numbers_editor');
      const title = 'Create new serials';
      const component = FootprintManager_manufacturing_orders_create_serial_numbers_editorComponent;
      const inParams:{ material_id?: number, produced_quantity?: number, lot_id?: number, packaging_id?: number, license_plate_id?: number } = { material_id: null, produced_quantity: null, lot_id: null, packaging_id: null, license_plate_id: null };
      if (!isNil(params.get('material_id'))) {
        const paramValueString = params.get('material_id');
        inParams.material_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('produced_quantity'))) {
        const paramValueString = params.get('produced_quantity');
        inParams.produced_quantity = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('lot_id'))) {
        const paramValueString = params.get('lot_id');
        inParams.lot_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('packaging_id'))) {
        const paramValueString = params.get('packaging_id');
        inParams.packaging_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('license_plate_id'))) {
        const paramValueString = params.get('license_plate_id');
        inParams.license_plate_id = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_material_editor') {
      const title = 'Edit material';
      const component = FootprintManager_material_editorComponent;
      const inParams:{ materialId: number } = { materialId: null };
      if (!isNil(params.get('materialId'))) {
        const paramValueString = params.get('materialId');
        inParams.materialId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_material_kit_editor') {
      const title = 'material_kit_editor';
      const component = FootprintManager_material_kit_editorComponent;
      const inParams:{ material_id: number, project_id: number, packaging_id?: number } = { material_id: null, project_id: null, packaging_id: null };
      if (!isNil(params.get('material_id'))) {
        const paramValueString = params.get('material_id');
        inParams.material_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('project_id'))) {
        const paramValueString = params.get('project_id');
        inParams.project_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('packaging_id'))) {
        const paramValueString = params.get('packaging_id');
        inParams.packaging_id = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_material_substitutions_editor') {
      const title = 'Material Substitutions';
      const component = FootprintManager_material_substitutions_editorComponent;
      const inParams:{ material_id: number, packaging_id?: number, project_id: number } = { material_id: null, packaging_id: null, project_id: null };
      if (!isNil(params.get('material_id'))) {
        const paramValueString = params.get('material_id');
        inParams.material_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('packaging_id'))) {
        const paramValueString = params.get('packaging_id');
        inParams.packaging_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('project_id'))) {
        const paramValueString = params.get('project_id');
        inParams.project_id = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_owner_editor') {
      const title = 'Edit Owner';
      const component = FootprintManager_owner_editorComponent;
      const inParams:{ ownerId: number } = { ownerId: null };
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_pack_verification_completion_editor') {
      const title = 'Complete verification';
      const component = FootprintManager_pack_verification_completion_editorComponent;
      const inParams:{ shippingContainerId: number, startVerificationTaskId: number, instructions?: { entity?: string, code?: string, instruction?: string, isCompleted?: boolean }[], scannedValues?: { scannedValue: string, lotId: number, packagingId: number }[], properties?: { containerType?: string, dimensions?: string, weight?: string }, targetLocationId: number, can_fail_verification: boolean } = { shippingContainerId: null, startVerificationTaskId: null, instructions: [], scannedValues: [], properties: { containerType: null, dimensions: null, weight: null }, targetLocationId: null, can_fail_verification: null };
      if (!isNil(params.get('shippingContainerId'))) {
        const paramValueString = params.get('shippingContainerId');
        inParams.shippingContainerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('startVerificationTaskId'))) {
        const paramValueString = params.get('startVerificationTaskId');
        inParams.startVerificationTaskId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('instructions'))) {
        const paramValueString = params.get('instructions');
        inParams.instructions = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('scannedValues'))) {
        const paramValueString = params.get('scannedValues');
        inParams.scannedValues = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('properties'))) {
        const paramValueString = params.get('properties');
        inParams.properties = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('targetLocationId'))) {
        const paramValueString = params.get('targetLocationId');
        inParams.targetLocationId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('can_fail_verification'))) {
        const paramValueString = params.get('can_fail_verification');
        inParams.can_fail_verification = this.convertToBoolean(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_pack_verification_shipping_container_properties_editor') {
      const title = 'Shipping container properties';
      const component = FootprintManager_pack_verification_shipping_container_properties_editorComponent;
      const inParams:{ shippingContainerId: number, startVerificationTaskId: number, targetLocationId?: number, isReadOnly: boolean, can_fail_verification: boolean } = { shippingContainerId: null, startVerificationTaskId: null, targetLocationId: null, isReadOnly: null, can_fail_verification: null };
      if (!isNil(params.get('shippingContainerId'))) {
        const paramValueString = params.get('shippingContainerId');
        inParams.shippingContainerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('startVerificationTaskId'))) {
        const paramValueString = params.get('startVerificationTaskId');
        inParams.startVerificationTaskId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('targetLocationId'))) {
        const paramValueString = params.get('targetLocationId');
        inParams.targetLocationId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('isReadOnly'))) {
        const paramValueString = params.get('isReadOnly');
        inParams.isReadOnly = this.convertToBoolean(paramValueString);
      }
      if (!isNil(params.get('can_fail_verification'))) {
        const paramValueString = params.get('can_fail_verification');
        inParams.can_fail_verification = this.convertToBoolean(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_pack_verification_verify_container_editor') {
      const title = 'Verify Container';
      const component = FootprintManager_pack_verification_verify_container_editorComponent;
      const inParams:{ shippingContainerId: number, startVerificationTaskId: number, isBlind?: boolean, targetLocationId?: number, isReadOnly?: boolean, can_fail_verification: boolean } = { shippingContainerId: null, startVerificationTaskId: null, isBlind: null, targetLocationId: null, isReadOnly: null, can_fail_verification: null };
      if (!isNil(params.get('shippingContainerId'))) {
        const paramValueString = params.get('shippingContainerId');
        inParams.shippingContainerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('startVerificationTaskId'))) {
        const paramValueString = params.get('startVerificationTaskId');
        inParams.startVerificationTaskId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('isBlind'))) {
        const paramValueString = params.get('isBlind');
        inParams.isBlind = this.convertToBoolean(paramValueString);
      }
      if (!isNil(params.get('targetLocationId'))) {
        const paramValueString = params.get('targetLocationId');
        inParams.targetLocationId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('isReadOnly'))) {
        const paramValueString = params.get('isReadOnly');
        inParams.isReadOnly = this.convertToBoolean(paramValueString);
      }
      if (!isNil(params.get('can_fail_verification'))) {
        const paramValueString = params.get('can_fail_verification');
        inParams.can_fail_verification = this.convertToBoolean(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_plan_editor') {
      this.$logger.log('FootprintManager', 'plan_editor');
      const title = 'Plan';
      const component = FootprintManager_plan_editorComponent;
      const inParams:{ plan_id?: string } = { plan_id: null };
      if (!isNil(params.get('plan_id'))) {
        const paramValueString = params.get('plan_id');
        // TODO: date
        inParams.plan_id = paramValueString;
              }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_process_order') {
      this.$logger.log('FootprintManager', 'process_order');
      const title = 'Process order';
      const component = FootprintManager_process_orderComponent;
      const inParams:{ order_id: number } = { order_id: null };
      if (!isNil(params.get('order_id'))) {
        const paramValueString = params.get('order_id');
        inParams.order_id = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_project_editor') {
      const title = 'Edit Project';
      const component = FootprintManager_project_editorComponent;
      const inParams:{ projectId: number } = { projectId: null };
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_purchase_order_editor') {
      const title = 'Edit purchase order';
      const component = FootprintManager_purchase_order_editorComponent;
      const inParams:{ orderId: number } = { orderId: null };
      if (!isNil(params.get('orderId'))) {
        const paramValueString = params.get('orderId');
        inParams.orderId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_reason_code_editor') {
      const title = 'reason_code_editor';
      const component = FootprintManager_reason_code_editorComponent;
      const inParams:{ reasonCodeId: number } = { reasonCodeId: null };
      if (!isNil(params.get('reasonCodeId'))) {
        const paramValueString = params.get('reasonCodeId');
        inParams.reasonCodeId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_return_order_editor') {
      const title = 'Edit Return Order';
      const component = FootprintManager_return_order_editorComponent;
      const inParams:{ orderId: number } = { orderId: null };
      if (!isNil(params.get('orderId'))) {
        const paramValueString = params.get('orderId');
        inParams.orderId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_sales_order_editor') {
      const title = 'Edit sales order';
      const component = FootprintManager_sales_order_editorComponent;
      const inParams:{ orderId: number } = { orderId: null };
      if (!isNil(params.get('orderId'))) {
        const paramValueString = params.get('orderId');
        inParams.orderId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_sales_order_line_kit_editor') {
      const title = 'Sale order line kit editor';
      const component = FootprintManager_sales_order_line_kit_editorComponent;
      const inParams:{ material_id: number, project_id: number, packaging_id: number, line_number: number, line_status_id: number, packaged_amount: number, order_id: number, shipment_id: number, warehouse_id: number, order_status_id: number } = { material_id: null, project_id: null, packaging_id: null, line_number: null, line_status_id: null, packaged_amount: null, order_id: null, shipment_id: null, warehouse_id: null, order_status_id: null };
      if (!isNil(params.get('material_id'))) {
        const paramValueString = params.get('material_id');
        inParams.material_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('project_id'))) {
        const paramValueString = params.get('project_id');
        inParams.project_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('packaging_id'))) {
        const paramValueString = params.get('packaging_id');
        inParams.packaging_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('line_number'))) {
        const paramValueString = params.get('line_number');
        inParams.line_number = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('line_status_id'))) {
        const paramValueString = params.get('line_status_id');
        inParams.line_status_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('packaged_amount'))) {
        const paramValueString = params.get('packaged_amount');
        inParams.packaged_amount = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('order_id'))) {
        const paramValueString = params.get('order_id');
        inParams.order_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('shipment_id'))) {
        const paramValueString = params.get('shipment_id');
        inParams.shipment_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouse_id'))) {
        const paramValueString = params.get('warehouse_id');
        inParams.warehouse_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('order_status_id'))) {
        const paramValueString = params.get('order_status_id');
        inParams.order_status_id = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_serialnumber_editor') {
      const title = 'Edit serial';
      const component = FootprintManager_serialnumber_editorComponent;
      const inParams:{ serialnumberId: number } = { serialnumberId: null };
      if (!isNil(params.get('serialnumberId'))) {
        const paramValueString = params.get('serialnumberId');
        inParams.serialnumberId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_shipping_container_editor') {
      const title = 'Container';
      const component = FootprintManager_shipping_container_editorComponent;
      const inParams:{ shippingContainerId: number } = { shippingContainerId: null };
      if (!isNil(params.get('shippingContainerId'))) {
        const paramValueString = params.get('shippingContainerId');
        inParams.shippingContainerId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_task_assignment_editor') {
      const title = 'Task';
      const component = FootprintManager_task_assignment_editorComponent;
      const inParams:{ taskId: number } = { taskId: null };
      if (!isNil(params.get('taskId'))) {
        const paramValueString = params.get('taskId');
        inParams.taskId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_task_details_editor') {
      const title = 'Task Detail';
      const component = FootprintManager_task_details_editorComponent;
      const inParams:{ taskId: number, is_non_editable?: boolean } = { taskId: null, is_non_editable: null };
      if (!isNil(params.get('taskId'))) {
        const paramValueString = params.get('taskId');
        inParams.taskId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('is_non_editable'))) {
        const paramValueString = params.get('is_non_editable');
        inParams.is_non_editable = this.convertToBoolean(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_transload_order_editor') {
      const title = 'Edit Transload Order';
      const component = FootprintManager_transload_order_editorComponent;
      const inParams:{ orderId: number } = { orderId: null };
      if (!isNil(params.get('orderId'))) {
        const paramValueString = params.get('orderId');
        inParams.orderId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_warehouse_editor') {
      const title = 'Edit Warehouse';
      const component = FootprintManager_warehouse_editorComponent;
      const inParams:{ warehouseId: number } = { warehouseId: null };
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_warehouse_transfer_editor') {
      const title = 'Warehouse transfer editor';
      const component = FootprintManager_warehouse_transfer_editorComponent;
      const inParams:{ warehouseTransferId: number } = { warehouseTransferId: null };
      if (!isNil(params.get('warehouseTransferId'))) {
        const paramValueString = params.get('warehouseTransferId');
        inParams.warehouseTransferId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_warehouse_transfer_inbound_order_editor') {
      const title = 'Edit Inbound Order';
      const component = FootprintManager_warehouse_transfer_inbound_order_editorComponent;
      const inParams:{ orderId: number, warehouseTransferId: number } = { orderId: null, warehouseTransferId: null };
      if (!isNil(params.get('orderId'))) {
        const paramValueString = params.get('orderId');
        inParams.orderId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouseTransferId'))) {
        const paramValueString = params.get('warehouseTransferId');
        inParams.warehouseTransferId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_warehouse_transfer_outbound_order_editor') {
      const title = 'Edit outbound order';
      const component = FootprintManager_warehouse_transfer_outbound_order_editorComponent;
      const inParams:{ orderId: number, warehouseTransferId: number } = { orderId: null, warehouseTransferId: null };
      if (!isNil(params.get('orderId'))) {
        const paramValueString = params.get('orderId');
        inParams.orderId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouseTransferId'))) {
        const paramValueString = params.get('warehouseTransferId');
        inParams.warehouseTransferId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_wave_editor') {
      const title = 'Wave editor';
      const component = FootprintManager_wave_editorComponent;
      const inParams:{ waveId: number, projectId?: number, ownerId?: number, warehouseId?: number, showCreate?: boolean } = { waveId: null, projectId: null, ownerId: null, warehouseId: null, showCreate: null };
      if (!isNil(params.get('waveId'))) {
        const paramValueString = params.get('waveId');
        inParams.waveId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('showCreate'))) {
        const paramValueString = params.get('showCreate');
        inParams.showCreate = this.convertToBoolean(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_work_class_editor') {
      const title = 'Work class';
      const component = FootprintManager_work_class_editorComponent;
      const inParams:{ workClassId: number } = { workClassId: null };
      if (!isNil(params.get('workClassId'))) {
        const paramValueString = params.get('workClassId');
        inParams.workClassId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_work_order_editor') {
      const title = 'Edit Work Order';
      const component = FootprintManager_work_order_editorComponent;
      const inParams:{ workOrderId: number } = { workOrderId: null };
      if (!isNil(params.get('workOrderId'))) {
        const paramValueString = params.get('workOrderId');
        inParams.workOrderId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_workshift_editor') {
      this.$logger.log('FootprintManager', 'workshift_editor');
      const title = 'Workshift Edit';
      const component = FootprintManager_workshift_editorComponent;
      const inParams:{ workshift_id: number, is_new: boolean } = { workshift_id: null, is_new: null };
      if (!isNil(params.get('workshift_id'))) {
        const paramValueString = params.get('workshift_id');
        inParams.workshift_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('is_new'))) {
        const paramValueString = params.get('is_new');
        inParams.is_new = this.convertToBoolean(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_accessorial_tasks_grid') {
      const title = 'Accessorials';
      const component = FootprintManager_accessorial_tasks_gridComponent;
      const inParams:{ workOrderId?: number, projectId?: number, entityStatusId: number, orderId?: number, warehouseId: number, shippingContainerId?: number, showAllOpCodes?: boolean, shipmentId?: number } = { workOrderId: null, projectId: null, entityStatusId: null, orderId: null, warehouseId: null, shippingContainerId: null, showAllOpCodes: null, shipmentId: null };
      if (!isNil(params.get('workOrderId'))) {
        const paramValueString = params.get('workOrderId');
        inParams.workOrderId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('entityStatusId'))) {
        const paramValueString = params.get('entityStatusId');
        inParams.entityStatusId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('orderId'))) {
        const paramValueString = params.get('orderId');
        inParams.orderId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('shippingContainerId'))) {
        const paramValueString = params.get('shippingContainerId');
        inParams.shippingContainerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('showAllOpCodes'))) {
        const paramValueString = params.get('showAllOpCodes');
        inParams.showAllOpCodes = this.convertToBoolean(paramValueString);
      }
      if (!isNil(params.get('shipmentId'))) {
        const paramValueString = params.get('shipmentId');
        inParams.shipmentId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_accounts_grid') {
      const title = 'Addresses';
      const component = FootprintManager_accounts_gridComponent;
      const inParams:{ ownerId: number, accountTypeId: number, typeIds: number[], allowSelection: boolean, title?: string, excludeAccountIds?: number[] } = { ownerId: null, accountTypeId: null, typeIds: [], allowSelection: null, title: null, excludeAccountIds: [] };
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('accountTypeId'))) {
        const paramValueString = params.get('accountTypeId');
        inParams.accountTypeId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('typeIds'))) {
        const paramValueString = params.get('typeIds');
        inParams.typeIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('allowSelection'))) {
        const paramValueString = params.get('allowSelection');
        inParams.allowSelection = this.convertToBoolean(paramValueString);
      }
      if (!isNil(params.get('title'))) {
        const paramValueString = params.get('title');
        // TODO: date
        inParams.title = paramValueString;
              }
      if (!isNil(params.get('excludeAccountIds'))) {
        const paramValueString = params.get('excludeAccountIds');
        inParams.excludeAccountIds = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_activity_grid') {
      const title = 'Activity Grid';
      const component = FootprintManager_activity_gridComponent;
      const inParams:{ project_ids?: number[], owner_ids?: number[], warehouse_ids?: number[], operation_code_ids?: number[], status_ids?: number[], location_id?: number, seven_days_before_flag?: boolean } = { project_ids: [], owner_ids: [], warehouse_ids: [], operation_code_ids: [], status_ids: [], location_id: null, seven_days_before_flag: null };
      if (!isNil(params.get('project_ids'))) {
        const paramValueString = params.get('project_ids');
        inParams.project_ids = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('owner_ids'))) {
        const paramValueString = params.get('owner_ids');
        inParams.owner_ids = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('warehouse_ids'))) {
        const paramValueString = params.get('warehouse_ids');
        inParams.warehouse_ids = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('operation_code_ids'))) {
        const paramValueString = params.get('operation_code_ids');
        inParams.operation_code_ids = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('status_ids'))) {
        const paramValueString = params.get('status_ids');
        inParams.status_ids = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('location_id'))) {
        const paramValueString = params.get('location_id');
        inParams.location_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('seven_days_before_flag'))) {
        const paramValueString = params.get('seven_days_before_flag');
        inParams.seven_days_before_flag = this.convertToBoolean(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_allocation_configurations_grid') {
      this.$logger.log('FootprintManager', 'allocation_configurations_grid');
      const title = 'Allocation configurations';
      const component = FootprintManager_allocation_configurations_gridComponent;
      const inParams:{ applicable_config_ids?: number[] } = { applicable_config_ids: [] };
      if (!isNil(params.get('applicable_config_ids'))) {
        const paramValueString = params.get('applicable_config_ids');
        inParams.applicable_config_ids = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_asn_order_children_tasks_grid') {
      const title = 'ASN order children tasks';
      const component = FootprintManager_asn_order_children_tasks_gridComponent;
      const inParams:{ taskId: number } = { taskId: null };
      if (!isNil(params.get('taskId'))) {
        const paramValueString = params.get('taskId');
        inParams.taskId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_asn_order_licenseplates_grid') {
      const title = 'License plates';
      const component = FootprintManager_asn_order_licenseplates_gridComponent;
      const inParams:{ order_id: number, order_status_id: number, project_id: number, can_unreceive?: boolean } = { order_id: null, order_status_id: null, project_id: null, can_unreceive: null };
      if (!isNil(params.get('order_id'))) {
        const paramValueString = params.get('order_id');
        inParams.order_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('order_status_id'))) {
        const paramValueString = params.get('order_status_id');
        inParams.order_status_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('project_id'))) {
        const paramValueString = params.get('project_id');
        inParams.project_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('can_unreceive'))) {
        const paramValueString = params.get('can_unreceive');
        inParams.can_unreceive = this.convertToBoolean(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_asn_order_licenseplates_receiving_tasks_grid') {
      const title = 'Receiving tasks';
      const component = FootprintManager_asn_order_licenseplates_receiving_tasks_gridComponent;
      const inParams:{ licenseplateId: number, orderId: number, projectId: number, orderStatusId: number } = { licenseplateId: null, orderId: null, projectId: null, orderStatusId: null };
      if (!isNil(params.get('licenseplateId'))) {
        const paramValueString = params.get('licenseplateId');
        inParams.licenseplateId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('orderId'))) {
        const paramValueString = params.get('orderId');
        inParams.orderId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('orderStatusId'))) {
        const paramValueString = params.get('orderStatusId');
        inParams.orderStatusId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_asn_order_receiving_tasks_grid') {
      const title = 'Receiving tasks';
      const component = FootprintManager_asn_order_receiving_tasks_gridComponent;
      const inParams:{ orderId: number, orderStatusId: number } = { orderId: null, orderStatusId: null };
      if (!isNil(params.get('orderId'))) {
        const paramValueString = params.get('orderId');
        inParams.orderId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('orderStatusId'))) {
        const paramValueString = params.get('orderStatusId');
        inParams.orderStatusId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_asn_order_tasks_grid') {
      const title = 'ASN order tasks';
      const component = FootprintManager_asn_order_tasks_gridComponent;
      const inParams:{ orderId: number, shipmentId: number } = { orderId: null, shipmentId: null };
      if (!isNil(params.get('orderId'))) {
        const paramValueString = params.get('orderId');
        inParams.orderId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('shipmentId'))) {
        const paramValueString = params.get('shipmentId');
        inParams.shipmentId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_asn_orderlines_grid') {
      const title = 'Order lines';
      const component = FootprintManager_asn_orderlines_gridComponent;
      const inParams:{ orderId: number } = { orderId: null };
      if (!isNil(params.get('orderId'))) {
        const paramValueString = params.get('orderId');
        inParams.orderId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_assigned_orders_on_wave_grid') {
      const title = 'Assigned orders';
      const component = FootprintManager_assigned_orders_on_wave_gridComponent;
      const inParams:{ waveId: number, waveStatusId: number } = { waveId: null, waveStatusId: null };
      if (!isNil(params.get('waveId'))) {
        const paramValueString = params.get('waveId');
        inParams.waveId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('waveStatusId'))) {
        const paramValueString = params.get('waveStatusId');
        inParams.waveStatusId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_audit_serial_numbers_grid') {
      const title = 'Audit serial numbers';
      const component = FootprintManager_audit_serial_numbers_gridComponent;
      const inParams:{ scannedBarcodes: { barcode: string, serialNumber: string, isValid: boolean, serialNumberId: number }[], watchList: { barcode: string, serialNumber: string }[], context?: string } = { scannedBarcodes: [], watchList: [], context: null };
      if (!isNil(params.get('scannedBarcodes'))) {
        const paramValueString = params.get('scannedBarcodes');
        inParams.scannedBarcodes = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('watchList'))) {
        const paramValueString = params.get('watchList');
        inParams.watchList = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('context'))) {
        const paramValueString = params.get('context');
        // TODO: date
        inParams.context = paramValueString;
              }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_available_inventory_grid') {
      const title = 'Available inventory';
      const component = FootprintManager_available_inventory_gridComponent;
      const inParams:{ materialId: number, warehouseId: number, recommendedAmount?: number, taskId?: number, lotId?: number, vendorLotId?: number, allowInactive?: boolean } = { materialId: null, warehouseId: null, recommendedAmount: null, taskId: null, lotId: null, vendorLotId: null, allowInactive: null };
      if (!isNil(params.get('materialId'))) {
        const paramValueString = params.get('materialId');
        inParams.materialId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('recommendedAmount'))) {
        const paramValueString = params.get('recommendedAmount');
        inParams.recommendedAmount = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('taskId'))) {
        const paramValueString = params.get('taskId');
        inParams.taskId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('lotId'))) {
        const paramValueString = params.get('lotId');
        inParams.lotId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('vendorLotId'))) {
        const paramValueString = params.get('vendorLotId');
        inParams.vendorLotId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('allowInactive'))) {
        const paramValueString = params.get('allowInactive');
        inParams.allowInactive = this.convertToBoolean(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_billing_contract_lines_grid') {
      const title = 'Billing contract lines';
      const component = FootprintManager_billing_contract_lines_gridComponent;
      const inParams:{ contractId: number, strategyName?: string, edit?: boolean, hide?: string[], statusId?: number } = { contractId: null, strategyName: null, edit: null, hide: [], statusId: null };
      if (!isNil(params.get('contractId'))) {
        const paramValueString = params.get('contractId');
        inParams.contractId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('strategyName'))) {
        const paramValueString = params.get('strategyName');
        // TODO: date
        inParams.strategyName = paramValueString;
              }
      if (!isNil(params.get('edit'))) {
        const paramValueString = params.get('edit');
        inParams.edit = this.convertToBoolean(paramValueString);
      }
      if (!isNil(params.get('hide'))) {
        const paramValueString = params.get('hide');
        inParams.hide = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('statusId'))) {
        const paramValueString = params.get('statusId');
        inParams.statusId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_billing_contracts_grid') {
      const title = 'Billing contracts';
      const component = FootprintManager_billing_contracts_gridComponent;
      const inParams:{ ownerId?: number, projectId?: number, statusIds?: number[], endDate?: string } = { ownerId: null, projectId: null, statusIds: [], endDate: null };
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('statusIds'))) {
        const paramValueString = params.get('statusIds');
        inParams.statusIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('endDate'))) {
        const paramValueString = params.get('endDate');
        // TODO: date
        inParams.endDate = paramValueString;
              }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_billing_projects_grid') {
      const title = 'Billing projects grid';
      const component = FootprintManager_billing_projects_gridComponent;
      const inParams:{ billingContractLineId: number, edit: boolean } = { billingContractLineId: null, edit: null };
      if (!isNil(params.get('billingContractLineId'))) {
        const paramValueString = params.get('billingContractLineId');
        inParams.billingContractLineId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('edit'))) {
        const paramValueString = params.get('edit');
        inParams.edit = this.convertToBoolean(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_billing_rates_grid') {
      const title = 'Billing rates';
      const component = FootprintManager_billing_rates_gridComponent;
      const inParams:{ billingContractLineId?: number, edit: boolean, typeId: number, accessorialTemplateLineId?: number } = { billingContractLineId: null, edit: null, typeId: null, accessorialTemplateLineId: null };
      if (!isNil(params.get('billingContractLineId'))) {
        const paramValueString = params.get('billingContractLineId');
        inParams.billingContractLineId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('edit'))) {
        const paramValueString = params.get('edit');
        inParams.edit = this.convertToBoolean(paramValueString);
      }
      if (!isNil(params.get('typeId'))) {
        const paramValueString = params.get('typeId');
        inParams.typeId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('accessorialTemplateLineId'))) {
        const paramValueString = params.get('accessorialTemplateLineId');
        inParams.accessorialTemplateLineId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_billing_records_by_invoiceline_grid') {
      const title = 'Billing records by invoice line';
      const component = FootprintManager_billing_records_by_invoiceline_gridComponent;
      const inParams:{ invoiceLineId: number } = { invoiceLineId: null };
      if (!isNil(params.get('invoiceLineId'))) {
        const paramValueString = params.get('invoiceLineId');
        inParams.invoiceLineId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_billing_records_grid') {
      const title = 'Billing records';
      const component = FootprintManager_billing_records_gridComponent;
      const inParams:{ ownerId?: number, projectId?: number, materialIds?: number[], warehouseIds?: number[], orderIds?: number[], includeCancelled?: boolean, includeInvoiced?: boolean, shipmentIds?: number[], workOrderId?: number } = { ownerId: null, projectId: null, materialIds: [], warehouseIds: [], orderIds: [], includeCancelled: null, includeInvoiced: null, shipmentIds: [], workOrderId: null };
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('materialIds'))) {
        const paramValueString = params.get('materialIds');
        inParams.materialIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('warehouseIds'))) {
        const paramValueString = params.get('warehouseIds');
        inParams.warehouseIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('orderIds'))) {
        const paramValueString = params.get('orderIds');
        inParams.orderIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('includeCancelled'))) {
        const paramValueString = params.get('includeCancelled');
        inParams.includeCancelled = this.convertToBoolean(paramValueString);
      }
      if (!isNil(params.get('includeInvoiced'))) {
        const paramValueString = params.get('includeInvoiced');
        inParams.includeInvoiced = this.convertToBoolean(paramValueString);
      }
      if (!isNil(params.get('shipmentIds'))) {
        const paramValueString = params.get('shipmentIds');
        inParams.shipmentIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('workOrderId'))) {
        const paramValueString = params.get('workOrderId');
        inParams.workOrderId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_billing_supplemental_fees_grid') {
      const title = 'Billing supplemental fees grid';
      const component = FootprintManager_billing_supplemental_fees_gridComponent;
      const inParams:{ billingContractLineId: number, edit: boolean } = { billingContractLineId: null, edit: null };
      if (!isNil(params.get('billingContractLineId'))) {
        const paramValueString = params.get('billingContractLineId');
        inParams.billingContractLineId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('edit'))) {
        const paramValueString = params.get('edit');
        inParams.edit = this.convertToBoolean(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_blind_shipping_container_return_tasks_grid') {
      const title = 'Return tasks';
      const component = FootprintManager_blind_shipping_container_return_tasks_gridComponent;
      const inParams:{ warehouseId?: number, locationId?: number, sourceShippingContainerId: number, sourceLicensePlateId?: number, inputScan?: string } = { warehouseId: null, locationId: null, sourceShippingContainerId: null, sourceLicensePlateId: null, inputScan: null };
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('locationId'))) {
        const paramValueString = params.get('locationId');
        inParams.locationId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('sourceShippingContainerId'))) {
        const paramValueString = params.get('sourceShippingContainerId');
        inParams.sourceShippingContainerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('sourceLicensePlateId'))) {
        const paramValueString = params.get('sourceLicensePlateId');
        inParams.sourceLicensePlateId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('inputScan'))) {
        const paramValueString = params.get('inputScan');
        // TODO: date
        inParams.inputScan = paramValueString;
              }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_carriers_grid') {
      const title = 'Carriers';
      const component = FootprintManager_carriers_gridComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_carrierservices_grid') {
      const title = 'Carrier services';
      const component = FootprintManager_carrierservices_gridComponent;
      const inParams:{ carrierId: number } = { carrierId: null };
      if (!isNil(params.get('carrierId'))) {
        const paramValueString = params.get('carrierId');
        inParams.carrierId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_carrierservicetypes_grid') {
      const title = 'Service types';
      const component = FootprintManager_carrierservicetypes_gridComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_child_serialnumbers_grid') {
      const title = 'Child serials';
      const component = FootprintManager_child_serialnumbers_gridComponent;
      const inParams:{ chainHead: number, archived: boolean, fullTextSearch?: string } = { chainHead: null, archived: null, fullTextSearch: null };
      if (!isNil(params.get('chainHead'))) {
        const paramValueString = params.get('chainHead');
        inParams.chainHead = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('archived'))) {
        const paramValueString = params.get('archived');
        inParams.archived = this.convertToBoolean(paramValueString);
      }
      if (!isNil(params.get('fullTextSearch'))) {
        const paramValueString = params.get('fullTextSearch');
        // TODO: date
        inParams.fullTextSearch = paramValueString;
              }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_contact_addresses_grid') {
      const title = 'Addresses';
      const component = FootprintManager_contact_addresses_gridComponent;
      const inParams:{ entity: string, entityId: number, typeIds?: number[] } = { entity: null, entityId: null, typeIds: [] };
      if (!isNil(params.get('entity'))) {
        const paramValueString = params.get('entity');
        // TODO: date
        inParams.entity = paramValueString;
              }
      if (!isNil(params.get('entityId'))) {
        const paramValueString = params.get('entityId');
        inParams.entityId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('typeIds'))) {
        const paramValueString = params.get('typeIds');
        inParams.typeIds = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_container_type_assignment_grid') {
      const title = 'Container assignment grid';
      const component = FootprintManager_container_type_assignment_gridComponent;
      const inParams:{ ownerId?: number, projectId?: number, materialId?: number, enabled?: boolean, assignmentLevel?: string } = { ownerId: null, projectId: null, materialId: null, enabled: null, assignmentLevel: null };
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('materialId'))) {
        const paramValueString = params.get('materialId');
        inParams.materialId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('enabled'))) {
        const paramValueString = params.get('enabled');
        inParams.enabled = this.convertToBoolean(paramValueString);
      }
      if (!isNil(params.get('assignmentLevel'))) {
        const paramValueString = params.get('assignmentLevel');
        // TODO: date
        inParams.assignmentLevel = paramValueString;
              }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_container_types_grid') {
      const title = 'Container types';
      const component = FootprintManager_container_types_gridComponent;
      const inParams:{ ownerId?: number, projectId?: number, materialId?: number } = { ownerId: null, projectId: null, materialId: null };
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('materialId'))) {
        const paramValueString = params.get('materialId');
        inParams.materialId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_count_tasks_grid') {
      const title = 'Count tasks';
      const component = FootprintManager_count_tasks_gridComponent;
      const inParams:{ inventoryCountId?: number, allowEdit?: boolean, statusIds?: number[], warehouseIds?: number[] } = { inventoryCountId: null, allowEdit: null, statusIds: [], warehouseIds: [] };
      if (!isNil(params.get('inventoryCountId'))) {
        const paramValueString = params.get('inventoryCountId');
        inParams.inventoryCountId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('allowEdit'))) {
        const paramValueString = params.get('allowEdit');
        inParams.allowEdit = this.convertToBoolean(paramValueString);
      }
      if (!isNil(params.get('statusIds'))) {
        const paramValueString = params.get('statusIds');
        inParams.statusIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('warehouseIds'))) {
        const paramValueString = params.get('warehouseIds');
        inParams.warehouseIds = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_count_tasks_no_filter_grid') {
      this.$logger.log('FootprintManager', 'count_tasks_no_filter_grid');
      const title = 'Count tasks';
      const component = FootprintManager_count_tasks_no_filter_gridComponent;
      const inParams:{ allowEdit?: boolean, statusIds?: number[], warehouseIds?: number[] } = { allowEdit: null, statusIds: [], warehouseIds: [] };
      if (!isNil(params.get('allowEdit'))) {
        const paramValueString = params.get('allowEdit');
        inParams.allowEdit = this.convertToBoolean(paramValueString);
      }
      if (!isNil(params.get('statusIds'))) {
        const paramValueString = params.get('statusIds');
        inParams.statusIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('warehouseIds'))) {
        const paramValueString = params.get('warehouseIds');
        inParams.warehouseIds = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_customer_return_shipping_containers_grid') {
      const title = 'Shipping containers';
      const component = FootprintManager_customer_return_shipping_containers_gridComponent;
      const inParams:{ orderId: number } = { orderId: null };
      if (!isNil(params.get('orderId'))) {
        const paramValueString = params.get('orderId');
        inParams.orderId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_dock_appointment_types_grid') {
      const title = 'Dock appointment types';
      const component = FootprintManager_dock_appointment_types_gridComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_dock_appointments_dashboard_grid') {
      const title = 'Appointments dashboard';
      const component = FootprintManager_dock_appointments_dashboard_gridComponent;
      const inParams:{ ownerId?: number, projectId?: number, warehouseIds: number[], typeIds?: number[], statusIds?: number[], fromDate?: string, toDate?: string } = { ownerId: null, projectId: null, warehouseIds: [], typeIds: [], statusIds: [], fromDate: null, toDate: null };
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouseIds'))) {
        const paramValueString = params.get('warehouseIds');
        inParams.warehouseIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('typeIds'))) {
        const paramValueString = params.get('typeIds');
        inParams.typeIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('statusIds'))) {
        const paramValueString = params.get('statusIds');
        inParams.statusIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('fromDate'))) {
        const paramValueString = params.get('fromDate');
        // TODO: date
        inParams.fromDate = paramValueString;
              }
      if (!isNil(params.get('toDate'))) {
        const paramValueString = params.get('toDate');
        // TODO: date
        inParams.toDate = paramValueString;
              }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_dock_appointments_grid') {
      const title = 'Appointments';
      const component = FootprintManager_dock_appointments_gridComponent;
      const inParams:{ typeIds?: number[], ownerId?: number, projectId?: number, carrierId?: number, statusIds?: number[], warehouseIds: number[], fromDate?: string, toDate?: string, dockDoorIds?: number[] } = { typeIds: [], ownerId: null, projectId: null, carrierId: null, statusIds: [], warehouseIds: [], fromDate: null, toDate: null, dockDoorIds: [] };
      if (!isNil(params.get('typeIds'))) {
        const paramValueString = params.get('typeIds');
        inParams.typeIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('carrierId'))) {
        const paramValueString = params.get('carrierId');
        inParams.carrierId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('statusIds'))) {
        const paramValueString = params.get('statusIds');
        inParams.statusIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('warehouseIds'))) {
        const paramValueString = params.get('warehouseIds');
        inParams.warehouseIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('fromDate'))) {
        const paramValueString = params.get('fromDate');
        // TODO: date
        inParams.fromDate = paramValueString;
              }
      if (!isNil(params.get('toDate'))) {
        const paramValueString = params.get('toDate');
        // TODO: date
        inParams.toDate = paramValueString;
              }
      if (!isNil(params.get('dockDoorIds'))) {
        const paramValueString = params.get('dockDoorIds');
        inParams.dockDoorIds = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_dock_appointments_selection_grid') {
      const title = 'Dock appointments';
      const component = FootprintManager_dock_appointments_selection_gridComponent;
      const inParams:{ typeIds?: number[], carrierId?: number, statusIds?: number[], warehouseId?: number, scheduledProjectId?: number, excludedDockAppointmentIds?: number[] } = { typeIds: [], carrierId: null, statusIds: [], warehouseId: null, scheduledProjectId: null, excludedDockAppointmentIds: [] };
      if (!isNil(params.get('typeIds'))) {
        const paramValueString = params.get('typeIds');
        inParams.typeIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('carrierId'))) {
        const paramValueString = params.get('carrierId');
        inParams.carrierId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('statusIds'))) {
        const paramValueString = params.get('statusIds');
        inParams.statusIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('scheduledProjectId'))) {
        const paramValueString = params.get('scheduledProjectId');
        inParams.scheduledProjectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('excludedDockAppointmentIds'))) {
        const paramValueString = params.get('excludedDockAppointmentIds');
        inParams.excludedDockAppointmentIds = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_entity_attachments_grid') {
      const title = 'Attachments';
      const component = FootprintManager_entity_attachments_gridComponent;
      const inParams:{ entityType: string, entityKeys: { name?: string, value?: any }[] } = { entityType: null, entityKeys: [] };
      if (!isNil(params.get('entityType'))) {
        const paramValueString = params.get('entityType');
        // TODO: date
        inParams.entityType = paramValueString;
              }
      if (!isNil(params.get('entityKeys'))) {
        const paramValueString = params.get('entityKeys');
        inParams.entityKeys = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_entity_import_requests_grid') {
      const title = 'Entity imports';
      const component = FootprintManager_entity_import_requests_gridComponent;
      const inParams:{ statusCodes?: string[], projects?: string[], warehouses?: string[], singleWarehouse?: string, singleProjectName?: string, singleProjectLookupCode?: string, requestId?: string, projectsExact?: string[], warehousesExact?: string[], dateFrom?: string, dateTo?: string, dateType?: string } = { statusCodes: [], projects: [], warehouses: [], singleWarehouse: null, singleProjectName: null, singleProjectLookupCode: null, requestId: null, projectsExact: [], warehousesExact: [], dateFrom: null, dateTo: null, dateType: null };
      if (!isNil(params.get('statusCodes'))) {
        const paramValueString = params.get('statusCodes');
        inParams.statusCodes = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('projects'))) {
        const paramValueString = params.get('projects');
        inParams.projects = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('warehouses'))) {
        const paramValueString = params.get('warehouses');
        inParams.warehouses = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('singleWarehouse'))) {
        const paramValueString = params.get('singleWarehouse');
        // TODO: date
        inParams.singleWarehouse = paramValueString;
              }
      if (!isNil(params.get('singleProjectName'))) {
        const paramValueString = params.get('singleProjectName');
        // TODO: date
        inParams.singleProjectName = paramValueString;
              }
      if (!isNil(params.get('singleProjectLookupCode'))) {
        const paramValueString = params.get('singleProjectLookupCode');
        // TODO: date
        inParams.singleProjectLookupCode = paramValueString;
              }
      if (!isNil(params.get('requestId'))) {
        const paramValueString = params.get('requestId');
        // TODO: date
        inParams.requestId = paramValueString;
              }
      if (!isNil(params.get('projectsExact'))) {
        const paramValueString = params.get('projectsExact');
        inParams.projectsExact = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('warehousesExact'))) {
        const paramValueString = params.get('warehousesExact');
        inParams.warehousesExact = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('dateFrom'))) {
        const paramValueString = params.get('dateFrom');
        // TODO: date
        inParams.dateFrom = paramValueString;
              }
      if (!isNil(params.get('dateTo'))) {
        const paramValueString = params.get('dateTo');
        // TODO: date
        inParams.dateTo = paramValueString;
              }
      if (!isNil(params.get('dateType'))) {
        const paramValueString = params.get('dateType');
        // TODO: date
        inParams.dateType = paramValueString;
              }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_entity_user_defined_field_values_grid') {
      const title = 'Custom fields';
      const component = FootprintManager_entity_user_defined_field_values_gridComponent;
      const inParams:{ entityType: string, entityKeys: { name?: string, value?: any }[] } = { entityType: null, entityKeys: [] };
      if (!isNil(params.get('entityType'))) {
        const paramValueString = params.get('entityType');
        // TODO: date
        inParams.entityType = paramValueString;
              }
      if (!isNil(params.get('entityKeys'))) {
        const paramValueString = params.get('entityKeys');
        inParams.entityKeys = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_field_selector_grid') {
      const title = 'Select fields';
      const component = FootprintManager_field_selector_gridComponent;
      const inParams:{ Columns: { Key?: string, Name?: string, IsSelected?: boolean }[] } = { Columns: [] };
      if (!isNil(params.get('Columns'))) {
        const paramValueString = params.get('Columns');
        inParams.Columns = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_footprint_events_grid') {
      this.$logger.log('FootprintManager', 'footprint_events_grid');
      const title = 'Footprint Events';
      const component = FootprintManager_footprint_events_gridComponent;
      const inParams:{ statusIds?: number[], typeIds?: number[] } = { statusIds: [], typeIds: [] };
      if (!isNil(params.get('statusIds'))) {
        const paramValueString = params.get('statusIds');
        inParams.statusIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('typeIds'))) {
        const paramValueString = params.get('typeIds');
        inParams.typeIds = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_inbound_orders_grid') {
      const title = 'Inbound orders';
      const component = FootprintManager_inbound_orders_gridComponent;
      const inParams:{ ownerId?: number, projectId?: number, warehouseId?: number[], statusIds?: number[], orderClassIds?: number[], reference?: string, materialIds?: number[] } = { ownerId: null, projectId: null, warehouseId: [], statusIds: [], orderClassIds: [], reference: null, materialIds: [] };
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('statusIds'))) {
        const paramValueString = params.get('statusIds');
        inParams.statusIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('orderClassIds'))) {
        const paramValueString = params.get('orderClassIds');
        inParams.orderClassIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('reference'))) {
        const paramValueString = params.get('reference');
        // TODO: date
        inParams.reference = paramValueString;
              }
      if (!isNil(params.get('materialIds'))) {
        const paramValueString = params.get('materialIds');
        inParams.materialIds = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_inspection_operation_codes_grid') {
      const title = 'Operation codes';
      const component = FootprintManager_inspection_operation_codes_gridComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_inspection_tasks_grid') {
      const title = 'Inspection tasks';
      const component = FootprintManager_inspection_tasks_gridComponent;
      const inParams:{ warehouseId: number, operationCodeIds?: number[] } = { warehouseId: null, operationCodeIds: [] };
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('operationCodeIds'))) {
        const paramValueString = params.get('operationCodeIds');
        inParams.operationCodeIds = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_instructions_grid') {
      const title = 'Instructions';
      const component = FootprintManager_instructions_gridComponent;
      const inParams:{ entityName: string, enabled: boolean, typeIds?: number[], entityKey1: number, entityKey2?: number, entityKey3?: number, entityKey4?: number, lookup_code?: string } = { entityName: null, enabled: null, typeIds: [], entityKey1: null, entityKey2: null, entityKey3: null, entityKey4: null, lookup_code: null };
      if (!isNil(params.get('entityName'))) {
        const paramValueString = params.get('entityName');
        // TODO: date
        inParams.entityName = paramValueString;
              }
      if (!isNil(params.get('enabled'))) {
        const paramValueString = params.get('enabled');
        inParams.enabled = this.convertToBoolean(paramValueString);
      }
      if (!isNil(params.get('typeIds'))) {
        const paramValueString = params.get('typeIds');
        inParams.typeIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('entityKey1'))) {
        const paramValueString = params.get('entityKey1');
        inParams.entityKey1 = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('entityKey2'))) {
        const paramValueString = params.get('entityKey2');
        inParams.entityKey2 = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('entityKey3'))) {
        const paramValueString = params.get('entityKey3');
        inParams.entityKey3 = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('entityKey4'))) {
        const paramValueString = params.get('entityKey4');
        inParams.entityKey4 = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('lookup_code'))) {
        const paramValueString = params.get('lookup_code');
        // TODO: date
        inParams.lookup_code = paramValueString;
              }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_inventory_by_licenseplate_selection_grid') {
      const title = 'Inventory by LP';
      const component = FootprintManager_inventory_by_licenseplate_selection_gridComponent;
      const inParams:{ warehouseId: number, materialId?: number, packagingId?: number, lotId?: number, projectId: number, packagedAmountRequest?: number } = { warehouseId: null, materialId: null, packagingId: null, lotId: null, projectId: null, packagedAmountRequest: null };
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('materialId'))) {
        const paramValueString = params.get('materialId');
        inParams.materialId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('packagingId'))) {
        const paramValueString = params.get('packagingId');
        inParams.packagingId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('lotId'))) {
        const paramValueString = params.get('lotId');
        inParams.lotId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('packagedAmountRequest'))) {
        const paramValueString = params.get('packagedAmountRequest');
        inParams.packagedAmountRequest = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_inventory_by_licenseplate_single_selection_grid') {
      const title = 'Inventory by LP single';
      const component = FootprintManager_inventory_by_licenseplate_single_selection_gridComponent;
      const inParams:{ warehouseId: number, materialId: number, packagingId: number, lotId?: number, projectId: number, packagedAmountRequest: number } = { warehouseId: null, materialId: null, packagingId: null, lotId: null, projectId: null, packagedAmountRequest: null };
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('materialId'))) {
        const paramValueString = params.get('materialId');
        inParams.materialId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('packagingId'))) {
        const paramValueString = params.get('packagingId');
        inParams.packagingId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('lotId'))) {
        const paramValueString = params.get('lotId');
        inParams.lotId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('packagedAmountRequest'))) {
        const paramValueString = params.get('packagedAmountRequest');
        inParams.packagedAmountRequest = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_inventory_by_location_selection_grid') {
      const title = 'Inventory by location';
      const component = FootprintManager_inventory_by_location_selection_gridComponent;
      const inParams:{ warehouseId: number, materialId?: number, packagingId?: number, lotId?: number, projectId: number, packagedAmountRequest?: number } = { warehouseId: null, materialId: null, packagingId: null, lotId: null, projectId: null, packagedAmountRequest: null };
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('materialId'))) {
        const paramValueString = params.get('materialId');
        inParams.materialId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('packagingId'))) {
        const paramValueString = params.get('packagingId');
        inParams.packagingId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('lotId'))) {
        const paramValueString = params.get('lotId');
        inParams.lotId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('packagedAmountRequest'))) {
        const paramValueString = params.get('packagedAmountRequest');
        inParams.packagedAmountRequest = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_inventory_by_lot_selection_grid') {
      const title = 'Inventory by lot';
      const component = FootprintManager_inventory_by_lot_selection_gridComponent;
      const inParams:{ warehouseId: number, materialId?: number, packagingId?: number, lotId?: number, projectId: number } = { warehouseId: null, materialId: null, packagingId: null, lotId: null, projectId: null };
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('materialId'))) {
        const paramValueString = params.get('materialId');
        inParams.materialId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('packagingId'))) {
        const paramValueString = params.get('packagingId');
        inParams.packagingId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('lotId'))) {
        const paramValueString = params.get('lotId');
        inParams.lotId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_inventory_by_lot_single_selection_grid') {
      const title = 'Inventory by lot single';
      const component = FootprintManager_inventory_by_lot_single_selection_gridComponent;
      const inParams:{ warehouseId: number, materialId: number, packagingId: number, projectId: number, packagedAmountRequest: number } = { warehouseId: null, materialId: null, packagingId: null, projectId: null, packagedAmountRequest: null };
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('materialId'))) {
        const paramValueString = params.get('materialId');
        inParams.materialId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('packagingId'))) {
        const paramValueString = params.get('packagingId');
        inParams.packagingId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('packagedAmountRequest'))) {
        const paramValueString = params.get('packagedAmountRequest');
        inParams.packagedAmountRequest = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_inventory_by_serialnumber_selection_grid') {
      const title = 'Inventory by serialnumber';
      const component = FootprintManager_inventory_by_serialnumber_selection_gridComponent;
      const inParams:{ warehouseId: number, materialId?: number, packagingId?: number, lotId?: number, projectId: number, exclude_serials?: number[] } = { warehouseId: null, materialId: null, packagingId: null, lotId: null, projectId: null, exclude_serials: [] };
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('materialId'))) {
        const paramValueString = params.get('materialId');
        inParams.materialId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('packagingId'))) {
        const paramValueString = params.get('packagingId');
        inParams.packagingId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('lotId'))) {
        const paramValueString = params.get('lotId');
        inParams.lotId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('exclude_serials'))) {
        const paramValueString = params.get('exclude_serials');
        inParams.exclude_serials = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_inventory_by_serialnumber_single_selection_grid') {
      const title = 'Inventory by SN single';
      const component = FootprintManager_inventory_by_serialnumber_single_selection_gridComponent;
      const inParams:{ warehouseId: number, materialId: number, packagingId: number, lotId?: number, projectId: number } = { warehouseId: null, materialId: null, packagingId: null, lotId: null, projectId: null };
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('materialId'))) {
        const paramValueString = params.get('materialId');
        inParams.materialId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('packagingId'))) {
        const paramValueString = params.get('packagingId');
        inParams.packagingId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('lotId'))) {
        const paramValueString = params.get('lotId');
        inParams.lotId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_inventory_counts_grid') {
      const title = 'Inventory counts';
      const component = FootprintManager_inventory_counts_gridComponent;
      const inParams:{ warehouseIds?: number[], statusIds?: number[] } = { warehouseIds: [], statusIds: [] };
      if (!isNil(params.get('warehouseIds'))) {
        const paramValueString = params.get('warehouseIds');
        inParams.warehouseIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('statusIds'))) {
        const paramValueString = params.get('statusIds');
        inParams.statusIds = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_inventory_licenseplate_grid') {
      const title = 'Inventory by LP';
      const component = FootprintManager_inventory_licenseplate_gridComponent;
      const inParams:{ licenseplateId?: number, ownerId?: number, projectId?: number, warehouseId?: number, materialIds?: number[] } = { licenseplateId: null, ownerId: null, projectId: null, warehouseId: null, materialIds: [] };
      if (!isNil(params.get('licenseplateId'))) {
        const paramValueString = params.get('licenseplateId');
        inParams.licenseplateId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('materialIds'))) {
        const paramValueString = params.get('materialIds');
        inParams.materialIds = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_inventory_licenseplate_snapshot_grid') {
      const title = 'Inventory licenseplate snapshot';
      const component = FootprintManager_inventory_licenseplate_snapshot_gridComponent;
      const inParams:{ captureDate: string, projectId: number, warehouseId: number, materialIds?: number[] } = { captureDate: null, projectId: null, warehouseId: null, materialIds: [] };
      if (!isNil(params.get('captureDate'))) {
        const paramValueString = params.get('captureDate');
        // TODO: date
        inParams.captureDate = paramValueString;
              }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('materialIds'))) {
        const paramValueString = params.get('materialIds');
        inParams.materialIds = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_inventory_location_grid') {
      const title = 'Inventory';
      const component = FootprintManager_inventory_location_gridComponent;
      const inParams:{ ownerId?: number, projectId?: number, warehouseId?: number, locationId?: number, materialIds?: number[], lotId?: number, zonePath?: string } = { ownerId: null, projectId: null, warehouseId: null, locationId: null, materialIds: [], lotId: null, zonePath: null };
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('locationId'))) {
        const paramValueString = params.get('locationId');
        inParams.locationId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('materialIds'))) {
        const paramValueString = params.get('materialIds');
        inParams.materialIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('lotId'))) {
        const paramValueString = params.get('lotId');
        inParams.lotId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('zonePath'))) {
        const paramValueString = params.get('zonePath');
        // TODO: date
        inParams.zonePath = paramValueString;
              }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_inventory_lot_grid') {
      const title = 'Inventory by lot';
      const component = FootprintManager_inventory_lot_gridComponent;
      const inParams:{ ownerId?: number, projectId?: number, warehouseId?: number, materialIds?: number[] } = { ownerId: null, projectId: null, warehouseId: null, materialIds: [] };
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('materialIds'))) {
        const paramValueString = params.get('materialIds');
        inParams.materialIds = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_inventory_lot_snapshot_grid') {
      const title = 'Inventory lot snapshot';
      const component = FootprintManager_inventory_lot_snapshot_gridComponent;
      const inParams:{ captureDate: string, projectId: number, warehouseId: number, materialIds?: number[] } = { captureDate: null, projectId: null, warehouseId: null, materialIds: [] };
      if (!isNil(params.get('captureDate'))) {
        const paramValueString = params.get('captureDate');
        // TODO: date
        inParams.captureDate = paramValueString;
              }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('materialIds'))) {
        const paramValueString = params.get('materialIds');
        inParams.materialIds = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_inventory_material_grid') {
      const title = 'Inventory by material';
      const component = FootprintManager_inventory_material_gridComponent;
      const inParams:{ ownerId?: number, projectId?: number, warehouseId?: number, materialIds?: number[] } = { ownerId: null, projectId: null, warehouseId: null, materialIds: [] };
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('materialIds'))) {
        const paramValueString = params.get('materialIds');
        inParams.materialIds = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_inventory_material_snapshot_grid') {
      const title = 'Inventory material snapshot';
      const component = FootprintManager_inventory_material_snapshot_gridComponent;
      const inParams:{ captureDate: string, projectId: number, warehouseId: number, materialIds?: number[] } = { captureDate: null, projectId: null, warehouseId: null, materialIds: [] };
      if (!isNil(params.get('captureDate'))) {
        const paramValueString = params.get('captureDate');
        // TODO: date
        inParams.captureDate = paramValueString;
              }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('materialIds'))) {
        const paramValueString = params.get('materialIds');
        inParams.materialIds = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_inventory_measurement_units_grid') {
      const title = 'Packages';
      const component = FootprintManager_inventory_measurement_units_gridComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_inventory_parent_licenseplate_grid') {
      const title = 'Inventory by parent LP';
      const component = FootprintManager_inventory_parent_licenseplate_gridComponent;
      const inParams:{ licenseplateId?: number, ownerId?: number, projectId?: number, warehouseId?: number[], materialIds?: number[] } = { licenseplateId: null, ownerId: null, projectId: null, warehouseId: [], materialIds: [] };
      if (!isNil(params.get('licenseplateId'))) {
        const paramValueString = params.get('licenseplateId');
        inParams.licenseplateId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('materialIds'))) {
        const paramValueString = params.get('materialIds');
        inParams.materialIds = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_inventory_statuses_grid') {
      const title = 'Inventory statuses';
      const component = FootprintManager_inventory_statuses_gridComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_inventory_tasks_grid') {
      const title = 'Inventory tasks';
      const component = FootprintManager_inventory_tasks_gridComponent;
      const inParams:{ lotId?: number, materialIds?: number[], projectId?: number, licenseplateId?: number, locationId?: number, ownerId?: number, warehouseIds?: number[], materialId?: number, serialnumberId?: number } = { lotId: null, materialIds: [], projectId: null, licenseplateId: null, locationId: null, ownerId: null, warehouseIds: [], materialId: null, serialnumberId: null };
      if (!isNil(params.get('lotId'))) {
        const paramValueString = params.get('lotId');
        inParams.lotId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('materialIds'))) {
        const paramValueString = params.get('materialIds');
        inParams.materialIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('licenseplateId'))) {
        const paramValueString = params.get('licenseplateId');
        inParams.licenseplateId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('locationId'))) {
        const paramValueString = params.get('locationId');
        inParams.locationId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouseIds'))) {
        const paramValueString = params.get('warehouseIds');
        inParams.warehouseIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('materialId'))) {
        const paramValueString = params.get('materialId');
        inParams.materialId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('serialnumberId'))) {
        const paramValueString = params.get('serialnumberId');
        inParams.serialnumberId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_inventory_transfer_intermediaries_grid') {
      const title = 'inventory transfer intermediaries';
      const component = FootprintManager_inventory_transfer_intermediaries_gridComponent;
      const inParams:{ inventoryTransferId: number, code: string, warehouseId: number, sourceProjectId: number, targetProjectId: number } = { inventoryTransferId: null, code: null, warehouseId: null, sourceProjectId: null, targetProjectId: null };
      if (!isNil(params.get('inventoryTransferId'))) {
        const paramValueString = params.get('inventoryTransferId');
        inParams.inventoryTransferId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('code'))) {
        const paramValueString = params.get('code');
        // TODO: date
        inParams.code = paramValueString;
              }
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('sourceProjectId'))) {
        const paramValueString = params.get('sourceProjectId');
        inParams.sourceProjectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('targetProjectId'))) {
        const paramValueString = params.get('targetProjectId');
        inParams.targetProjectId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_inventory_transfer_lines_grid') {
      const title = 'Inventory transfer lines';
      const component = FootprintManager_inventory_transfer_lines_gridComponent;
      const inParams:{ inventoryTransferId: number, sourceProjectId?: number, targetProjectId?: number, warehouseId?: number, can_update?: boolean, can_delete?: boolean } = { inventoryTransferId: null, sourceProjectId: null, targetProjectId: null, warehouseId: null, can_update: null, can_delete: null };
      if (!isNil(params.get('inventoryTransferId'))) {
        const paramValueString = params.get('inventoryTransferId');
        inParams.inventoryTransferId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('sourceProjectId'))) {
        const paramValueString = params.get('sourceProjectId');
        inParams.sourceProjectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('targetProjectId'))) {
        const paramValueString = params.get('targetProjectId');
        inParams.targetProjectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('can_update'))) {
        const paramValueString = params.get('can_update');
        inParams.can_update = this.convertToBoolean(paramValueString);
      }
      if (!isNil(params.get('can_delete'))) {
        const paramValueString = params.get('can_delete');
        inParams.can_delete = this.convertToBoolean(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_inventory_transfers_grid') {
      const title = 'Inventory transfers';
      const component = FootprintManager_inventory_transfers_gridComponent;
      const inParams:{ warehouses?: number[], sourceProjectId?: number, targetProjectId?: number, statusIds?: number[] } = { warehouses: [], sourceProjectId: null, targetProjectId: null, statusIds: [] };
      if (!isNil(params.get('warehouses'))) {
        const paramValueString = params.get('warehouses');
        inParams.warehouses = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('sourceProjectId'))) {
        const paramValueString = params.get('sourceProjectId');
        inParams.sourceProjectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('targetProjectId'))) {
        const paramValueString = params.get('targetProjectId');
        inParams.targetProjectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('statusIds'))) {
        const paramValueString = params.get('statusIds');
        inParams.statusIds = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_inventory_transformation_source_lines_grid') {
      this.$logger.log('FootprintManager', 'inventory_transformation_source_lines_grid');
      const title = 'Inventory transformation source lines';
      const component = FootprintManager_inventory_transformation_source_lines_gridComponent;
      const inParams:{ inventory_transformation_id: number, line_number?: number, project_id: number, warehouse_id: number, inventory_transformation_status_id?: number, source_read_only?: boolean, target_read_only?: boolean } = { inventory_transformation_id: null, line_number: null, project_id: null, warehouse_id: null, inventory_transformation_status_id: null, source_read_only: null, target_read_only: null };
      if (!isNil(params.get('inventory_transformation_id'))) {
        const paramValueString = params.get('inventory_transformation_id');
        inParams.inventory_transformation_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('line_number'))) {
        const paramValueString = params.get('line_number');
        inParams.line_number = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('project_id'))) {
        const paramValueString = params.get('project_id');
        inParams.project_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouse_id'))) {
        const paramValueString = params.get('warehouse_id');
        inParams.warehouse_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('inventory_transformation_status_id'))) {
        const paramValueString = params.get('inventory_transformation_status_id');
        inParams.inventory_transformation_status_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('source_read_only'))) {
        const paramValueString = params.get('source_read_only');
        inParams.source_read_only = this.convertToBoolean(paramValueString);
      }
      if (!isNil(params.get('target_read_only'))) {
        const paramValueString = params.get('target_read_only');
        inParams.target_read_only = this.convertToBoolean(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_inventory_transformation_source_lines_selector_by_licenseplate_grid') {
      this.$logger.log('FootprintManager', 'inventory_transformation_source_lines_selector_by_licenseplate_grid');
      const title = 'inventory_transformation_source_lines_selector_by_licenseplate_grid';
      const component = FootprintManager_inventory_transformation_source_lines_selector_by_licenseplate_gridComponent;
      const inParams:{ material_id: number, lot_id?: number, vendor_lot_id?: number, warehouse_id?: number, project_id?: number, package_id?: number, inventory_transformation_id: number, type: number, source_line_id?: number, gross_weight?: number, weight_uom?: number } = { material_id: null, lot_id: null, vendor_lot_id: null, warehouse_id: null, project_id: null, package_id: null, inventory_transformation_id: null, type: null, source_line_id: null, gross_weight: null, weight_uom: null };
      if (!isNil(params.get('material_id'))) {
        const paramValueString = params.get('material_id');
        inParams.material_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('lot_id'))) {
        const paramValueString = params.get('lot_id');
        inParams.lot_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('vendor_lot_id'))) {
        const paramValueString = params.get('vendor_lot_id');
        inParams.vendor_lot_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouse_id'))) {
        const paramValueString = params.get('warehouse_id');
        inParams.warehouse_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('project_id'))) {
        const paramValueString = params.get('project_id');
        inParams.project_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('package_id'))) {
        const paramValueString = params.get('package_id');
        inParams.package_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('inventory_transformation_id'))) {
        const paramValueString = params.get('inventory_transformation_id');
        inParams.inventory_transformation_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('type'))) {
        const paramValueString = params.get('type');
        inParams.type = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('source_line_id'))) {
        const paramValueString = params.get('source_line_id');
        inParams.source_line_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('gross_weight'))) {
        const paramValueString = params.get('gross_weight');
        inParams.gross_weight = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('weight_uom'))) {
        const paramValueString = params.get('weight_uom');
        inParams.weight_uom = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_inventory_transformation_source_lines_selector_by_location_grid') {
      this.$logger.log('FootprintManager', 'inventory_transformation_source_lines_selector_by_location_grid');
      const title = 'inventory_transformation_source_lines_selector_by_location_grid';
      const component = FootprintManager_inventory_transformation_source_lines_selector_by_location_gridComponent;
      const inParams:{ material_id: number, lot_id?: number, vendor_lot_id?: number, warehouse_id?: number, project_id?: number, package_id?: number, inventory_transformation_id: number, type: number } = { material_id: null, lot_id: null, vendor_lot_id: null, warehouse_id: null, project_id: null, package_id: null, inventory_transformation_id: null, type: null };
      if (!isNil(params.get('material_id'))) {
        const paramValueString = params.get('material_id');
        inParams.material_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('lot_id'))) {
        const paramValueString = params.get('lot_id');
        inParams.lot_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('vendor_lot_id'))) {
        const paramValueString = params.get('vendor_lot_id');
        inParams.vendor_lot_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouse_id'))) {
        const paramValueString = params.get('warehouse_id');
        inParams.warehouse_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('project_id'))) {
        const paramValueString = params.get('project_id');
        inParams.project_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('package_id'))) {
        const paramValueString = params.get('package_id');
        inParams.package_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('inventory_transformation_id'))) {
        const paramValueString = params.get('inventory_transformation_id');
        inParams.inventory_transformation_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('type'))) {
        const paramValueString = params.get('type');
        inParams.type = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_inventory_transformation_source_lines_selector_by_lot_grid') {
      this.$logger.log('FootprintManager', 'inventory_transformation_source_lines_selector_by_lot_grid');
      const title = 'inventory_transformation_source_lines_selector_by_lot_grid';
      const component = FootprintManager_inventory_transformation_source_lines_selector_by_lot_gridComponent;
      const inParams:{ material_id: number, lot_id?: number, vendor_lot_id?: number, warehouse_id?: number, project_id?: number, package_id?: number, inventory_transformation_id: number, type: number, source_line_id?: number, gross_weight?: number, weight_uom?: number } = { material_id: null, lot_id: null, vendor_lot_id: null, warehouse_id: null, project_id: null, package_id: null, inventory_transformation_id: null, type: null, source_line_id: null, gross_weight: null, weight_uom: null };
      if (!isNil(params.get('material_id'))) {
        const paramValueString = params.get('material_id');
        inParams.material_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('lot_id'))) {
        const paramValueString = params.get('lot_id');
        inParams.lot_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('vendor_lot_id'))) {
        const paramValueString = params.get('vendor_lot_id');
        inParams.vendor_lot_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouse_id'))) {
        const paramValueString = params.get('warehouse_id');
        inParams.warehouse_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('project_id'))) {
        const paramValueString = params.get('project_id');
        inParams.project_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('package_id'))) {
        const paramValueString = params.get('package_id');
        inParams.package_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('inventory_transformation_id'))) {
        const paramValueString = params.get('inventory_transformation_id');
        inParams.inventory_transformation_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('type'))) {
        const paramValueString = params.get('type');
        inParams.type = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('source_line_id'))) {
        const paramValueString = params.get('source_line_id');
        inParams.source_line_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('gross_weight'))) {
        const paramValueString = params.get('gross_weight');
        inParams.gross_weight = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('weight_uom'))) {
        const paramValueString = params.get('weight_uom');
        inParams.weight_uom = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_inventory_transformation_source_lines_selector_by_material_grid') {
      this.$logger.log('FootprintManager', 'inventory_transformation_source_lines_selector_by_material_grid');
      const title = 'inventory_transformation_source_lines_selector_by_material_grid';
      const component = FootprintManager_inventory_transformation_source_lines_selector_by_material_gridComponent;
      const inParams:{ material_id: number, lot_id?: number, vendor_lot_id?: number, warehouse_id?: number, project_id?: number, package_id?: number, inventory_transformation_id: number, type: number, source_line_id?: number, weight?: number, weight_uom?: number } = { material_id: null, lot_id: null, vendor_lot_id: null, warehouse_id: null, project_id: null, package_id: null, inventory_transformation_id: null, type: null, source_line_id: null, weight: null, weight_uom: null };
      if (!isNil(params.get('material_id'))) {
        const paramValueString = params.get('material_id');
        inParams.material_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('lot_id'))) {
        const paramValueString = params.get('lot_id');
        inParams.lot_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('vendor_lot_id'))) {
        const paramValueString = params.get('vendor_lot_id');
        inParams.vendor_lot_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouse_id'))) {
        const paramValueString = params.get('warehouse_id');
        inParams.warehouse_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('project_id'))) {
        const paramValueString = params.get('project_id');
        inParams.project_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('package_id'))) {
        const paramValueString = params.get('package_id');
        inParams.package_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('inventory_transformation_id'))) {
        const paramValueString = params.get('inventory_transformation_id');
        inParams.inventory_transformation_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('type'))) {
        const paramValueString = params.get('type');
        inParams.type = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('source_line_id'))) {
        const paramValueString = params.get('source_line_id');
        inParams.source_line_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('weight'))) {
        const paramValueString = params.get('weight');
        inParams.weight = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('weight_uom'))) {
        const paramValueString = params.get('weight_uom');
        inParams.weight_uom = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_inventory_transformation_source_lines_selector_by_serialnumbers_grid') {
      this.$logger.log('FootprintManager', 'inventory_transformation_source_lines_selector_by_serialnumbers_grid');
      const title = 'inventory_transformation_source_lines_selector_by_serialnumbers_grid';
      const component = FootprintManager_inventory_transformation_source_lines_selector_by_serialnumbers_gridComponent;
      const inParams:{ material_id: number, lot_id?: number, vendor_lot_id?: number, warehouse_id?: number, project_id?: number, package_id?: number, inventory_transformation_id: number, type: number, source_line_id?: number, gross_weight?: number, weight_uom?: number } = { material_id: null, lot_id: null, vendor_lot_id: null, warehouse_id: null, project_id: null, package_id: null, inventory_transformation_id: null, type: null, source_line_id: null, gross_weight: null, weight_uom: null };
      if (!isNil(params.get('material_id'))) {
        const paramValueString = params.get('material_id');
        inParams.material_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('lot_id'))) {
        const paramValueString = params.get('lot_id');
        inParams.lot_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('vendor_lot_id'))) {
        const paramValueString = params.get('vendor_lot_id');
        inParams.vendor_lot_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouse_id'))) {
        const paramValueString = params.get('warehouse_id');
        inParams.warehouse_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('project_id'))) {
        const paramValueString = params.get('project_id');
        inParams.project_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('package_id'))) {
        const paramValueString = params.get('package_id');
        inParams.package_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('inventory_transformation_id'))) {
        const paramValueString = params.get('inventory_transformation_id');
        inParams.inventory_transformation_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('type'))) {
        const paramValueString = params.get('type');
        inParams.type = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('source_line_id'))) {
        const paramValueString = params.get('source_line_id');
        inParams.source_line_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('gross_weight'))) {
        const paramValueString = params.get('gross_weight');
        inParams.gross_weight = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('weight_uom'))) {
        const paramValueString = params.get('weight_uom');
        inParams.weight_uom = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_inventory_transformation_target_lines_grid') {
      this.$logger.log('FootprintManager', 'inventory_transformation_target_lines_grid');
      const title = 'Inventory transformation target lines';
      const component = FootprintManager_inventory_transformation_target_lines_gridComponent;
      const inParams:{ inventory_transformation_id: number, line_numbers?: number[], source_line_id?: number, inventory_to_transform?: { target_material_id?: number, packaging_id?: number, lot_id?: number, vendor_lot_id?: number, weight?: number, weight_uom?: number, new_quantity?: number, length?: number, width?: number, height?: number, dimensions_uom?: number }, warehouse_id: number, additional_options?: { general: { keep_source_creation_date: boolean, convert_packaging_to_base: boolean }, serial_number_options: { copy_weights: boolean, copy_volume: boolean, copy_dimensions: boolean }, lot_number_options: { copy_udfs: boolean, copy_lot_number: boolean, copy_vendor_lot_number: boolean } }, is_read_only?: boolean, inventory_transformation_status_id?: number } = { inventory_transformation_id: null, line_numbers: [], source_line_id: null, inventory_to_transform: { target_material_id: null, packaging_id: null, lot_id: null, vendor_lot_id: null, weight: null, weight_uom: null, new_quantity: null, length: null, width: null, height: null, dimensions_uom: null }, warehouse_id: null, additional_options: { general: { keep_source_creation_date: null, convert_packaging_to_base: null }, serial_number_options: { copy_weights: null, copy_volume: null, copy_dimensions: null }, lot_number_options: { copy_udfs: null, copy_lot_number: null, copy_vendor_lot_number: null } }, is_read_only: null, inventory_transformation_status_id: null };
      if (!isNil(params.get('inventory_transformation_id'))) {
        const paramValueString = params.get('inventory_transformation_id');
        inParams.inventory_transformation_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('line_numbers'))) {
        const paramValueString = params.get('line_numbers');
        inParams.line_numbers = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('source_line_id'))) {
        const paramValueString = params.get('source_line_id');
        inParams.source_line_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('inventory_to_transform'))) {
        const paramValueString = params.get('inventory_to_transform');
        inParams.inventory_to_transform = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('warehouse_id'))) {
        const paramValueString = params.get('warehouse_id');
        inParams.warehouse_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('additional_options'))) {
        const paramValueString = params.get('additional_options');
        inParams.additional_options = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('is_read_only'))) {
        const paramValueString = params.get('is_read_only');
        inParams.is_read_only = this.convertToBoolean(paramValueString);
      }
      if (!isNil(params.get('inventory_transformation_status_id'))) {
        const paramValueString = params.get('inventory_transformation_status_id');
        inParams.inventory_transformation_status_id = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_inventory_transformations_grid') {
      this.$logger.log('FootprintManager', 'inventory_transformations_grid');
      const title = 'inventory_transformations_grid';
      const component = FootprintManager_inventory_transformations_gridComponent;
      const inParams:{ owner_id?: number, project_id?: number, warehouse_ids?: number[], status_ids?: number[] } = { owner_id: null, project_id: null, warehouse_ids: [], status_ids: [] };
      if (!isNil(params.get('owner_id'))) {
        const paramValueString = params.get('owner_id');
        inParams.owner_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('project_id'))) {
        const paramValueString = params.get('project_id');
        inParams.project_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouse_ids'))) {
        const paramValueString = params.get('warehouse_ids');
        inParams.warehouse_ids = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('status_ids'))) {
        const paramValueString = params.get('status_ids');
        inParams.status_ids = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_invoice_lines_grid') {
      const title = 'Invoice lines';
      const component = FootprintManager_invoice_lines_gridComponent;
      const inParams:{ invoiceId: number, invoiceTypeId?: number, open_to_line?: number } = { invoiceId: null, invoiceTypeId: null, open_to_line: null };
      if (!isNil(params.get('invoiceId'))) {
        const paramValueString = params.get('invoiceId');
        inParams.invoiceId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('invoiceTypeId'))) {
        const paramValueString = params.get('invoiceTypeId');
        inParams.invoiceTypeId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('open_to_line'))) {
        const paramValueString = params.get('open_to_line');
        inParams.open_to_line = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_invoices_grid') {
      const title = 'Invoices';
      const component = FootprintManager_invoices_gridComponent;
      const inParams:{ ownerId?: number, projectId?: number, statusIds?: number[] } = { ownerId: null, projectId: null, statusIds: [] };
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('statusIds'))) {
        const paramValueString = params.get('statusIds');
        inParams.statusIds = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_licenseplate_grid') {
      const title = 'Select a licenseplate';
      const component = FootprintManager_licenseplate_gridComponent;
      const inParams:{ locationId: number, lotId: number, packagedId: number } = { locationId: null, lotId: null, packagedId: null };
      if (!isNil(params.get('locationId'))) {
        const paramValueString = params.get('locationId');
        inParams.locationId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('lotId'))) {
        const paramValueString = params.get('lotId');
        inParams.lotId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('packagedId'))) {
        const paramValueString = params.get('packagedId');
        inParams.packagedId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_load_container_orders_grid') {
      const title = 'Orders by load container';
      const component = FootprintManager_load_container_orders_gridComponent;
      const inParams:{ loadContainerId: number, edit?: boolean, warehouseId?: number, orderTypeId?: number, status_id?: number } = { loadContainerId: null, edit: null, warehouseId: null, orderTypeId: null, status_id: null };
      if (!isNil(params.get('loadContainerId'))) {
        const paramValueString = params.get('loadContainerId');
        inParams.loadContainerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('edit'))) {
        const paramValueString = params.get('edit');
        inParams.edit = this.convertToBoolean(paramValueString);
      }
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('orderTypeId'))) {
        const paramValueString = params.get('orderTypeId');
        inParams.orderTypeId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('status_id'))) {
        const paramValueString = params.get('status_id');
        inParams.status_id = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_load_container_unassigned_orders_grid') {
      const title = 'Unassigned orders for load containers';
      const component = FootprintManager_load_container_unassigned_orders_gridComponent;
      const inParams:{ ownerId?: number, projectId?: number, statusIds?: number[], orderTypeId?: number, warehouseId?: number, loadContainerId?: number, lookupCode?: string } = { ownerId: null, projectId: null, statusIds: [], orderTypeId: null, warehouseId: null, loadContainerId: null, lookupCode: null };
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('statusIds'))) {
        const paramValueString = params.get('statusIds');
        inParams.statusIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('orderTypeId'))) {
        const paramValueString = params.get('orderTypeId');
        inParams.orderTypeId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('loadContainerId'))) {
        const paramValueString = params.get('loadContainerId');
        inParams.loadContainerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('lookupCode'))) {
        const paramValueString = params.get('lookupCode');
        // TODO: date
        inParams.lookupCode = paramValueString;
              }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_load_containers_grid') {
      const title = 'Load containers';
      const component = FootprintManager_load_containers_gridComponent;
      const inParams:{ statusIds?: number[], ownerId?: number, orderTypeIds?: number[] } = { statusIds: [], ownerId: null, orderTypeIds: [] };
      if (!isNil(params.get('statusIds'))) {
        const paramValueString = params.get('statusIds');
        inParams.statusIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('orderTypeIds'))) {
        const paramValueString = params.get('orderTypeIds');
        inParams.orderTypeIds = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_location_projects_grid') {
      const title = 'Location project assignments';
      const component = FootprintManager_location_projects_gridComponent;
      const inParams:{ locationId: number } = { locationId: null };
      if (!isNil(params.get('locationId'))) {
        const paramValueString = params.get('locationId');
        inParams.locationId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_locations_grid') {
      const title = 'Locations';
      const component = FootprintManager_locations_gridComponent;
      const inParams:{ warehouseId: number } = { warehouseId: null };
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_locations_navigational_grid') {
      const title = 'Locations';
      const component = FootprintManager_locations_navigational_gridComponent;
      const inParams:{ warehouseId: number } = { warehouseId: null };
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_locations_replenishments_grid') {
      const title = 'Replenishments';
      const component = FootprintManager_locations_replenishments_gridComponent;
      const inParams:{ materialId?: number[], warehouseIds?: number[], locationId?: number[], projectId?: number, ownerId?: number } = { materialId: [], warehouseIds: [], locationId: [], projectId: null, ownerId: null };
      if (!isNil(params.get('materialId'))) {
        const paramValueString = params.get('materialId');
        inParams.materialId = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('warehouseIds'))) {
        const paramValueString = params.get('warehouseIds');
        inParams.warehouseIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('locationId'))) {
        const paramValueString = params.get('locationId');
        inParams.locationId = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_locations_selector_grid') {
      const title = 'Location selector';
      const component = FootprintManager_locations_selector_gridComponent;
      const inParams:{ warehouseId: number, selectedLocationIds?: number[], isExclude?: boolean, allowEdit: boolean } = { warehouseId: null, selectedLocationIds: [], isExclude: null, allowEdit: null };
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('selectedLocationIds'))) {
        const paramValueString = params.get('selectedLocationIds');
        inParams.selectedLocationIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('isExclude'))) {
        const paramValueString = params.get('isExclude');
        inParams.isExclude = this.convertToBoolean(paramValueString);
      }
      if (!isNil(params.get('allowEdit'))) {
        const paramValueString = params.get('allowEdit');
        inParams.allowEdit = this.convertToBoolean(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_lots_grid') {
      this.$logger.log('FootprintManager', 'lots_grid');
      const title = 'Lots grid';
      const component = FootprintManager_lots_gridComponent;
      const inParams:{ ownerIds?: number[], projectIds?: number[], materialIds?: number[], statusIds?: number[] } = { ownerIds: [], projectIds: [], materialIds: [], statusIds: [] };
      if (!isNil(params.get('ownerIds'))) {
        const paramValueString = params.get('ownerIds');
        inParams.ownerIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('projectIds'))) {
        const paramValueString = params.get('projectIds');
        inParams.projectIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('materialIds'))) {
        const paramValueString = params.get('materialIds');
        inParams.materialIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('statusIds'))) {
        const paramValueString = params.get('statusIds');
        inParams.statusIds = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_lots_grid_flat') {
      const title = 'Lots grid from flat data source';
      const component = FootprintManager_lots_grid_flatComponent;
      const inParams:{ ownerIds?: number[], projectIds?: number[], materialIds?: number[], statusIds?: number[] } = { ownerIds: [], projectIds: [], materialIds: [], statusIds: [] };
      if (!isNil(params.get('ownerIds'))) {
        const paramValueString = params.get('ownerIds');
        inParams.ownerIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('projectIds'))) {
        const paramValueString = params.get('projectIds');
        inParams.projectIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('materialIds'))) {
        const paramValueString = params.get('materialIds');
        inParams.materialIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('statusIds'))) {
        const paramValueString = params.get('statusIds');
        inParams.statusIds = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_lots_udf_grid') {
      const title = 'Lots UDF';
      const component = FootprintManager_lots_udf_gridComponent;
      const inParams:{ projectId?: number, ownerId?: number, materialIds?: number[], lotId?: number } = { projectId: null, ownerId: null, materialIds: [], lotId: null };
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('materialIds'))) {
        const paramValueString = params.get('materialIds');
        inParams.materialIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('lotId'))) {
        const paramValueString = params.get('lotId');
        inParams.lotId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_manual_allocations_grid') {
      const title = 'Manual allocations';
      const component = FootprintManager_manual_allocations_gridComponent;
      const inParams:{ waveId?: number, orderId?: number, allowInactive?: boolean } = { waveId: null, orderId: null, allowInactive: null };
      if (!isNil(params.get('waveId'))) {
        const paramValueString = params.get('waveId');
        inParams.waveId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('orderId'))) {
        const paramValueString = params.get('orderId');
        inParams.orderId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('allowInactive'))) {
        const paramValueString = params.get('allowInactive');
        inParams.allowInactive = this.convertToBoolean(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_manufacturing_equipment_grid') {
      this.$logger.log('FootprintManager', 'manufacturing_equipment_grid');
      const title = 'Equipment';
      const component = FootprintManager_manufacturing_equipment_gridComponent;
      const inParams:{ warehouse: number } = { warehouse: null };
      if (!isNil(params.get('warehouse'))) {
        const paramValueString = params.get('warehouse');
        inParams.warehouse = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_manufacturing_locations_grid') {
      this.$logger.log('FootprintManager', 'manufacturing_locations_grid');
      const title = 'Locations';
      const component = FootprintManager_manufacturing_locations_gridComponent;
      const inParams:{ warehouse_id: number } = { warehouse_id: null };
      if (!isNil(params.get('warehouse_id'))) {
        const paramValueString = params.get('warehouse_id');
        inParams.warehouse_id = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_manufacturing_order_component_serial_number_selection_grid') {
      this.$logger.log('FootprintManager', 'manufacturing_order_component_serial_number_selection_grid');
      const title = 'manufacturing_order_component_serial_number_selection_grid';
      const component = FootprintManager_manufacturing_order_component_serial_number_selection_gridComponent;
      const inParams:{ material_id?: number, warehouse_id?: number, serials_needed_count?: number, iteration?: number, license_plate?: number } = { material_id: null, warehouse_id: null, serials_needed_count: null, iteration: null, license_plate: null };
      if (!isNil(params.get('material_id'))) {
        const paramValueString = params.get('material_id');
        inParams.material_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouse_id'))) {
        const paramValueString = params.get('warehouse_id');
        inParams.warehouse_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('serials_needed_count'))) {
        const paramValueString = params.get('serials_needed_count');
        inParams.serials_needed_count = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('iteration'))) {
        const paramValueString = params.get('iteration');
        inParams.iteration = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('license_plate'))) {
        const paramValueString = params.get('license_plate');
        inParams.license_plate = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_manufacturing_order_line_components_production_confirmation_grid') {
      this.$logger.log('FootprintManager', 'manufacturing_order_line_components_production_confirmation_grid');
      const title = 'Order line components production confirmation grid';
      const component = FootprintManager_manufacturing_order_line_components_production_confirmation_gridComponent;
      const inParams:{ finished_good_id?: number, warehouse_id?: number, quantity_to_produce?: number, license_plate_ids?: number[], location_id?: number, project_id?: number } = { finished_good_id: null, warehouse_id: null, quantity_to_produce: null, license_plate_ids: [], location_id: null, project_id: null };
      if (!isNil(params.get('finished_good_id'))) {
        const paramValueString = params.get('finished_good_id');
        inParams.finished_good_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouse_id'))) {
        const paramValueString = params.get('warehouse_id');
        inParams.warehouse_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('quantity_to_produce'))) {
        const paramValueString = params.get('quantity_to_produce');
        inParams.quantity_to_produce = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('license_plate_ids'))) {
        const paramValueString = params.get('license_plate_ids');
        inParams.license_plate_ids = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('location_id'))) {
        const paramValueString = params.get('location_id');
        inParams.location_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('project_id'))) {
        const paramValueString = params.get('project_id');
        inParams.project_id = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_manufacturing_order_line_production_confirmation_grid') {
      this.$logger.log('FootprintManager', 'manufacturing_order_line_production_confirmation_grid');
      const title = 'Order line production confirmation';
      const component = FootprintManager_manufacturing_order_line_production_confirmation_gridComponent;
      const inParams:{ finished_good?: string, planned_quantity?: number, material_id?: number, output_location_id?: number } = { finished_good: null, planned_quantity: null, material_id: null, output_location_id: null };
      if (!isNil(params.get('finished_good'))) {
        const paramValueString = params.get('finished_good');
        // TODO: date
        inParams.finished_good = paramValueString;
              }
      if (!isNil(params.get('planned_quantity'))) {
        const paramValueString = params.get('planned_quantity');
        inParams.planned_quantity = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('material_id'))) {
        const paramValueString = params.get('material_id');
        inParams.material_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('output_location_id'))) {
        const paramValueString = params.get('output_location_id');
        inParams.output_location_id = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_manufacturing_order_lines_components_for_process_grid') {
      this.$logger.log('FootprintManager', 'manufacturing_order_lines_components_for_process_grid');
      const title = 'Components to be processed';
      const component = FootprintManager_manufacturing_order_lines_components_for_process_gridComponent;
      const inParams:{ order_id: number, warehouse_id: number } = { order_id: null, warehouse_id: null };
      if (!isNil(params.get('order_id'))) {
        const paramValueString = params.get('order_id');
        inParams.order_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouse_id'))) {
        const paramValueString = params.get('warehouse_id');
        inParams.warehouse_id = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_manufacturing_order_lines_components_grid') {
      this.$logger.log('FootprintManager', 'manufacturing_order_lines_components_grid');
      const title = 'Manufacturing Order Lines Components';
      const component = FootprintManager_manufacturing_order_lines_components_gridComponent;
      const inParams:{ finished_good_id: number, warehouse_id: number, finished_good_quantity?: number, is_kit?: boolean, project_id: number, order_id: number, line_number: number, order_status_id: number } = { finished_good_id: null, warehouse_id: null, finished_good_quantity: null, is_kit: null, project_id: null, order_id: null, line_number: null, order_status_id: null };
      if (!isNil(params.get('finished_good_id'))) {
        const paramValueString = params.get('finished_good_id');
        inParams.finished_good_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouse_id'))) {
        const paramValueString = params.get('warehouse_id');
        inParams.warehouse_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('finished_good_quantity'))) {
        const paramValueString = params.get('finished_good_quantity');
        inParams.finished_good_quantity = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('is_kit'))) {
        const paramValueString = params.get('is_kit');
        inParams.is_kit = this.convertToBoolean(paramValueString);
      }
      if (!isNil(params.get('project_id'))) {
        const paramValueString = params.get('project_id');
        inParams.project_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('order_id'))) {
        const paramValueString = params.get('order_id');
        inParams.order_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('line_number'))) {
        const paramValueString = params.get('line_number');
        inParams.line_number = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('order_status_id'))) {
        const paramValueString = params.get('order_status_id');
        inParams.order_status_id = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_manufacturing_order_lines_grid') {
      this.$logger.log('FootprintManager', 'manufacturing_order_lines_grid');
      const title = 'Manufacturing order lines';
      const component = FootprintManager_manufacturing_order_lines_gridComponent;
      const inParams:{ order_id: number, project_id: number, order_status_id: number, warehouse_id: number, output_location_id?: number, source_location_id?: number } = { order_id: null, project_id: null, order_status_id: null, warehouse_id: null, output_location_id: null, source_location_id: null };
      if (!isNil(params.get('order_id'))) {
        const paramValueString = params.get('order_id');
        inParams.order_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('project_id'))) {
        const paramValueString = params.get('project_id');
        inParams.project_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('order_status_id'))) {
        const paramValueString = params.get('order_status_id');
        inParams.order_status_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouse_id'))) {
        const paramValueString = params.get('warehouse_id');
        inParams.warehouse_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('output_location_id'))) {
        const paramValueString = params.get('output_location_id');
        inParams.output_location_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('source_location_id'))) {
        const paramValueString = params.get('source_location_id');
        inParams.source_location_id = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_manufacturing_order_lines_production_sub_components_grid') {
      this.$logger.log('FootprintManager', 'manufacturing_order_lines_production_sub_components_grid');
      const title = 'Selecting component for manufacturing production';
      const component = FootprintManager_manufacturing_order_lines_production_sub_components_gridComponent;
      const inParams:{ material_id?: number, location_id?: number, component?: string, main_component_identifier?: number, rows?: { lineNumber: number, consumedQuantity: number, scrappedQuantity: number, sourceLicensePlate: number, lot: number, lotExpiration: string, mainComponentIdentifier: number, packageId: number, componentMaterialId: number }[], package_id?: number, project_id?: number, warehouse_id?: number } = { material_id: null, location_id: null, component: null, main_component_identifier: null, rows: [], package_id: null, project_id: null, warehouse_id: null };
      if (!isNil(params.get('material_id'))) {
        const paramValueString = params.get('material_id');
        inParams.material_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('location_id'))) {
        const paramValueString = params.get('location_id');
        inParams.location_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('component'))) {
        const paramValueString = params.get('component');
        // TODO: date
        inParams.component = paramValueString;
              }
      if (!isNil(params.get('main_component_identifier'))) {
        const paramValueString = params.get('main_component_identifier');
        inParams.main_component_identifier = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('rows'))) {
        const paramValueString = params.get('rows');
        inParams.rows = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('package_id'))) {
        const paramValueString = params.get('package_id');
        inParams.package_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('project_id'))) {
        const paramValueString = params.get('project_id');
        inParams.project_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouse_id'))) {
        const paramValueString = params.get('warehouse_id');
        inParams.warehouse_id = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_manufacturing_order_return_to_stock_grid') {
      this.$logger.log('FootprintManager', 'manufacturing_order_return_to_stock_grid');
      const title = 'Components';
      const component = FootprintManager_manufacturing_order_return_to_stock_gridComponent;
      const inParams:{ manufacturing_order_line_id?: number, warehouse_id?: number, location: number, manufacturing_order_id?: number, task_chain_head?: number } = { manufacturing_order_line_id: null, warehouse_id: null, location: null, manufacturing_order_id: null, task_chain_head: null };
      if (!isNil(params.get('manufacturing_order_line_id'))) {
        const paramValueString = params.get('manufacturing_order_line_id');
        inParams.manufacturing_order_line_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouse_id'))) {
        const paramValueString = params.get('warehouse_id');
        inParams.warehouse_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('location'))) {
        const paramValueString = params.get('location');
        inParams.location = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('manufacturing_order_id'))) {
        const paramValueString = params.get('manufacturing_order_id');
        inParams.manufacturing_order_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('task_chain_head'))) {
        const paramValueString = params.get('task_chain_head');
        inParams.task_chain_head = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_manufacturing_order_undo_manufacturing_production_components_grid') {
      this.$logger.log('FootprintManager', 'manufacturing_order_undo_manufacturing_production_components_grid');
      const title = 'Undo production confirmation';
      const component = FootprintManager_manufacturing_order_undo_manufacturing_production_components_gridComponent;
      const inParams:{ manufacturing_order_id?: number, manufacturing_order_line_id?: number, chain_head_id?: number } = { manufacturing_order_id: null, manufacturing_order_line_id: null, chain_head_id: null };
      if (!isNil(params.get('manufacturing_order_id'))) {
        const paramValueString = params.get('manufacturing_order_id');
        inParams.manufacturing_order_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('manufacturing_order_line_id'))) {
        const paramValueString = params.get('manufacturing_order_line_id');
        inParams.manufacturing_order_line_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('chain_head_id'))) {
        const paramValueString = params.get('chain_head_id');
        inParams.chain_head_id = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_manufacturing_order_undo_manufacturing_production_finished_product_grid') {
      this.$logger.log('FootprintManager', 'manufacturing_order_undo_manufacturing_production_finished_product_grid');
      const title = 'Undoing manufacturing production for the finished products';
      const component = FootprintManager_manufacturing_order_undo_manufacturing_production_finished_product_gridComponent;
      const inParams:{ manufacturing_order_id?: number, manufacturing_order_line_id?: number, task_chain_head?: number } = { manufacturing_order_id: null, manufacturing_order_line_id: null, task_chain_head: null };
      if (!isNil(params.get('manufacturing_order_id'))) {
        const paramValueString = params.get('manufacturing_order_id');
        inParams.manufacturing_order_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('manufacturing_order_line_id'))) {
        const paramValueString = params.get('manufacturing_order_line_id');
        inParams.manufacturing_order_line_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('task_chain_head'))) {
        const paramValueString = params.get('task_chain_head');
        inParams.task_chain_head = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_manufacturing_orders_grid') {
      this.$logger.log('FootprintManager', 'manufacturing_orders_grid');
      const title = 'Orders';
      const component = FootprintManager_manufacturing_orders_gridComponent;
      const inParams:{ warehouse_ids?: number[], owner_id?: number, project_id?: number, status_ids?: number[] } = { warehouse_ids: [], owner_id: null, project_id: null, status_ids: [] };
      if (!isNil(params.get('warehouse_ids'))) {
        const paramValueString = params.get('warehouse_ids');
        inParams.warehouse_ids = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('owner_id'))) {
        const paramValueString = params.get('owner_id');
        inParams.owner_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('project_id'))) {
        const paramValueString = params.get('project_id');
        inParams.project_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('status_ids'))) {
        const paramValueString = params.get('status_ids');
        inParams.status_ids = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_manufacturing_orders_manufacturing_production_components_grid') {
      this.$logger.log('FootprintManager', 'manufacturing_orders_manufacturing_production_components_grid');
      const title = 'Manufacturing order production components';
      const component = FootprintManager_manufacturing_orders_manufacturing_production_components_gridComponent;
      const inParams:{ manufacturing_order_id?: number, manufacturing_order_line_id?: number, warehouse_id?: number, task_chain_head?: number } = { manufacturing_order_id: null, manufacturing_order_line_id: null, warehouse_id: null, task_chain_head: null };
      if (!isNil(params.get('manufacturing_order_id'))) {
        const paramValueString = params.get('manufacturing_order_id');
        inParams.manufacturing_order_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('manufacturing_order_line_id'))) {
        const paramValueString = params.get('manufacturing_order_line_id');
        inParams.manufacturing_order_line_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouse_id'))) {
        const paramValueString = params.get('warehouse_id');
        inParams.warehouse_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('task_chain_head'))) {
        const paramValueString = params.get('task_chain_head');
        inParams.task_chain_head = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_manufacturing_orders_manufacturing_production_grid') {
      this.$logger.log('FootprintManager', 'manufacturing_orders_manufacturing_production_grid');
      const title = 'Manufacturing production';
      const component = FootprintManager_manufacturing_orders_manufacturing_production_gridComponent;
      const inParams:{ manufacturing_order_id?: number } = { manufacturing_order_id: null };
      if (!isNil(params.get('manufacturing_order_id'))) {
        const paramValueString = params.get('manufacturing_order_id');
        inParams.manufacturing_order_id = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_manufacturing_workshifts_grid') {
      this.$logger.log('FootprintManager', 'manufacturing_workshifts_grid');
      const title = 'Workshifts';
      const component = FootprintManager_manufacturing_workshifts_gridComponent;
      const inParams:{ warehouse: number } = { warehouse: null };
      if (!isNil(params.get('warehouse'))) {
        const paramValueString = params.get('warehouse');
        inParams.warehouse = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_material_aliases_grid') {
      const title = 'Material aliases';
      const component = FootprintManager_material_aliases_gridComponent;
      const inParams:{ material_id: number, project_id: number, materialCode?: string } = { material_id: null, project_id: null, materialCode: null };
      if (!isNil(params.get('material_id'))) {
        const paramValueString = params.get('material_id');
        inParams.material_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('project_id'))) {
        const paramValueString = params.get('project_id');
        inParams.project_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('materialCode'))) {
        const paramValueString = params.get('materialCode');
        // TODO: date
        inParams.materialCode = paramValueString;
              }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_material_catalog_source_material_project_subscribers_grid') {
      const title = 'Material catalog source material project subscribers';
      const component = FootprintManager_material_catalog_source_material_project_subscribers_gridComponent;
      const inParams:{ source_material_id: number } = { source_material_id: null };
      if (!isNil(params.get('source_material_id'))) {
        const paramValueString = params.get('source_material_id');
        inParams.source_material_id = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_material_catalog_source_materials_grid') {
      const title = 'Material catalog source materials';
      const component = FootprintManager_material_catalog_source_materials_gridComponent;
      const inParams:{ catalog_id: number } = { catalog_id: null };
      if (!isNil(params.get('catalog_id'))) {
        const paramValueString = params.get('catalog_id');
        inParams.catalog_id = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_material_catalogs_by_project_grid') {
      const title = 'Material catalogs by project';
      const component = FootprintManager_material_catalogs_by_project_gridComponent;
      const inParams:{ project_id: number } = { project_id: null };
      if (!isNil(params.get('project_id'))) {
        const paramValueString = params.get('project_id');
        inParams.project_id = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_material_catalogs_grid') {
      const title = 'Material catalogs';
      const component = FootprintManager_material_catalogs_gridComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_material_catalogs_project_subscribers_grid') {
      const title = 'Material catalog project subscribers';
      const component = FootprintManager_material_catalogs_project_subscribers_gridComponent;
      const inParams:{ catalog_id: number } = { catalog_id: null };
      if (!isNil(params.get('catalog_id'))) {
        const paramValueString = params.get('catalog_id');
        inParams.catalog_id = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_material_components_grid') {
      const title = 'Material components';
      const component = FootprintManager_material_components_gridComponent;
      const inParams:{ material_id: number, packaging_id: number, project_id: number, suppress_new_row: boolean } = { material_id: null, packaging_id: null, project_id: null, suppress_new_row: null };
      if (!isNil(params.get('material_id'))) {
        const paramValueString = params.get('material_id');
        inParams.material_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('packaging_id'))) {
        const paramValueString = params.get('packaging_id');
        inParams.packaging_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('project_id'))) {
        const paramValueString = params.get('project_id');
        inParams.project_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('suppress_new_row'))) {
        const paramValueString = params.get('suppress_new_row');
        inParams.suppress_new_row = this.convertToBoolean(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_material_kits_grid') {
      const title = 'Material kits';
      const component = FootprintManager_material_kits_gridComponent;
      const inParams:{ material_id: number, project_id: number } = { material_id: null, project_id: null };
      if (!isNil(params.get('material_id'))) {
        const paramValueString = params.get('material_id');
        inParams.material_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('project_id'))) {
        const paramValueString = params.get('project_id');
        inParams.project_id = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_material_packagings_by_project_grid') {
      const title = 'Packagings by project';
      const component = FootprintManager_material_packagings_by_project_gridComponent;
      const inParams:{ materialIds?: number[], ownerId?: number, projectId?: number } = { materialIds: [], ownerId: null, projectId: null };
      if (!isNil(params.get('materialIds'))) {
        const paramValueString = params.get('materialIds');
        inParams.materialIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_material_packagings_grid') {
      const title = 'Packagings';
      const component = FootprintManager_material_packagings_gridComponent;
      const inParams:{ materialId?: number } = { materialId: null };
      if (!isNil(params.get('materialId'))) {
        const paramValueString = params.get('materialId');
        inParams.materialId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_material_substitutions_grid') {
      const title = 'Material substitutions';
      const component = FootprintManager_material_substitutions_gridComponent;
      const inParams:{ material_id: number, packaging_id: number, project_id: number } = { material_id: null, packaging_id: null, project_id: null };
      if (!isNil(params.get('material_id'))) {
        const paramValueString = params.get('material_id');
        inParams.material_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('packaging_id'))) {
        const paramValueString = params.get('packaging_id');
        inParams.packaging_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('project_id'))) {
        const paramValueString = params.get('project_id');
        inParams.project_id = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_materials_by_base_packaging_grid') {
      const title = 'Materials';
      const component = FootprintManager_materials_by_base_packaging_gridComponent;
      const inParams:{ projectId?: number, ownerId?: number } = { projectId: null, ownerId: null };
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_materials_navigational_grid') {
      const title = 'Materials';
      const component = FootprintManager_materials_navigational_gridComponent;
      const inParams:{ ownerId?: number, projectId?: number, materialIds?: number[] } = { ownerId: null, projectId: null, materialIds: [] };
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('materialIds'))) {
        const paramValueString = params.get('materialIds');
        inParams.materialIds = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_materials_selector_grid') {
      const title = 'Material selector';
      const component = FootprintManager_materials_selector_gridComponent;
      const inParams:{ selectedMaterialIds?: number[], isExclude?: boolean, allowEdit: boolean } = { selectedMaterialIds: [], isExclude: null, allowEdit: null };
      if (!isNil(params.get('selectedMaterialIds'))) {
        const paramValueString = params.get('selectedMaterialIds');
        inParams.selectedMaterialIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('isExclude'))) {
        const paramValueString = params.get('isExclude');
        inParams.isExclude = this.convertToBoolean(paramValueString);
      }
      if (!isNil(params.get('allowEdit'))) {
        const paramValueString = params.get('allowEdit');
        inParams.allowEdit = this.convertToBoolean(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_materials_udf_grid') {
      const title = 'Materials advanced';
      const component = FootprintManager_materials_udf_gridComponent;
      const inParams:{ projectId?: number, ownerId?: number, materialIds?: number[] } = { projectId: null, ownerId: null, materialIds: [] };
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('materialIds'))) {
        const paramValueString = params.get('materialIds');
        inParams.materialIds = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_orderaddresses_grid') {
      const title = 'Order addresses';
      const component = FootprintManager_orderaddresses_gridComponent;
      const inParams:{ orderId: number } = { orderId: null };
      if (!isNil(params.get('orderId'))) {
        const paramValueString = params.get('orderId');
        inParams.orderId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_outbound_orders_eligible_for_return_grid') {
      const title = 'Completed outbound orders';
      const component = FootprintManager_outbound_orders_eligible_for_return_gridComponent;
      const inParams:{ warehouseIds?: number[], ownerId?: number, projectId?: number } = { warehouseIds: [], ownerId: null, projectId: null };
      if (!isNil(params.get('warehouseIds'))) {
        const paramValueString = params.get('warehouseIds');
        inParams.warehouseIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_outbound_orders_grid') {
      const title = 'Outbound orders';
      const component = FootprintManager_outbound_orders_gridComponent;
      const inParams:{ ownerId?: number, projectId?: number, warehouseId?: number[], statusIds?: number[], countries?: string[], carrierId?: number, carrierServiceId?: number, reference?: string, materialIds?: number[], waveId?: number } = { ownerId: null, projectId: null, warehouseId: [], statusIds: [], countries: [], carrierId: null, carrierServiceId: null, reference: null, materialIds: [], waveId: null };
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('statusIds'))) {
        const paramValueString = params.get('statusIds');
        inParams.statusIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('countries'))) {
        const paramValueString = params.get('countries');
        inParams.countries = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('carrierId'))) {
        const paramValueString = params.get('carrierId');
        inParams.carrierId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('carrierServiceId'))) {
        const paramValueString = params.get('carrierServiceId');
        inParams.carrierServiceId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('reference'))) {
        const paramValueString = params.get('reference');
        // TODO: date
        inParams.reference = paramValueString;
              }
      if (!isNil(params.get('materialIds'))) {
        const paramValueString = params.get('materialIds');
        inParams.materialIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('waveId'))) {
        const paramValueString = params.get('waveId');
        inParams.waveId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_owners_navigation_grid') {
      const title = 'Owners';
      const component = FootprintManager_owners_navigation_gridComponent;
      const inParams:{ ownerStatusId?: number, ownerId?: number, projectIds?: number[] } = { ownerStatusId: null, ownerId: null, projectIds: [] };
      if (!isNil(params.get('ownerStatusId'))) {
        const paramValueString = params.get('ownerStatusId');
        inParams.ownerStatusId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectIds'))) {
        const paramValueString = params.get('projectIds');
        inParams.projectIds = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_ownersaccounts_grid') {
      const title = 'Addresses';
      const component = FootprintManager_ownersaccounts_gridComponent;
      const inParams:{ ownerId: number, accountTypeId: number, typeIds: number[], allowSelection: boolean } = { ownerId: null, accountTypeId: null, typeIds: [], allowSelection: null };
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('accountTypeId'))) {
        const paramValueString = params.get('accountTypeId');
        inParams.accountTypeId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('typeIds'))) {
        const paramValueString = params.get('typeIds');
        inParams.typeIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('allowSelection'))) {
        const paramValueString = params.get('allowSelection');
        inParams.allowSelection = this.convertToBoolean(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_ownerscarrierslookup_grid') {
      const title = 'Owner carriers lookup';
      const component = FootprintManager_ownerscarrierslookup_gridComponent;
      const inParams:{ ownerId: number } = { ownerId: null };
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_pack_verification_instructions_grid') {
      const title = 'Instructions';
      const component = FootprintManager_pack_verification_instructions_gridComponent;
      const inParams:{ shippingContainerId: number, startVerificationTaskId: number, isReadOnly: boolean } = { shippingContainerId: null, startVerificationTaskId: null, isReadOnly: null };
      if (!isNil(params.get('shippingContainerId'))) {
        const paramValueString = params.get('shippingContainerId');
        inParams.shippingContainerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('startVerificationTaskId'))) {
        const paramValueString = params.get('startVerificationTaskId');
        inParams.startVerificationTaskId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('isReadOnly'))) {
        const paramValueString = params.get('isReadOnly');
        inParams.isReadOnly = this.convertToBoolean(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_pack_verification_shipping_container_contents_grid') {
      const title = 'Container contents';
      const component = FootprintManager_pack_verification_shipping_container_contents_gridComponent;
      const inParams:{ shippingContainerId: number, canAddManually?: boolean, startVerificationTaskId: number, isReadOnly?: boolean, scannedValues: { scannedValue?: string, lotId?: number, packagingId?: number }[], isBlind?: boolean, expectedSerialNumbers?: { lookupCode: string, lotId: number, packagingId: number, id: number, licensePlateId: number }[], locationId: number } = { shippingContainerId: null, canAddManually: null, startVerificationTaskId: null, isReadOnly: null, scannedValues: [], isBlind: null, expectedSerialNumbers: [], locationId: null };
      if (!isNil(params.get('shippingContainerId'))) {
        const paramValueString = params.get('shippingContainerId');
        inParams.shippingContainerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('canAddManually'))) {
        const paramValueString = params.get('canAddManually');
        inParams.canAddManually = this.convertToBoolean(paramValueString);
      }
      if (!isNil(params.get('startVerificationTaskId'))) {
        const paramValueString = params.get('startVerificationTaskId');
        inParams.startVerificationTaskId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('isReadOnly'))) {
        const paramValueString = params.get('isReadOnly');
        inParams.isReadOnly = this.convertToBoolean(paramValueString);
      }
      if (!isNil(params.get('scannedValues'))) {
        const paramValueString = params.get('scannedValues');
        inParams.scannedValues = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('isBlind'))) {
        const paramValueString = params.get('isBlind');
        inParams.isBlind = this.convertToBoolean(paramValueString);
      }
      if (!isNil(params.get('expectedSerialNumbers'))) {
        const paramValueString = params.get('expectedSerialNumbers');
        inParams.expectedSerialNumbers = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('locationId'))) {
        const paramValueString = params.get('locationId');
        inParams.locationId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_pallet_classes_grid') {
      const title = 'Pallet classes grid';
      const component = FootprintManager_pallet_classes_gridComponent;
      const inParams:{ pallet_class_id?: number } = { pallet_class_id: null };
      if (!isNil(params.get('pallet_class_id'))) {
        const paramValueString = params.get('pallet_class_id');
        inParams.pallet_class_id = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_pallet_inventory_by_class_grid') {
      const title = 'Pallet inventory by class grid';
      const component = FootprintManager_pallet_inventory_by_class_gridComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_pallet_inventory_by_project_grid') {
      const title = 'pallet_inventory_by_project_grid';
      const component = FootprintManager_pallet_inventory_by_project_gridComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_pallet_transactions_grid') {
      const title = 'Pallet transactions grid';
      const component = FootprintManager_pallet_transactions_gridComponent;
      const inParams:{ project_id?: number, pallet_class_id?: number, project_lookup_code?: string, pallet_class_name?: string } = { project_id: null, pallet_class_id: null, project_lookup_code: null, pallet_class_name: null };
      if (!isNil(params.get('project_id'))) {
        const paramValueString = params.get('project_id');
        inParams.project_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('pallet_class_id'))) {
        const paramValueString = params.get('pallet_class_id');
        inParams.pallet_class_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('project_lookup_code'))) {
        const paramValueString = params.get('project_lookup_code');
        // TODO: date
        inParams.project_lookup_code = paramValueString;
              }
      if (!isNil(params.get('pallet_class_name'))) {
        const paramValueString = params.get('pallet_class_name');
        // TODO: date
        inParams.pallet_class_name = paramValueString;
              }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_pallet_transactions_shipment_grid') {
      const title = 'Pallet transactions shipment grid';
      const component = FootprintManager_pallet_transactions_shipment_gridComponent;
      const inParams:{ project_id?: number, shipment_id?: number, order_lookup_code?: string } = { project_id: null, shipment_id: null, order_lookup_code: null };
      if (!isNil(params.get('project_id'))) {
        const paramValueString = params.get('project_id');
        inParams.project_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('shipment_id'))) {
        const paramValueString = params.get('shipment_id');
        inParams.shipment_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('order_lookup_code'))) {
        const paramValueString = params.get('order_lookup_code');
        // TODO: date
        inParams.order_lookup_code = paramValueString;
              }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_pick_slips_grid') {
      const title = 'Pick slips';
      const component = FootprintManager_pick_slips_gridComponent;
      const inParams:{ waveId: number } = { waveId: null };
      if (!isNil(params.get('waveId'))) {
        const paramValueString = params.get('waveId');
        inParams.waveId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_pick_waves_expanded_grid') {
      const title = 'Pick waves expanded';
      const component = FootprintManager_pick_waves_expanded_gridComponent;
      const inParams:{ WaveId: number } = { WaveId: null };
      if (!isNil(params.get('WaveId'))) {
        const paramValueString = params.get('WaveId');
        inParams.WaveId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_pick_waves_grid') {
      const title = 'Pick waves';
      const component = FootprintManager_pick_waves_gridComponent;
      const inParams:{ ownerId?: number[], projectId?: number[], warehouseId?: number[], statusIds?: number[] } = { ownerId: [], projectId: [], warehouseId: [], statusIds: [] };
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('statusIds'))) {
        const paramValueString = params.get('statusIds');
        inParams.statusIds = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_plans_grid') {
      this.$logger.log('FootprintManager', 'plans_grid');
      const title = 'Plans';
      const component = FootprintManager_plans_gridComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_primary_picks_grid') {
      const title = 'Primary picks';
      const component = FootprintManager_primary_picks_gridComponent;
      const inParams:{ warehouse_id?: number, location_id?: number, material_id?: number } = { warehouse_id: null, location_id: null, material_id: null };
      if (!isNil(params.get('warehouse_id'))) {
        const paramValueString = params.get('warehouse_id');
        inParams.warehouse_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('location_id'))) {
        const paramValueString = params.get('location_id');
        inParams.location_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('material_id'))) {
        const paramValueString = params.get('material_id');
        inParams.material_id = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_projects_grid') {
      const title = 'Projects';
      const component = FootprintManager_projects_gridComponent;
      const inParams:{ projectStatusId?: number, ownerId?: number, projectIds?: number[] } = { projectStatusId: null, ownerId: null, projectIds: [] };
      if (!isNil(params.get('projectStatusId'))) {
        const paramValueString = params.get('projectStatusId');
        inParams.projectStatusId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectIds'))) {
        const paramValueString = params.get('projectIds');
        inParams.projectIds = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_purchase_order_bulk_receiving_by_taskId_grid') {
      const title = 'Bulk receiving task';
      const component = FootprintManager_purchase_order_bulk_receiving_by_taskId_gridComponent;
      const inParams:{ taskId: number, palletCount: number, fullPalletQuantity?: number } = { taskId: null, palletCount: null, fullPalletQuantity: null };
      if (!isNil(params.get('taskId'))) {
        const paramValueString = params.get('taskId');
        inParams.taskId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('palletCount'))) {
        const paramValueString = params.get('palletCount');
        inParams.palletCount = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('fullPalletQuantity'))) {
        const paramValueString = params.get('fullPalletQuantity');
        inParams.fullPalletQuantity = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_purchase_order_children_tasks_grid') {
      const title = 'Purchase order children tasks';
      const component = FootprintManager_purchase_order_children_tasks_gridComponent;
      const inParams:{ taskId: number } = { taskId: null };
      if (!isNil(params.get('taskId'))) {
        const paramValueString = params.get('taskId');
        inParams.taskId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_purchase_order_lines_grid') {
      const title = 'Order lines';
      const component = FootprintManager_purchase_order_lines_gridComponent;
      const inParams:{ orderId: number, shipmentId: number, projectId: number, orderStatusId: number } = { orderId: null, shipmentId: null, projectId: null, orderStatusId: null };
      if (!isNil(params.get('orderId'))) {
        const paramValueString = params.get('orderId');
        inParams.orderId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('shipmentId'))) {
        const paramValueString = params.get('shipmentId');
        inParams.shipmentId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('orderStatusId'))) {
        const paramValueString = params.get('orderStatusId');
        inParams.orderStatusId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_purchase_order_received_inventory_grid') {
      const title = 'Received inventory';
      const component = FootprintManager_purchase_order_received_inventory_gridComponent;
      const inParams:{ orderId: number, shipmentId: number } = { orderId: null, shipmentId: null };
      if (!isNil(params.get('orderId'))) {
        const paramValueString = params.get('orderId');
        inParams.orderId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('shipmentId'))) {
        const paramValueString = params.get('shipmentId');
        inParams.shipmentId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_purchase_order_receiving_grid') {
      const title = 'Receiving tasks';
      const component = FootprintManager_purchase_order_receiving_gridComponent;
      const inParams:{ orderId: number, shipmentId: number, orderStatusId: number } = { orderId: null, shipmentId: null, orderStatusId: null };
      if (!isNil(params.get('orderId'))) {
        const paramValueString = params.get('orderId');
        inParams.orderId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('shipmentId'))) {
        const paramValueString = params.get('shipmentId');
        inParams.shipmentId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('orderStatusId'))) {
        const paramValueString = params.get('orderStatusId');
        inParams.orderStatusId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_purchase_order_tasks_grid') {
      const title = 'Purchase order tasks';
      const component = FootprintManager_purchase_order_tasks_gridComponent;
      const inParams:{ orderId: number, shipmentId: number } = { orderId: null, shipmentId: null };
      if (!isNil(params.get('orderId'))) {
        const paramValueString = params.get('orderId');
        inParams.orderId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('shipmentId'))) {
        const paramValueString = params.get('shipmentId');
        inParams.shipmentId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_reason_codes_grid') {
      const title = 'Reason codes';
      const component = FootprintManager_reason_codes_gridComponent;
      const inParams:{ parentEntity?: string } = { parentEntity: null };
      if (!isNil(params.get('parentEntity'))) {
        const paramValueString = params.get('parentEntity');
        // TODO: date
        inParams.parentEntity = paramValueString;
              }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_replenishment_inventory_licenseplate_grid') {
      const title = 'Inventory by LP';
      const component = FootprintManager_replenishment_inventory_licenseplate_gridComponent;
      const inParams:{ ownerId?: number, projectId?: number, warehouseIds?: number[], materialIds?: number[], locationIds?: number[] } = { ownerId: null, projectId: null, warehouseIds: [], materialIds: [], locationIds: [] };
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouseIds'))) {
        const paramValueString = params.get('warehouseIds');
        inParams.warehouseIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('materialIds'))) {
        const paramValueString = params.get('materialIds');
        inParams.materialIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('locationIds'))) {
        const paramValueString = params.get('locationIds');
        inParams.locationIds = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_replenishment_tasks_grid') {
      const title = 'Replenishment tasks';
      const component = FootprintManager_replenishment_tasks_gridComponent;
      const inParams:{ materialIds?: number[], projectId?: number, locationIds?: number[], ownerId?: number, warehouseIds?: number[] } = { materialIds: [], projectId: null, locationIds: [], ownerId: null, warehouseIds: [] };
      if (!isNil(params.get('materialIds'))) {
        const paramValueString = params.get('materialIds');
        inParams.materialIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('locationIds'))) {
        const paramValueString = params.get('locationIds');
        inParams.locationIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouseIds'))) {
        const paramValueString = params.get('warehouseIds');
        inParams.warehouseIds = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_return_order_lines_grid') {
      const title = 'Order lines';
      const component = FootprintManager_return_order_lines_gridComponent;
      const inParams:{ orderId: number, shipmentId: number, projectId: number, orderStatusId: number } = { orderId: null, shipmentId: null, projectId: null, orderStatusId: null };
      if (!isNil(params.get('orderId'))) {
        const paramValueString = params.get('orderId');
        inParams.orderId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('shipmentId'))) {
        const paramValueString = params.get('shipmentId');
        inParams.shipmentId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('orderStatusId'))) {
        const paramValueString = params.get('orderStatusId');
        inParams.orderStatusId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_return_orders_grid') {
      const title = 'Return orders';
      const component = FootprintManager_return_orders_gridComponent;
      const inParams:{ ownerId?: number, projectId?: number, warehouseIds?: number[], statusIds?: number[], orderClassIds?: number[], reference?: string, blindShippingContainerId?: number } = { ownerId: null, projectId: null, warehouseIds: [], statusIds: [], orderClassIds: [], reference: null, blindShippingContainerId: null };
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouseIds'))) {
        const paramValueString = params.get('warehouseIds');
        inParams.warehouseIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('statusIds'))) {
        const paramValueString = params.get('statusIds');
        inParams.statusIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('orderClassIds'))) {
        const paramValueString = params.get('orderClassIds');
        inParams.orderClassIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('reference'))) {
        const paramValueString = params.get('reference');
        // TODO: date
        inParams.reference = paramValueString;
              }
      if (!isNil(params.get('blindShippingContainerId'))) {
        const paramValueString = params.get('blindShippingContainerId');
        inParams.blindShippingContainerId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_return_shipping_containers_grid') {
      const title = 'Return shipping containers';
      const component = FootprintManager_return_shipping_containers_gridComponent;
      const inParams:{ ownerId?: number, projectId?: number, warehouseIds?: number[], orderStatusIds?: number[], orderClassIds?: number[], reference?: string } = { ownerId: null, projectId: null, warehouseIds: [], orderStatusIds: [], orderClassIds: [], reference: null };
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouseIds'))) {
        const paramValueString = params.get('warehouseIds');
        inParams.warehouseIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('orderStatusIds'))) {
        const paramValueString = params.get('orderStatusIds');
        inParams.orderStatusIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('orderClassIds'))) {
        const paramValueString = params.get('orderClassIds');
        inParams.orderClassIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('reference'))) {
        const paramValueString = params.get('reference');
        // TODO: date
        inParams.reference = paramValueString;
              }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_sales_order_children_tasks_grid') {
      const title = 'Sales order children tasks';
      const component = FootprintManager_sales_order_children_tasks_gridComponent;
      const inParams:{ taskId: number } = { taskId: null };
      if (!isNil(params.get('taskId'))) {
        const paramValueString = params.get('taskId');
        inParams.taskId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_sales_order_line_components_grid') {
      const title = 'Sales order line kit components';
      const component = FootprintManager_sales_order_line_components_gridComponent;
      const inParams:{ order_id: number, shipment_id: number, project_id: number, order_status_id: number, warehouse_id: number, line_number: number } = { order_id: null, shipment_id: null, project_id: null, order_status_id: null, warehouse_id: null, line_number: null };
      if (!isNil(params.get('order_id'))) {
        const paramValueString = params.get('order_id');
        inParams.order_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('shipment_id'))) {
        const paramValueString = params.get('shipment_id');
        inParams.shipment_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('project_id'))) {
        const paramValueString = params.get('project_id');
        inParams.project_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('order_status_id'))) {
        const paramValueString = params.get('order_status_id');
        inParams.order_status_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouse_id'))) {
        const paramValueString = params.get('warehouse_id');
        inParams.warehouse_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('line_number'))) {
        const paramValueString = params.get('line_number');
        inParams.line_number = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_sales_order_line_kit_grid') {
      const title = 'Sales order line kit management';
      const component = FootprintManager_sales_order_line_kit_gridComponent;
      const inParams:{ material_id: number, packaging_id: number, project_id: number, order_id: number, line_number: number, line_status_id: number, packaged_amount: number, warehouse_id: number, shipment_id: number } = { material_id: null, packaging_id: null, project_id: null, order_id: null, line_number: null, line_status_id: null, packaged_amount: null, warehouse_id: null, shipment_id: null };
      if (!isNil(params.get('material_id'))) {
        const paramValueString = params.get('material_id');
        inParams.material_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('packaging_id'))) {
        const paramValueString = params.get('packaging_id');
        inParams.packaging_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('project_id'))) {
        const paramValueString = params.get('project_id');
        inParams.project_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('order_id'))) {
        const paramValueString = params.get('order_id');
        inParams.order_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('line_number'))) {
        const paramValueString = params.get('line_number');
        inParams.line_number = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('line_status_id'))) {
        const paramValueString = params.get('line_status_id');
        inParams.line_status_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('packaged_amount'))) {
        const paramValueString = params.get('packaged_amount');
        inParams.packaged_amount = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouse_id'))) {
        const paramValueString = params.get('warehouse_id');
        inParams.warehouse_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('shipment_id'))) {
        const paramValueString = params.get('shipment_id');
        inParams.shipment_id = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_sales_order_line_substitutions_grid') {
      const title = 'Sales order line substitutions management';
      const component = FootprintManager_sales_order_line_substitutions_gridComponent;
      const inParams:{ material_id: number, packaging_id: number, warehouse_id: number } = { material_id: null, packaging_id: null, warehouse_id: null };
      if (!isNil(params.get('material_id'))) {
        const paramValueString = params.get('material_id');
        inParams.material_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('packaging_id'))) {
        const paramValueString = params.get('packaging_id');
        inParams.packaging_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouse_id'))) {
        const paramValueString = params.get('warehouse_id');
        inParams.warehouse_id = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_sales_order_lines_grid') {
      const title = 'Order lines';
      const component = FootprintManager_sales_order_lines_gridComponent;
      const inParams:{ orderId: number, shipmentId: number, projectId: number, orderStatusId: number, warehouseId: number, orderState?: number } = { orderId: null, shipmentId: null, projectId: null, orderStatusId: null, warehouseId: null, orderState: null };
      if (!isNil(params.get('orderId'))) {
        const paramValueString = params.get('orderId');
        inParams.orderId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('shipmentId'))) {
        const paramValueString = params.get('shipmentId');
        inParams.shipmentId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('orderStatusId'))) {
        const paramValueString = params.get('orderStatusId');
        inParams.orderStatusId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('orderState'))) {
        const paramValueString = params.get('orderState');
        inParams.orderState = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_sales_order_picking_grid') {
      const title = 'Picking tasks';
      const component = FootprintManager_sales_order_picking_gridComponent;
      const inParams:{ orderId?: number, shipmentId?: number, waveId?: number, orderStatusId?: number, waveStatusId?: number } = { orderId: null, shipmentId: null, waveId: null, orderStatusId: null, waveStatusId: null };
      if (!isNil(params.get('orderId'))) {
        const paramValueString = params.get('orderId');
        inParams.orderId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('shipmentId'))) {
        const paramValueString = params.get('shipmentId');
        inParams.shipmentId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('waveId'))) {
        const paramValueString = params.get('waveId');
        inParams.waveId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('orderStatusId'))) {
        const paramValueString = params.get('orderStatusId');
        inParams.orderStatusId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('waveStatusId'))) {
        const paramValueString = params.get('waveStatusId');
        inParams.waveStatusId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_sales_order_tasks_grid') {
      const title = 'Sales Order Tasks';
      const component = FootprintManager_sales_order_tasks_gridComponent;
      const inParams:{ orderId?: number, shipmentId?: number, waveId?: number } = { orderId: null, shipmentId: null, waveId: null };
      if (!isNil(params.get('orderId'))) {
        const paramValueString = params.get('orderId');
        inParams.orderId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('shipmentId'))) {
        const paramValueString = params.get('shipmentId');
        inParams.shipmentId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('waveId'))) {
        const paramValueString = params.get('waveId');
        inParams.waveId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_scanned_values_grid') {
      const title = 'Scanned values';
      const component = FootprintManager_scanned_values_gridComponent;
      const inParams:{ scannedValues: { Value?: string, Note?: string }[], expectedValues?: string[] } = { scannedValues: [], expectedValues: [] };
      if (!isNil(params.get('scannedValues'))) {
        const paramValueString = params.get('scannedValues');
        inParams.scannedValues = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('expectedValues'))) {
        const paramValueString = params.get('expectedValues');
        inParams.expectedValues = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_serialnumbers_creation_grid') {
      const title = 'Create serial numbers';
      const component = FootprintManager_serialnumbers_creation_gridComponent;
      const inParams:{ materialId: number, packagingId: number, packagedAmount: number, averageGross?: number, averageNet?: number, weightUomId?: number, averageLength?: number, averageWidth?: number, averageHeight?: number, dimensionUomId?: number, lotId?: number, licensePlateId?: number } = { materialId: null, packagingId: null, packagedAmount: null, averageGross: null, averageNet: null, weightUomId: null, averageLength: null, averageWidth: null, averageHeight: null, dimensionUomId: null, lotId: null, licensePlateId: null };
      if (!isNil(params.get('materialId'))) {
        const paramValueString = params.get('materialId');
        inParams.materialId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('packagingId'))) {
        const paramValueString = params.get('packagingId');
        inParams.packagingId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('packagedAmount'))) {
        const paramValueString = params.get('packagedAmount');
        inParams.packagedAmount = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('averageGross'))) {
        const paramValueString = params.get('averageGross');
        inParams.averageGross = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('averageNet'))) {
        const paramValueString = params.get('averageNet');
        inParams.averageNet = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('weightUomId'))) {
        const paramValueString = params.get('weightUomId');
        inParams.weightUomId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('averageLength'))) {
        const paramValueString = params.get('averageLength');
        inParams.averageLength = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('averageWidth'))) {
        const paramValueString = params.get('averageWidth');
        inParams.averageWidth = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('averageHeight'))) {
        const paramValueString = params.get('averageHeight');
        inParams.averageHeight = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('dimensionUomId'))) {
        const paramValueString = params.get('dimensionUomId');
        inParams.dimensionUomId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('lotId'))) {
        const paramValueString = params.get('lotId');
        inParams.lotId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('licensePlateId'))) {
        const paramValueString = params.get('licensePlateId');
        inParams.licensePlateId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_serialnumbers_grid') {
      const title = 'Serial numbers';
      const component = FootprintManager_serialnumbers_gridComponent;
      const inParams:{ licenseplateIds?: number[], locationId?: number, warehouseIds?: number[], lotId?: number, materialIds?: number[], projectId?: number, ownerId?: number, archived?: boolean, search?: string, packagingId?: number, orderId?: number, orderLineNumber?: number } = { licenseplateIds: [], locationId: null, warehouseIds: [], lotId: null, materialIds: [], projectId: null, ownerId: null, archived: null, search: null, packagingId: null, orderId: null, orderLineNumber: null };
      if (!isNil(params.get('licenseplateIds'))) {
        const paramValueString = params.get('licenseplateIds');
        inParams.licenseplateIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('locationId'))) {
        const paramValueString = params.get('locationId');
        inParams.locationId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouseIds'))) {
        const paramValueString = params.get('warehouseIds');
        inParams.warehouseIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('lotId'))) {
        const paramValueString = params.get('lotId');
        inParams.lotId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('materialIds'))) {
        const paramValueString = params.get('materialIds');
        inParams.materialIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('archived'))) {
        const paramValueString = params.get('archived');
        inParams.archived = this.convertToBoolean(paramValueString);
      }
      if (!isNil(params.get('search'))) {
        const paramValueString = params.get('search');
        // TODO: date
        inParams.search = paramValueString;
              }
      if (!isNil(params.get('packagingId'))) {
        const paramValueString = params.get('packagingId');
        inParams.packagingId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('orderId'))) {
        const paramValueString = params.get('orderId');
        inParams.orderId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('orderLineNumber'))) {
        const paramValueString = params.get('orderLineNumber');
        inParams.orderLineNumber = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_serialnumbers_modification_grid') {
      this.$logger.log('FootprintManager', 'serialnumbers_modification_grid');
      const title = 'Select serial numbers';
      const component = FootprintManager_serialnumbers_modification_gridComponent;
      const inParams:{ serial_number_request?: { GrossVolumeValue?: number, GrossWeightValue?: number, Height?: number, Length?: number, LookupCode?: string, NetVolumeValue?: number, NetWeightValue?: number, DimensionsUOM?: number, WeightUOM?: number, Width?: number }[], packagedAmountRequest?: number } = { serial_number_request: [], packagedAmountRequest: null };
      if (!isNil(params.get('serial_number_request'))) {
        const paramValueString = params.get('serial_number_request');
        inParams.serial_number_request = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('packagedAmountRequest'))) {
        const paramValueString = params.get('packagedAmountRequest');
        inParams.packagedAmountRequest = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_serialnumbers_selection_grid') {
      const title = 'Select serial numbers';
      const component = FootprintManager_serialnumbers_selection_gridComponent;
      const inParams:{ lotId: number, licenseplateId: number, packagingId: number, packagedAmountRequest: number, serialNumberIds?: number[], filterSerialNumberIds?: number[] } = { lotId: null, licenseplateId: null, packagingId: null, packagedAmountRequest: null, serialNumberIds: [], filterSerialNumberIds: [] };
      if (!isNil(params.get('lotId'))) {
        const paramValueString = params.get('lotId');
        inParams.lotId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('licenseplateId'))) {
        const paramValueString = params.get('licenseplateId');
        inParams.licenseplateId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('packagingId'))) {
        const paramValueString = params.get('packagingId');
        inParams.packagingId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('packagedAmountRequest'))) {
        const paramValueString = params.get('packagedAmountRequest');
        inParams.packagedAmountRequest = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('serialNumberIds'))) {
        const paramValueString = params.get('serialNumberIds');
        inParams.serialNumberIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('filterSerialNumberIds'))) {
        const paramValueString = params.get('filterSerialNumberIds');
        inParams.filterSerialNumberIds = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_shipping_container_tasks_child_grid') {
      const title = 'Shipping container child tasks';
      const component = FootprintManager_shipping_container_tasks_child_gridComponent;
      const inParams:{ shippingContainerId: number, chainHead?: number } = { shippingContainerId: null, chainHead: null };
      if (!isNil(params.get('shippingContainerId'))) {
        const paramValueString = params.get('shippingContainerId');
        inParams.shippingContainerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('chainHead'))) {
        const paramValueString = params.get('chainHead');
        inParams.chainHead = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_shipping_container_tasks_grid') {
      const title = 'Shipping container tasks';
      const component = FootprintManager_shipping_container_tasks_gridComponent;
      const inParams:{ shippingContainerId: number, chainHead?: number } = { shippingContainerId: null, chainHead: null };
      if (!isNil(params.get('shippingContainerId'))) {
        const paramValueString = params.get('shippingContainerId');
        inParams.shippingContainerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('chainHead'))) {
        const paramValueString = params.get('chainHead');
        inParams.chainHead = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_shipping_containers_grid') {
      const title = 'Shipping containers grid';
      const component = FootprintManager_shipping_containers_gridComponent;
      const inParams:{ ownerIds?: number[], projectIds?: number[], warehouseIds?: number[], orderTypeIds?: number[], shipmentStatuses?: number[] } = { ownerIds: [], projectIds: [], warehouseIds: [], orderTypeIds: [], shipmentStatuses: [] };
      if (!isNil(params.get('ownerIds'))) {
        const paramValueString = params.get('ownerIds');
        inParams.ownerIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('projectIds'))) {
        const paramValueString = params.get('projectIds');
        inParams.projectIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('warehouseIds'))) {
        const paramValueString = params.get('warehouseIds');
        inParams.warehouseIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('orderTypeIds'))) {
        const paramValueString = params.get('orderTypeIds');
        inParams.orderTypeIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('shipmentStatuses'))) {
        const paramValueString = params.get('shipmentStatuses');
        inParams.shipmentStatuses = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_shipping_containers_to_verify_grid') {
      const title = 'Containers to verify';
      const component = FootprintManager_shipping_containers_to_verify_gridComponent;
      const inParams:{ warehouseId: number, locationId?: number, shippingContainerCode?: string, isFailed: boolean } = { warehouseId: null, locationId: null, shippingContainerCode: null, isFailed: null };
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('locationId'))) {
        const paramValueString = params.get('locationId');
        inParams.locationId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('shippingContainerCode'))) {
        const paramValueString = params.get('shippingContainerCode');
        // TODO: date
        inParams.shippingContainerCode = paramValueString;
              }
      if (!isNil(params.get('isFailed'))) {
        const paramValueString = params.get('isFailed');
        inParams.isFailed = this.convertToBoolean(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_shippingcontents_grid') {
      const title = 'Shipping contents';
      const component = FootprintManager_shippingcontents_gridComponent;
      const inParams:{ orderId: number, shipmentId: number } = { orderId: null, shipmentId: null };
      if (!isNil(params.get('orderId'))) {
        const paramValueString = params.get('orderId');
        inParams.orderId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('shipmentId'))) {
        const paramValueString = params.get('shipmentId');
        inParams.shipmentId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_storage_categories_grid') {
      const title = 'Storage categories';
      const component = FootprintManager_storage_categories_gridComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_storage_category_rules_grid') {
      const title = 'Storage category rules';
      const component = FootprintManager_storage_category_rules_gridComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_submitted_survey_inputs_grid') {
      const title = 'Survey inputs';
      const component = FootprintManager_submitted_survey_inputs_gridComponent;
      const inParams:{ surveyId: number } = { surveyId: null };
      if (!isNil(params.get('surveyId'))) {
        const paramValueString = params.get('surveyId');
        inParams.surveyId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_submitted_surveys_grid') {
      const title = 'Submitted surveys';
      const component = FootprintManager_submitted_surveys_gridComponent;
      const inParams:{ entities?: { type?: string, ids?: number[] }[], operationContextTypes?: string[], warehouseIds?: number[] } = { entities: [], operationContextTypes: [], warehouseIds: [] };
      if (!isNil(params.get('entities'))) {
        const paramValueString = params.get('entities');
        inParams.entities = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('operationContextTypes'))) {
        const paramValueString = params.get('operationContextTypes');
        inParams.operationContextTypes = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('warehouseIds'))) {
        const paramValueString = params.get('warehouseIds');
        inParams.warehouseIds = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_support_tests_grid') {
      this.$logger.log('FootprintManager', 'support_tests_grid');
      const title = 'Support tests grid';
      const component = FootprintManager_support_tests_gridComponent;
      const inParams:{ test_ids?: number[], test_runs?: number, rows_override?: number } = { test_ids: [], test_runs: null, rows_override: null };
      if (!isNil(params.get('test_ids'))) {
        const paramValueString = params.get('test_ids');
        inParams.test_ids = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('test_runs'))) {
        const paramValueString = params.get('test_runs');
        inParams.test_runs = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('rows_override'))) {
        const paramValueString = params.get('rows_override');
        inParams.rows_override = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_survey_grid_input_values_grid') {
      const title = 'Grid inputs';
      const component = FootprintManager_survey_grid_input_values_gridComponent;
      const inParams:{ values: { header1?: string, header2?: string, header3?: string, header4?: string, header5?: string }[], headers?: { header1?: string, header2?: string, header3?: string, header4?: string, header5?: string } } = { values: [], headers: { header1: null, header2: null, header3: null, header4: null, header5: null } };
      if (!isNil(params.get('values'))) {
        const paramValueString = params.get('values');
        inParams.values = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('headers'))) {
        const paramValueString = params.get('headers');
        inParams.headers = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_task_assignment_grid') {
      const title = 'Task assignment';
      const component = FootprintManager_task_assignment_gridComponent;
      const inParams:{ warehouseIds?: number[], workClassIds?: number[], fromDate?: string, toDate?: string, projectId?: number, ownerId?: number } = { warehouseIds: [], workClassIds: [], fromDate: null, toDate: null, projectId: null, ownerId: null };
      if (!isNil(params.get('warehouseIds'))) {
        const paramValueString = params.get('warehouseIds');
        inParams.warehouseIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('workClassIds'))) {
        const paramValueString = params.get('workClassIds');
        inParams.workClassIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('fromDate'))) {
        const paramValueString = params.get('fromDate');
        // TODO: date
        inParams.fromDate = paramValueString;
              }
      if (!isNil(params.get('toDate'))) {
        const paramValueString = params.get('toDate');
        // TODO: date
        inParams.toDate = paramValueString;
              }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_temperature_capture_reading_points_grid') {
      const title = 'Temperature reading points';
      const component = FootprintManager_temperature_capture_reading_points_gridComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_temperature_capture_reading_types_grid') {
      const title = 'Temperature reading types';
      const component = FootprintManager_temperature_capture_reading_types_gridComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_temperature_readings_grid') {
      const title = 'Temperature readings';
      const component = FootprintManager_temperature_readings_gridComponent;
      const inParams:{ loadContainerId?: number, shipmentId?: number, licensePlateId?: number, orderId?: number } = { loadContainerId: null, shipmentId: null, licensePlateId: null, orderId: null };
      if (!isNil(params.get('loadContainerId'))) {
        const paramValueString = params.get('loadContainerId');
        inParams.loadContainerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('shipmentId'))) {
        const paramValueString = params.get('shipmentId');
        inParams.shipmentId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('licensePlateId'))) {
        const paramValueString = params.get('licensePlateId');
        inParams.licensePlateId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('orderId'))) {
        const paramValueString = params.get('orderId');
        inParams.orderId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_transload_order_lines_grid') {
      const title = 'Order lines';
      const component = FootprintManager_transload_order_lines_gridComponent;
      const inParams:{ orderId: number, shipmentId: number, projectId: number, orderStatusId: number } = { orderId: null, shipmentId: null, projectId: null, orderStatusId: null };
      if (!isNil(params.get('orderId'))) {
        const paramValueString = params.get('orderId');
        inParams.orderId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('shipmentId'))) {
        const paramValueString = params.get('shipmentId');
        inParams.shipmentId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('orderStatusId'))) {
        const paramValueString = params.get('orderStatusId');
        inParams.orderStatusId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_transload_order_received_inventory_grid') {
      const title = 'Received inventory';
      const component = FootprintManager_transload_order_received_inventory_gridComponent;
      const inParams:{ orderId: number, shipmentId: number, transload_id: number } = { orderId: null, shipmentId: null, transload_id: null };
      if (!isNil(params.get('orderId'))) {
        const paramValueString = params.get('orderId');
        inParams.orderId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('shipmentId'))) {
        const paramValueString = params.get('shipmentId');
        inParams.shipmentId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('transload_id'))) {
        const paramValueString = params.get('transload_id');
        inParams.transload_id = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_transload_order_receiving_grid') {
      const title = 'Receiving tasks';
      const component = FootprintManager_transload_order_receiving_gridComponent;
      const inParams:{ orderId: number, shipmentId: number, orderStatusId: number, transload_id: number } = { orderId: null, shipmentId: null, orderStatusId: null, transload_id: null };
      if (!isNil(params.get('orderId'))) {
        const paramValueString = params.get('orderId');
        inParams.orderId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('shipmentId'))) {
        const paramValueString = params.get('shipmentId');
        inParams.shipmentId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('orderStatusId'))) {
        const paramValueString = params.get('orderStatusId');
        inParams.orderStatusId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('transload_id'))) {
        const paramValueString = params.get('transload_id');
        inParams.transload_id = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_transload_orders_grid') {
      const title = 'Transload orders';
      const component = FootprintManager_transload_orders_gridComponent;
      const inParams:{ ownerId?: number, projectId?: number, warehouseId?: number[], statusIds?: number[], materialIds?: number[] } = { ownerId: null, projectId: null, warehouseId: [], statusIds: [], materialIds: [] };
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('statusIds'))) {
        const paramValueString = params.get('statusIds');
        inParams.statusIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('materialIds'))) {
        const paramValueString = params.get('materialIds');
        inParams.materialIds = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_transload_outbound_shipments_grid') {
      const title = 'Transload outbound shipments';
      const component = FootprintManager_transload_outbound_shipments_gridComponent;
      const inParams:{ orderId: number } = { orderId: null };
      if (!isNil(params.get('orderId'))) {
        const paramValueString = params.get('orderId');
        inParams.orderId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_vendorlots_selector_grid') {
      const title = 'Vendor lot selector';
      const component = FootprintManager_vendorlots_selector_gridComponent;
      const inParams:{ selectedVendorlotIds?: number[], isExclude?: boolean, allowEdit: boolean } = { selectedVendorlotIds: [], isExclude: null, allowEdit: null };
      if (!isNil(params.get('selectedVendorlotIds'))) {
        const paramValueString = params.get('selectedVendorlotIds');
        inParams.selectedVendorlotIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('isExclude'))) {
        const paramValueString = params.get('isExclude');
        inParams.isExclude = this.convertToBoolean(paramValueString);
      }
      if (!isNil(params.get('allowEdit'))) {
        const paramValueString = params.get('allowEdit');
        inParams.allowEdit = this.convertToBoolean(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_warehouse_transfer_inbound_licenseplates_grid') {
      const title = 'License plates';
      const component = FootprintManager_warehouse_transfer_inbound_licenseplates_gridComponent;
      const inParams:{ orderId: number, orderStatusId: number } = { orderId: null, orderStatusId: null };
      if (!isNil(params.get('orderId'))) {
        const paramValueString = params.get('orderId');
        inParams.orderId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('orderStatusId'))) {
        const paramValueString = params.get('orderStatusId');
        inParams.orderStatusId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_warehouse_transfer_inbound_order_licenseplates_receiving_tasks_grid') {
      const title = 'Receiving tasks';
      const component = FootprintManager_warehouse_transfer_inbound_order_licenseplates_receiving_tasks_gridComponent;
      const inParams:{ licenseplateId: number, orderId: number } = { licenseplateId: null, orderId: null };
      if (!isNil(params.get('licenseplateId'))) {
        const paramValueString = params.get('licenseplateId');
        inParams.licenseplateId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('orderId'))) {
        const paramValueString = params.get('orderId');
        inParams.orderId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_warehouse_transfer_inbound_order_receiving_tasks_grid') {
      const title = 'Receiving tasks';
      const component = FootprintManager_warehouse_transfer_inbound_order_receiving_tasks_gridComponent;
      const inParams:{ orderId: number, readOnly?: boolean } = { orderId: null, readOnly: null };
      if (!isNil(params.get('orderId'))) {
        const paramValueString = params.get('orderId');
        inParams.orderId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('readOnly'))) {
        const paramValueString = params.get('readOnly');
        inParams.readOnly = this.convertToBoolean(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_warehouse_transfer_inbound_orderlines_grid') {
      const title = 'Order lines';
      const component = FootprintManager_warehouse_transfer_inbound_orderlines_gridComponent;
      const inParams:{ orderId: number } = { orderId: null };
      if (!isNil(params.get('orderId'))) {
        const paramValueString = params.get('orderId');
        inParams.orderId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_warehouse_transfer_outbound_order_lines_grid') {
      const title = 'Order lines';
      const component = FootprintManager_warehouse_transfer_outbound_order_lines_gridComponent;
      const inParams:{ orderId: number, shipmentId: number, projectId: number, orderStatusId: number, warehouseId: number, warehouseTransferId: number, readOnly?: boolean } = { orderId: null, shipmentId: null, projectId: null, orderStatusId: null, warehouseId: null, warehouseTransferId: null, readOnly: null };
      if (!isNil(params.get('orderId'))) {
        const paramValueString = params.get('orderId');
        inParams.orderId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('shipmentId'))) {
        const paramValueString = params.get('shipmentId');
        inParams.shipmentId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('orderStatusId'))) {
        const paramValueString = params.get('orderStatusId');
        inParams.orderStatusId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouseTransferId'))) {
        const paramValueString = params.get('warehouseTransferId');
        inParams.warehouseTransferId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('readOnly'))) {
        const paramValueString = params.get('readOnly');
        inParams.readOnly = this.convertToBoolean(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_warehouse_transfer_outbound_order_manual_allocations_grid') {
      const title = 'Manual allocations';
      const component = FootprintManager_warehouse_transfer_outbound_order_manual_allocations_gridComponent;
      const inParams:{ orderId: number } = { orderId: null };
      if (!isNil(params.get('orderId'))) {
        const paramValueString = params.get('orderId');
        inParams.orderId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_warehouse_transfer_outbound_order_shippingcontents_grid') {
      const title = 'Shipping contents';
      const component = FootprintManager_warehouse_transfer_outbound_order_shippingcontents_gridComponent;
      const inParams:{ orderId: number, shipmentId: number, orderStatusId: number } = { orderId: null, shipmentId: null, orderStatusId: null };
      if (!isNil(params.get('orderId'))) {
        const paramValueString = params.get('orderId');
        inParams.orderId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('shipmentId'))) {
        const paramValueString = params.get('shipmentId');
        inParams.shipmentId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('orderStatusId'))) {
        const paramValueString = params.get('orderStatusId');
        inParams.orderStatusId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_warehouse_transfer_picking_grid') {
      const title = 'Picking tasks';
      const component = FootprintManager_warehouse_transfer_picking_gridComponent;
      const inParams:{ orderId?: number, shipmentId?: number, waveId?: number, orderStatusId?: number, waveStatusId?: number } = { orderId: null, shipmentId: null, waveId: null, orderStatusId: null, waveStatusId: null };
      if (!isNil(params.get('orderId'))) {
        const paramValueString = params.get('orderId');
        inParams.orderId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('shipmentId'))) {
        const paramValueString = params.get('shipmentId');
        inParams.shipmentId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('waveId'))) {
        const paramValueString = params.get('waveId');
        inParams.waveId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('orderStatusId'))) {
        const paramValueString = params.get('orderStatusId');
        inParams.orderStatusId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('waveStatusId'))) {
        const paramValueString = params.get('waveStatusId');
        inParams.waveStatusId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_warehouse_transfers_grid') {
      const title = 'Warehouse transfers';
      const component = FootprintManager_warehouse_transfers_gridComponent;
      const inParams:{ warehouseIds?: number[], statusIds?: number[] } = { warehouseIds: [], statusIds: [] };
      if (!isNil(params.get('warehouseIds'))) {
        const paramValueString = params.get('warehouseIds');
        inParams.warehouseIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('statusIds'))) {
        const paramValueString = params.get('statusIds');
        inParams.statusIds = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_warehouses_navigation_grid') {
      const title = 'Warehouses';
      const component = FootprintManager_warehouses_navigation_gridComponent;
      const inParams:{ warehouseId?: number, timezone?: string[] } = { warehouseId: null, timezone: [] };
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('timezone'))) {
        const paramValueString = params.get('timezone');
        inParams.timezone = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_wave_creation_grid') {
      const title = 'Create wave';
      const component = FootprintManager_wave_creation_gridComponent;
      const inParams:{ ownerId?: number, projectId?: number, warehouseIds?: number[], waveId?: number, showCreate?: boolean, carrierId?: number, carrierServiceId?: number } = { ownerId: null, projectId: null, warehouseIds: [], waveId: null, showCreate: null, carrierId: null, carrierServiceId: null };
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouseIds'))) {
        const paramValueString = params.get('warehouseIds');
        inParams.warehouseIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('waveId'))) {
        const paramValueString = params.get('waveId');
        inParams.waveId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('showCreate'))) {
        const paramValueString = params.get('showCreate');
        inParams.showCreate = this.convertToBoolean(paramValueString);
      }
      if (!isNil(params.get('carrierId'))) {
        const paramValueString = params.get('carrierId');
        inParams.carrierId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('carrierServiceId'))) {
        const paramValueString = params.get('carrierServiceId');
        inParams.carrierServiceId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_work_class_operation_codes_grid') {
      const title = 'Operation codes';
      const component = FootprintManager_work_class_operation_codes_gridComponent;
      const inParams:{ workClassId: number, operationCodes?: any } = { workClassId: null, operationCodes: null };
      if (!isNil(params.get('workClassId'))) {
        const paramValueString = params.get('workClassId');
        inParams.workClassId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('operationCodes'))) {
        const paramValueString = params.get('operationCodes');
        inParams.operationCodes = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_work_class_users_grid') {
      const title = 'Work class users';
      const component = FootprintManager_work_class_users_gridComponent;
      const inParams:{ users?: any[] } = { users: [] };
      if (!isNil(params.get('users'))) {
        const paramValueString = params.get('users');
        inParams.users = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_work_classes_grid') {
      const title = 'Work classes';
      const component = FootprintManager_work_classes_gridComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_work_orders_grid') {
      const title = 'Work orders';
      const component = FootprintManager_work_orders_gridComponent;
      const inParams:{ ownerId?: number, projectId?: number, warehouseId?: number, statusIds?: number[] } = { ownerId: null, projectId: null, warehouseId: null, statusIds: [] };
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('statusIds'))) {
        const paramValueString = params.get('statusIds');
        inParams.statusIds = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_activity_hub') {
      const title = 'Activity Hub';
      const component = FootprintManager_activity_hubComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_allocation_configurations_hub') {
      this.$logger.log('FootprintManager', 'allocation_configurations_hub');
      const title = 'Allocation configurations';
      const component = FootprintManager_allocation_configurations_hubComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_audit_serial_numbers_hub') {
      const title = 'Audit serial numbers';
      const component = FootprintManager_audit_serial_numbers_hubComponent;
      const inParams:{ licensePlateId?: number } = { licensePlateId: null };
      if (!isNil(params.get('licensePlateId'))) {
        const paramValueString = params.get('licensePlateId');
        inParams.licensePlateId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_billing_contracts_hub') {
      const title = 'Billing Contracts Hub';
      const component = FootprintManager_billing_contracts_hubComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_billing_records_hub') {
      const title = 'Billing records hub';
      const component = FootprintManager_billing_records_hubComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_blind_return_shipping_container_hub') {
      const title = 'Blind return';
      const component = FootprintManager_blind_return_shipping_container_hubComponent;
      const inParams:{ shippingContainerId?: number } = { shippingContainerId: null };
      if (!isNil(params.get('shippingContainerId'))) {
        const paramValueString = params.get('shippingContainerId');
        inParams.shippingContainerId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_carrier_management_hub') {
      const title = 'Carrier management hub';
      const component = FootprintManager_carrier_management_hubComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_configurations_inventory_hub') {
      const title = 'Inventory configurations';
      const component = FootprintManager_configurations_inventory_hubComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_configurations_storage_categories_hub') {
      const title = 'Storage Configurations';
      const component = FootprintManager_configurations_storage_categories_hubComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_dock_appointments_hub') {
      const title = 'Dock appointments hub';
      const component = FootprintManager_dock_appointments_hubComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_dock_doors_hub') {
      const title = 'Dock doors hub';
      const component = FootprintManager_dock_doors_hubComponent;
      const inParams:{ warehouseIds?: number[] } = { warehouseIds: [] };
      if (!isNil(params.get('warehouseIds'))) {
        const paramValueString = params.get('warehouseIds');
        inParams.warehouseIds = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_driver_check_out_hub') {
      const title = 'Driver check out hub';
      const component = FootprintManager_driver_check_out_hubComponent;
      const inParams:{ orderId?: number, load_container_id?: number } = { orderId: null, load_container_id: null };
      if (!isNil(params.get('orderId'))) {
        const paramValueString = params.get('orderId');
        inParams.orderId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('load_container_id'))) {
        const paramValueString = params.get('load_container_id');
        inParams.load_container_id = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_entity_import_hub') {
      const title = 'Entity import hub';
      const component = FootprintManager_entity_import_hubComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_footprint_events_hub') {
      this.$logger.log('FootprintManager', 'footprint_events_hub');
      const title = 'Footprint events';
      const component = FootprintManager_footprint_events_hubComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_inbound_orders_hub') {
      const title = 'Inbound hub';
      const component = FootprintManager_inbound_orders_hubComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_inspections_hub') {
      const title = 'Inspections hub';
      const component = FootprintManager_inspections_hubComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_inventory_counts_hub') {
      const title = 'Inventory Counts';
      const component = FootprintManager_inventory_counts_hubComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_inventory_hub') {
      const title = 'Inventory Hub';
      const component = FootprintManager_inventory_hubComponent;
      const inParams:{ ownerId?: number, projectId?: number, warehouseId?: number } = { ownerId: null, projectId: null, warehouseId: null };
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_inventory_transfers_hub') {
      const title = 'Inventory transfers hub';
      const component = FootprintManager_inventory_transfers_hubComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_inventory_transformations_hub') {
      this.$logger.log('FootprintManager', 'inventory_transformations_hub');
      const title = 'Inventory transformations hub';
      const component = FootprintManager_inventory_transformations_hubComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_invoices_hub') {
      const title = 'Invoices Hub';
      const component = FootprintManager_invoices_hubComponent;
      const inParams:{ ownerId?: number, projectId?: number } = { ownerId: null, projectId: null };
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_labor_management_hub') {
      const title = 'Labor management';
      const component = FootprintManager_labor_management_hubComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_load_containers_hub') {
      const title = 'Load Containers Hub';
      const component = FootprintManager_load_containers_hubComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_lots_hub') {
      const title = 'Lots hub';
      const component = FootprintManager_lots_hubComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_manufacturing_configuration_hub') {
      this.$logger.log('FootprintManager', 'manufacturing_configuration_hub');
      const title = 'Manufacturing configuration';
      const component = FootprintManager_manufacturing_configuration_hubComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_manufacturing_locations_hub') {
      this.$logger.log('FootprintManager', 'manufacturing_locations_hub');
      const title = 'locations_for_manufacturing_hub';
      const component = FootprintManager_manufacturing_locations_hubComponent;
      const inParams:{ warehouse_id: number } = { warehouse_id: null };
      if (!isNil(params.get('warehouse_id'))) {
        const paramValueString = params.get('warehouse_id');
        inParams.warehouse_id = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_manufacturing_orders_hub') {
      this.$logger.log('FootprintManager', 'manufacturing_orders_hub');
      const title = 'Manufacturing orders hub';
      const component = FootprintManager_manufacturing_orders_hubComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_material_attachments_hub') {
      const title = 'Material attachments';
      const component = FootprintManager_material_attachments_hubComponent;
      const inParams:{ materialId: number, packagingId?: number } = { materialId: null, packagingId: null };
      if (!isNil(params.get('materialId'))) {
        const paramValueString = params.get('materialId');
        inParams.materialId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('packagingId'))) {
        const paramValueString = params.get('packagingId');
        inParams.packagingId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_material_catalogs_hub') {
      const title = 'Material catalogs Hub';
      const component = FootprintManager_material_catalogs_hubComponent;
      const inParams:{ project_id?: number, material_catalog_id?: number } = { project_id: null, material_catalog_id: null };
      if (!isNil(params.get('project_id'))) {
        const paramValueString = params.get('project_id');
        inParams.project_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('material_catalog_id'))) {
        const paramValueString = params.get('material_catalog_id');
        inParams.material_catalog_id = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_materials_hub') {
      const title = 'Materials hub';
      const component = FootprintManager_materials_hubComponent;
      const inParams:{ ownerId?: number, projectId?: number } = { ownerId: null, projectId: null };
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_orders_attachments_hub') {
      const title = 'orders_attachments_hub';
      const component = FootprintManager_orders_attachments_hubComponent;
      const inParams:{ orderId?: number, shipmentId?: number } = { orderId: null, shipmentId: null };
      if (!isNil(params.get('orderId'))) {
        const paramValueString = params.get('orderId');
        inParams.orderId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('shipmentId'))) {
        const paramValueString = params.get('shipmentId');
        inParams.shipmentId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_orders_hub') {
      const title = 'Orders Hub';
      const component = FootprintManager_orders_hubComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_outbound_orders_hub') {
      const title = 'Outbound orders hub';
      const component = FootprintManager_outbound_orders_hubComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_owners_and_projects_hub') {
      this.$logger.log('FootprintManager', 'owners_and_projects_hub');
      const title = 'Owners and projects hub';
      const component = FootprintManager_owners_and_projects_hubComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_owners_hub') {
      const title = 'Owners Hub';
      const component = FootprintManager_owners_hubComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_pack_verification_hub') {
      const title = 'Pack verification hub';
      const component = FootprintManager_pack_verification_hubComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_projects_hub') {
      const title = 'Projects Hub';
      const component = FootprintManager_projects_hubComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_replenishment_hub') {
      const title = 'Replenishment Hub';
      const component = FootprintManager_replenishment_hubComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_returns_hub') {
      const title = 'Returns hub';
      const component = FootprintManager_returns_hubComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_serialnumbers_hub') {
      const title = 'Serialnumbers Hub';
      const component = FootprintManager_serialnumbers_hubComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_shipping_containers_hub') {
      const title = 'Shipping containers hub';
      const component = FootprintManager_shipping_containers_hubComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_single_licenseplate_hub') {
      const title = 'Single license plate hub';
      const component = FootprintManager_single_licenseplate_hubComponent;
      const inParams:{ licenseplateId: number } = { licenseplateId: null };
      if (!isNil(params.get('licenseplateId'))) {
        const paramValueString = params.get('licenseplateId');
        inParams.licenseplateId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_single_location_hub') {
      const title = 'Single Location Hub';
      const component = FootprintManager_single_location_hubComponent;
      const inParams:{ locationId: number } = { locationId: null };
      if (!isNil(params.get('locationId'))) {
        const paramValueString = params.get('locationId');
        inParams.locationId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_single_lot_hub') {
      const title = 'Single Lot Hub';
      const component = FootprintManager_single_lot_hubComponent;
      const inParams:{ lotId: number } = { lotId: null };
      if (!isNil(params.get('lotId'))) {
        const paramValueString = params.get('lotId');
        inParams.lotId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_single_material_catalog_source_material_hub') {
      const title = 'Single material catalog source material Hub';
      const component = FootprintManager_single_material_catalog_source_material_hubComponent;
      const inParams:{ materialId: number } = { materialId: null };
      if (!isNil(params.get('materialId'))) {
        const paramValueString = params.get('materialId');
        inParams.materialId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_single_material_hub') {
      const title = 'Single Material Hub';
      const component = FootprintManager_single_material_hubComponent;
      const inParams:{ materialId: number } = { materialId: null };
      if (!isNil(params.get('materialId'))) {
        const paramValueString = params.get('materialId');
        inParams.materialId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_single_owner_hub') {
      const title = 'Single Owner Hub';
      const component = FootprintManager_single_owner_hubComponent;
      const inParams:{ ownerId: number } = { ownerId: null };
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_single_parent_licenseplate_hub') {
      const title = 'Single Parent Licenseplate Hub';
      const component = FootprintManager_single_parent_licenseplate_hubComponent;
      const inParams:{ licenseplateId: number } = { licenseplateId: null };
      if (!isNil(params.get('licenseplateId'))) {
        const paramValueString = params.get('licenseplateId');
        inParams.licenseplateId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_single_project_hub') {
      const title = 'Single Project Hub';
      const component = FootprintManager_single_project_hubComponent;
      const inParams:{ projectId: number, ownerId?: number } = { projectId: null, ownerId: null };
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_single_serialnumber_hub') {
      const title = 'Single serial number hub';
      const component = FootprintManager_single_serialnumber_hubComponent;
      const inParams:{ serialnumberId: number } = { serialnumberId: null };
      if (!isNil(params.get('serialnumberId'))) {
        const paramValueString = params.get('serialnumberId');
        inParams.serialnumberId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_single_survey_hub') {
      const title = 'Submitted survey';
      const component = FootprintManager_single_survey_hubComponent;
      const inParams:{ surveyId: number } = { surveyId: null };
      if (!isNil(params.get('surveyId'))) {
        const paramValueString = params.get('surveyId');
        inParams.surveyId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_single_warehouse_hub') {
      const title = 'Single Warehouse Hub';
      const component = FootprintManager_single_warehouse_hubComponent;
      const inParams:{ warehouseId: number } = { warehouseId: null };
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_single_wave_hub') {
      const title = 'Single wave';
      const component = FootprintManager_single_wave_hubComponent;
      const inParams:{ waveId: number, waveDescription?: string, waveStatus?: string, ownerId?: number, projectId?: number, warehouseIds?: number[], allowInactive?: boolean } = { waveId: null, waveDescription: null, waveStatus: null, ownerId: null, projectId: null, warehouseIds: [], allowInactive: null };
      if (!isNil(params.get('waveId'))) {
        const paramValueString = params.get('waveId');
        inParams.waveId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('waveDescription'))) {
        const paramValueString = params.get('waveDescription');
        // TODO: date
        inParams.waveDescription = paramValueString;
              }
      if (!isNil(params.get('waveStatus'))) {
        const paramValueString = params.get('waveStatus');
        // TODO: date
        inParams.waveStatus = paramValueString;
              }
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouseIds'))) {
        const paramValueString = params.get('warehouseIds');
        inParams.warehouseIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('allowInactive'))) {
        const paramValueString = params.get('allowInactive');
        inParams.allowInactive = this.convertToBoolean(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_support_tests_hub') {
      this.$logger.log('FootprintManager', 'support_tests_hub');
      const title = 'Support Tests Hub';
      const component = FootprintManager_support_tests_hubComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_surveys_hub') {
      const title = 'Surveys hub';
      const component = FootprintManager_surveys_hubComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_transload_orders_hub') {
      const title = 'Transload Orders Hub';
      const component = FootprintManager_transload_orders_hubComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_warehouse_transfers_hub') {
      const title = 'Warehouse transfers';
      const component = FootprintManager_warehouse_transfers_hubComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_warehouses_hub') {
      const title = 'Warehouses hub';
      const component = FootprintManager_warehouses_hubComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_waves_hub') {
      const title = 'Waves hub';
      const component = FootprintManager_waves_hubComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_work_classes_hub') {
      const title = 'Manage work classes';
      const component = FootprintManager_work_classes_hubComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_work_orders_hub') {
      const title = 'Work orders hub';
      const component = FootprintManager_work_orders_hubComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_dock_appointments_calendar') {
      const title = 'Calendar';
      const component = FootprintManager_dock_appointments_calendarComponent;
      const inParams:{ warehouseIds: number[], typeIds?: number[], ownerId?: number, projectId?: number, carrierId?: number, statusIds?: number[], dockDoorIds?: number[], viewDate?: string } = { warehouseIds: [], typeIds: [], ownerId: null, projectId: null, carrierId: null, statusIds: [], dockDoorIds: [], viewDate: null };
      if (!isNil(params.get('warehouseIds'))) {
        const paramValueString = params.get('warehouseIds');
        inParams.warehouseIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('typeIds'))) {
        const paramValueString = params.get('typeIds');
        inParams.typeIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('carrierId'))) {
        const paramValueString = params.get('carrierId');
        inParams.carrierId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('statusIds'))) {
        const paramValueString = params.get('statusIds');
        inParams.statusIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('dockDoorIds'))) {
        const paramValueString = params.get('dockDoorIds');
        inParams.dockDoorIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('viewDate'))) {
        const paramValueString = params.get('viewDate');
        // TODO: date
        inParams.viewDate = paramValueString;
              }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_manufacturing_orders_calendar') {
      this.$logger.log('FootprintManager', 'manufacturing_orders_calendar');
      const title = 'manufacturing_orders_calendar';
      const component = FootprintManager_manufacturing_orders_calendarComponent;
      const inParams:{ warehouse_ids?: number[], project_id?: number } = { warehouse_ids: [], project_id: null };
      if (!isNil(params.get('warehouse_ids'))) {
        const paramValueString = params.get('warehouse_ids');
        inParams.warehouse_ids = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('project_id'))) {
        const paramValueString = params.get('project_id');
        inParams.project_id = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_dock_appointment_selection_wizard') {
      const title = 'Dock appointment selection';
      const component = FootprintManager_dock_appointment_selection_wizardComponent;
      const inParams:{ warehouseId?: number, dockDoor?: number, carrierId?: number, orderId?: number, scheduledProjectId?: number, excludedDockAppointmentIds?: number[], typeIds?: number[] } = { warehouseId: null, dockDoor: null, carrierId: null, orderId: null, scheduledProjectId: null, excludedDockAppointmentIds: [], typeIds: [] };
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('dockDoor'))) {
        const paramValueString = params.get('dockDoor');
        inParams.dockDoor = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('carrierId'))) {
        const paramValueString = params.get('carrierId');
        inParams.carrierId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('orderId'))) {
        const paramValueString = params.get('orderId');
        inParams.orderId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('scheduledProjectId'))) {
        const paramValueString = params.get('scheduledProjectId');
        inParams.scheduledProjectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('excludedDockAppointmentIds'))) {
        const paramValueString = params.get('excludedDockAppointmentIds');
        inParams.excludedDockAppointmentIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('typeIds'))) {
        const paramValueString = params.get('typeIds');
        inParams.typeIds = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_inventory_by_location_selection_wizard') {
      const title = 'Inventory by Location Selection Wizard';
      const component = FootprintManager_inventory_by_location_selection_wizardComponent;
      const inParams:{ warehouseId: number, projectId: number, materialId?: number, packagingId?: number, lotId?: number, packagedAmountRequest?: number } = { warehouseId: null, projectId: null, materialId: null, packagingId: null, lotId: null, packagedAmountRequest: null };
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('materialId'))) {
        const paramValueString = params.get('materialId');
        inParams.materialId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('packagingId'))) {
        const paramValueString = params.get('packagingId');
        inParams.packagingId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('lotId'))) {
        const paramValueString = params.get('lotId');
        inParams.lotId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('packagedAmountRequest'))) {
        const paramValueString = params.get('packagedAmountRequest');
        inParams.packagedAmountRequest = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_inventory_by_lot_selection_wizard') {
      const title = 'Inventory By Lot Selection Wizard';
      const component = FootprintManager_inventory_by_lot_selection_wizardComponent;
      const inParams:{ warehouseId: number, projectId: number } = { warehouseId: null, projectId: null };
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_inventory_by_lot_single_selection_wizard') {
      const title = 'Inventory By Lot Single Selection Wizard';
      const component = FootprintManager_inventory_by_lot_single_selection_wizardComponent;
      const inParams:{ warehouseId: number, projectId: number, materialId: number, packagingId: number, packagedAmountRequest: number } = { warehouseId: null, projectId: null, materialId: null, packagingId: null, packagedAmountRequest: null };
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('materialId'))) {
        const paramValueString = params.get('materialId');
        inParams.materialId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('packagingId'))) {
        const paramValueString = params.get('packagingId');
        inParams.packagingId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('packagedAmountRequest'))) {
        const paramValueString = params.get('packagedAmountRequest');
        inParams.packagedAmountRequest = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_inventory_by_lp_selection_wizard') {
      const title = 'Inventory by LP Selection Wizard';
      const component = FootprintManager_inventory_by_lp_selection_wizardComponent;
      const inParams:{ warehouseId: number, projectId: number, materialId?: number, packagingId?: number, lotId?: number, packagedAmountRequest?: number } = { warehouseId: null, projectId: null, materialId: null, packagingId: null, lotId: null, packagedAmountRequest: null };
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('materialId'))) {
        const paramValueString = params.get('materialId');
        inParams.materialId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('packagingId'))) {
        const paramValueString = params.get('packagingId');
        inParams.packagingId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('lotId'))) {
        const paramValueString = params.get('lotId');
        inParams.lotId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('packagedAmountRequest'))) {
        const paramValueString = params.get('packagedAmountRequest');
        inParams.packagedAmountRequest = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_inventory_by_lp_single_selection_wizard') {
      const title = 'Inventory by LP Single Selection Wizard';
      const component = FootprintManager_inventory_by_lp_single_selection_wizardComponent;
      const inParams:{ warehouseId: number, projectId: number, materialId: number, packagingId: number, lotId?: number, packagedAmountRequest: number } = { warehouseId: null, projectId: null, materialId: null, packagingId: null, lotId: null, packagedAmountRequest: null };
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('materialId'))) {
        const paramValueString = params.get('materialId');
        inParams.materialId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('packagingId'))) {
        const paramValueString = params.get('packagingId');
        inParams.packagingId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('lotId'))) {
        const paramValueString = params.get('lotId');
        inParams.lotId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('packagedAmountRequest'))) {
        const paramValueString = params.get('packagedAmountRequest');
        inParams.packagedAmountRequest = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_inventory_by_serialnumber_selection_wizard') {
      const title = 'Inventory By Serialnumber Selection Wizard';
      const component = FootprintManager_inventory_by_serialnumber_selection_wizardComponent;
      const inParams:{ warehouseId: number, projectId: number, excludeSerials?: number[] } = { warehouseId: null, projectId: null, excludeSerials: [] };
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('excludeSerials'))) {
        const paramValueString = params.get('excludeSerials');
        inParams.excludeSerials = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_inventory_by_serialnumber_single_selection_wizard') {
      const title = 'Inventory By SN Single Selection Wizard';
      const component = FootprintManager_inventory_by_serialnumber_single_selection_wizardComponent;
      const inParams:{ warehouseId: number, projectId: number, materialId: number, packagingId: number, lotId?: number } = { warehouseId: null, projectId: null, materialId: null, packagingId: null, lotId: null };
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('materialId'))) {
        const paramValueString = params.get('materialId');
        inParams.materialId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('packagingId'))) {
        const paramValueString = params.get('packagingId');
        inParams.packagingId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('lotId'))) {
        const paramValueString = params.get('lotId');
        inParams.lotId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_inventory_transformation_advanced_wizard') {
      this.$logger.log('FootprintManager', 'inventory_transformation_advanced_wizard');
      const title = 'Add inventory to transform';
      const component = FootprintManager_inventory_transformation_advanced_wizardComponent;
      const inParams:{ project_id: number, warehouse_id: number, inventory_transformation_id: number, source_line_id?: number } = { project_id: null, warehouse_id: null, inventory_transformation_id: null, source_line_id: null };
      if (!isNil(params.get('project_id'))) {
        const paramValueString = params.get('project_id');
        inParams.project_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouse_id'))) {
        const paramValueString = params.get('warehouse_id');
        inParams.warehouse_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('inventory_transformation_id'))) {
        const paramValueString = params.get('inventory_transformation_id');
        inParams.inventory_transformation_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('source_line_id'))) {
        const paramValueString = params.get('source_line_id');
        inParams.source_line_id = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_inventory_transformation_quick_wizard') {
      this.$logger.log('FootprintManager', 'inventory_transformation_quick_wizard');
      const title = 'Quick transformation a material';
      const component = FootprintManager_inventory_transformation_quick_wizardComponent;
      const inParams:{ is_quick_transformation: boolean, project_id?: number, warehouse_id?: number, owner_id?: number } = { is_quick_transformation: null, project_id: null, warehouse_id: null, owner_id: null };
      if (!isNil(params.get('is_quick_transformation'))) {
        const paramValueString = params.get('is_quick_transformation');
        inParams.is_quick_transformation = this.convertToBoolean(paramValueString);
      }
      if (!isNil(params.get('project_id'))) {
        const paramValueString = params.get('project_id');
        inParams.project_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouse_id'))) {
        const paramValueString = params.get('warehouse_id');
        inParams.warehouse_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('owner_id'))) {
        const paramValueString = params.get('owner_id');
        inParams.owner_id = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_manufacturing_order_production_confirmation_undo_wizard') {
      this.$logger.log('FootprintManager', 'manufacturing_order_production_confirmation_undo_wizard');
      const title = 'Undo production confirmation';
      const component = FootprintManager_manufacturing_order_production_confirmation_undo_wizardComponent;
      const inParams:{ manufacturing_order_id?: number, manufacturing_order_line_id?: number, task_chain_head?: number, warehouse_id?: number } = { manufacturing_order_id: null, manufacturing_order_line_id: null, task_chain_head: null, warehouse_id: null };
      if (!isNil(params.get('manufacturing_order_id'))) {
        const paramValueString = params.get('manufacturing_order_id');
        inParams.manufacturing_order_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('manufacturing_order_line_id'))) {
        const paramValueString = params.get('manufacturing_order_line_id');
        inParams.manufacturing_order_line_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('task_chain_head'))) {
        const paramValueString = params.get('task_chain_head');
        inParams.task_chain_head = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouse_id'))) {
        const paramValueString = params.get('warehouse_id');
        inParams.warehouse_id = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_manufacturing_order_production_confirmation_wizard') {
      this.$logger.log('FootprintManager', 'manufacturing_order_production_confirmation_wizard');
      const title = 'Confirm manufacturing production';
      const component = FootprintManager_manufacturing_order_production_confirmation_wizardComponent;
      const inParams:{ scheduled_run_code?: number, warehouse_id?: number, output_location_id?: number, project_id?: number, planned_quantity?: number, material_id?: number, finished_good?: string, finished_good_id?: number, expected_source_location?: number, manufacturing_order_id?: number, finished_product_is_serialized?: boolean } = { scheduled_run_code: null, warehouse_id: null, output_location_id: null, project_id: null, planned_quantity: null, material_id: null, finished_good: null, finished_good_id: null, expected_source_location: null, manufacturing_order_id: null, finished_product_is_serialized: null };
      if (!isNil(params.get('scheduled_run_code'))) {
        const paramValueString = params.get('scheduled_run_code');
        inParams.scheduled_run_code = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouse_id'))) {
        const paramValueString = params.get('warehouse_id');
        inParams.warehouse_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('output_location_id'))) {
        const paramValueString = params.get('output_location_id');
        inParams.output_location_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('project_id'))) {
        const paramValueString = params.get('project_id');
        inParams.project_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('planned_quantity'))) {
        const paramValueString = params.get('planned_quantity');
        inParams.planned_quantity = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('material_id'))) {
        const paramValueString = params.get('material_id');
        inParams.material_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('finished_good'))) {
        const paramValueString = params.get('finished_good');
        // TODO: date
        inParams.finished_good = paramValueString;
              }
      if (!isNil(params.get('finished_good_id'))) {
        const paramValueString = params.get('finished_good_id');
        inParams.finished_good_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('expected_source_location'))) {
        const paramValueString = params.get('expected_source_location');
        inParams.expected_source_location = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('manufacturing_order_id'))) {
        const paramValueString = params.get('manufacturing_order_id');
        inParams.manufacturing_order_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('finished_product_is_serialized'))) {
        const paramValueString = params.get('finished_product_is_serialized');
        inParams.finished_product_is_serialized = this.convertToBoolean(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_pack_verification_wizard') {
      const title = 'Pack verification';
      const component = FootprintManager_pack_verification_wizardComponent;
      const inParams:{ shippingContainerId: number, startVerificationTaskId?: number, targetLocationId?: number, isBlind?: boolean } = { shippingContainerId: null, startVerificationTaskId: null, targetLocationId: null, isBlind: null };
      if (!isNil(params.get('shippingContainerId'))) {
        const paramValueString = params.get('shippingContainerId');
        inParams.shippingContainerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('startVerificationTaskId'))) {
        const paramValueString = params.get('startVerificationTaskId');
        inParams.startVerificationTaskId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('targetLocationId'))) {
        const paramValueString = params.get('targetLocationId');
        inParams.targetLocationId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('isBlind'))) {
        const paramValueString = params.get('isBlind');
        inParams.isBlind = this.convertToBoolean(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_purchase_order_bulk_receiving_by_taskId_wizard') {
      const title = 'Bulk Receiving';
      const component = FootprintManager_purchase_order_bulk_receiving_by_taskId_wizardComponent;
      const inParams:{ taskId: number, materialId: number, packagingId: number } = { taskId: null, materialId: null, packagingId: null };
      if (!isNil(params.get('taskId'))) {
        const paramValueString = params.get('taskId');
        inParams.taskId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('materialId'))) {
        const paramValueString = params.get('materialId');
        inParams.materialId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('packagingId'))) {
        const paramValueString = params.get('packagingId');
        inParams.packagingId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_billing_record_activity_list') {
      const title = 'Billing record activity';
      const component = FootprintManager_billing_record_activity_listComponent;
      const inParams:{ billingTaskId: number } = { billingTaskId: null };
      if (!isNil(params.get('billingTaskId'))) {
        const paramValueString = params.get('billingTaskId');
        inParams.billingTaskId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_count_tasks_list') {
      const title = 'Count tasks';
      const component = FootprintManager_count_tasks_listComponent;
      const inParams:{ countTaskId: number } = { countTaskId: null };
      if (!isNil(params.get('countTaskId'))) {
        const paramValueString = params.get('countTaskId');
        inParams.countTaskId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_dock_appointment_activity_list') {
      const title = 'Appointment history';
      const component = FootprintManager_dock_appointment_activity_listComponent;
      const inParams:{ dockAppointmentId: number } = { dockAppointmentId: null };
      if (!isNil(params.get('dockAppointmentId'))) {
        const paramValueString = params.get('dockAppointmentId');
        inParams.dockAppointmentId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_dock_doors_list') {
      const title = 'Dock doors';
      const component = FootprintManager_dock_doors_listComponent;
      const inParams:{ warehouseIds?: number[], appointmentType?: string, active?: boolean } = { warehouseIds: [], appointmentType: null, active: null };
      if (!isNil(params.get('warehouseIds'))) {
        const paramValueString = params.get('warehouseIds');
        inParams.warehouseIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('appointmentType'))) {
        const paramValueString = params.get('appointmentType');
        // TODO: date
        inParams.appointmentType = paramValueString;
              }
      if (!isNil(params.get('active'))) {
        const paramValueString = params.get('active');
        inParams.active = this.convertToBoolean(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_licenseplate_list') {
      const title = 'License plates';
      const component = FootprintManager_licenseplate_listComponent;
      const inParams:{ locationId?: number, materialId?: number, projectId?: number, lotId?: number } = { locationId: null, materialId: null, projectId: null, lotId: null };
      if (!isNil(params.get('locationId'))) {
        const paramValueString = params.get('locationId');
        inParams.locationId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('materialId'))) {
        const paramValueString = params.get('materialId');
        inParams.materialId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('lotId'))) {
        const paramValueString = params.get('lotId');
        inParams.lotId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_licenseplatecontent_list') {
      this.$logger.log('FootprintManager', 'licenseplatecontent_list');
      const title = 'License plate content';
      const component = FootprintManager_licenseplatecontent_listComponent;
      const inParams:{ licenseplateId: number } = { licenseplateId: null };
      if (!isNil(params.get('licenseplateId'))) {
        const paramValueString = params.get('licenseplateId');
        inParams.licenseplateId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_licenseplates_by_shipping_container_list') {
      this.$logger.log('FootprintManager', 'licenseplates_by_shipping_container_list');
      const title = 'License plates by shipping container';
      const component = FootprintManager_licenseplates_by_shipping_container_listComponent;
      const inParams:{ shippingContainerId: number } = { shippingContainerId: null };
      if (!isNil(params.get('shippingContainerId'))) {
        const paramValueString = params.get('shippingContainerId');
        inParams.shippingContainerId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_shipping_containers_list') {
      this.$logger.log('FootprintManager', 'shipping_containers_list');
      const title = 'Shipping containers';
      const component = FootprintManager_shipping_containers_listComponent;
      const inParams:{ shipmentId: number } = { shipmentId: null };
      if (!isNil(params.get('shipmentId'))) {
        const paramValueString = params.get('shipmentId');
        inParams.shipmentId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_view_xml_payload') {
      const title = 'view_xml_payload';
      const component = FootprintManager_view_xml_payloadComponent;
      const inParams:{ payload?: any, title?: string } = { payload: null, title: null };
      if (!isNil(params.get('payload'))) {
        const paramValueString = params.get('payload');
        inParams.payload = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('title'))) {
        const paramValueString = params.get('title');
        // TODO: date
        inParams.title = paramValueString;
              }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_dock_door_visualization') {
      const title = 'Dock door view';
      const component = FootprintManager_dock_door_visualizationComponent;
      const inParams:{ warehouse_id: number } = { warehouse_id: null };
      if (!isNil(params.get('warehouse_id'))) {
        const paramValueString = params.get('warehouse_id');
        inParams.warehouse_id = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_commercial_invoice_content') {
      this.$logger.log('FootprintManager', 'commercial_invoice_content');
      const title = 'Commercial invoice';
      const component = FootprintManager_commercial_invoice_contentComponent;
      const inParams:{ url: string } = { url: null };
      if (!isNil(params.get('url'))) {
        const paramValueString = params.get('url');
        // TODO: date
        inParams.url = paramValueString;
              }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_shipping_label_content') {
      const title = 'Shipping label';
      const component = FootprintManager_shipping_label_contentComponent;
      const inParams:{ url: string } = { url: null };
      if (!isNil(params.get('url'))) {
        const paramValueString = params.get('url');
        // TODO: date
        inParams.url = paramValueString;
              }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_archived_options_dd_single') {
      const title = 'archived_options_dd';
      const component = FootprintManager_archived_options_dd_singleComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_daysOfWeek_zt_single') {
      const title = 'daysOfWeek_zt';
      const component = FootprintManager_daysOfWeek_zt_singleComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_enabled_disabled_toggle_dd_single') {
      const title = 'toggle_options_dd';
      const component = FootprintManager_enabled_disabled_toggle_dd_singleComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_footprint_events_statuses_dd_single') {
      this.$logger.log('FootprintManager', 'footprint_events_statuses_dd_single');
      const title = 'List of footprint event statuses';
      const component = FootprintManager_footprint_events_statuses_dd_singleComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_footprint_events_type_dd_single') {
      this.$logger.log('FootprintManager', 'footprint_events_type_dd_single');
      const title = 'footprint_events_type_dd';
      const component = FootprintManager_footprint_events_type_dd_singleComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_hourly_options_dd_single') {
      const title = 'hourly_options_dd';
      const component = FootprintManager_hourly_options_dd_singleComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_inventory_count_statuses_dd_alt_single') {
      this.$logger.log('FootprintManager', 'inventory_count_statuses_dd_alt_single');
      const title = 'inventory_count_statuses_dd_alt';
      const component = FootprintManager_inventory_count_statuses_dd_alt_singleComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_kit_view_sales_order_lines_single') {
      const title = 'Kit view options';
      const component = FootprintManager_kit_view_sales_order_lines_singleComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_lots_dd_single') {
      const title = 'Lots dropdown';
      const component = FootprintManager_lots_dd_singleComponent;
      const inParams:{ materialId: number, vendorLotId?: number, lotLookupCode?: string, vendorLotLookupCode?: string } = { materialId: null, vendorLotId: null, lotLookupCode: null, vendorLotLookupCode: null };
      if (!isNil(params.get('materialId'))) {
        const paramValueString = params.get('materialId');
        inParams.materialId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('vendorLotId'))) {
        const paramValueString = params.get('vendorLotId');
        inParams.vendorLotId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('lotLookupCode'))) {
        const paramValueString = params.get('lotLookupCode');
        // TODO: date
        inParams.lotLookupCode = paramValueString;
              }
      if (!isNil(params.get('vendorLotLookupCode'))) {
        const paramValueString = params.get('vendorLotLookupCode');
        // TODO: date
        inParams.vendorLotLookupCode = paramValueString;
              }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_manufacturing_output_locations_dd_single') {
      this.$logger.log('FootprintManager', 'manufacturing_output_locations_dd_single');
      const title = 'manufacturing_output_locations_dd';
      const component = FootprintManager_manufacturing_output_locations_dd_singleComponent;
      const inParams:{ warehouse_ids?: number[], project_id?: number } = { warehouse_ids: [], project_id: null };
      if (!isNil(params.get('warehouse_ids'))) {
        const paramValueString = params.get('warehouse_ids');
        inParams.warehouse_ids = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('project_id'))) {
        const paramValueString = params.get('project_id');
        inParams.project_id = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_manufacturing_output_locations_simple_dd_single') {
      this.$logger.log('FootprintManager', 'manufacturing_output_locations_simple_dd_single');
      const title = 'manufacturing_output_locations_simple_dd';
      const component = FootprintManager_manufacturing_output_locations_simple_dd_singleComponent;
      const inParams:{ warehouse_ids?: number[], project_id?: number } = { warehouse_ids: [], project_id: null };
      if (!isNil(params.get('warehouse_ids'))) {
        const paramValueString = params.get('warehouse_ids');
        inParams.warehouse_ids = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('project_id'))) {
        const paramValueString = params.get('project_id');
        inParams.project_id = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_manufacturing_staging_locations_dd_single') {
      this.$logger.log('FootprintManager', 'manufacturing_staging_locations_dd_single');
      const title = 'manufacturing_staging_locations_dd';
      const component = FootprintManager_manufacturing_staging_locations_dd_singleComponent;
      const inParams:{ warehouse_id?: number, project_id?: number } = { warehouse_id: null, project_id: null };
      if (!isNil(params.get('warehouse_id'))) {
        const paramValueString = params.get('warehouse_id');
        inParams.warehouse_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('project_id'))) {
        const paramValueString = params.get('project_id');
        inParams.project_id = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_material_type_dd_single') {
      const title = 'material_type_dd';
      const component = FootprintManager_material_type_dd_singleComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_monthsOfYear_zt_single') {
      const title = 'monthsOfYear_zt';
      const component = FootprintManager_monthsOfYear_zt_singleComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_orderclasses_inbound_dd_single') {
      const title = 'orderclasses_inbound_dd';
      const component = FootprintManager_orderclasses_inbound_dd_singleComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_orders_by_project_dd_single') {
      const title = 'orders_by_project_dd';
      const component = FootprintManager_orders_by_project_dd_singleComponent;
      const inParams:{ project_id: number } = { project_id: null };
      if (!isNil(params.get('project_id'))) {
        const paramValueString = params.get('project_id');
        inParams.project_id = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_pallet_classes_dd_single') {
      const title = 'pallet_classes_dd';
      const component = FootprintManager_pallet_classes_dd_singleComponent;
      const inParams:{ project_id?: number } = { project_id: null };
      if (!isNil(params.get('project_id'))) {
        const paramValueString = params.get('project_id');
        inParams.project_id = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_print_order_labels_options_dd_single') {
      this.$logger.log('FootprintManager', 'print_order_labels_options_dd_single');
      const title = 'print_order_labels_options_dd';
      const component = FootprintManager_print_order_labels_options_dd_singleComponent;
      const inParams:{ include?: string[], exclude?: string[] } = { include: [], exclude: [] };
      if (!isNil(params.get('include'))) {
        const paramValueString = params.get('include');
        inParams.include = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('exclude'))) {
        const paramValueString = params.get('exclude');
        inParams.exclude = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_reason_code_parent_entities_dd_single') {
      const title = 'reason_code_parent_entities_dd';
      const component = FootprintManager_reason_code_parent_entities_dd_singleComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_reason_code_parent_entity_ids_dd_single') {
      const title = 'reason_code_parent_entity_ids_dd';
      const component = FootprintManager_reason_code_parent_entity_ids_dd_singleComponent;
      const inParams:{ id?: number, parent?: string } = { id: null, parent: null };
      if (!isNil(params.get('id'))) {
        const paramValueString = params.get('id');
        inParams.id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('parent'))) {
        const paramValueString = params.get('parent');
        // TODO: date
        inParams.parent = paramValueString;
              }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_reason_codes_dd_single') {
      const title = 'reason_codes_dd';
      const component = FootprintManager_reason_codes_dd_singleComponent;
      const inParams:{ parentEntity?: string, parentId?: number } = { parentEntity: null, parentId: null };
      if (!isNil(params.get('parentEntity'))) {
        const paramValueString = params.get('parentEntity');
        // TODO: date
        inParams.parentEntity = paramValueString;
              }
      if (!isNil(params.get('parentId'))) {
        const paramValueString = params.get('parentId');
        inParams.parentId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_support_tests_dd_single') {
      this.$logger.log('FootprintManager', 'support_tests_dd_single');
      const title = 'support_tests_dd';
      const component = FootprintManager_support_tests_dd_singleComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_vendorlots_dd_single') {
      const title = 'Vendor Lots dropdown';
      const component = FootprintManager_vendorlots_dd_singleComponent;
      const inParams:{ materialId: number, lotId?: number, vendorLotLookupCode?: string } = { materialId: null, lotId: null, vendorLotLookupCode: null };
      if (!isNil(params.get('materialId'))) {
        const paramValueString = params.get('materialId');
        inParams.materialId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('lotId'))) {
        const paramValueString = params.get('lotId');
        inParams.lotId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('vendorLotLookupCode'))) {
        const paramValueString = params.get('vendorLotLookupCode');
        // TODO: date
        inParams.vendorLotLookupCode = paramValueString;
              }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_weight_field_dd_single') {
      this.$logger.log('FootprintManager', 'weight_field_dd_single');
      const title = 'weight_field_dd';
      const component = FootprintManager_weight_field_dd_singleComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_archived_options_dd_multi') {
      const title = 'archived_options_dd';
      const component = FootprintManager_archived_options_dd_multiComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_daysOfWeek_zt_multi') {
      const title = 'daysOfWeek_zt';
      const component = FootprintManager_daysOfWeek_zt_multiComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_enabled_disabled_toggle_dd_multi') {
      const title = 'toggle_options_dd';
      const component = FootprintManager_enabled_disabled_toggle_dd_multiComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_footprint_events_statuses_dd_multi') {
      this.$logger.log('FootprintManager', 'footprint_events_statuses_dd_multi');
      const title = 'List of footprint event statuses';
      const component = FootprintManager_footprint_events_statuses_dd_multiComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_footprint_events_type_dd_multi') {
      this.$logger.log('FootprintManager', 'footprint_events_type_dd_multi');
      const title = 'footprint_events_type_dd';
      const component = FootprintManager_footprint_events_type_dd_multiComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_hourly_options_dd_multi') {
      const title = 'hourly_options_dd';
      const component = FootprintManager_hourly_options_dd_multiComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_inventory_count_statuses_dd_alt_multi') {
      this.$logger.log('FootprintManager', 'inventory_count_statuses_dd_alt_multi');
      const title = 'inventory_count_statuses_dd_alt';
      const component = FootprintManager_inventory_count_statuses_dd_alt_multiComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_kit_view_sales_order_lines_multi') {
      const title = 'Kit view options';
      const component = FootprintManager_kit_view_sales_order_lines_multiComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_lots_dd_multi') {
      const title = 'Lots dropdown';
      const component = FootprintManager_lots_dd_multiComponent;
      const inParams:{ materialId: number, vendorLotId?: number, lotLookupCode?: string, vendorLotLookupCode?: string } = { materialId: null, vendorLotId: null, lotLookupCode: null, vendorLotLookupCode: null };
      if (!isNil(params.get('materialId'))) {
        const paramValueString = params.get('materialId');
        inParams.materialId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('vendorLotId'))) {
        const paramValueString = params.get('vendorLotId');
        inParams.vendorLotId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('lotLookupCode'))) {
        const paramValueString = params.get('lotLookupCode');
        // TODO: date
        inParams.lotLookupCode = paramValueString;
              }
      if (!isNil(params.get('vendorLotLookupCode'))) {
        const paramValueString = params.get('vendorLotLookupCode');
        // TODO: date
        inParams.vendorLotLookupCode = paramValueString;
              }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_manufacturing_output_locations_dd_multi') {
      this.$logger.log('FootprintManager', 'manufacturing_output_locations_dd_multi');
      const title = 'manufacturing_output_locations_dd';
      const component = FootprintManager_manufacturing_output_locations_dd_multiComponent;
      const inParams:{ warehouse_ids?: number[], project_id?: number } = { warehouse_ids: [], project_id: null };
      if (!isNil(params.get('warehouse_ids'))) {
        const paramValueString = params.get('warehouse_ids');
        inParams.warehouse_ids = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('project_id'))) {
        const paramValueString = params.get('project_id');
        inParams.project_id = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_manufacturing_output_locations_simple_dd_multi') {
      this.$logger.log('FootprintManager', 'manufacturing_output_locations_simple_dd_multi');
      const title = 'manufacturing_output_locations_simple_dd';
      const component = FootprintManager_manufacturing_output_locations_simple_dd_multiComponent;
      const inParams:{ warehouse_ids?: number[], project_id?: number } = { warehouse_ids: [], project_id: null };
      if (!isNil(params.get('warehouse_ids'))) {
        const paramValueString = params.get('warehouse_ids');
        inParams.warehouse_ids = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('project_id'))) {
        const paramValueString = params.get('project_id');
        inParams.project_id = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_manufacturing_staging_locations_dd_multi') {
      this.$logger.log('FootprintManager', 'manufacturing_staging_locations_dd_multi');
      const title = 'manufacturing_staging_locations_dd';
      const component = FootprintManager_manufacturing_staging_locations_dd_multiComponent;
      const inParams:{ warehouse_id?: number, project_id?: number } = { warehouse_id: null, project_id: null };
      if (!isNil(params.get('warehouse_id'))) {
        const paramValueString = params.get('warehouse_id');
        inParams.warehouse_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('project_id'))) {
        const paramValueString = params.get('project_id');
        inParams.project_id = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_material_type_dd_multi') {
      const title = 'material_type_dd';
      const component = FootprintManager_material_type_dd_multiComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_monthsOfYear_zt_multi') {
      const title = 'monthsOfYear_zt';
      const component = FootprintManager_monthsOfYear_zt_multiComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_orderclasses_inbound_dd_multi') {
      const title = 'orderclasses_inbound_dd';
      const component = FootprintManager_orderclasses_inbound_dd_multiComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_orders_by_project_dd_multi') {
      const title = 'orders_by_project_dd';
      const component = FootprintManager_orders_by_project_dd_multiComponent;
      const inParams:{ project_id: number } = { project_id: null };
      if (!isNil(params.get('project_id'))) {
        const paramValueString = params.get('project_id');
        inParams.project_id = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_pallet_classes_dd_multi') {
      const title = 'pallet_classes_dd';
      const component = FootprintManager_pallet_classes_dd_multiComponent;
      const inParams:{ project_id?: number } = { project_id: null };
      if (!isNil(params.get('project_id'))) {
        const paramValueString = params.get('project_id');
        inParams.project_id = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_print_order_labels_options_dd_multi') {
      this.$logger.log('FootprintManager', 'print_order_labels_options_dd_multi');
      const title = 'print_order_labels_options_dd';
      const component = FootprintManager_print_order_labels_options_dd_multiComponent;
      const inParams:{ include?: string[], exclude?: string[] } = { include: [], exclude: [] };
      if (!isNil(params.get('include'))) {
        const paramValueString = params.get('include');
        inParams.include = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('exclude'))) {
        const paramValueString = params.get('exclude');
        inParams.exclude = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_reason_code_parent_entities_dd_multi') {
      const title = 'reason_code_parent_entities_dd';
      const component = FootprintManager_reason_code_parent_entities_dd_multiComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_reason_code_parent_entity_ids_dd_multi') {
      const title = 'reason_code_parent_entity_ids_dd';
      const component = FootprintManager_reason_code_parent_entity_ids_dd_multiComponent;
      const inParams:{ id?: number, parent?: string } = { id: null, parent: null };
      if (!isNil(params.get('id'))) {
        const paramValueString = params.get('id');
        inParams.id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('parent'))) {
        const paramValueString = params.get('parent');
        // TODO: date
        inParams.parent = paramValueString;
              }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_reason_codes_dd_multi') {
      const title = 'reason_codes_dd';
      const component = FootprintManager_reason_codes_dd_multiComponent;
      const inParams:{ parentEntity?: string, parentId?: number } = { parentEntity: null, parentId: null };
      if (!isNil(params.get('parentEntity'))) {
        const paramValueString = params.get('parentEntity');
        // TODO: date
        inParams.parentEntity = paramValueString;
              }
      if (!isNil(params.get('parentId'))) {
        const paramValueString = params.get('parentId');
        inParams.parentId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_support_tests_dd_multi') {
      this.$logger.log('FootprintManager', 'support_tests_dd_multi');
      const title = 'support_tests_dd';
      const component = FootprintManager_support_tests_dd_multiComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_vendorlots_dd_multi') {
      const title = 'Vendor Lots dropdown';
      const component = FootprintManager_vendorlots_dd_multiComponent;
      const inParams:{ materialId: number, lotId?: number, vendorLotLookupCode?: string } = { materialId: null, lotId: null, vendorLotLookupCode: null };
      if (!isNil(params.get('materialId'))) {
        const paramValueString = params.get('materialId');
        inParams.materialId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('lotId'))) {
        const paramValueString = params.get('lotId');
        inParams.lotId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('vendorLotLookupCode'))) {
        const paramValueString = params.get('vendorLotLookupCode');
        // TODO: date
        inParams.vendorLotLookupCode = paramValueString;
              }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_weight_field_dd_multi') {
      this.$logger.log('FootprintManager', 'weight_field_dd_multi');
      const title = 'weight_field_dd';
      const component = FootprintManager_weight_field_dd_multiComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_manufacturing_order_serial_number_selector_current_component_widget') {
      this.$logger.log('FootprintManager', 'manufacturing_order_serial_number_selector_current_component_widget');
      const title = 'Current component';
      const component = FootprintManager_manufacturing_order_serial_number_selector_current_component_widgetComponent;
      const inParams:{ component_count?: number } = { component_count: null };
      if (!isNil(params.get('component_count'))) {
        const paramValueString = params.get('component_count');
        inParams.component_count = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_manufacturing_order_serial_number_selector_total_components_widget') {
      this.$logger.log('FootprintManager', 'manufacturing_order_serial_number_selector_total_components_widget');
      const title = 'Total components';
      const component = FootprintManager_manufacturing_order_serial_number_selector_total_components_widgetComponent;
      const inParams:{ component_count?: number } = { component_count: null };
      if (!isNil(params.get('component_count'))) {
        const paramValueString = params.get('component_count');
        inParams.component_count = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_scheduled_for_today_widget') {
      this.$logger.log('FootprintManager', 'scheduled_for_today_widget');
      const title = 'Scheduled for today';
      const component = FootprintManager_scheduled_for_today_widgetComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_billing_record_activity_card') {
      const title = 'Billing Record Activity Card';
      const component = FootprintManager_billing_record_activity_cardComponent;
      const inParams:{ billingTaskId: number, activityDetails?: string, activityDate?: string, activityUser?: string, style?: string, title?: string } = { billingTaskId: null, activityDetails: null, activityDate: null, activityUser: null, style: null, title: null };
      if (!isNil(params.get('billingTaskId'))) {
        const paramValueString = params.get('billingTaskId');
        inParams.billingTaskId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('activityDetails'))) {
        const paramValueString = params.get('activityDetails');
        // TODO: date
        inParams.activityDetails = paramValueString;
              }
      if (!isNil(params.get('activityDate'))) {
        const paramValueString = params.get('activityDate');
        // TODO: date
        inParams.activityDate = paramValueString;
              }
      if (!isNil(params.get('activityUser'))) {
        const paramValueString = params.get('activityUser');
        // TODO: date
        inParams.activityUser = paramValueString;
              }
      if (!isNil(params.get('style'))) {
        const paramValueString = params.get('style');
        // TODO: date
        inParams.style = paramValueString;
              }
      if (!isNil(params.get('title'))) {
        const paramValueString = params.get('title');
        // TODO: date
        inParams.title = paramValueString;
              }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_count_task_card') {
      const title = 'count_task_card';
      const component = FootprintManager_count_task_cardComponent;
      const inParams:{ taskId: number } = { taskId: null };
      if (!isNil(params.get('taskId'))) {
        const paramValueString = params.get('taskId');
        inParams.taskId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_dock_appoinment_activity_card') {
      const title = 'Dock Appointment Activity Card';
      const component = FootprintManager_dock_appoinment_activity_cardComponent;
      const inParams:{ dockAppointmentId: number, activityDetails?: string, activityDate?: string, activityUser?: string, style?: string, title?: string } = { dockAppointmentId: null, activityDetails: null, activityDate: null, activityUser: null, style: null, title: null };
      if (!isNil(params.get('dockAppointmentId'))) {
        const paramValueString = params.get('dockAppointmentId');
        inParams.dockAppointmentId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('activityDetails'))) {
        const paramValueString = params.get('activityDetails');
        // TODO: date
        inParams.activityDetails = paramValueString;
              }
      if (!isNil(params.get('activityDate'))) {
        const paramValueString = params.get('activityDate');
        // TODO: date
        inParams.activityDate = paramValueString;
              }
      if (!isNil(params.get('activityUser'))) {
        const paramValueString = params.get('activityUser');
        // TODO: date
        inParams.activityUser = paramValueString;
              }
      if (!isNil(params.get('style'))) {
        const paramValueString = params.get('style');
        // TODO: date
        inParams.style = paramValueString;
              }
      if (!isNil(params.get('title'))) {
        const paramValueString = params.get('title');
        // TODO: date
        inParams.title = paramValueString;
              }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_dock_appointment_card') {
      const title = 'Dock Appointment Card';
      const component = FootprintManager_dock_appointment_cardComponent;
      const inParams:{ dockAppointment: { lookupCode?: string, carrier?: string, referenceNumber?: string, status?: string, id?: number, typeId?: number, warehouseId?: number, orderId?: number } } = { dockAppointment: { lookupCode: null, carrier: null, referenceNumber: null, status: null, id: null, typeId: null, warehouseId: null, orderId: null } };
      if (!isNil(params.get('dockAppointment'))) {
        const paramValueString = params.get('dockAppointment');
        inParams.dockAppointment = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_dock_door_card') {
      const title = 'Dock Door Card';
      const component = FootprintManager_dock_door_cardComponent;
      const inParams:{ dockDoorId: number } = { dockDoorId: null };
      if (!isNil(params.get('dockDoorId'))) {
        const paramValueString = params.get('dockDoorId');
        inParams.dockDoorId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_licenseplate_card') {
      const title = 'Licenseplate Card';
      const component = FootprintManager_licenseplate_cardComponent;
      const inParams:{ licenseplate: { totalPackagedAmount?: number, lookupCode?: string, totalGrossWeight?: number, locationName?: string, licenseplateId?: number } } = { licenseplate: { totalPackagedAmount: null, lookupCode: null, totalGrossWeight: null, locationName: null, licenseplateId: null } };
      if (!isNil(params.get('licenseplate'))) {
        const paramValueString = params.get('licenseplate');
        inParams.licenseplate = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_licenseplate_content_card') {
      this.$logger.log('FootprintManager', 'licenseplate_content_card');
      const title = 'License plate content';
      const component = FootprintManager_licenseplate_content_cardComponent;
      const inParams:{ licenseplateId: number, lotId: number, packagingId: number } = { licenseplateId: null, lotId: null, packagingId: null };
      if (!isNil(params.get('licenseplateId'))) {
        const paramValueString = params.get('licenseplateId');
        inParams.licenseplateId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('lotId'))) {
        const paramValueString = params.get('lotId');
        inParams.lotId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('packagingId'))) {
        const paramValueString = params.get('packagingId');
        inParams.packagingId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_licenseplate_with_content_card') {
      this.$logger.log('FootprintManager', 'licenseplate_with_content_card');
      const title = 'Licenseplate with content card';
      const component = FootprintManager_licenseplate_with_content_cardComponent;
      const inParams:{ licenseplateId: number } = { licenseplateId: null };
      if (!isNil(params.get('licenseplateId'))) {
        const paramValueString = params.get('licenseplateId');
        inParams.licenseplateId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_manufacturing_orders_for_calendar_card') {
      this.$logger.log('FootprintManager', 'manufacturing_orders_for_calendar_card');
      const title = 'manufacturing_orders_for_calendar_card';
      const component = FootprintManager_manufacturing_orders_for_calendar_cardComponent;
      const inParams:{ order_id: number, lookup_code: string, order_lines?: string[], start_date: string, end_date: string } = { order_id: null, lookup_code: null, order_lines: [], start_date: null, end_date: null };
      if (!isNil(params.get('order_id'))) {
        const paramValueString = params.get('order_id');
        inParams.order_id = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('lookup_code'))) {
        const paramValueString = params.get('lookup_code');
        // TODO: date
        inParams.lookup_code = paramValueString;
              }
      if (!isNil(params.get('order_lines'))) {
        const paramValueString = params.get('order_lines');
        inParams.order_lines = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('start_date'))) {
        const paramValueString = params.get('start_date');
        // TODO: date
        inParams.start_date = paramValueString;
              }
      if (!isNil(params.get('end_date'))) {
        const paramValueString = params.get('end_date');
        // TODO: date
        inParams.end_date = paramValueString;
              }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootprintManager_shipping_container_card') {
      this.$logger.log('FootprintManager', 'shipping_container_card');
      const title = 'Shipping container';
      const component = FootprintManager_shipping_container_cardComponent;
      const inParams:{ shippingContainerId: number } = { shippingContainerId: null };
      if (!isNil(params.get('shippingContainerId'))) {
        const paramValueString = params.get('shippingContainerId');
        inParams.shippingContainerId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }


    let result = null;
    result = this.Document360.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.Usersnap.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.Utilities.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.Addresses.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.BarcodeParsing.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.BarTender.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.Catalogs.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.Discussions.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.DockAppointments.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.EntityImport.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.Equipment.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.ExcelInventoryImport.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.ExcelLocationImport.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.ExcelMaterialImport.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.ExcelProjectImport.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.Inspections.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.InventoryTransfers.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.LaborManagement.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.LoadContainers.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.Owners.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.PalletTransactions.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.PrimaryPicks.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.Replenishments.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.Returns.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.Surveys.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.TemperatureReadings.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.TransloadOrders.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.WarehouseTransfers.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.Waves.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.Instructions.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.WorkOrders.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.InventoryCounts.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.ShippingContainers.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.Materials.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.Carriers.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.Locations.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.PurchaseOrders.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.Allocations.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.PrintNode.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.SerialNumbers.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.Lots.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.Inventory.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.AsnOrders.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.ExcelOrderImport.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.Attachments.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.Cartonization.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.Invoices.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.Notifications.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.InventoryTransformations.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.Manifesting.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.PackVerification.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.SalesOrders.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.Manufacturing.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    return result;
  }
}
